/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date (isoformat) */
  Date: { input: any; output: any; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  /** Decimal (fixed-point) */
  Decimal: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any; }
  UUID: { input: any; output: any; }
  /** Represents a file upload. */
  Upload: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

export type AddProductDiagnosisCodeInput = {
  diagnosisCode: Scalars['String']['input'];
  distributorOrderInvoiceProductId: Scalars['Int']['input'];
};

export type AddWorklistCoverageScheduleInput = {
  absentOpsUserId: Scalars['Int']['input'];
  coveringOpsUserId: Scalars['Int']['input'];
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  firstDay: Scalars['Date']['input'];
  lastDay?: InputMaybe<Scalars['Date']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  worklist: WorklistTeam;
};

export type AddressAutoCompleteInput = {
  addressPrefix: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressAutoCompleteSuggestion = {
  __typename?: 'AddressAutoCompleteSuggestion';
  city: Scalars['String']['output'];
  primaryLine: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type AddressVerificationResult = {
  __typename?: 'AddressVerificationResult';
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  city: Scalars['String']['output'];
  lobAddress1: Scalars['String']['output'];
  lobAddress2: Scalars['String']['output'];
  lobCity: Scalars['String']['output'];
  lobDeliverability: LobDeliverability;
  lobFootnotes: Array<Scalars['String']['output']>;
  lobRecordType?: Maybe<Scalars['String']['output']>;
  lobState: Scalars['String']['output'];
  lobValidAddress?: Maybe<Scalars['Boolean']['output']>;
  lobZipcode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export enum AmountBasis {
  Estimate = 'ESTIMATE',
  PayorResponse = 'PAYOR_RESPONSE'
}

export type AnalyticsFilter = {
  endDate: Scalars['Date']['input'];
  hospitalIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate: Scalars['Date']['input'];
};

export type AnalyticsFulfillment = {
  __typename?: 'AnalyticsFulfillment';
  byHospital: Array<FulfillmentByHospital>;
};

export type AnalyticsHospital = {
  __typename?: 'AnalyticsHospital';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AnalyticsHospitalSystem = {
  __typename?: 'AnalyticsHospitalSystem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AnalyticsKpis = {
  __typename?: 'AnalyticsKpis';
  activeHospitals: Scalars['Int']['output'];
  avgFulfillmentHours?: Maybe<Scalars['Float']['output']>;
  estimatedSavings: Scalars['Int']['output'];
  onTimeOrders: Scalars['Int']['output'];
  ordersDelivered: Scalars['Int']['output'];
  pctDeliveredIn48h?: Maybe<Scalars['Float']['output']>;
  totalOrders: Scalars['Int']['output'];
};

export type AnalyticsOrderCategory = {
  __typename?: 'AnalyticsOrderCategory';
  kpis: OrderCategoryKpis;
  slices: Array<OrderCategorySlice>;
};

export type AnalyticsOrderInsights = {
  __typename?: 'AnalyticsOrderInsights';
  issues: OrderInsightsIssues;
  refill: OrderInsightsRefill;
};

export type AnalyticsOverview = {
  __typename?: 'AnalyticsOverview';
  kpis: AnalyticsKpis;
  ordersByHospital: Array<OrdersByHospitalSlice>;
  ordersOverTime: Array<OrdersOverTimePoint>;
};

export type AnalyticsPayorMix = {
  __typename?: 'AnalyticsPayorMix';
  kpis: PayorMixKpis;
  slices: Array<PayorMixSlice>;
};

export type AnalyticsSavings = {
  __typename?: 'AnalyticsSavings';
  byHospital: Array<SavingsByHospital>;
  kpis: SavingsKpis;
};

export type AnalyticsTopProducts = {
  __typename?: 'AnalyticsTopProducts';
  byLocation: Array<LocationTopProducts>;
  kpis: TopProductsKpis;
  summary: Array<TopProductSummarySlice>;
};

export type AnalyticsUser = {
  __typename?: 'AnalyticsUser';
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  hospitalSystemId?: Maybe<Scalars['Int']['output']>;
  hospitalSystemName?: Maybe<Scalars['String']['output']>;
  hospitals?: Maybe<Array<AnalyticsUserHospital>>;
  id: Scalars['Int']['output'];
  role: Scalars['String']['output'];
};

export type AnalyticsUserHospital = {
  __typename?: 'AnalyticsUserHospital';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AppealsCoverLetterInput = {
  coverLetterType?: InputMaybe<AppealsCoverLetterType>;
  description?: InputMaybe<Scalars['String']['input']>;
  explanation?: InputMaybe<Scalars['String']['input']>;
};

export enum AppealsCoverLetterType {
  Generic = 'GENERIC'
}

export enum AppealsLetterType {
  AuthDenial = 'AUTH_DENIAL',
  CorrectDiagnosisDenied = 'CORRECT_DIAGNOSIS_DENIED',
  DiagnosisCode = 'DIAGNOSIS_CODE',
  ExceedingUnits = 'EXCEEDING_UNITS',
  ExceedingUnitsTfl = 'EXCEEDING_UNITS_TFL',
  FacilityAddressIssue = 'FACILITY_ADDRESS_ISSUE',
  Generic = 'GENERIC',
  GwModifier = 'GW_MODIFIER',
  MedicalRecordsRequest = 'MEDICAL_RECORDS_REQUEST',
  MedNecessity = 'MED_NECESSITY',
  Modifier = 'MODIFIER',
  ModifierTfl = 'MODIFIER_TFL',
  NotCoveredUnderBenefitPlan = 'NOT_COVERED_UNDER_BENEFIT_PLAN',
  OonProvider = 'OON_PROVIDER',
  OonTfl = 'OON_TFL',
  PatientResponsibility = 'PATIENT_RESPONSIBILITY',
  PreferredHomecare = 'PREFERRED_HOMECARE',
  Underpayment = 'UNDERPAYMENT'
}

export type AppealsPackageInput = {
  additionalFiles: Array<Scalars['Upload']['input']>;
  amountBilled?: InputMaybe<Scalars['String']['input']>;
  amountExpected?: InputMaybe<Scalars['String']['input']>;
  amountPaid?: InputMaybe<Scalars['String']['input']>;
  appealsLetterType: AppealsLetterType;
  claimId: Scalars['String']['input'];
  coverLetterInput?: InputMaybe<AppealsCoverLetterInput>;
  currentUserId: Scalars['Int']['input'];
  delayExplanation?: InputMaybe<Scalars['String']['input']>;
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  equipmentName?: InputMaybe<Scalars['String']['input']>;
  funcImpairment?: InputMaybe<Scalars['String']['input']>;
  hcpcsCodes?: InputMaybe<Scalars['String']['input']>;
  includeWaiver?: InputMaybe<Scalars['Boolean']['input']>;
  medNecessity?: InputMaybe<Scalars['String']['input']>;
  serviceDate?: InputMaybe<Scalars['String']['input']>;
  waiverOfLiabilityGenericHealthPlan?: InputMaybe<Scalars['String']['input']>;
  waiverOfLiabilityType: WaiverOfLiabilityType;
};

export type AppealsSectionDocument = {
  __typename?: 'AppealsSectionDocument';
  pdfBase64?: Maybe<Scalars['String']['output']>;
  sectionId: AppealsSectionId;
};

export enum AppealsSectionId {
  AppealLetter = 'APPEAL_LETTER',
  CoverLetter = 'COVER_LETTER',
  DeliveryReceipt = 'DELIVERY_RECEIPT',
  Invoice = 'INVOICE',
  ProgressNote = 'PROGRESS_NOTE',
  Swo = 'SWO',
  WaiverLiability = 'WAIVER_LIABILITY'
}

export type AssignHandOffPortalOrderResponse = {
  __typename?: 'AssignHandOffPortalOrderResponse';
  assignedToEmail?: Maybe<Scalars['String']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  assignedToUserId?: Maybe<Scalars['Int']['output']>;
  handOffPortalOrderId: Scalars['Int']['output'];
  handOffPortalOrderRef?: Maybe<Scalars['String']['output']>;
};

export type AssignedFilterInput = {
  statuses?: InputMaybe<Array<AssignmentOptions>>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum AssignmentOptions {
  AssignedToAnyone = 'ASSIGNED_TO_ANYONE',
  Unassigned = 'UNASSIGNED'
}

export enum AttributeType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Enum = 'ENUM',
  List = 'LIST',
  Number = 'NUMBER',
  Text = 'TEXT'
}

export type AutoAppealPackageSettingsInput = {
  appealLetterToCarcCodes?: InputMaybe<Scalars['JSON']['input']>;
  autoSubmitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dollarAmountThreshold?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  payorToCoverLetter?: InputMaybe<Scalars['JSON']['input']>;
  payorWhitelist?: InputMaybe<Array<Scalars['String']['input']>>;
  tflCarcCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  tflLetterNames?: InputMaybe<Array<Scalars['String']['input']>>;
  useGenericLetter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutoAppealPackageSettingsSchema = {
  __typename?: 'AutoAppealPackageSettingsSchema';
  appealLetterToCarcCodes: Scalars['JSON']['output'];
  autoSubmitEnabled: Scalars['Boolean']['output'];
  dollarAmountThreshold: Scalars['Float']['output'];
  enabled: Scalars['Boolean']['output'];
  payorToCoverLetter: Scalars['JSON']['output'];
  payorWhitelist: Array<Scalars['String']['output']>;
  tflCarcCodes: Array<Scalars['String']['output']>;
  tflLetterNames: Array<Scalars['String']['output']>;
  useGenericLetter: Scalars['Boolean']['output'];
};

export type AutoApprovalSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ineligiblePrepperEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  maxSegmentsPerRun?: InputMaybe<Scalars['Int']['input']>;
};

export type AutoApprovalSettingsSchema = {
  __typename?: 'AutoApprovalSettingsSchema';
  enabled: Scalars['Boolean']['output'];
  ineligiblePrepperEmails: Array<Scalars['String']['output']>;
  maxSegmentsPerRun?: Maybe<Scalars['Int']['output']>;
};

export type AutoClaimFileSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  hcpcsWhitelist?: InputMaybe<Array<Scalars['String']['input']>>;
  payorWhitelist?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AutoClaimFileSettingsSchema = {
  __typename?: 'AutoClaimFileSettingsSchema';
  enabled: Scalars['Boolean']['output'];
  hcpcsWhitelist: Array<Scalars['String']['output']>;
  payorWhitelist: Array<Scalars['String']['output']>;
};

export type AutoFileEligibility = {
  __typename?: 'AutoFileEligibility';
  eligible: Scalars['Boolean']['output'];
  ineligibleReasons: Array<Scalars['String']['output']>;
};

export type AutoInsuranceInfo = {
  __typename?: 'AutoInsuranceInfo';
  caseManagerName?: Maybe<Scalars['String']['output']>;
  caseManagerPhone?: Maybe<Scalars['String']['output']>;
  claimAddress?: Maybe<Scalars['String']['output']>;
  claimNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dateOfAccident?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insuranceName?: Maybe<Scalars['String']['output']>;
  stateOfAccident?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AutoInsuranceInfoInput = {
  caseManagerName?: InputMaybe<Scalars['String']['input']>;
  caseManagerPhone?: InputMaybe<Scalars['String']['input']>;
  claimAddress?: InputMaybe<Scalars['String']['input']>;
  claimNumber?: InputMaybe<Scalars['String']['input']>;
  dateOfAccident?: InputMaybe<Scalars['String']['input']>;
  insuranceName?: InputMaybe<Scalars['String']['input']>;
  stateOfAccident?: InputMaybe<Scalars['String']['input']>;
};

export type AutofillGuess = {
  __typename?: 'AutofillGuess';
  selectedProductLink: Scalars['String']['output'];
  selectedProductName: Scalars['String']['output'];
};

export type AvailableCheckPayment = {
  __typename?: 'AvailableCheckPayment';
  checkNumber: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  paymentDate: Scalars['Date']['output'];
  remainingBalance: Scalars['Float']['output'];
};

export type BatchCopyDocumentsResult = {
  __typename?: 'BatchCopyDocumentsResult';
  failures: Array<DocumentCopyFailure>;
  success: Scalars['Boolean']['output'];
};

export type BatchCreateOrderResult = {
  __typename?: 'BatchCreateOrderResult';
  createdOrders: Array<CreatedOrderResult>;
  failedOrders: Array<FailedOrderResult>;
};

export type BatchOrderResult = {
  __typename?: 'BatchOrderResult';
  orderNumber: Scalars['String']['output'];
  providerReferral?: Maybe<ProviderReferral>;
};

export type BatchRequestNotificationData = {
  __typename?: 'BatchRequestNotificationData';
  count: Scalars['Int']['output'];
  lastNotificationSent?: Maybe<Scalars['DateTime']['output']>;
};

export type BatchSignatureRequestOrderData = {
  __typename?: 'BatchSignatureRequestOrderData';
  email?: Maybe<BatchRequestNotificationData>;
  fax?: Maybe<BatchRequestNotificationData>;
  orderNumber: Scalars['String']['output'];
};

export type BillerReview = {
  __typename?: 'BillerReview';
  archived?: Maybe<Scalars['Boolean']['output']>;
  completedAtEst?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  notesTitle?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  reasonType: BillerReviewReasonType;
  responseDisplay?: Maybe<Scalars['String']['output']>;
  responseId?: Maybe<Scalars['Int']['output']>;
  userCompletedBy?: Maybe<Scalars['String']['output']>;
};

export type BillerReviewDraft = {
  __typename?: 'BillerReviewDraft';
  billerReviewId: Scalars['Int']['output'];
  context: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  response: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BillerReviewOrderNoteInput = {
  contextData?: InputMaybe<Scalars['JSON']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['Int']['input']>;
};

export type BillerReviewParentResponseOption = {
  __typename?: 'BillerReviewParentResponseOption';
  childOptions: Array<BillerReviewResponseOption>;
  parentTitle: Scalars['String']['output'];
};

export type BillerReviewProductInput = {
  lineItemIds: Array<Scalars['String']['input']>;
  segmentId: Scalars['Int']['input'];
};

export type BillerReviewReason = {
  __typename?: 'BillerReviewReason';
  reasonType: BillerReviewReasonType;
  title: Scalars['String']['output'];
};

export enum BillerReviewReasonType {
  CostAbove_1000 = 'COST_ABOVE_1000',
  FailedValidationChecks = 'FAILED_VALIDATION_CHECKS',
  HandOff = 'HAND_OFF',
  HhaOrder = 'HHA_ORDER',
  McrOrderWA6196OrAa6212 = 'MCR_ORDER_W_A6196_OR_AA6212',
  MedicalRecords = 'MEDICAL_RECORDS',
  MedicalRecordsHcpcsAudit = 'MEDICAL_RECORDS_HCPCS_AUDIT',
  MedicalRecordsHighCost = 'MEDICAL_RECORDS_HIGH_COST',
  MedicalRecordsInternal = 'MEDICAL_RECORDS_INTERNAL',
  MedicalRecordsUpicAudit = 'MEDICAL_RECORDS_UPIC_AUDIT'
}

export type BillerReviewResponseOption = {
  __typename?: 'BillerReviewResponseOption';
  hasNotes: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  responseType: BillerReviewResponseType;
  subTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum BillerReviewResponseType {
  CheckIfWeCanHandOff = 'CHECK_IF_WE_CAN_HAND_OFF',
  DocsAreInsufficient = 'DOCS_ARE_INSUFFICIENT',
  FulfillOurselves = 'FULFILL_OURSELVES',
  HandOffAll = 'HAND_OFF_ALL',
  HandOffPartial = 'HAND_OFF_PARTIAL',
  MedicalRecordsAccurate = 'MEDICAL_RECORDS_ACCURATE',
  MedicalRecordsIssuesCombined = 'MEDICAL_RECORDS_ISSUES_COMBINED',
  MedicalRecordsIssuesFixable = 'MEDICAL_RECORDS_ISSUES_FIXABLE',
  MedicalRecordsIssuesFound = 'MEDICAL_RECORDS_ISSUES_FOUND',
  MedicalRecordsIssuesNonfixable = 'MEDICAL_RECORDS_ISSUES_NONFIXABLE',
  NoHandoffPlanHasNoDmeOop = 'NO_HANDOFF_PLAN_HAS_NO_DME_OOP',
  NoHandoffPlanHasNoDmeTerminate = 'NO_HANDOFF_PLAN_HAS_NO_DME_TERMINATE',
  PlanDoesntCoverOfferOop = 'PLAN_DOESNT_COVER_OFFER_OOP',
  PlanDoesntCoverTerminate = 'PLAN_DOESNT_COVER_TERMINATE',
  WeCanBill = 'WE_CAN_BILL'
}

export type BillingAuditKeywordsSettingsInput = {
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BillingAuditKeywordsSettingsSchema = {
  __typename?: 'BillingAuditKeywordsSettingsSchema';
  keywords: Array<Scalars['String']['output']>;
};

export type BillingDataForOrderSegment = {
  __typename?: 'BillingDataForOrderSegment';
  billingServiceId: Scalars['Int']['output'];
};

export type BlockedStep = {
  __typename?: 'BlockedStep';
  blockingNodeIds: Array<Scalars['Int']['output']>;
  nodeId: Scalars['Int']['output'];
  orderSegmentId?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  status: DagNodeStatus;
  taskType?: Maybe<DagTaskType>;
};

export type BlockingNode = {
  __typename?: 'BlockingNode';
  metadata: Scalars['JSON']['output'];
  nodeId: Scalars['Int']['output'];
  nodeType: DagNodeType;
  orderSegmentId?: Maybe<Scalars['Int']['output']>;
  pin?: Maybe<BlockingNodePin>;
  since?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  status: DagNodeStatus;
  stuck: Scalars['Boolean']['output'];
  taskType?: Maybe<DagTaskType>;
  waitingOn: DagWaitingOn;
};

export type BlockingNodePin = {
  __typename?: 'BlockingNodePin';
  pinReason?: Maybe<Scalars['String']['output']>;
  pinnedAt: Scalars['DateTime']['output'];
  pinnedByName?: Maybe<Scalars['String']['output']>;
  pinnedByUserId?: Maybe<Scalars['Int']['output']>;
};

export type BoundingBox = {
  __typename?: 'BoundingBox';
  h: Scalars['Float']['output'];
  w: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type BufferOrSendResultGql = {
  __typename?: 'BufferOrSendResultGQL';
  bufferedOrderNoteId?: Maybe<Scalars['Int']['output']>;
  orderNoteId?: Maybe<Scalars['Int']['output']>;
};

export type BufferedOrderNoteGql = {
  __typename?: 'BufferedOrderNoteGQL';
  createdAt: Scalars['DateTime']['output'];
  createdByOpsUserName?: Maybe<Scalars['String']['output']>;
  departmentOrderId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  messageTemplateId?: Maybe<Scalars['Int']['output']>;
  messageTemplateNames?: Maybe<Array<Scalars['String']['output']>>;
  nodeId?: Maybe<Scalars['Int']['output']>;
  noteText: Scalars['String']['output'];
  orderNoteInputSnapshot: Scalars['JSON']['output'];
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  willBeActionItem: Scalars['Boolean']['output'];
};

export type BulkActivateResult = {
  __typename?: 'BulkActivateResult';
  failedDepartments: Array<Scalars['String']['output']>;
  successfulDepartments: Array<Scalars['String']['output']>;
};

export type BulkAssignHospitalSalesRepsItemInput = {
  hospitalId: Scalars['Int']['input'];
  salesRepId?: InputMaybe<Scalars['Int']['input']>;
};

export type BulkAssignHospitalSalesRepsResult = {
  __typename?: 'BulkAssignHospitalSalesRepsResult';
  failed: Array<Scalars['String']['output']>;
  success: Array<Scalars['String']['output']>;
};

export enum BypassReason {
  DidNotReceiveSupplies = 'DID_NOT_RECEIVE_SUPPLIES',
  Hardship = 'HARDSHIP',
  IncorrectFlagging = 'INCORRECT_FLAGGING',
  IncorrectPr = 'INCORRECT_PR',
  PatientDeath = 'PATIENT_DEATH',
  PatientDidNotAuthorizeSupplies = 'PATIENT_DID_NOT_AUTHORIZE_SUPPLIES',
  PatientFeelsHarassment = 'PATIENT_FEELS_HARASSMENT',
  Qmb = 'QMB',
  ReturnNotEligible = 'RETURN_NOT_ELIGIBLE',
  SecondaryInsurance = 'SECONDARY_INSURANCE',
  TertiaryInsurance = 'TERTIARY_INSURANCE'
}

export type CalculatedSizeAndQuantitySet = {
  __typename?: 'CalculatedSizeAndQuantitySet';
  quantity: Scalars['Int']['output'];
  sizeId: Scalars['Int']['output'];
  sizeName: Scalars['String']['output'];
  woundUuids?: Maybe<Array<Scalars['String']['output']>>;
  wounds: Array<Scalars['Int']['output']>;
};

export type CalculatedSizeAndQuantitySetListResponse = {
  __typename?: 'CalculatedSizeAndQuantitySetListResponse';
  confidence: Scalars['Float']['output'];
  reasoning: Scalars['String']['output'];
  suggestedSizeAndQuantitySets: Array<CalculatedSizeAndQuantitySet>;
};

export type CanonicalPayor = {
  __typename?: 'CanonicalPayor';
  apiCodes: Array<PayorApiCode>;
  appealHandler?: Maybe<PayorAppealHandler>;
  displayName: Scalars['String']['output'];
  frequentlyUsed: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  verified: Scalars['Boolean']['output'];
};

export type CanonicalPayorInput = {
  apiCodeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  canonicalPayorId?: InputMaybe<Scalars['Int']['input']>;
  displayName: Scalars['String']['input'];
  frequentlyUsed?: InputMaybe<Scalars['Boolean']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CardinalOrderPlacementResponse = {
  __typename?: 'CardinalOrderPlacementResponse';
  cardinalOrderNumber?: Maybe<Scalars['String']['output']>;
  messages: Array<Scalars['String']['output']>;
  status: CardinalOrderPlacementStatus;
  updatedOrderSegmentStatus?: Maybe<VerseOsOrderSearchSegmentStatus>;
};

export enum CardinalOrderPlacementStatus {
  Error = 'ERROR',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type CareBridgeFormItem = {
  __typename?: 'CareBridgeFormItem';
  isPurchaseOrderItem?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedRequired?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  types: Array<CareBridgeProductType>;
};

export type CareBridgeLineItem = {
  __typename?: 'CareBridgeLineItem';
  id: Scalars['Int']['output'];
  isPurchaseOrderItem?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedLifetime?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedMonths?: Maybe<Scalars['Int']['output']>;
  lengthOfNeedOther?: Maybe<Scalars['Boolean']['output']>;
  productCategory?: Maybe<ProductCategory>;
  productName: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  productTypeDefaultDistributorId?: Maybe<Scalars['Int']['output']>;
  productTypeDefaultLink?: Maybe<Scalars['String']['output']>;
  productTypeId?: Maybe<Scalars['Int']['output']>;
  quantity: Scalars['Int']['output'];
  sku?: Maybe<Scalars['String']['output']>;
};

export type CareBridgeLineItemInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isPurchaseOrderItem?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedLifetime?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedMonths?: InputMaybe<Scalars['Int']['input']>;
  lengthOfNeedOther?: InputMaybe<Scalars['Boolean']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  productTypeId?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type CareBridgeOrder = {
  __typename?: 'CareBridgeOrder';
  additionalDiagnosisInfo?: Maybe<Scalars['String']['output']>;
  careBridgeLineItems: Array<CareBridgeLineItem>;
  id?: Maybe<Scalars['Int']['output']>;
  patientHeightFeet?: Maybe<Scalars['Int']['output']>;
  patientHeightInches?: Maybe<Scalars['Int']['output']>;
  patientWeight?: Maybe<Scalars['Int']['output']>;
};

export type CareBridgeOrderInput = {
  additionalDiagnosisInfo?: InputMaybe<Scalars['String']['input']>;
  careBridgeLineItems: Array<CareBridgeLineItemInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  patientHeightFeet?: InputMaybe<Scalars['Int']['input']>;
  patientHeightInches?: InputMaybe<Scalars['Int']['input']>;
  patientWeight?: InputMaybe<Scalars['Int']['input']>;
};

export type CareBridgeProductType = {
  __typename?: 'CareBridgeProductType';
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type CareCoordinationRetrieval = {
  __typename?: 'CareCoordinationRetrieval';
  assignee?: Maybe<OpsUser>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  groupKey: Scalars['String']['output'];
  hospital?: Maybe<Hospital>;
  id: Scalars['Int']['output'];
  notes: Array<CareCoordinationRetrievalNote>;
  numAttempts: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
  persistentNotes?: Maybe<Scalars['String']['output']>;
  pnCollectionSource?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ProviderSigner>;
  providerNpi?: Maybe<Scalars['String']['output']>;
  retrievalType: CareCoordinationRetrievalType;
  signatureCollectionSource?: Maybe<Scalars['String']['output']>;
  snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
  stageSlug: CareCoordinationRetrievalStageSlug;
  tags: Array<CareCoordinationRetrievalTag>;
};

export enum CareCoordinationRetrievalEdgeType {
  Advance = 'ADVANCE',
  Cancel = 'CANCEL',
  Escalate = 'ESCALATE',
  Reopen = 'REOPEN',
  SendBack = 'SEND_BACK',
  WriteOff = 'WRITE_OFF'
}

export type CareCoordinationRetrievalEvent = {
  __typename?: 'CareCoordinationRetrievalEvent';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  user?: Maybe<OpsUser>;
};

export type CareCoordinationRetrievalListInput = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  maxNumAttempts?: InputMaybe<Scalars['Int']['input']>;
  minNumAttempts?: InputMaybe<Scalars['Int']['input']>;
  pageNumber: Scalars['Int']['input'];
  providerRiskStatus?: InputMaybe<ProviderRiskStatus>;
  providerValidated?: InputMaybe<Scalars['Boolean']['input']>;
  retrievalTypes?: InputMaybe<Array<CareCoordinationRetrievalType>>;
  search?: InputMaybe<Scalars['String']['input']>;
  snoozed?: InputMaybe<Scalars['Boolean']['input']>;
  stageSlugs?: InputMaybe<Array<CareCoordinationRetrievalStageSlug>>;
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  timezones?: InputMaybe<Array<Scalars['Int']['input']>>;
  unclaimedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CareCoordinationRetrievalListResponse = {
  __typename?: 'CareCoordinationRetrievalListResponse';
  maxPage: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  retrievals: Array<CareCoordinationRetrieval>;
  totalCount: Scalars['Int']['output'];
};

export type CareCoordinationRetrievalNote = {
  __typename?: 'CareCoordinationRetrievalNote';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  user?: Maybe<OpsUser>;
};

export type CareCoordinationRetrievalStageActions = {
  __typename?: 'CareCoordinationRetrievalStageActions';
  cancellationReopenTransitions: Array<CareCoordinationRetrievalStageTransition>;
  /** @deprecated Replaced by the document_verification stage; always false. Removed once verseOS stops querying it. */
  checkpointEngageable: Scalars['Boolean']['output'];
  mainTrackTransitions: Array<CareCoordinationRetrievalStageTransition>;
  outreachConfirmationStatus?: Maybe<CareCoordinationRetrievalStageStatus>;
  providerValidationStatus?: Maybe<CareCoordinationRetrievalStageStatus>;
  snoozeable: Scalars['Boolean']['output'];
  /** @deprecated Replaced by the document_verification stage; always empty. Removed once verseOS stops querying it. */
  verificationCheckpointTransitions: Array<CareCoordinationRetrievalStageTransition>;
  verificationStages: Array<CareCoordinationRetrievalVerificationStageStatus>;
};

export type CareCoordinationRetrievalStageActionsForRetrieval = {
  __typename?: 'CareCoordinationRetrievalStageActionsForRetrieval';
  retrievalId: Scalars['Int']['output'];
  stageActions: CareCoordinationRetrievalStageActions;
};

export enum CareCoordinationRetrievalStageSlug {
  Canceled = 'CANCELED',
  CmnVerification = 'CMN_VERIFICATION',
  Completed = 'COMPLETED',
  DocumentVerification = 'DOCUMENT_VERIFICATION',
  FollowUp = 'FOLLOW_UP',
  InitialOutreach = 'INITIAL_OUTREACH',
  L2Escalation = 'L2_ESCALATION',
  New = 'NEW',
  OutreachConfirmation = 'OUTREACH_CONFIRMATION',
  ProgressNoteSummaryVerification = 'PROGRESS_NOTE_SUMMARY_VERIFICATION',
  ProgressNoteVerification = 'PROGRESS_NOTE_VERIFICATION',
  ProviderValidation = 'PROVIDER_VALIDATION',
  SignatureVerification = 'SIGNATURE_VERIFICATION',
  SupervisorEscalation = 'SUPERVISOR_ESCALATION',
  SwoVerification = 'SWO_VERIFICATION',
  WrittenOff = 'WRITTEN_OFF'
}

export enum CareCoordinationRetrievalStageStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Skipped = 'SKIPPED',
  Waiting = 'WAITING'
}

export type CareCoordinationRetrievalStageTransition = {
  __typename?: 'CareCoordinationRetrievalStageTransition';
  edgeType: CareCoordinationRetrievalEdgeType;
  toSlug: CareCoordinationRetrievalStageSlug;
};

export type CareCoordinationRetrievalTag = {
  __typename?: 'CareCoordinationRetrievalTag';
  displayString: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export enum CareCoordinationRetrievalType {
  Audit = 'AUDIT',
  CoordinatedFulfillmentSignature = 'COORDINATED_FULFILLMENT_SIGNATURE',
  DenialDocumentation = 'DENIAL_DOCUMENTATION',
  MedicalRecordRequest = 'MEDICAL_RECORD_REQUEST',
  PriorAuthorization = 'PRIOR_AUTHORIZATION',
  ProgressNoteCollection = 'PROGRESS_NOTE_COLLECTION',
  SignatureRequest = 'SIGNATURE_REQUEST',
  VendorOrderValidationDocumentation = 'VENDOR_ORDER_VALIDATION_DOCUMENTATION'
}

export type CareCoordinationRetrievalVerificationStageStatus = {
  __typename?: 'CareCoordinationRetrievalVerificationStageStatus';
  slug: CareCoordinationRetrievalStageSlug;
  status: CareCoordinationRetrievalStageStatus;
};

export type CareCoordinationTask = {
  __typename?: 'CareCoordinationTask';
  assignee?: Maybe<OpsUser>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dueDate: Scalars['DateTime']['output'];
  events: Array<CareCoordinationTaskEvent>;
  hasUnreachableCmOrder: Scalars['Boolean']['output'];
  hospital?: Maybe<Hospital>;
  id: Scalars['Int']['output'];
  numAttempts: Scalars['Int']['output'];
  orders: Array<Scalars['String']['output']>;
  persistentNotes?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<ProviderSigner>;
  providerNpi?: Maybe<Scalars['String']['output']>;
  scoring?: Maybe<CareCoordinationTaskScore>;
  status: CareCoordinationTaskStatus;
  tags: Array<CareCoordinationTaskTag>;
  taskNotes?: Maybe<Scalars['String']['output']>;
  type: CareCoordinationTaskType;
};

export type CareCoordinationTaskEvent = {
  __typename?: 'CareCoordinationTaskEvent';
  createdAt: Scalars['DateTime']['output'];
  eventDescription: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  user?: Maybe<OpsUser>;
};

export type CareCoordinationTaskListInput = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  escalatedToSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  everEscalatedToSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  hospitalName: Scalars['String']['input'];
  maxNumAttempts?: InputMaybe<Scalars['Int']['input']>;
  minNumAttempts?: InputMaybe<Scalars['Int']['input']>;
  orderByScore?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber: Scalars['Int']['input'];
  providerName: Scalars['String']['input'];
  providerRiskStatus?: InputMaybe<ProviderRiskStatus>;
  providerValidated?: InputMaybe<Scalars['Boolean']['input']>;
  statuses: Array<CareCoordinationTaskStatus>;
  tagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  timezones?: InputMaybe<Array<Scalars['Int']['input']>>;
  typeIds: Array<Scalars['Int']['input']>;
};

export type CareCoordinationTaskListResponse = {
  __typename?: 'CareCoordinationTaskListResponse';
  maxPage: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  tasks: Array<CareCoordinationTask>;
  totalCount: Scalars['Int']['output'];
};

export type CareCoordinationTaskScore = {
  __typename?: 'CareCoordinationTaskScore';
  history: Array<CareCoordinationTaskScoreHistory>;
  score: Scalars['Int']['output'];
};

export type CareCoordinationTaskScoreFactorEntry = {
  __typename?: 'CareCoordinationTaskScoreFactorEntry';
  factor: CareCoordinationTaskScoreHistoryFactor;
  name: Scalars['String']['output'];
};

export type CareCoordinationTaskScoreHistory = {
  __typename?: 'CareCoordinationTaskScoreHistory';
  calculatedAt: Scalars['DateTime']['output'];
  factors: Array<CareCoordinationTaskScoreFactorEntry>;
  score: Scalars['Int']['output'];
};

export type CareCoordinationTaskScoreHistoryFactor = {
  __typename?: 'CareCoordinationTaskScoreHistoryFactor';
  raw?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
};

export enum CareCoordinationTaskStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW'
}

export type CareCoordinationTaskTag = {
  __typename?: 'CareCoordinationTaskTag';
  displayString: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  taskCount?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type CareCoordinationTaskType = {
  __typename?: 'CareCoordinationTaskType';
  id: Scalars['Int']['output'];
  priority: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type CatalogCalculator = {
  __typename?: 'CatalogCalculator';
  fixedQuantity?: Maybe<Scalars['Int']['output']>;
  fixedSize?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type CatalogDistributorMapping = {
  __typename?: 'CatalogDistributorMapping';
  costPrice?: Maybe<Scalars['Float']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  distributorId: Scalars['Int']['output'];
  distributorName: Scalars['String']['output'];
  distributorProductId: Scalars['Int']['output'];
  externalManufacturerProductId?: Maybe<Scalars['String']['output']>;
  externalProductId?: Maybe<Scalars['String']['output']>;
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isHazmat?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerPartNumber?: Maybe<Scalars['String']['output']>;
  numInSale?: Maybe<Scalars['Int']['output']>;
  packageAmount?: Maybe<Scalars['Int']['output']>;
  packageAmountString?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  productLink?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  salUnitMsr?: Maybe<Scalars['String']['output']>;
};

export type CatalogFormItem = {
  __typename?: 'CatalogFormItem';
  calculator: CatalogCalculator;
  canBeAutoPrepped: Scalars['Boolean']['output'];
  category: Scalars['String']['output'];
  clinicianQuantityRuleDescription?: Maybe<Scalars['String']['output']>;
  displayUnitLabel?: Maybe<Scalars['String']['output']>;
  dressingCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isBordered: Scalars['Boolean']['output'];
  isGeneric: Scalars['Boolean']['output'];
  llmQuantityRuleDescription?: Maybe<Scalars['String']['output']>;
  llmSizeRuleDescription?: Maybe<Scalars['String']['output']>;
  llmSizeRuleIsManaged: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  popularity: Scalars['Int']['output'];
  sizes: Array<CatalogFormItemSize>;
  woundItemTraits?: Maybe<WoundItemTraits>;
  woundItemTypeId?: Maybe<Scalars['Int']['output']>;
};

export type CatalogFormItemSize = {
  __typename?: 'CatalogFormItemSize';
  cardinalMappings: Array<CatalogDistributorMapping>;
  cardinalNotAvailable: Scalars['Boolean']['output'];
  display?: Maybe<Scalars['String']['output']>;
  displayPad?: Maybe<Scalars['String']['output']>;
  formItemId: Scalars['Int']['output'];
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mckessonMappings: Array<CatalogDistributorMapping>;
  mckessonNotAvailable: Scalars['Boolean']['output'];
  mercyMappings: Array<CatalogDistributorMapping>;
  mercyNotAvailable: Scalars['Boolean']['output'];
  position?: Maybe<Scalars['Int']['output']>;
};

export type CatalogModernFormItem = {
  __typename?: 'CatalogModernFormItem';
  categoryDisplayName: Scalars['String']['output'];
  categoryId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  productCategory: Scalars['String']['output'];
  variants: Array<CatalogModernFormItemVariant>;
};

export type CatalogModernFormItemVariant = {
  __typename?: 'CatalogModernFormItemVariant';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  mappings: Array<CatalogDistributorMapping>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type Category = {
  __typename?: 'Category';
  categoryDiagnosisTypes: Array<CategoryDiagnosisType>;
  defaultIcd10Descriptions?: Maybe<Array<ModernIcd10Description>>;
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  identifier: Scalars['String']['output'];
  isDeactivated: Scalars['Boolean']['output'];
  isNew: Scalars['Boolean']['output'];
  planOfCareFields: Array<PlanOfCareField>;
  productCategory: ProductCategory;
  subcategories: Array<Subcategory>;
};

export type CategoryDiagnosisType = {
  __typename?: 'CategoryDiagnosisType';
  categoryId: Scalars['Int']['output'];
  diagnosisType: DiagnosisType;
  id: Scalars['Int']['output'];
  numberOfCustomDiagnosis: Scalars['Int']['output'];
};

export type CategoryDisplayName = {
  __typename?: 'CategoryDisplayName';
  displayName: Scalars['String']['output'];
  productCategory: ProductCategory;
};

export enum ChargeType {
  Deductible = 'DEDUCTIBLE',
  Mixed = 'MIXED',
  Oop = 'OOP'
}

export type Claim = {
  __typename?: 'Claim';
  encounterId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type ClaimNextWorklistTasksResult = {
  __typename?: 'ClaimNextWorklistTasksResult';
  blockedByUnfinishedTasks: Scalars['Boolean']['output'];
  tasks: Array<WorklistTask>;
};

export type ClaimPreviewLineItem = {
  __typename?: 'ClaimPreviewLineItem';
  diagnosisCodes: Array<Scalars['String']['output']>;
  exceedsSwoCap: Scalars['Boolean']['output'];
  finalQuantity: Scalars['Float']['output'];
  hcpcsCode: Scalars['String']['output'];
  modifiers: Array<Scalars['String']['output']>;
  serviceDate?: Maybe<Scalars['Date']['output']>;
};

export type ClinicDelivery = {
  __typename?: 'ClinicDelivery';
  address: ShippingAddress;
  deliveryInstructions?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ClinicDeliveryInput = {
  address: ShippingAddressInput;
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ClinicEditWindowStatus = {
  __typename?: 'ClinicEditWindowStatus';
  applies: Scalars['Boolean']['output'];
  editClosesAt?: Maybe<Scalars['DateTime']['output']>;
  editSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  leaseEndsAt?: Maybe<Scalars['DateTime']['output']>;
  serverNow: Scalars['DateTime']['output'];
  windowEndsAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ClinicInfo = {
  __typename?: 'ClinicInfo';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  departmentId: Scalars['Int']['output'];
  departmentName: Scalars['String']['output'];
  departmentType?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  hospitalName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  stateAbbr?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type ClinicalReviewHubData = {
  __typename?: 'ClinicalReviewHubData';
  availableVersions: Array<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  metrics: ClinicalReviewMetrics;
  orders: Array<ClinicalReviewOrderSummary>;
  pipelineVersion: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ClinicalReviewMetrics = {
  __typename?: 'ClinicalReviewMetrics';
  baseRate: Scalars['Float']['output'];
  confusion: ConfusionMatrix;
  perPrompt: Array<PromptMetrics>;
  sensitivity: Scalars['Float']['output'];
  specificity: Scalars['Float']['output'];
};

export type ClinicalReviewOrderDetail = {
  __typename?: 'ClinicalReviewOrderDetail';
  documentSources: Array<DocumentSourceInfo>;
  humanOnlyFields: Array<HumanField>;
  humanValid?: Maybe<Scalars['Boolean']['output']>;
  llmValid: Scalars['Boolean']['output'];
  model: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  pipelineVersion: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['String']['output']>;
  prompts: Array<PromptDetail>;
};

export type ClinicalReviewOrderSummary = {
  __typename?: 'ClinicalReviewOrderSummary';
  agrees: Scalars['Boolean']['output'];
  hasBenchmark: Scalars['Boolean']['output'];
  humanValid?: Maybe<Scalars['Boolean']['output']>;
  isFn: Scalars['Boolean']['output'];
  isFp: Scalars['Boolean']['output'];
  llmValid: Scalars['Boolean']['output'];
  orderNumber: Scalars['String']['output'];
  pipelineVersion: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['String']['output']>;
  promptBadges: Array<PromptBadge>;
  reviewedAt?: Maybe<Scalars['String']['output']>;
};

export type ClinicalReviewSettingsInput = {
  allowedAmountThreshold?: InputMaybe<Scalars['Float']['input']>;
  cogsThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type ClinicalReviewSettingsSchema = {
  __typename?: 'ClinicalReviewSettingsSchema';
  allowedAmountThreshold: Scalars['Float']['output'];
  cogsThreshold: Scalars['Float']['output'];
  usesAllowedAmount: Scalars['Boolean']['output'];
};

export type ClinicianUser = {
  __typename?: 'ClinicianUser';
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ColocatedLineItemInput = {
  dressingCategory?: InputMaybe<Scalars['String']['input']>;
  formItemId: Scalars['Int']['input'];
  isBordered?: InputMaybe<Scalars['Boolean']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  sizeId?: InputMaybe<Scalars['Int']['input']>;
  sizeName?: InputMaybe<Scalars['String']['input']>;
  wounds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CommsGateNodeInfo = {
  __typename?: 'CommsGateNodeInfo';
  blockers: Array<DagTaskType>;
  id: Scalars['Int']['output'];
  status: DagNodeStatus;
};

export type CompressionColor = {
  __typename?: 'CompressionColor';
  hex?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  subCategories: Array<ProductSubCategory>;
};

export type CompressionDiagnosis = {
  __typename?: 'CompressionDiagnosis';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  diagnosis?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompressionDiagnosisInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  diagnosis: Scalars['String']['input'];
};

export enum CompressionItemSide {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type CompressionLineItem = {
  __typename?: 'CompressionLineItem';
  colorId?: Maybe<Scalars['Int']['output']>;
  colorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  formItemId?: Maybe<Scalars['Int']['output']>;
  formItemOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  formItemOptionNames?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  side?: Maybe<CompressionItemSide>;
  subCategory?: Maybe<ProductSubCategory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CompressionLineItemInput = {
  colorId?: InputMaybe<Scalars['Int']['input']>;
  formItemId?: InputMaybe<Scalars['Int']['input']>;
  formItemOptionIds: Array<Scalars['Int']['input']>;
  isCustomItem?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemId?: InputMaybe<Scalars['String']['input']>;
  productName: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  side?: InputMaybe<CompressionItemSide>;
  subCategory?: InputMaybe<ProductSubCategory>;
};

export type CompressionOrder = {
  __typename?: 'CompressionOrder';
  compressionLineItems: Array<CompressionLineItem>;
  compressionPlanOfCare?: Maybe<CompressionPlanOfCare>;
  diagnoses: Array<CompressionDiagnosis>;
};

export type CompressionOrderInput = {
  compressionLineItems: Array<CompressionLineItemInput>;
  compressionPlanOfCare?: InputMaybe<CompressionPlanOfCareInput>;
  diagnoses: Array<CompressionDiagnosisInput>;
};

export type CompressionPlanOfCare = {
  __typename?: 'CompressionPlanOfCare';
  armLeftLength?: Maybe<Scalars['String']['output']>;
  armRightLength?: Maybe<Scalars['String']['output']>;
  compressionBraBandSize?: Maybe<Scalars['String']['output']>;
  compressionLevelSleeve?: Maybe<Scalars['String']['output']>;
  compressionLevelWrapStocking?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  leftAnkle?: Maybe<Scalars['String']['output']>;
  leftCalf?: Maybe<Scalars['String']['output']>;
  leftElbow?: Maybe<Scalars['String']['output']>;
  leftFootCircumference?: Maybe<Scalars['String']['output']>;
  leftFootLength?: Maybe<Scalars['String']['output']>;
  leftFootShoeSize?: Maybe<Scalars['String']['output']>;
  leftHand?: Maybe<Scalars['String']['output']>;
  leftUpperArm?: Maybe<Scalars['String']['output']>;
  leftWrist1?: Maybe<Scalars['String']['output']>;
  leftWrist2?: Maybe<Scalars['String']['output']>;
  legLeftLength?: Maybe<Scalars['String']['output']>;
  legRightLength?: Maybe<Scalars['String']['output']>;
  rightAnkle?: Maybe<Scalars['String']['output']>;
  rightCalf?: Maybe<Scalars['String']['output']>;
  rightElbow?: Maybe<Scalars['String']['output']>;
  rightFootCircumference?: Maybe<Scalars['String']['output']>;
  rightFootLength?: Maybe<Scalars['String']['output']>;
  rightFootShoeSize?: Maybe<Scalars['String']['output']>;
  rightHand?: Maybe<Scalars['String']['output']>;
  rightUpperArm?: Maybe<Scalars['String']['output']>;
  rightWrist1?: Maybe<Scalars['String']['output']>;
  rightWrist2?: Maybe<Scalars['String']['output']>;
  thighLeftLength?: Maybe<Scalars['String']['output']>;
  thighRightLength?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CompressionPlanOfCareInput = {
  armLeftLength?: InputMaybe<Scalars['String']['input']>;
  armRightLength?: InputMaybe<Scalars['String']['input']>;
  compressionBraBandSize?: InputMaybe<Scalars['String']['input']>;
  compressionLevelSleeve?: InputMaybe<Scalars['String']['input']>;
  compressionLevelWrapStocking?: InputMaybe<Scalars['String']['input']>;
  leftAnkle?: InputMaybe<Scalars['String']['input']>;
  leftCalf?: InputMaybe<Scalars['String']['input']>;
  leftElbow?: InputMaybe<Scalars['String']['input']>;
  leftFootCircumference?: InputMaybe<Scalars['String']['input']>;
  leftFootLength?: InputMaybe<Scalars['String']['input']>;
  leftFootShoeSize?: InputMaybe<Scalars['String']['input']>;
  leftHand?: InputMaybe<Scalars['String']['input']>;
  leftUpperArm?: InputMaybe<Scalars['String']['input']>;
  leftWrist1?: InputMaybe<Scalars['String']['input']>;
  leftWrist2?: InputMaybe<Scalars['String']['input']>;
  legLeftLength?: InputMaybe<Scalars['String']['input']>;
  legRightLength?: InputMaybe<Scalars['String']['input']>;
  rightAnkle?: InputMaybe<Scalars['String']['input']>;
  rightCalf?: InputMaybe<Scalars['String']['input']>;
  rightElbow?: InputMaybe<Scalars['String']['input']>;
  rightFootCircumference?: InputMaybe<Scalars['String']['input']>;
  rightFootLength?: InputMaybe<Scalars['String']['input']>;
  rightFootShoeSize?: InputMaybe<Scalars['String']['input']>;
  rightHand?: InputMaybe<Scalars['String']['input']>;
  rightUpperArm?: InputMaybe<Scalars['String']['input']>;
  rightWrist1?: InputMaybe<Scalars['String']['input']>;
  rightWrist2?: InputMaybe<Scalars['String']['input']>;
  thighLeftLength?: InputMaybe<Scalars['String']['input']>;
  thighRightLength?: InputMaybe<Scalars['String']['input']>;
};

export type CompressionStandardItems = {
  __typename?: 'CompressionStandardItems';
  armSleeveStandardItems?: Maybe<Array<FormOptionItem>>;
  braStandardItems?: Maybe<Array<FormOptionItem>>;
  stockingStandardItems?: Maybe<Array<FormOptionItem>>;
  wrapStandardItems?: Maybe<Array<FormOptionItem>>;
};

export type ConfusionMatrix = {
  __typename?: 'ConfusionMatrix';
  fn: Scalars['Int']['output'];
  fp: Scalars['Int']['output'];
  tn: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  tp: Scalars['Int']['output'];
};

export type ContactFormInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  practice?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type CoordinatedFulfillmentSegmentStatus = {
  __typename?: 'CoordinatedFulfillmentSegmentStatus';
  categoryDisplayNames: Array<Scalars['String']['output']>;
  segmentId: Scalars['Int']['output'];
  status: CoordinatedFulfillmentStatus;
};

export enum CoordinatedFulfillmentStatus {
  Canceled = 'CANCELED',
  ContactingPatientForCopayDelivery = 'CONTACTING_PATIENT_FOR_COPAY_DELIVERY',
  ContactingPatientToConfirmOrder = 'CONTACTING_PATIENT_TO_CONFIRM_ORDER',
  Delivered = 'DELIVERED',
  HeldForAdditionalDocumentation = 'HELD_FOR_ADDITIONAL_DOCUMENTATION',
  OrderOnHold = 'ORDER_ON_HOLD',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  PostDeliveryIssue = 'POST_DELIVERY_ISSUE',
  Processing = 'PROCESSING',
  RequestingPar = 'REQUESTING_PAR',
  ReviewingDocumentation = 'REVIEWING_DOCUMENTATION',
  ScheduledForDelivery = 'SCHEDULED_FOR_DELIVERY',
  Todo = 'TODO',
  UnableToReachPatient = 'UNABLE_TO_REACH_PATIENT',
  VerifyingEligibility = 'VERIFYING_ELIGIBILITY',
  WaitingForClinicResponse = 'WAITING_FOR_CLINIC_RESPONSE',
  WaitingToReceiveItemInStock = 'WAITING_TO_RECEIVE_ITEM_IN_STOCK'
}

export type CoverageDetail = {
  __typename?: 'CoverageDetail';
  details?: Maybe<Array<Scalars['String']['output']>>;
  heading: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CoverageSchedule = {
  __typename?: 'CoverageSchedule';
  absentName: Scalars['String']['output'];
  absentOpsUserId: Scalars['Int']['output'];
  coveringName: Scalars['String']['output'];
  coveringOpsUserId: Scalars['Int']['output'];
  daysOfWeek?: Maybe<Array<Scalars['Int']['output']>>;
  firstDay: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  lastDay?: Maybe<Scalars['Date']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status: CoverageScheduleStatus;
};

export enum CoverageScheduleStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Ended = 'ENDED',
  Upcoming = 'UPCOMING'
}

export type CpapDiagnosis = {
  __typename?: 'CpapDiagnosis';
  diagnosis?: Maybe<Scalars['String']['output']>;
  icd10Code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type CpapDiagnosisInput = {
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  icd10Code?: InputMaybe<Scalars['String']['input']>;
};

export type CpapLineItem = {
  __typename?: 'CpapLineItem';
  createdAt: Scalars['DateTime']['output'];
  formItemId?: Maybe<Scalars['Int']['output']>;
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CpapLineItemInput = {
  formItemId?: InputMaybe<Scalars['Int']['input']>;
  productName: Scalars['String']['input'];
};

export type CpapOrder = {
  __typename?: 'CpapOrder';
  ahiRdiQualifyingOption?: Maybe<Scalars['String']['output']>;
  ahiRdiSymptoms?: Maybe<Array<Scalars['String']['output']>>;
  autoBilevelMaxIpap?: Maybe<Scalars['String']['output']>;
  autoBilevelMinEpap?: Maybe<Scalars['String']['output']>;
  autoBilevelPressureSupport?: Maybe<Scalars['String']['output']>;
  autoCpapExpiratoryRelief?: Maybe<Scalars['String']['output']>;
  autoCpapPressureMax?: Maybe<Scalars['String']['output']>;
  autoCpapPressureMin?: Maybe<Scalars['String']['output']>;
  autoCpapRampTime?: Maybe<Scalars['String']['output']>;
  autoCpapStartingPressure?: Maybe<Scalars['String']['output']>;
  bilevelBloodGasConfirmed?: Maybe<Scalars['Boolean']['output']>;
  bilevelEpap?: Maybe<Scalars['String']['output']>;
  bilevelIpap?: Maybe<Scalars['String']['output']>;
  bilevelOximetryConfirmed?: Maybe<Scalars['Boolean']['output']>;
  bilevelQualifyingStatement?: Maybe<Scalars['String']['output']>;
  bilevelTestsPerformed?: Maybe<Array<Scalars['String']['output']>>;
  bipapStBackupRate?: Maybe<Scalars['String']['output']>;
  bipapStMaxIpap?: Maybe<Scalars['String']['output']>;
  bipapStMinEpap?: Maybe<Scalars['String']['output']>;
  bipapStPressureSupportMax?: Maybe<Scalars['String']['output']>;
  bipapStPressureSupportMin?: Maybe<Scalars['String']['output']>;
  bipapStRampTime?: Maybe<Scalars['String']['output']>;
  cpapDiagnoses: Array<CpapDiagnosis>;
  cpapLineItems: Array<CpapLineItem>;
  cpapPressure?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  existingSizeAndModel?: Maybe<Scalars['String']['output']>;
  followUpEncounterDate?: Maybe<Scalars['String']['output']>;
  hadBilevelLast5Years?: Maybe<Scalars['Boolean']['output']>;
  hadCpapLast5Years?: Maybe<Scalars['Boolean']['output']>;
  humidifierType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialConsultDate?: Maybe<Scalars['String']['output']>;
  lengthOfNeedMonths?: Maybe<Scalars['Int']['output']>;
  lengthOfNeedType?: Maybe<Scalars['String']['output']>;
  machineType?: Maybe<Scalars['String']['output']>;
  makeAndModel?: Maybe<Scalars['String']['output']>;
  maskType?: Maybe<Scalars['String']['output']>;
  noSleepApneaEvidence?: Maybe<Scalars['String']['output']>;
  nocturnalOxygen?: Maybe<Scalars['String']['output']>;
  noseLength?: Maybe<Scalars['Float']['output']>;
  noseToChin?: Maybe<Scalars['Float']['output']>;
  noseWidth?: Maybe<Scalars['Float']['output']>;
  priorBilevelReason?: Maybe<Scalars['String']['output']>;
  priorCpapReason?: Maybe<Scalars['String']['output']>;
  sleepStudyDate?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usesOxygen?: Maybe<Scalars['Boolean']['output']>;
};

export type CpapOrderInput = {
  ahiRdiQualifyingOption?: InputMaybe<Scalars['String']['input']>;
  ahiRdiSymptoms?: InputMaybe<Array<Scalars['String']['input']>>;
  autoBilevelMaxIpap?: InputMaybe<Scalars['String']['input']>;
  autoBilevelMinEpap?: InputMaybe<Scalars['String']['input']>;
  autoBilevelPressureSupport?: InputMaybe<Scalars['String']['input']>;
  autoCpapExpiratoryRelief?: InputMaybe<Scalars['String']['input']>;
  autoCpapPressureMax?: InputMaybe<Scalars['String']['input']>;
  autoCpapPressureMin?: InputMaybe<Scalars['String']['input']>;
  autoCpapRampTime?: InputMaybe<Scalars['String']['input']>;
  autoCpapStartingPressure?: InputMaybe<Scalars['String']['input']>;
  bilevelBloodGasConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  bilevelEpap?: InputMaybe<Scalars['String']['input']>;
  bilevelIpap?: InputMaybe<Scalars['String']['input']>;
  bilevelOximetryConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  bilevelQualifyingStatement?: InputMaybe<Scalars['String']['input']>;
  bilevelTestsPerformed?: InputMaybe<Array<Scalars['String']['input']>>;
  bipapStBackupRate?: InputMaybe<Scalars['String']['input']>;
  bipapStMaxIpap?: InputMaybe<Scalars['String']['input']>;
  bipapStMinEpap?: InputMaybe<Scalars['String']['input']>;
  bipapStPressureSupportMax?: InputMaybe<Scalars['String']['input']>;
  bipapStPressureSupportMin?: InputMaybe<Scalars['String']['input']>;
  bipapStRampTime?: InputMaybe<Scalars['String']['input']>;
  cpapDiagnoses?: InputMaybe<Array<CpapDiagnosisInput>>;
  cpapLineItems?: InputMaybe<Array<CpapLineItemInput>>;
  cpapPressure?: InputMaybe<Scalars['String']['input']>;
  existingSizeAndModel?: InputMaybe<Scalars['String']['input']>;
  followUpEncounterDate?: InputMaybe<Scalars['String']['input']>;
  hadBilevelLast5Years?: InputMaybe<Scalars['Boolean']['input']>;
  hadCpapLast5Years?: InputMaybe<Scalars['Boolean']['input']>;
  hasSleepStudyDocument?: InputMaybe<Scalars['Boolean']['input']>;
  humidifierType?: InputMaybe<Scalars['String']['input']>;
  initialConsultDate?: InputMaybe<Scalars['String']['input']>;
  lengthOfNeedMonths?: InputMaybe<Scalars['Int']['input']>;
  lengthOfNeedType?: InputMaybe<Scalars['String']['input']>;
  machineType?: InputMaybe<Scalars['String']['input']>;
  makeAndModel?: InputMaybe<Scalars['String']['input']>;
  maskType?: InputMaybe<Scalars['String']['input']>;
  noSleepApneaEvidence?: InputMaybe<Scalars['String']['input']>;
  nocturnalOxygen?: InputMaybe<Scalars['String']['input']>;
  noseLength?: InputMaybe<Scalars['Float']['input']>;
  noseToChin?: InputMaybe<Scalars['Float']['input']>;
  noseWidth?: InputMaybe<Scalars['Float']['input']>;
  priorBilevelReason?: InputMaybe<Scalars['String']['input']>;
  priorCpapReason?: InputMaybe<Scalars['String']['input']>;
  sleepStudyDate?: InputMaybe<Scalars['String']['input']>;
  sleepStudyDocumentationConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  usesOxygen?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCompressionColorInput = {
  hex?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDistributorProductInput = {
  costPrice?: InputMaybe<Scalars['Float']['input']>;
  distributorId: Scalars['Int']['input'];
  externalManufacturerProductId?: InputMaybe<Scalars['String']['input']>;
  externalProductId?: InputMaybe<Scalars['String']['input']>;
  hcpcsCode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isHazmat?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturerPartNumber?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numInSale?: InputMaybe<Scalars['Int']['input']>;
  packageAmount?: InputMaybe<Scalars['Int']['input']>;
  packageAmountString?: InputMaybe<Scalars['String']['input']>;
  salUnitMsr?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFormItemInput = {
  dressingCategory?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateFormItemSizeInput = {
  display: Scalars['String']['input'];
  formItemId: Scalars['Int']['input'];
  hcpcsCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateHospitalInput = {
  departmentAddress1: Scalars['String']['input'];
  departmentAddress2?: InputMaybe<Scalars['String']['input']>;
  departmentCity: Scalars['String']['input'];
  departmentFaxNumber?: InputMaybe<Scalars['String']['input']>;
  departmentName: Scalars['String']['input'];
  departmentStateAbbr: Scalars['String']['input'];
  departmentTypeId?: InputMaybe<Scalars['Int']['input']>;
  departmentZipcode: Scalars['String']['input'];
  formItemTemplateIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hospitalName: Scalars['String']['input'];
  hospitalPhoneNumber: Scalars['String']['input'];
  isHomeHealth?: InputMaybe<Scalars['Boolean']['input']>;
  medicalRecordsFaxNumber?: InputMaybe<Scalars['String']['input']>;
  salesRepId?: Scalars['Int']['input'];
  sourceId?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  usageType: HospitalUsageType;
};

export type CreateNewHospitalResponse = {
  __typename?: 'CreateNewHospitalResponse';
  departmentId: Scalars['Int']['output'];
  hospitalId: Scalars['Int']['output'];
};

export type CreateOpsUserPositionHistoryInput = {
  effectiveFrom: Scalars['String']['input'];
  opsManagerId: Scalars['Int']['input'];
  opsUserId: Scalars['Int']['input'];
  title: OpsTitle;
};

export type CreateUserResponse = {
  __typename?: 'CreateUserResponse';
  message: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
};

export type CreatedOrderResult = {
  __typename?: 'CreatedOrderResult';
  createdOrderNumber: Scalars['String']['output'];
  sourceOrderNumber: Scalars['String']['output'];
};

export type CustomOrthoticsDiagnosis = {
  __typename?: 'CustomOrthoticsDiagnosis';
  diagnosis?: Maybe<Scalars['String']['output']>;
  icd10Code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  qualifyingGroups: Array<Scalars['Int']['output']>;
};

export type CustomOrthoticsDiagnosisInput = {
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  icd10Code?: InputMaybe<Scalars['String']['input']>;
  qualifyingGroups?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CustomOrthoticsLineItem = {
  __typename?: 'CustomOrthoticsLineItem';
  bodyParts: Array<Scalars['String']['output']>;
  formItemId?: Maybe<Scalars['Int']['output']>;
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isMaximumAllowedQuantity?: Maybe<Scalars['Boolean']['output']>;
  jointType?: Maybe<Scalars['String']['output']>;
  laterality?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  region: Scalars['String']['output'];
  systemKey?: Maybe<Scalars['String']['output']>;
};

export type CustomOrthoticsLineItemInput = {
  bodyParts?: InputMaybe<Array<Scalars['String']['input']>>;
  formItemId?: InputMaybe<Scalars['Int']['input']>;
  isMaximumAllowedQuantity?: InputMaybe<Scalars['Boolean']['input']>;
  jointType?: InputMaybe<Scalars['String']['input']>;
  laterality?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  systemKey?: InputMaybe<Scalars['String']['input']>;
};

export type CustomOrthoticsOrder = {
  __typename?: 'CustomOrthoticsOrder';
  afoCustomFabricationCriteria?: Maybe<Array<Scalars['String']['output']>>;
  customOrthoticsDiagnoses: Array<CustomOrthoticsDiagnosis>;
  customOrthoticsLineItems: Array<CustomOrthoticsLineItem>;
  depthShoeCannotAccommodateDeformity?: Maybe<Scalars['Boolean']['output']>;
  documentsWhyPrefabricatedInsufficient?: Maybe<Scalars['Boolean']['output']>;
  feetSpecifications?: Maybe<Scalars['String']['output']>;
  hasLigamentousInstability?: Maybe<Scalars['Boolean']['output']>;
  hasOaPainOrMobilityLoss?: Maybe<Scalars['Boolean']['output']>;
  hasRecentKneeInjuryOrSurgery?: Maybe<Scalars['Boolean']['output']>;
  headNeckSpineSpecifications?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isAmbulatory?: Maybe<Scalars['Boolean']['output']>;
  isLifetimeLengthOfNeed?: Maybe<Scalars['Boolean']['output']>;
  isWillingToUseKneeOrthosis?: Maybe<Scalars['Boolean']['output']>;
  kneeBracesSpecifications?: Maybe<Scalars['String']['output']>;
  lengthOfNeedInMonths?: Maybe<Scalars['Int']['output']>;
  lowerLimbSpecifications?: Maybe<Scalars['String']['output']>;
  orthosisBenefitsFunctionality?: Maybe<Scalars['Boolean']['output']>;
  orthosisProvidesVarusValgusAdjustment?: Maybe<Scalars['Boolean']['output']>;
  patientAgeYears?: Maybe<Scalars['Int']['output']>;
  patientWeightLbs?: Maybe<Scalars['Int']['output']>;
  preferredDmeCompany?: Maybe<Scalars['String']['output']>;
  requiresAnkleFootStabilization?: Maybe<Scalars['Boolean']['output']>;
  requiresKneeStabilization?: Maybe<Scalars['Boolean']['output']>;
  shoeSize?: Maybe<Scalars['String']['output']>;
  shoeWidth?: Maybe<Scalars['String']['output']>;
  spinalTreatmentGoals?: Maybe<Array<Scalars['String']['output']>>;
  upperLimbSpecifications?: Maybe<Scalars['String']['output']>;
};

export type CustomOrthoticsOrderInput = {
  afoCustomFabricationCriteria?: InputMaybe<Array<Scalars['String']['input']>>;
  customOrthoticsDiagnoses?: InputMaybe<Array<CustomOrthoticsDiagnosisInput>>;
  customOrthoticsLineItems?: InputMaybe<Array<CustomOrthoticsLineItemInput>>;
  depthShoeCannotAccommodateDeformity?: InputMaybe<Scalars['Boolean']['input']>;
  documentsWhyPrefabricatedInsufficient?: InputMaybe<Scalars['Boolean']['input']>;
  feetSpecifications?: InputMaybe<Scalars['String']['input']>;
  hasLigamentousInstability?: InputMaybe<Scalars['Boolean']['input']>;
  hasOaPainOrMobilityLoss?: InputMaybe<Scalars['Boolean']['input']>;
  hasRecentKneeInjuryOrSurgery?: InputMaybe<Scalars['Boolean']['input']>;
  headNeckSpineSpecifications?: InputMaybe<Scalars['String']['input']>;
  isAmbulatory?: InputMaybe<Scalars['Boolean']['input']>;
  isLifetimeLengthOfNeed?: InputMaybe<Scalars['Boolean']['input']>;
  isWillingToUseKneeOrthosis?: InputMaybe<Scalars['Boolean']['input']>;
  kneeBracesSpecifications?: InputMaybe<Scalars['String']['input']>;
  lengthOfNeedInMonths?: InputMaybe<Scalars['Int']['input']>;
  lowerLimbSpecifications?: InputMaybe<Scalars['String']['input']>;
  orthosisBenefitsFunctionality?: InputMaybe<Scalars['Boolean']['input']>;
  orthosisProvidesVarusValgusAdjustment?: InputMaybe<Scalars['Boolean']['input']>;
  patientAgeYears?: InputMaybe<Scalars['Int']['input']>;
  patientWeightLbs?: InputMaybe<Scalars['Int']['input']>;
  preferredDmeCompany?: InputMaybe<Scalars['String']['input']>;
  requiresAnkleFootStabilization?: InputMaybe<Scalars['Boolean']['input']>;
  requiresKneeStabilization?: InputMaybe<Scalars['Boolean']['input']>;
  shoeSize?: InputMaybe<Scalars['String']['input']>;
  shoeWidth?: InputMaybe<Scalars['String']['input']>;
  spinalTreatmentGoals?: InputMaybe<Array<Scalars['String']['input']>>;
  upperLimbSpecifications?: InputMaybe<Scalars['String']['input']>;
};

export type CustomOrthoticsQualifyingDiagnosisCode = {
  __typename?: 'CustomOrthoticsQualifyingDiagnosisCode';
  icd10Code: Scalars['String']['output'];
  qualifyingGroups: Array<Scalars['Int']['output']>;
};

export enum DmePartnerOrderPreference {
  Email = 'EMAIL',
  Fax = 'FAX',
  Portal = 'PORTAL'
}

export enum DagNodeSource {
  Task = 'TASK',
  Template = 'TEMPLATE'
}

export enum DagNodeStatus {
  AwaitingExternal = 'AWAITING_EXTERNAL',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  InProgress = 'IN_PROGRESS',
  Ready = 'READY',
  Scheduled = 'SCHEDULED',
  Skipped = 'SKIPPED',
  Waiting = 'WAITING'
}

export enum DagNodeType {
  AndGate = 'AND_GATE',
  Auxiliary = 'AUXILIARY',
  OrGate = 'OR_GATE',
  Start = 'START',
  Suspension = 'SUSPENSION',
  Task = 'TASK'
}

export enum DagTaskType {
  Approval = 'APPROVAL',
  ClinicalReview = 'CLINICAL_REVIEW',
  CommsReview = 'COMMS_REVIEW',
  EligibilityIssue = 'ELIGIBILITY_ISSUE',
  ECheck = 'E_CHECK',
  GenericHold = 'GENERIC_HOLD',
  OopPayment = 'OOP_PAYMENT',
  OrderNoteResponse = 'ORDER_NOTE_RESPONSE',
  PatientResponsibility = 'PATIENT_RESPONSIBILITY',
  Placement = 'PLACEMENT',
  PmnReview = 'PMN_REVIEW',
  PotentialLiabilityAcknowledgement = 'POTENTIAL_LIABILITY_ACKNOWLEDGEMENT',
  PoBoxBlock = 'PO_BOX_BLOCK',
  Prep = 'PREP',
  Transcription = 'TRANSCRIPTION',
  VendorOrderValidationApproval = 'VENDOR_ORDER_VALIDATION_APPROVAL',
  WoundMatching = 'WOUND_MATCHING'
}

export enum DagWaitingOn {
  Clinic = 'CLINIC',
  ClinicalReview = 'CLINICAL_REVIEW',
  Ops = 'OPS',
  Patient = 'PATIENT',
  System = 'SYSTEM',
  Upstream = 'UPSTREAM'
}

export type DeleteOrderFaxInput = {
  orderFaxId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
};

export type DeleteS3DocumentInput = {
  orderNumber: Scalars['String']['input'];
  s3DocumentId: Scalars['Int']['input'];
};

export type DeletedClinicEnteredLineItem = {
  __typename?: 'DeletedClinicEnteredLineItem';
  deletedAt: Scalars['DateTime']['output'];
  deletedBy?: Maybe<OpsUser>;
  enteredProductName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  orderSegmentId: Scalars['Int']['output'];
};

export type DeletedOrderDocument = {
  __typename?: 'DeletedOrderDocument';
  deletedAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  orderDocumentId: Scalars['Int']['output'];
  s3DocumentId: Scalars['Int']['output'];
  s3Key: Scalars['String']['output'];
};

export type DeletedOrderFax = {
  __typename?: 'DeletedOrderFax';
  deletedAt: Scalars['DateTime']['output'];
  filename: Scalars['String']['output'];
  orderFaxId: Scalars['Int']['output'];
};

export type DeliveryAttestableItem = {
  __typename?: 'DeliveryAttestableItem';
  hcpcsCandidates: Array<Scalars['String']['output']>;
  lockedQuantity?: Maybe<Scalars['Int']['output']>;
  orderSegmentLineItemId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  size?: Maybe<Scalars['String']['output']>;
};

export type DeliveryAttestationItemInput = {
  deliveryDate: Scalars['Date']['input'];
  hcpcs: Scalars['String']['input'];
  orderSegmentLineItemId: Scalars['Int']['input'];
  proofOfDelivery: Scalars['Upload']['input'];
  quantity: Scalars['Int']['input'];
};

export enum DeliveryLocationType {
  Clinic = 'CLINIC',
  Patient = 'PATIENT'
}

export type Department = {
  __typename?: 'Department';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  aiExtractionEnabled?: Maybe<Scalars['Boolean']['output']>;
  allowSignersWithoutFaxNumbers?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cpapFormEnabled?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  departmentProfileId?: Maybe<Scalars['Int']['output']>;
  faxNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  faxNumbers?: Maybe<Array<DepartmentFaxNumber>>;
  hospitalId: Scalars['Int']['output'];
  hospitalName: Scalars['String']['output'];
  hospitalPhoneNumber?: Maybe<Scalars['String']['output']>;
  hospitalSystem?: Maybe<HospitalSystem>;
  hospitalTimezone?: Maybe<Scalars['String']['output']>;
  hospitalUsageType: HospitalUsageType;
  id: Scalars['Int']['output'];
  isHomeHealth?: Maybe<Scalars['Boolean']['output']>;
  isPriorityClinic?: Maybe<Scalars['Boolean']['output']>;
  isRisk?: Maybe<Scalars['Boolean']['output']>;
  isStrategicAccount?: Maybe<Scalars['Boolean']['output']>;
  isZingPreferred?: Maybe<Scalars['Boolean']['output']>;
  miscellaneousFormEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  orderVolumeRank?: Maybe<Scalars['Int']['output']>;
  ostomyFormEnabled?: Maybe<Scalars['Boolean']['output']>;
  sourceType?: Maybe<DepartmentSourceType>;
  stateAbbr?: Maybe<Scalars['String']['output']>;
  strategicClassification?: Maybe<Scalars['String']['output']>;
  typeId: Scalars['Int']['output'];
  typeName?: Maybe<DepartmentType>;
  urologyFormEnabled?: Maybe<Scalars['Boolean']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type DepartmentCategories = {
  __typename?: 'DepartmentCategories';
  categories: Array<Category>;
};

export type DepartmentDesignation = {
  __typename?: 'DepartmentDesignation';
  hospitalName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isPriorityClinic?: Maybe<Scalars['Boolean']['output']>;
  isStrategicAccount?: Maybe<Scalars['Boolean']['output']>;
  isZingPreferred?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type DepartmentFaxNumber = {
  __typename?: 'DepartmentFaxNumber';
  departmentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  number: Scalars['String']['output'];
  primary: Scalars['Boolean']['output'];
};

export type DepartmentFaxNumberInput = {
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  departmentId: Scalars['Int']['input'];
  faxNumber: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  primary: Scalars['Boolean']['input'];
};

export type DepartmentFormItem = {
  __typename?: 'DepartmentFormItem';
  departmentId: Scalars['Int']['output'];
  formItem: FormItem;
  id: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  userCreated: Scalars['Boolean']['output'];
};

export type DepartmentFormItemSubstitution = {
  __typename?: 'DepartmentFormItemSubstitution';
  departmentId: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  fromFormItem: Scalars['String']['output'];
  toFormItem: Scalars['String']['output'];
};

export enum DepartmentOrderPreferenceOption {
  BrandOosAskEveryTime = 'BRAND_OOS__ASK_EVERY_TIME',
  BrandOosSendSubstitute = 'BRAND_OOS__SEND_SUBSTITUTE',
  CollectPtPnMethodBoth = 'COLLECT_PT_PN_METHOD__BOTH',
  CollectPtPnMethodEmail = 'COLLECT_PT_PN_METHOD__EMAIL',
  CollectPtPnMethodFax = 'COLLECT_PT_PN_METHOD__FAX',
  CollectPtPnReachOutToMe = 'COLLECT_PT_PN__REACH_OUT_TO_ME',
  CollectPtPnReachOutToMedDept = 'COLLECT_PT_PN__REACH_OUT_TO_MED_DEPT',
  CollectPtPnReachOutToProvider = 'COLLECT_PT_PN__REACH_OUT_TO_PROVIDER',
  FaxMedicareNotCoveredReachOutToPatient = 'FAX_MEDICARE_NOT_COVERED__REACH_OUT_TO_PATIENT',
  FaxMedicareNotCoveredSendOnlyCovered = 'FAX_MEDICARE_NOT_COVERED__SEND_ONLY_COVERED',
  FaxSubsPreApprove = 'FAX_SUBS__PRE_APPROVE',
  FaxSubsReachOutToPatient = 'FAX_SUBS__REACH_OUT_TO_PATIENT',
  FaxSubsRemovedItem = 'FAX_SUBS__REMOVED_ITEM',
  FaxTimingEod = 'FAX_TIMING__EOD',
  FaxTimingEow = 'FAX_TIMING__EOW',
  FaxTimingEoFourthWeek = 'FAX_TIMING__EO_FOURTH_WEEK',
  FaxTimingImmediate = 'FAX_TIMING__IMMEDIATE',
  FocAskEveryTime = 'FOC__ASK_EVERY_TIME',
  FocReachOutToPatient = 'FOC__REACH_OUT_TO_PATIENT',
  FocSendMaxCovered = 'FOC__SEND_MAX_COVERED',
  NonCoveredAskEveryTime = 'NON_COVERED__ASK_EVERY_TIME',
  NonCoveredLetUsKnow = 'NON_COVERED__LET_US_KNOW',
  NonCoveredReachOutToPatient = 'NON_COVERED__REACH_OUT_TO_PATIENT',
  NotYetEligibleAskEveryTime = 'NOT_YET_ELIGIBLE__ASK_EVERY_TIME',
  NotYetEligibleReachOutToPatient = 'NOT_YET_ELIGIBLE__REACH_OUT_TO_PATIENT',
  NotYetEligibleWaitUntilEligible = 'NOT_YET_ELIGIBLE__WAIT_UNTIL_ELIGIBLE',
  PatientAutoSmsDisabled = 'PATIENT_AUTO_SMS__DISABLED',
  PatientAutoSmsEnabled = 'PATIENT_AUTO_SMS__ENABLED',
  PnTimingEod = 'PN_TIMING__EOD',
  PnTimingEow = 'PN_TIMING__EOW',
  PnTimingEoFourthWeek = 'PN_TIMING__EO_FOURTH_WEEK',
  PnTimingImmediate = 'PN_TIMING__IMMEDIATE',
  SchedulingVisit = 'SCHEDULING_VISIT',
  SignatureRequestsMethodBoth = 'SIGNATURE_REQUESTS_METHOD__BOTH',
  SignatureRequestsMethodEmail = 'SIGNATURE_REQUESTS_METHOD__EMAIL',
  SignatureRequestsMethodFax = 'SIGNATURE_REQUESTS_METHOD__FAX',
  SignatureRequestsRecipientClinicFaxNumber = 'SIGNATURE_REQUESTS_RECIPIENT__CLINIC_FAX_NUMBER',
  SignatureRequestsRecipientSigningProvider = 'SIGNATURE_REQUESTS_RECIPIENT__SIGNING_PROVIDER',
  SignatureRequestsTimingEod = 'SIGNATURE_REQUESTS_TIMING__EOD',
  SignatureRequestsTimingEow = 'SIGNATURE_REQUESTS_TIMING__EOW',
  SignatureRequestsTimingMonday = 'SIGNATURE_REQUESTS_TIMING__MONDAY',
  SignatureRequestsTimingThursday = 'SIGNATURE_REQUESTS_TIMING__THURSDAY',
  SignatureRequestsTimingTuesday = 'SIGNATURE_REQUESTS_TIMING__TUESDAY',
  SignatureRequestsTimingWednesday = 'SIGNATURE_REQUESTS_TIMING__WEDNESDAY',
  SizeTooLargeAskEveryTime = 'SIZE_TOO_LARGE__ASK_EVERY_TIME',
  SizeTooLargeReachOutToPatient = 'SIZE_TOO_LARGE__REACH_OUT_TO_PATIENT',
  SizeTooLargeSendCoveredSize = 'SIZE_TOO_LARGE__SEND_COVERED_SIZE',
  SubAskEveryTime = 'SUB__ASK_EVERY_TIME',
  SubPreApprove = 'SUB__PRE_APPROVE',
  SubReachOutToPatient = 'SUB__REACH_OUT_TO_PATIENT',
  SubRemovedItem = 'SUB__REMOVED_ITEM',
  VisitScheduled = 'VISIT_SCHEDULED'
}

export type DepartmentOrderPreferences = {
  __typename?: 'DepartmentOrderPreferences';
  optionRef?: Maybe<Scalars['String']['output']>;
  question: OrderPreferencesQuestion;
  responseId?: Maybe<Scalars['Int']['output']>;
};

export enum DepartmentOrderRemarkType {
  AwaitingEligibility = 'AWAITING_ELIGIBILITY',
  AwaitingPatientResponse = 'AWAITING_PATIENT_RESPONSE',
  AwaitingSignerResponse = 'AWAITING_SIGNER_RESPONSE',
  DepartmentOrderHold = 'DEPARTMENT_ORDER_HOLD',
  DocumentRequested = 'DOCUMENT_REQUESTED',
  DocumentUpdateRequested = 'DOCUMENT_UPDATE_REQUESTED',
  MedicareAdvantagePotentialLiabilityNoticeDeclined = 'MEDICARE_ADVANTAGE_POTENTIAL_LIABILITY_NOTICE_DECLINED',
  NeedsYourResponse = 'NEEDS_YOUR_RESPONSE',
  NpiOrderHold = 'NPI_ORDER_HOLD',
  OnHold = 'ON_HOLD',
  PatientDidNotRespondToOopRequest = 'PATIENT_DID_NOT_RESPOND_TO_OOP_REQUEST',
  PatientDidNotRespondToPatientResponsibilityRequest = 'PATIENT_DID_NOT_RESPOND_TO_PATIENT_RESPONSIBILITY_REQUEST',
  PatientRejectedPatientResponsibility = 'PATIENT_REJECTED_PATIENT_RESPONSIBILITY',
  PatientResponsibilityRequested = 'PATIENT_RESPONSIBILITY_REQUESTED',
  PotentialLiabilityAcknowledgementDeclined = 'POTENTIAL_LIABILITY_ACKNOWLEDGEMENT_DECLINED',
  PotentialLiabilityAcknowledgementRequested = 'POTENTIAL_LIABILITY_ACKNOWLEDGEMENT_REQUESTED',
  ProviderSignatureHold = 'PROVIDER_SIGNATURE_HOLD',
  SchedulingVisit = 'SCHEDULING_VISIT',
  SynapseApproved = 'SYNAPSE_APPROVED',
  SynapseAwaitingSubmission = 'SYNAPSE_AWAITING_SUBMISSION',
  SynapseMissingDocumentation = 'SYNAPSE_MISSING_DOCUMENTATION',
  SynapseSubmitted = 'SYNAPSE_SUBMITTED',
  Unsigned = 'UNSIGNED',
  VisitScheduled = 'VISIT_SCHEDULED'
}

export type DepartmentPreference = {
  __typename?: 'DepartmentPreference';
  departmentId: Scalars['Int']['output'];
  optionId: Scalars['Int']['output'];
  optionTitle: Scalars['String']['output'];
  questionId: Scalars['Int']['output'];
  questionTitle: Scalars['String']['output'];
};

export type DepartmentProducts = {
  __typename?: 'DepartmentProducts';
  compressionStandardItems: CompressionStandardItems;
  cpapStandardItems: Array<FormOptionItem>;
  customOrthoticsStandardItems: Array<FormOptionItem>;
  diabetesStandardItems: Array<FormOptionItem>;
  nebulizerStandardItems: Array<FormOptionItem>;
  offTheShelfOrthoticsStandardItems: Array<FormOptionItem>;
  ostomyStandardItems: Array<FormOptionItem>;
  prostheticsStandardItems: Array<FormOptionItem>;
  urologyStandardItems: Array<FormOptionItem>;
  ventilatorStandardItems: Array<FormOptionItem>;
  wheelchairsAndScootersStandardItems: Array<FormOptionItem>;
  woundCareStandardItems: Array<FormOptionItem>;
  woundSuctionStandardItems: Array<FormOptionItem>;
};

export type DepartmentProfileInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  aiExtractionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cpapFormEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  departmentProfileId?: InputMaybe<Scalars['Int']['input']>;
  faxNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  formItemTemplateIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hospitalId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isPriorityClinic?: InputMaybe<Scalars['Boolean']['input']>;
  isStrategicAccount?: InputMaybe<Scalars['Boolean']['input']>;
  isZingPreferred?: InputMaybe<Scalars['Boolean']['input']>;
  miscellaneousFormEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  ostomyFormEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  stateAbbr?: InputMaybe<Scalars['String']['input']>;
  strategicClassification?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
  urologyFormEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type DepartmentProfileOption = {
  __typename?: 'DepartmentProfileOption';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type DepartmentSearchResult = {
  __typename?: 'DepartmentSearchResult';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  hospitalName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  stateAbbr?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type DepartmentSearchResults = {
  __typename?: 'DepartmentSearchResults';
  departments: Array<DepartmentSearchResult>;
  hasMore: Scalars['Boolean']['output'];
};

export enum DepartmentSourceType {
  Insurecare = 'INSURECARE'
}

export enum DepartmentType {
  BurnCenter = 'BURN_CENTER',
  CancerCenter = 'CANCER_CENTER',
  CaseManagement = 'CASE_MANAGEMENT',
  Dermatology = 'DERMATOLOGY',
  DmePartner = 'DME_PARTNER',
  Endocrinology = 'ENDOCRINOLOGY',
  Enterprise = 'ENTERPRISE',
  GeneralSurgery = 'GENERAL_SURGERY',
  HomeHealthAgency = 'HOME_HEALTH_AGENCY',
  InfectiousDisease = 'INFECTIOUS_DISEASE',
  Lymphedema = 'LYMPHEDEMA',
  Ostomy = 'OSTOMY',
  Other = 'OTHER',
  PhysicalTherapy = 'PHYSICAL_THERAPY',
  PlasticSurgery = 'PLASTIC_SURGERY',
  Podiatry = 'PODIATRY',
  PrimaryCarePcp = 'PRIMARY_CARE_PCP',
  Rehab = 'REHAB',
  SpecialtyClinic = 'SPECIALTY_CLINIC',
  SurgicalCenter = 'SURGICAL_CENTER',
  Telehealth = 'TELEHEALTH',
  Urology = 'UROLOGY',
  VascularSurgeryCenter = 'VASCULAR_SURGERY_CENTER',
  VeinClinic = 'VEIN_CLINIC',
  WoundCare = 'WOUND_CARE'
}

export type DevMockOptions = {
  patientResponsibility?: InputMaybe<PatientResponsibilityMockOptions>;
};

export type DevMockSetupResult = {
  __typename?: 'DevMockSetupResult';
  message: Scalars['String']['output'];
  mockType: DevMockType;
  orderSegmentId: Scalars['Int']['output'];
};

export enum DevMockType {
  PatientResponsibility = 'PATIENT_RESPONSIBILITY'
}

export enum DiabetesBgmSystem {
  AccuChekGuide = 'ACCU_CHEK_GUIDE',
  FreestyleLite = 'FREESTYLE_LITE',
  OnetouchVerioFlex = 'ONETOUCH_VERIO_FLEX',
  TrueMetrixPro = 'TRUE_METRIX_PRO'
}

export enum DiabetesCgmSensorType {
  FifteenDay = 'FIFTEEN_DAY',
  TenDay = 'TEN_DAY'
}

export enum DiabetesCgmSystem {
  DexcomG7 = 'DEXCOM_G7',
  FreestyleLibre_3 = 'FREESTYLE_LIBRE_3'
}

export type DiabetesDiagnosis = {
  __typename?: 'DiabetesDiagnosis';
  diagnosis?: Maybe<Scalars['String']['output']>;
  icd10Code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  qualifyingGroups: Array<Scalars['Int']['output']>;
};

export type DiabetesDiagnosisInput = {
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  icd10Code?: InputMaybe<Scalars['String']['input']>;
  qualifyingGroups?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum DiabetesHypoglycemicEvent {
  Level_2Recurrent = 'LEVEL_2_RECURRENT',
  Level_3History = 'LEVEL_3_HISTORY',
  None = 'NONE'
}

export enum DiabetesInsulinTreatmentType {
  InsulinPump = 'INSULIN_PUMP',
  MultipleDailyInjections = 'MULTIPLE_DAILY_INJECTIONS',
  Other = 'OTHER'
}

export type DiabetesLineItem = {
  __typename?: 'DiabetesLineItem';
  formItemId?: Maybe<Scalars['Int']['output']>;
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  section?: Maybe<DiabetesLineItemSection>;
  size?: Maybe<Scalars['String']['output']>;
  sizeId?: Maybe<Scalars['Int']['output']>;
};

export type DiabetesLineItemInput = {
  formItemId?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<DiabetesLineItemSection>;
  size?: InputMaybe<Scalars['String']['input']>;
  sizeId?: InputMaybe<Scalars['Int']['input']>;
};

export enum DiabetesLineItemSection {
  Bgm = 'BGM',
  Cgm = 'CGM',
  Other = 'OTHER',
  Pump = 'PUMP'
}

export enum DiabetesMdiQualifyingCondition {
  DawnPhenomenon = 'DAWN_PHENOMENON',
  Hba1CAbove_7 = 'HBA1C_ABOVE_7',
  None = 'NONE',
  RecurringHypoglycemia = 'RECURRING_HYPOGLYCEMIA',
  SevereGlycemicExcursions = 'SEVERE_GLYCEMIC_EXCURSIONS',
  WideFluctuationsBeforeMealtime = 'WIDE_FLUCTUATIONS_BEFORE_MEALTIME'
}

export type DiabetesOrder = {
  __typename?: 'DiabetesOrder';
  bgmIsInitialOrder?: Maybe<Scalars['Boolean']['output']>;
  bgmSystem?: Maybe<DiabetesBgmSystem>;
  cPeptideLabLowerLimitNgMl?: Maybe<Scalars['Float']['output']>;
  cPeptideNgMl?: Maybe<Scalars['Float']['output']>;
  cgmDocumentationOnFile?: Maybe<Scalars['Boolean']['output']>;
  cgmIsInitialOrder?: Maybe<Scalars['Boolean']['output']>;
  cgmSensorType?: Maybe<DiabetesCgmSensorType>;
  cgmSystem?: Maybe<DiabetesCgmSystem>;
  completedDiabetesEducationProgram?: Maybe<Scalars['Boolean']['output']>;
  currentlyOnCgmTherapy?: Maybe<Scalars['Boolean']['output']>;
  diabetesDiagnoses: Array<DiabetesDiagnosis>;
  diabetesLineItems: Array<DiabetesLineItem>;
  fastingBloodSugarMgDl?: Maybe<Scalars['Float']['output']>;
  glucoseTestsPerDayBeforeMedicare?: Maybe<Scalars['Int']['output']>;
  glucoseTestsPerDayPrior2Months?: Maybe<Scalars['Int']['output']>;
  hasRenalInsufficiency?: Maybe<Scalars['Boolean']['output']>;
  hypoglycemicEventHistory?: Maybe<Array<DiabetesHypoglycemicEvent>>;
  id?: Maybe<Scalars['ID']['output']>;
  insulinTreatmentType?: Maybe<DiabetesInsulinTreatmentType>;
  isLifetimeLengthOfNeed?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedInMonths?: Maybe<Scalars['Int']['output']>;
  mdiInjectionsPerDay?: Maybe<Scalars['Int']['output']>;
  mdiQualifyingConditions?: Maybe<Array<DiabetesMdiQualifyingCondition>>;
  onMdiWithSelfAdjustments6Months?: Maybe<Scalars['Boolean']['output']>;
  positiveBetaCellAutoantibody?: Maybe<Scalars['Boolean']['output']>;
  preferredDmeCompany?: Maybe<Scalars['String']['output']>;
  pumpIsInitialOrder?: Maybe<Scalars['Boolean']['output']>;
  pumpSystem?: Maybe<DiabetesPumpSystem>;
  smbgTestsPerDay?: Maybe<Scalars['Int']['output']>;
  treatedWithInsulin?: Maybe<Scalars['Boolean']['output']>;
  usedPumpBeforeMedicare?: Maybe<Scalars['Boolean']['output']>;
};

export type DiabetesOrderInput = {
  bgmIsInitialOrder?: InputMaybe<Scalars['Boolean']['input']>;
  bgmSystem?: InputMaybe<DiabetesBgmSystem>;
  cPeptideLabLowerLimitNgMl?: InputMaybe<Scalars['Float']['input']>;
  cPeptideNgMl?: InputMaybe<Scalars['Float']['input']>;
  cgmDocumentationOnFile?: InputMaybe<Scalars['Boolean']['input']>;
  cgmIsInitialOrder?: InputMaybe<Scalars['Boolean']['input']>;
  cgmSensorType?: InputMaybe<DiabetesCgmSensorType>;
  cgmSystem?: InputMaybe<DiabetesCgmSystem>;
  completedDiabetesEducationProgram?: InputMaybe<Scalars['Boolean']['input']>;
  currentlyOnCgmTherapy?: InputMaybe<Scalars['Boolean']['input']>;
  diabetesDiagnoses?: InputMaybe<Array<DiabetesDiagnosisInput>>;
  diabetesLineItems?: InputMaybe<Array<DiabetesLineItemInput>>;
  fastingBloodSugarMgDl?: InputMaybe<Scalars['Float']['input']>;
  glucoseTestsPerDayBeforeMedicare?: InputMaybe<Scalars['Int']['input']>;
  glucoseTestsPerDayPrior2Months?: InputMaybe<Scalars['Int']['input']>;
  hasRenalInsufficiency?: InputMaybe<Scalars['Boolean']['input']>;
  hypoglycemicEventHistory?: InputMaybe<Array<DiabetesHypoglycemicEvent>>;
  insulinTreatmentType?: InputMaybe<DiabetesInsulinTreatmentType>;
  isLifetimeLengthOfNeed?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedInMonths?: InputMaybe<Scalars['Int']['input']>;
  mdiInjectionsPerDay?: InputMaybe<Scalars['Int']['input']>;
  mdiQualifyingConditions?: InputMaybe<Array<DiabetesMdiQualifyingCondition>>;
  onMdiWithSelfAdjustments6Months?: InputMaybe<Scalars['Boolean']['input']>;
  positiveBetaCellAutoantibody?: InputMaybe<Scalars['Boolean']['input']>;
  preferredDmeCompany?: InputMaybe<Scalars['String']['input']>;
  pumpIsInitialOrder?: InputMaybe<Scalars['Boolean']['input']>;
  pumpSystem?: InputMaybe<DiabetesPumpSystem>;
  smbgTestsPerDay?: InputMaybe<Scalars['Int']['input']>;
  treatedWithInsulin?: InputMaybe<Scalars['Boolean']['input']>;
  usedPumpBeforeMedicare?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DiabetesPumpSystem {
  BetaBionicsIlet = 'BETA_BIONICS_ILET',
  MedtronicMinimed = 'MEDTRONIC_MINIMED',
  TandemMobi = 'TANDEM_MOBI',
  TandemTslimX2 = 'TANDEM_TSLIM_X2'
}

export enum DiabeticFootCondition {
  Amputation = 'AMPUTATION',
  FootDeformity = 'FOOT_DEFORMITY',
  FootUlceration = 'FOOT_ULCERATION',
  None = 'NONE',
  PeripheralNeuropathyWithCallus = 'PERIPHERAL_NEUROPATHY_WITH_CALLUS',
  PoorCirculation = 'POOR_CIRCULATION',
  PreUlcerativeCallus = 'PRE_ULCERATIVE_CALLUS'
}

export type Diagnosis = {
  __typename?: 'Diagnosis';
  categoryDiagnosisTypeId: Scalars['Int']['output'];
  customIcd10Code?: Maybe<Scalars['String']['output']>;
  customIcd10Description?: Maybe<Scalars['String']['output']>;
  icd10DescriptionId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type DiagnosisField = {
  __typename?: 'DiagnosisField';
  columnName: Scalars['String']['output'];
  display: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type DiagnosisInput = {
  categoryDiagnosisTypeId: Scalars['Int']['input'];
  customIcd10Code?: InputMaybe<Scalars['String']['input']>;
  customIcd10Description?: InputMaybe<Scalars['String']['input']>;
  icd10DescriptionId?: InputMaybe<Scalars['Int']['input']>;
};

export type DiagnosisType = {
  __typename?: 'DiagnosisType';
  diagnosisFields: Array<DiagnosisField>;
  id: Scalars['Int']['output'];
  type: DiagnosisTypeEnum;
};

export enum DiagnosisTypeEnum {
  Icd10Diagnosis = 'ICD10_DIAGNOSIS'
}

export type DisableMedicareBlockingHcpcsAuditInput = {
  auditStateId: Scalars['Int']['input'];
  hcpcsCode: Scalars['String']['input'];
  payorId?: InputMaybe<Scalars['Int']['input']>;
};

export type DisplayLineItem = {
  __typename?: 'DisplayLineItem';
  hcpcs?: Maybe<Scalars['String']['output']>;
  laterality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  quantity?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
};

export type DisplayRow = {
  __typename?: 'DisplayRow';
  emphasis: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DisplaySection = {
  __typename?: 'DisplaySection';
  heading?: Maybe<Scalars['String']['output']>;
  lineItems: Array<DisplayLineItem>;
  rows: Array<DisplayRow>;
};

export type Distributor = {
  __typename?: 'Distributor';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  preferredShippingMode?: Maybe<Scalars['String']['output']>;
  undeliverableToPoBox?: Maybe<Scalars['Boolean']['output']>;
};

export type DistributorInvoiceProduct = {
  __typename?: 'DistributorInvoiceProduct';
  diagnosisCodes: Array<DistributorOrderInvoiceProductDiagnosis>;
  /** @deprecated This field is deprecated; use diagnosisCodes instead. */
  diagnosisIds: Array<Scalars['Int']['output']>;
  distributorId: Scalars['Int']['output'];
  distributorOrderInvoiceProductId: Scalars['Int']['output'];
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  itemsPerPackage?: Maybe<Scalars['String']['output']>;
  modifier1?: Maybe<Scalars['String']['output']>;
  modifier1AutoGenerated: Scalars['Boolean']['output'];
  modifier2?: Maybe<Scalars['String']['output']>;
  modifier2AutoGenerated: Scalars['Boolean']['output'];
  modifier3?: Maybe<Scalars['String']['output']>;
  modifier3AutoGenerated?: Maybe<Scalars['Boolean']['output']>;
  numPackages?: Maybe<Scalars['String']['output']>;
  productDescription: Scalars['String']['output'];
  productNumber: Scalars['String']['output'];
  reimbursementRate?: Maybe<Scalars['Int']['output']>;
  reimbursementType?: Maybe<ReimbursementType>;
  selectedForPreview: Scalars['Boolean']['output'];
  serviceDate?: Maybe<Scalars['Date']['output']>;
  unitsPerItem?: Maybe<Scalars['String']['output']>;
};

export type DistributorInvoiceProductInput = {
  hcpcsCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  unitsPerItem?: InputMaybe<Scalars['String']['input']>;
};

export type DistributorInvoiceProductMapping = {
  __typename?: 'DistributorInvoiceProductMapping';
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  productDescription: Scalars['String']['output'];
  productNumber: Scalars['String']['output'];
};

export type DistributorInvoiceProductMappingsPage = {
  __typename?: 'DistributorInvoiceProductMappingsPage';
  items: Array<DistributorInvoiceProductMapping>;
  totalCount: Scalars['Int']['output'];
};

export type DistributorInvoiceProductSearchResult = {
  __typename?: 'DistributorInvoiceProductSearchResult';
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  productDescription: Scalars['String']['output'];
  productNumber: Scalars['String']['output'];
  reimbursementRate?: Maybe<Scalars['Int']['output']>;
  reimbursementType?: Maybe<ReimbursementType>;
  unitsPerItem?: Maybe<Scalars['String']['output']>;
};

export type DistributorOrder = {
  __typename?: 'DistributorOrder';
  claims?: Maybe<Array<Claim>>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  distributorId: Scalars['Int']['output'];
  distributorOrderNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastAlertSentAt?: Maybe<Scalars['DateTime']['output']>;
  orderPlacedAt?: Maybe<Scalars['DateTime']['output']>;
  orderPlacedBy?: Maybe<OpsUser>;
  orderSegmentId?: Maybe<Scalars['Int']['output']>;
  priorAuthorizationNumber?: Maybe<Scalars['String']['output']>;
  queuedAt?: Maybe<Scalars['DateTime']['output']>;
  returnTracking?: Maybe<ReturnTracking>;
  trackingNumbers?: Maybe<Array<TrackingNumber>>;
  warningSuppressed: Scalars['Boolean']['output'];
};

export type DistributorOrderDiagnosis = {
  __typename?: 'DistributorOrderDiagnosis';
  code: Scalars['String']['output'];
  distributorOrderId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type DistributorOrderInput = {
  distributorAccountName?: InputMaybe<Scalars['String']['input']>;
  distributorId: Scalars['Int']['input'];
  distributorOrderNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderPlacedBy: Scalars['Int']['input'];
  orderSegmentId: Scalars['Int']['input'];
  queuedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DistributorOrderInvoiceProductDiagnosesInput = {
  diagnosisIds: Array<Scalars['Int']['input']>;
  distributorOrderInvoiceProductId: Scalars['Int']['input'];
};

export type DistributorOrderInvoiceProductDiagnosis = {
  __typename?: 'DistributorOrderInvoiceProductDiagnosis';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  diagnosisCode: Scalars['String']['output'];
  distributorOrderInvoiceProductId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isAutoGenerated: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DistributorOrderInvoiceProductInput = {
  id: Scalars['Int']['input'];
  itemsPerPackage?: InputMaybe<Scalars['String']['input']>;
  modifier1?: InputMaybe<Scalars['String']['input']>;
  modifier2?: InputMaybe<Scalars['String']['input']>;
  modifier3?: InputMaybe<Scalars['String']['input']>;
  numPackages?: InputMaybe<Scalars['String']['input']>;
};

export type DistributorProductGroup = {
  __typename?: 'DistributorProductGroup';
  id: Scalars['Int']['output'];
  link?: Maybe<Scalars['String']['output']>;
  mercyOnlineLink?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type DistributorProductSearchResult = {
  __typename?: 'DistributorProductSearchResult';
  concatenatedAttributes?: Maybe<Scalars['String']['output']>;
  costPrice?: Maybe<Scalars['Float']['output']>;
  displayName: Scalars['String']['output'];
  distributorGroupName: Scalars['String']['output'];
  distributorProductGroupId: Scalars['Int']['output'];
  externalManufacturerProductId?: Maybe<Scalars['String']['output']>;
  externalProductId?: Maybe<Scalars['String']['output']>;
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isHazmat?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerPartNumber?: Maybe<Scalars['String']['output']>;
  numInSale?: Maybe<Scalars['Int']['output']>;
  packageAmount?: Maybe<Scalars['Int']['output']>;
  packageAmountString?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
  salUnitMsr?: Maybe<Scalars['String']['output']>;
  undeliverableToPoBox?: Maybe<Scalars['Boolean']['output']>;
};

export enum DoNotBillOrderFlag {
  DoNotBill = 'DO_NOT_BILL',
  None = 'NONE'
}

export type DocReviewBox = {
  __typename?: 'DocReviewBox';
  h: Scalars['Float']['output'];
  w: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type DocReviewCitation = {
  __typename?: 'DocReviewCitation';
  boundingBoxes: Array<DocReviewBox>;
  caption: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  expectation?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  page: Scalars['Int']['output'];
};

export type DocReviewDeadlines = {
  __typename?: 'DocReviewDeadlines';
  billingPeriodEnd: Scalars['String']['output'];
  certPeriodEnd: Scalars['String']['output'];
};

export type DocReviewDocument = {
  __typename?: 'DocReviewDocument';
  effectiveDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  pageCount: Scalars['Int']['output'];
  presignedUrl: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DocReviewFinding = {
  __typename?: 'DocReviewFinding';
  citations: Array<DocReviewCitation>;
  decision?: Maybe<Scalars['String']['output']>;
  decisionText?: Maybe<Scalars['String']['output']>;
  draftBody: Scalars['String']['output'];
  enteredAt?: Maybe<Scalars['String']['output']>;
  evidenceSummary: Scalars['String']['output'];
  feedbackComment?: Maybe<Scalars['String']['output']>;
  feedbackRating?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  severity: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type DocReviewNote = {
  __typename?: 'DocReviewNote';
  checkedAgainstDocumentIds: Array<Scalars['String']['output']>;
  clinicianDisplayName: Scalars['String']['output'];
  deadlines: DocReviewDeadlines;
  dismissedBy?: Maybe<Scalars['String']['output']>;
  dismissedOn?: Maybe<Scalars['String']['output']>;
  documents: Array<DocReviewDocument>;
  findings: Array<DocReviewFinding>;
  id: Scalars['String']['output'];
  noteDocumentId: Scalars['String']['output'];
  noteFeedback?: Maybe<Scalars['String']['output']>;
  patientDisplayName: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  planInForceLabel: Scalars['String']['output'];
  recordState: Scalars['String']['output'];
  reviewState: Scalars['String']['output'];
  sourceDocumentIds: Array<Scalars['String']['output']>;
  visitDate: Scalars['String']['output'];
  visitLabel: Scalars['String']['output'];
};

export type DocReviewQueueResult = {
  __typename?: 'DocReviewQueueResult';
  accountUnverified: Scalars['Boolean']['output'];
  hospitalIds: Array<Scalars['Int']['output']>;
  notes: Array<DocReviewNote>;
};

export type DocumentAssignmentInput = {
  documentId: Scalars['Int']['input'];
  documentType: DocumentType;
  needToAssign: Scalars['Boolean']['input'];
  opsUserId: Scalars['Int']['input'];
};

export type DocumentCollectionCallQueueRow = {
  __typename?: 'DocumentCollectionCallQueueRow';
  ageDays: Scalars['Int']['output'];
  assignedToId?: Maybe<Scalars['Int']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  blockingOutcomes: Array<Scalars['String']['output']>;
  callFailureCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  dueOn?: Maybe<Scalars['Date']['output']>;
  escalationReason: DocumentCollectionEscalationReason;
  escalationReasons: Array<DocumentCollectionEscalationReason>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  hospitalName: Scalars['String']['output'];
  noProgressCount: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
  patientAddress?: Maybe<Scalars['String']['output']>;
  patientDob?: Maybe<Scalars['Date']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  patientPhoneNumber?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Split into noProgressCount and callFailureCount. */
  strikeCount: Scalars['Int']['output'];
};

export enum DocumentCollectionEscalationReason {
  AgentFlagged = 'AGENT_FLAGGED',
  ClinicRefusesAi = 'CLINIC_REFUSES_AI',
  DoNotCall = 'DO_NOT_CALL',
  NoDialablePhone = 'NO_DIALABLE_PHONE',
  NoFaxOnRecord = 'NO_FAX_ON_RECORD',
  NoProviderAssigned = 'NO_PROVIDER_ASSIGNED',
  PhoneBlocked = 'PHONE_BLOCKED',
  ProviderNotTreating = 'PROVIDER_NOT_TREATING',
  RepeatedCallFailures = 'REPEATED_CALL_FAILURES',
  RepeatedFaxNotReceived = 'REPEATED_FAX_NOT_RECEIVED',
  RepeatedNoProgress = 'REPEATED_NO_PROGRESS'
}

export type DocumentCollectionMessage = {
  __typename?: 'DocumentCollectionMessage';
  createdAt: Scalars['String']['output'];
  message: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type DocumentCollectionOrder = {
  __typename?: 'DocumentCollectionOrder';
  awaitingClinicResponse: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  encounterDate?: Maybe<Scalars['String']['output']>;
  events: Array<DocumentCollectionOrderEvent>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  hospitalName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  messages: Array<DocumentCollectionMessage>;
  orderNumber: Scalars['String']['output'];
  orderStatus: Scalars['String']['output'];
  patientAddress?: Maybe<Scalars['String']['output']>;
  patientDob?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  placingHospitalName?: Maybe<Scalars['String']['output']>;
  providerName: Scalars['String']['output'];
  providerNpi?: Maybe<Scalars['String']['output']>;
  providerPhoneNumber?: Maybe<Scalars['String']['output']>;
  requestedDocuments: Array<S3Document>;
  sendEmail: Scalars['Boolean']['output'];
  sendFax: Scalars['Boolean']['output'];
  signedDocuments: Array<S3Document>;
};

export type DocumentCollectionOrderEvent = {
  __typename?: 'DocumentCollectionOrderEvent';
  createdAt: Scalars['DateTime']['output'];
  documentCollectionOrderId: Scalars['Int']['output'];
  eventDescription: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type DocumentCollectionOrderList = {
  __typename?: 'DocumentCollectionOrderList';
  maxPage: Scalars['Int']['output'];
  medicalRecordsDepartmentFaxNumber?: Maybe<Scalars['String']['output']>;
  orders: Array<DocumentCollectionOrder>;
};

export type DocumentCollectionProviderContactChange = {
  __typename?: 'DocumentCollectionProviderContactChange';
  oldValue?: Maybe<Scalars['String']['output']>;
  orderNumber: Scalars['String']['output'];
  patientName?: Maybe<Scalars['String']['output']>;
};

export type DocumentCollectionProviderContactNumber = {
  __typename?: 'DocumentCollectionProviderContactNumber';
  number: Scalars['String']['output'];
  numberType: Scalars['String']['output'];
  sources: Array<Scalars['String']['output']>;
};

export type DocumentCollectionStats = {
  __typename?: 'DocumentCollectionStats';
  newLast7Days: Scalars['Int']['output'];
  signed: Scalars['Int']['output'];
};

export type DocumentCopyFailure = {
  __typename?: 'DocumentCopyFailure';
  error: Scalars['String']['output'];
  sourceOrderNumber: Scalars['String']['output'];
  targetOrderNumber: Scalars['String']['output'];
};

export type DocumentNeededOrders = {
  __typename?: 'DocumentNeededOrders';
  missingProgressNoteOrderList: ProgressNoteOrderList;
  missingSignatureOrderList: ProgressNoteOrderList;
};

export type DocumentSourceInfo = {
  __typename?: 'DocumentSourceInfo';
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  sourceTier?: Maybe<Scalars['String']['output']>;
};

export enum DocumentType {
  Fax = 'FAX',
  Order = 'ORDER'
}

export type DraftOrdersPage = {
  __typename?: 'DraftOrdersPage';
  editHistory: Array<Array<OrderEvent>>;
  orders: Array<ProviderReferral>;
};

export type DuplicateHospital = {
  __typename?: 'DuplicateHospital';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EditBufferedOrderNoteInput = {
  id: Scalars['Int']['input'];
  noteText?: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityCheckResponse = {
  __typename?: 'EligibilityCheckResponse';
  billerReviewRequested: Scalars['Boolean']['output'];
  eligibility: EligibilityResponse;
  message?: Maybe<Scalars['String']['output']>;
  potentialHandoff: Scalars['Boolean']['output'];
};

export type EligibilityFlag = {
  __typename?: 'EligibilityFlag';
  confidence: Scalars['Float']['output'];
  lineItemId: Scalars['Int']['output'];
  previousLineItemData?: Maybe<EligibilityFlagLineItem>;
  previousLineItemId: Scalars['Int']['output'];
  previousOrderNumber: Scalars['String']['output'];
  previousOrderSegmentId: Scalars['Int']['output'];
  rationale: Scalars['String']['output'];
  woundMatchingConfidence: Scalars['Float']['output'];
  woundMatchingRationale: Scalars['String']['output'];
};

export type EligibilityFlagLineItem = {
  __typename?: 'EligibilityFlagLineItem';
  duration?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  hcpcs?: Maybe<Scalars['String']['output']>;
  lineItemId: Scalars['Int']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  selectedWounds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type EligibilityHistoryEntry = {
  __typename?: 'EligibilityHistoryEntry';
  createdAt: Scalars['String']['output'];
  eligibleForDme?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  liabilities: Array<PatientLiabilityHistoryEntry>;
  memberId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  openpmCodes: Array<Scalars['String']['output']>;
  payorId?: Maybe<Scalars['Int']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  planStatus?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<Scalars['String']['output']>;
  policyType?: Maybe<Scalars['String']['output']>;
  queryDate?: Maybe<Scalars['String']['output']>;
  rawResponse?: Maybe<Scalars['JSON']['output']>;
  reportedPayorName?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  sourceCode: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type EligibilityResponse = {
  __typename?: 'EligibilityResponse';
  coInsInNet?: Maybe<Scalars['Float']['output']>;
  coInsOutNet?: Maybe<Scalars['Float']['output']>;
  coPayInNet?: Maybe<Scalars['Float']['output']>;
  coPayOutNet?: Maybe<Scalars['Float']['output']>;
  eligibleForDme?: Maybe<Scalars['Boolean']['output']>;
  expiryDate?: Maybe<Scalars['Date']['output']>;
  famDeductibleRemInNet?: Maybe<Scalars['Float']['output']>;
  famDeductibleRemOutNet?: Maybe<Scalars['Float']['output']>;
  famOopRemInNet?: Maybe<Scalars['Float']['output']>;
  famOopRemOutNet?: Maybe<Scalars['Float']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  indDeductibleRemInNet?: Maybe<Scalars['Float']['output']>;
  indDeductibleRemOutNet?: Maybe<Scalars['Float']['output']>;
  indOopRemInNet?: Maybe<Scalars['Float']['output']>;
  indOopRemOutNet?: Maybe<Scalars['Float']['output']>;
  isHomeHealth?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  needsManualVerification?: Maybe<Scalars['Boolean']['output']>;
  payorId?: Maybe<Scalars['Int']['output']>;
  payorName?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  planStatus?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<PlanType>;
  policyType?: Maybe<Scalars['String']['output']>;
  priorAuthorizationRequired?: Maybe<Scalars['Boolean']['output']>;
  rawResponse?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  requiredManualUpdate: Scalars['Boolean']['output'];
  returnedPayorName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<OpsUser>;
};

export type EligibilitySource = {
  __typename?: 'EligibilitySource';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type EligiblePayor = {
  __typename?: 'EligiblePayor';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EstimatedRefill = {
  __typename?: 'EstimatedRefill';
  /** When the refill opens and the patient can be contacted. */
  dueAt: Scalars['DateTime']['output'];
  /** The earliest ship date. */
  earliestShipAt: Scalars['DateTime']['output'];
  itemNames: Array<Scalars['String']['output']>;
  /** When the current supply runs out. */
  neededAt: Scalars['DateTime']['output'];
  periodIndex: Scalars['Int']['output'];
};

export type EvidenceQuote = {
  __typename?: 'EvidenceQuote';
  boundingBoxes: Array<BoundingBox>;
  page?: Maybe<Scalars['Int']['output']>;
  quote: Scalars['String']['output'];
  supports: Scalars['String']['output'];
};

export type ExtractedAppealFields = {
  __typename?: 'ExtractedAppealFields';
  functionalImpairment?: Maybe<Scalars['String']['output']>;
  medicalNecessity?: Maybe<Scalars['String']['output']>;
};

export type ExtractedPatientDemographicsComparison = {
  __typename?: 'ExtractedPatientDemographicsComparison';
  patientAddress?: Maybe<Scalars['String']['output']>;
  patientAddressConfidence?: Maybe<Scalars['Float']['output']>;
  patientCity?: Maybe<Scalars['String']['output']>;
  patientCityConfidence?: Maybe<Scalars['Float']['output']>;
  patientDateOfBirthIso?: Maybe<Scalars['String']['output']>;
  patientDateOfBirthIsoConfidence?: Maybe<Scalars['Float']['output']>;
  patientEmail?: Maybe<Scalars['String']['output']>;
  patientEmailConfidence?: Maybe<Scalars['Float']['output']>;
  patientFullName?: Maybe<Scalars['String']['output']>;
  patientFullNameConfidence?: Maybe<Scalars['Float']['output']>;
  patientGender?: Maybe<Scalars['String']['output']>;
  patientGenderConfidence?: Maybe<Scalars['Float']['output']>;
  patientPhone?: Maybe<Scalars['String']['output']>;
  patientPhoneConfidence?: Maybe<Scalars['Float']['output']>;
  patientPrimaryInsuranceGroupNumber?: Maybe<Scalars['String']['output']>;
  patientPrimaryInsuranceGroupNumberConfidence?: Maybe<Scalars['Float']['output']>;
  patientPrimaryInsuranceMemberId?: Maybe<Scalars['String']['output']>;
  patientPrimaryInsuranceMemberIdConfidence?: Maybe<Scalars['Float']['output']>;
  patientPrimaryInsurancePlan?: Maybe<Scalars['String']['output']>;
  patientPrimaryInsurancePlanConfidence?: Maybe<Scalars['Float']['output']>;
  patientPrimaryInsuranceType?: Maybe<Scalars['String']['output']>;
  patientPrimaryInsuranceTypeConfidence?: Maybe<Scalars['Float']['output']>;
  patientSecondaryInsuranceGroupNumber?: Maybe<Scalars['String']['output']>;
  patientSecondaryInsuranceGroupNumberConfidence?: Maybe<Scalars['Float']['output']>;
  patientSecondaryInsuranceMemberId?: Maybe<Scalars['String']['output']>;
  patientSecondaryInsuranceMemberIdConfidence?: Maybe<Scalars['Float']['output']>;
  patientSecondaryInsurancePlan?: Maybe<Scalars['String']['output']>;
  patientSecondaryInsurancePlanConfidence?: Maybe<Scalars['Float']['output']>;
  patientSecondaryInsuranceType?: Maybe<Scalars['String']['output']>;
  patientSecondaryInsuranceTypeConfidence?: Maybe<Scalars['Float']['output']>;
  patientSecondaryPhone?: Maybe<Scalars['String']['output']>;
  patientSecondaryPhoneConfidence?: Maybe<Scalars['Float']['output']>;
  patientState?: Maybe<Scalars['String']['output']>;
  patientStateConfidence?: Maybe<Scalars['Float']['output']>;
  patientZipCode?: Maybe<Scalars['String']['output']>;
  patientZipCodeConfidence?: Maybe<Scalars['Float']['output']>;
};

export type ExtractedWoundInfoComparison = {
  __typename?: 'ExtractedWoundInfoComparison';
  actualDateOfDebridement?: Maybe<Scalars['String']['output']>;
  actualDebrided?: Maybe<Scalars['String']['output']>;
  actualDrainageEstimate?: Maybe<Scalars['String']['output']>;
  actualIcdDescription?: Maybe<Scalars['String']['output']>;
  actualWoundDepth?: Maybe<Scalars['String']['output']>;
  actualWoundLength?: Maybe<Scalars['String']['output']>;
  actualWoundLocation?: Maybe<Scalars['String']['output']>;
  actualWoundThickness?: Maybe<Scalars['String']['output']>;
  actualWoundWidth?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  retrievedDateOfDebridement: Scalars['String']['output'];
  retrievedDebrided: Scalars['String']['output'];
  retrievedDrainageEstimate: Scalars['String']['output'];
  retrievedIcdDescription: Scalars['String']['output'];
  retrievedWhyDebrided?: Maybe<Scalars['String']['output']>;
  retrievedWoundDepth: Scalars['String']['output'];
  retrievedWoundLength: Scalars['String']['output'];
  retrievedWoundLocation: Scalars['String']['output'];
  retrievedWoundThickness: Scalars['String']['output'];
  retrievedWoundWidth: Scalars['String']['output'];
};

export type ExtractedWoundLineItemComparison = {
  __typename?: 'ExtractedWoundLineItemComparison';
  extractedDurationOfUse?: Maybe<Scalars['String']['output']>;
  extractedFrequencyOfUse?: Maybe<Scalars['String']['output']>;
  extractedLineItemId?: Maybe<Scalars['Int']['output']>;
  extractedProductName: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
};

export type FailedOrderResult = {
  __typename?: 'FailedOrderResult';
  error: Scalars['String']['output'];
  sourceOrderNumber: Scalars['String']['output'];
};

export type Fax = {
  __typename?: 'Fax';
  addendumResponse?: Maybe<Scalars['Boolean']['output']>;
  attachedAt?: Maybe<Scalars['DateTime']['output']>;
  correctedOrder?: Maybe<Scalars['Boolean']['output']>;
  filename: Scalars['String']['output'];
  filenameHash: Scalars['String']['output'];
  newOrder?: Maybe<Scalars['Boolean']['output']>;
  opsUserName?: Maybe<Scalars['String']['output']>;
  orderFaxId: Scalars['Int']['output'];
  otherFiles?: Maybe<Scalars['Boolean']['output']>;
  partialProgressNote: Scalars['Boolean']['output'];
  patientDemographics?: Maybe<Scalars['Boolean']['output']>;
  progressNotes?: Maybe<Scalars['Boolean']['output']>;
  progressNotesResponse?: Maybe<Scalars['Boolean']['output']>;
  progressNotesSummary: Scalars['Boolean']['output'];
  signature?: Maybe<Scalars['Boolean']['output']>;
};

export type FaxInput = {
  addendumResponse?: InputMaybe<Scalars['Boolean']['input']>;
  correctedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  departmentOrderId?: InputMaybe<Scalars['Int']['input']>;
  faxType?: InputMaybe<FaxType>;
  filename?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  newOrder?: InputMaybe<Scalars['Boolean']['input']>;
  otherFiles?: InputMaybe<Scalars['Boolean']['input']>;
  partialProgressNote?: InputMaybe<Scalars['Boolean']['input']>;
  patientDemographics?: InputMaybe<Scalars['Boolean']['input']>;
  progressNotes?: InputMaybe<Scalars['Boolean']['input']>;
  progressNotesResponse?: InputMaybe<Scalars['Boolean']['input']>;
  progressNotesSummary?: InputMaybe<Scalars['Boolean']['input']>;
  signature?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FaxOrderFormTemplateCategoryUrl = {
  __typename?: 'FaxOrderFormTemplateCategoryUrl';
  downloadUrl: Scalars['String']['output'];
  productCategory: ProductCategory;
};

export type FaxOrderFormTemplateVersion = {
  __typename?: 'FaxOrderFormTemplateVersion';
  createdAt: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  hospitalId?: Maybe<Scalars['Int']['output']>;
  hospitalName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isCurrent: Scalars['Boolean']['output'];
  uploadedByName?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type FaxTab = {
  __typename?: 'FaxTab';
  faxes: Array<UnmatchedFax>;
  incompleteOrders: Array<IncompleteOrder>;
};

export enum FaxType {
  FaxOrder = 'FAX_ORDER',
  Other = 'OTHER',
  ProgressNote = 'PROGRESS_NOTE'
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  active: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type FeeScheduleRateInput = {
  hcpcsCode: Scalars['String']['input'];
  rate: Scalars['Decimal']['input'];
  unit: Scalars['String']['input'];
};

export type FieldValidationError = {
  __typename?: 'FieldValidationError';
  fieldPath: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type FilterAttribute = {
  __typename?: 'FilterAttribute';
  allowedValues: Array<Scalars['String']['output']>;
  attributeKey: Scalars['String']['output'];
  dataType: AttributeType;
  id: Scalars['Int']['output'];
  operators: Array<RuleOperator>;
  sourceColumn?: Maybe<Scalars['String']['output']>;
  sourceTable?: Maybe<Scalars['String']['output']>;
};

export type FilterRuleset = {
  __typename?: 'FilterRuleset';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  filterRulesetGroupId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isLive: Scalars['Boolean']['output'];
  outputCap?: Maybe<Scalars['Int']['output']>;
  ruleKey: Scalars['String']['output'];
  ruleTree?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FilterRulesetGroup = {
  __typename?: 'FilterRulesetGroup';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  groupKey: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  maintainer?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FormItem = {
  __typename?: 'FormItem';
  category: ProductCategory;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  optionGroups: Array<FormItemOptionGroup>;
};

export type FormItemOption = {
  __typename?: 'FormItemOption';
  optionId: Scalars['Int']['output'];
  optionName: Scalars['String']['output'];
};

export type FormItemOptionGroup = {
  __typename?: 'FormItemOptionGroup';
  id: Scalars['Int']['output'];
  options: Array<FormItemOption>;
  position: Scalars['Int']['output'];
};

export type FormItemTemplate = {
  __typename?: 'FormItemTemplate';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FormOptionItem = {
  __typename?: 'FormOptionItem';
  clinicianQuantityRuleDescription?: Maybe<Scalars['String']['output']>;
  disableQuantityAutocalculationDefaultQuantity?: Maybe<Scalars['Int']['output']>;
  displayUnitLabel?: Maybe<Scalars['String']['output']>;
  dressingCategory?: Maybe<Scalars['String']['output']>;
  frequencies?: Maybe<Array<ProductFrequency>>;
  id: Scalars['Int']['output'];
  isBordered: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['String']['output']>;
  sizes?: Maybe<Array<ProductSize>>;
  subOptions: Array<Array<FormItemOption>>;
  subcategory?: Maybe<Scalars['String']['output']>;
  systemKey?: Maybe<Scalars['String']['output']>;
  woundSizeAgnostic?: Maybe<Scalars['Boolean']['output']>;
};

export type FrequencyViolationInfo = {
  __typename?: 'FrequencyViolationInfo';
  lineItemId: Scalars['String']['output'];
  maxFrequency: Scalars['String']['output'];
};

export type FulfillmentByHospital = {
  __typename?: 'FulfillmentByHospital';
  avgFulfillmentHours?: Maybe<Scalars['Float']['output']>;
  deliveredIn48h: Scalars['Int']['output'];
  hospitalId: Scalars['Int']['output'];
  hospitalName: Scalars['String']['output'];
  ordersDelivered: Scalars['Int']['output'];
  pctOnTime?: Maybe<Scalars['Float']['output']>;
};

export type GeneratePaymentLinkResult = {
  __typename?: 'GeneratePaymentLinkResult';
  fallbackTaskCreated: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  paymentLinkUrl?: Maybe<Scalars['String']['output']>;
  smsSent: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type Group2SupportSurfaceSurgicalDates = {
  __typename?: 'Group2SupportSurfaceSurgicalDates';
  dischargeDate?: Maybe<Scalars['DateTime']['output']>;
  group2SupportSurfacePriorToDischarge?: Maybe<Scalars['Boolean']['output']>;
  surgicalDate?: Maybe<Scalars['DateTime']['output']>;
  values?: Maybe<Array<PlanOfCareCondition>>;
};

export type Group2SupportSurfaceSurgicalDatesInput = {
  dischargeDate?: InputMaybe<Scalars['DateTime']['input']>;
  group2SupportSurfacePriorToDischarge?: InputMaybe<Scalars['Boolean']['input']>;
  surgicalDate?: InputMaybe<Scalars['DateTime']['input']>;
  values?: InputMaybe<Array<PlanOfCareConditionInput>>;
};

export type HcpcFeeSchedule = {
  __typename?: 'HCPCFeeSchedule';
  amount: Scalars['Decimal']['output'];
  feeDate: Scalars['DateTime']['output'];
  hcpcsCode: Scalars['String']['output'];
  reimbursementType: ReimbursementType;
};

export type HcpcsData = {
  __typename?: 'HCPCSData';
  code: Scalars['String']['output'];
  descriptions: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  opsGuidance?: Maybe<Array<Scalars['String']['output']>>;
  size: Scalars['String']['output'];
};

export type HandOffFailureReason = {
  __typename?: 'HandOffFailureReason';
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: HandOffFailureReasonType;
};

export enum HandOffFailureReasonType {
  FailureReason = 'FAILURE_REASON',
  TerminationReason = 'TERMINATION_REASON'
}

export type HandOffOrderEvent = {
  __typename?: 'HandOffOrderEvent';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  text: Scalars['String']['output'];
  type: HandOffOrderEventType;
};

export enum HandOffOrderEventType {
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED'
}

export type HandOffOrderSegment = {
  __typename?: 'HandOffOrderSegment';
  currentPartner?: Maybe<HandOffOrderSegmentPartner>;
  events: Array<HandOffOrderEvent>;
  hospitalUsageType?: Maybe<HospitalUsageType>;
  id: Scalars['Int']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  internalStatus?: Maybe<CoordinatedFulfillmentStatus>;
  orderSegmentId?: Maybe<Scalars['Int']['output']>;
  portalOrderId?: Maybe<Scalars['Int']['output']>;
  preferredDmeCompanies?: Maybe<Array<HandOffPreferredDmeCompanies>>;
  revisionNote?: Maybe<Scalars['String']['output']>;
  revisionRequests?: Maybe<Array<HandOffPortalOrderRevisionRequest>>;
  status: HandOffStatus;
  terminationReason?: Maybe<Scalars['String']['output']>;
  type?: Maybe<HandOffOrderSegmentType>;
};

export type HandOffOrderSegmentInput = {
  clearInternalStatus?: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  internalStatus?: InputMaybe<CoordinatedFulfillmentStatus>;
  orderSegmentPartnerInput?: InputMaybe<HandOffOrderSegmentPartnerInput>;
  status?: InputMaybe<HandOffStatus>;
  terminationReasonId?: InputMaybe<Scalars['Int']['input']>;
};

export type HandOffOrderSegmentMessage = {
  __typename?: 'HandOffOrderSegmentMessage';
  createdAt: Scalars['DateTime']['output'];
  fromVerse?: Maybe<Scalars['Boolean']['output']>;
  handOffOrderSegmentId: Scalars['Int']['output'];
  handOffOrderSegmentPartnerId: Scalars['Int']['output'];
  handOffPartnerId: Scalars['Int']['output'];
  handOffPortalOrderId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  opsUserId?: Maybe<Scalars['Int']['output']>;
  senderEmail?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  spreeUserId?: Maybe<Scalars['Int']['output']>;
};

export type HandOffOrderSegmentPartner = {
  __typename?: 'HandOffOrderSegmentPartner';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoiceLink?: Maybe<Scalars['String']['output']>;
  otherRejectionReason?: Maybe<Scalars['String']['output']>;
  partnerDiscount: Scalars['Decimal']['output'];
  partnerId: Scalars['Int']['output'];
  partnerName: Scalars['String']['output'];
  partnerNote?: Maybe<Scalars['String']['output']>;
  partnerNoteUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  result?: Maybe<HandOffStatus>;
  subcontracted: Scalars['Boolean']['output'];
  tag?: Maybe<HandOffOrderSegmentPartnerTag>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type HandOffOrderSegmentPartnerInput = {
  actionBy?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  failureReasonId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  newOrderPartner: Scalars['Boolean']['input'];
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<HandOffStatus>;
  subcontracted?: InputMaybe<Scalars['Boolean']['input']>;
  tag?: InputMaybe<HandOffOrderSegmentPartnerTag>;
};

export enum HandOffOrderSegmentPartnerTag {
  EditNew = 'EDIT_NEW',
  EditPendingClinicResponse = 'EDIT_PENDING_CLINIC_RESPONSE',
  EditPendingInternalResponse = 'EDIT_PENDING_INTERNAL_RESPONSE',
  EditPendingPatientResponse = 'EDIT_PENDING_PATIENT_RESPONSE'
}

export type HandOffOrderSegmentTab = {
  __typename?: 'HandOffOrderSegmentTab';
  activeDate?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  handOffOrderSegmentId?: Maybe<Scalars['Int']['output']>;
  handOffOrderSegmentType?: Maybe<HandOffOrderSegmentType>;
  orderSegmentId: Scalars['Int']['output'];
  segmentType: OrderSegmentTypes;
  status?: Maybe<HandOffStatus>;
  terminationReason?: Maybe<Scalars['String']['output']>;
};

export enum HandOffOrderSegmentType {
  Handoff = 'HANDOFF',
  RoutedHandoff = 'ROUTED_HANDOFF',
  Subcontract = 'SUBCONTRACT'
}

export type HandOffPartner = {
  __typename?: 'HandOffPartner';
  accessiblePortals: Array<HandOffPortal>;
  activeOrderLimit: Scalars['Int']['output'];
  activeOrders: Scalars['Int']['output'];
  allowPartialProgressNotes: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creditLimit: Scalars['Int']['output'];
  defaultDiscount: Scalars['Decimal']['output'];
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  hasPortalAccount: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  invoiceEmail?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  oldestUnpaidInvoice?: Maybe<Scalars['DateTime']['output']>;
  orderPreference: DmePartnerOrderPreference;
  outstandingBalance: Scalars['Float']['output'];
  phoneNumber: Scalars['String']['output'];
  ref?: Maybe<Scalars['String']['output']>;
  status: HandOffPartnerStatus;
  subcontracted: Scalars['Boolean']['output'];
  successRate?: Maybe<Scalars['Float']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  totalOrders?: Maybe<Scalars['Int']['output']>;
  versePayorHandoffPortalEnabled: Scalars['Boolean']['output'];
};

export type HandOffPartnerFeeScheduleRate = {
  __typename?: 'HandOffPartnerFeeScheduleRate';
  hcpcsCode: Scalars['String']['output'];
  rate: Scalars['Decimal']['output'];
  unit: Scalars['String']['output'];
};

export type HandOffPartnerInput = {
  activeOrderLimit: Scalars['Int']['input'];
  activeOrders: Scalars['Int']['input'];
  allowPartialProgressNotes: Scalars['Boolean']['input'];
  creditLimit: Scalars['Int']['input'];
  defaultDiscount?: Scalars['Float']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  hasPortalAccount: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderPreference: DmePartnerOrderPreference;
  outstandingBalance: Scalars['Float']['input'];
  phoneNumber: Scalars['String']['input'];
  status?: InputMaybe<HandOffPartnerStatus>;
  subcontracted: Scalars['Boolean']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  versePayorHandoffPortalEnabled?: Scalars['Boolean']['input'];
};

export type HandOffPartnerInsurer = {
  __typename?: 'HandOffPartnerInsurer';
  allStates: Scalars['Boolean']['output'];
  payor: Scalars['String']['output'];
  payorId: Scalars['Int']['output'];
  planType?: Maybe<PlanType>;
  policyType: PolicyType;
  states: Array<UsState>;
};

export type HandOffPartnerPolicyRoutingEntry = {
  __typename?: 'HandOffPartnerPolicyRoutingEntry';
  destinationPartner: Scalars['String']['output'];
  destinationPartnerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  insuranceProvider: Scalars['String']['output'];
  insuranceProviderId: Scalars['Int']['output'];
  patientState: Scalars['String']['output'];
  policyType: Scalars['String']['output'];
};

export type HandOffPartnerRampVendor = {
  __typename?: 'HandOffPartnerRampVendor';
  handOffPartnerId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rampVendorId?: Maybe<Scalars['UUID']['output']>;
  status: HandOffPartnerStatus;
};

export type HandOffPartnerRoutingHospitalBlocklistEntry = {
  __typename?: 'HandOffPartnerRoutingHospitalBlocklistEntry';
  hospitalId: Scalars['Int']['output'];
  hospitalName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export enum HandOffPartnerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Paused = 'PAUSED'
}

export enum HandOffPortal {
  CfHandoff = 'CF_HANDOFF',
  Subcontract = 'SUBCONTRACT',
  VersePayorHandoff = 'VERSE_PAYOR_HANDOFF'
}

export type HandOffPortalAssignableUser = {
  __typename?: 'HandOffPortalAssignableUser';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type HandOffPortalOrder = {
  __typename?: 'HandOffPortalOrder';
  assignedToEmail?: Maybe<Scalars['String']['output']>;
  assignedToName?: Maybe<Scalars['String']['output']>;
  assignedToUserId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  highValue: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isSubcontracted: Scalars['Boolean']['output'];
  lastMessageFromVerse?: Maybe<Scalars['Boolean']['output']>;
  orderNumber: Scalars['String']['output'];
  orderSegmentActiveDate: Scalars['DateTime']['output'];
  orderSegmentApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  orderStatus: HandOffPortalOrderStatus;
  oxygen: Scalars['Boolean']['output'];
  partnerNote?: Maybe<Scalars['String']['output']>;
  partnerStatus: HandOffPortalOrderPartnerStatus;
  partnerStatusCoordinatedFulfillment?: Maybe<CoordinatedFulfillmentStatus>;
  patientData: PatientData;
  patientResponsibility?: Maybe<Scalars['Float']['output']>;
  portalOrderNote?: Maybe<Scalars['String']['output']>;
  previousRefillPortalOrder?: Maybe<HandOffPortalOrderPreviousRefill>;
  previouslyRejectedPortalOrder?: Maybe<HandOffPortalOrderPreviouslyRejectedOrder>;
  priorAuthorizationApproved?: Maybe<Scalars['Boolean']['output']>;
  ref?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<HandOffPortalOrderRejectionReason>;
  revisionResponses: Array<HandOffPortalOrderRevisionResponse>;
  revisions?: Maybe<Array<HandOffPortalOrderRevision>>;
  s3DocumentUrl: Scalars['String']['output'];
  subcontractOrderLineItems: Array<SubcontractOrderLineItem>;
  submittedByCurrentPartner?: Maybe<Scalars['Boolean']['output']>;
  timeSensitive: Scalars['Boolean']['output'];
  timelyFilingInternalDeadline?: Maybe<Scalars['Int']['output']>;
  trackingDetails: Array<HandOffPortalOrderTrackingDetails>;
  updatedAt: Scalars['DateTime']['output'];
};

export type HandOffPortalOrderCount = {
  __typename?: 'HandOffPortalOrderCount';
  handoffAccepted: Scalars['Int']['output'];
  handoffDelivered: Scalars['Int']['output'];
  handoffPendingAdditionalInfo: Scalars['Int']['output'];
  handoffPendingAdditionalInfoVerseLast: Scalars['Int']['output'];
  handoffPendingEdits: Scalars['Int']['output'];
  handoffPendingResponse: Scalars['Int']['output'];
  subcontractPendingEdits: Scalars['Int']['output'];
  subcontractPendingResponse: Scalars['Int']['output'];
  versePayorHandoffAccepted: Scalars['Int']['output'];
  versePayorHandoffDelivered: Scalars['Int']['output'];
  versePayorHandoffPendingResponse: Scalars['Int']['output'];
};

export type HandOffPortalOrderPartnerNoteInput = {
  handOffPortalOrderId?: InputMaybe<Scalars['Int']['input']>;
  handOffPortalOrderRef?: InputMaybe<Scalars['String']['input']>;
  partnerNote?: InputMaybe<Scalars['String']['input']>;
};

export enum HandOffPortalOrderPartnerStatus {
  AddStatus = 'ADD_STATUS',
  CollectingDocumentationFromPatient = 'COLLECTING_DOCUMENTATION_FROM_PATIENT',
  ContactingPatient = 'CONTACTING_PATIENT',
  RequestingAuthorization = 'REQUESTING_AUTHORIZATION',
  ReviewingDocumentation = 'REVIEWING_DOCUMENTATION',
  Todo = 'TODO'
}

export type HandOffPortalOrderPartnerStatusCoordinatedFulfillmentResponse = {
  __typename?: 'HandOffPortalOrderPartnerStatusCoordinatedFulfillmentResponse';
  handOffPortalOrderId: Scalars['Int']['output'];
  handOffPortalOrderRef?: Maybe<Scalars['String']['output']>;
  status: CoordinatedFulfillmentStatus;
};

export type HandOffPortalOrderPartnerStatusResponse = {
  __typename?: 'HandOffPortalOrderPartnerStatusResponse';
  handOffPortalOrderId: Scalars['Int']['output'];
  handOffPortalOrderRef?: Maybe<Scalars['String']['output']>;
  priorAuthorizationApproved?: Maybe<Scalars['Boolean']['output']>;
  status: HandOffPortalOrderPartnerStatus;
};

export type HandOffPortalOrderPreviousRefill = {
  __typename?: 'HandOffPortalOrderPreviousRefill';
  id: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
  ref?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type HandOffPortalOrderPreviouslyRejectedOrder = {
  __typename?: 'HandOffPortalOrderPreviouslyRejectedOrder';
  handOffOrderSegmentId: Scalars['Int']['output'];
  handOffPortalOrderId: Scalars['Int']['output'];
  handOffPortalOrderRef?: Maybe<Scalars['String']['output']>;
  otherRejectionReason?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<HandOffPortalOrderRejectionReason>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum HandOffPortalOrderRejectionReason {
  AgeRestrictedItemsViolation = 'AGE_RESTRICTED_ITEMS_VIOLATION',
  AutoTerminatedByVerse = 'AUTO_TERMINATED_BY_VERSE',
  BilledSameOrSimilarItemsTooRecently = 'BILLED_SAME_OR_SIMILAR_ITEMS_TOO_RECENTLY',
  CostGreaterThanReimbursement = 'COST_GREATER_THAN_REIMBURSEMENT',
  CostGtReimbursementOrderTooExpensive = 'COST_GT_REIMBURSEMENT_ORDER_TOO_EXPENSIVE',
  CostGtReimbursementOrderTooSmall = 'COST_GT_REIMBURSEMENT_ORDER_TOO_SMALL',
  HomeHealthServicesIssue = 'HOME_HEALTH_SERVICES_ISSUE',
  HomeHealthServicesIssueHasNotReceivedHhsButRequired = 'HOME_HEALTH_SERVICES_ISSUE_HAS_NOT_RECEIVED_HHS_BUT_REQUIRED',
  HomeHealthServicesIssueReceivedHhs = 'HOME_HEALTH_SERVICES_ISSUE_RECEIVED_HHS',
  HomeHealthServicesIssueReceivedHhsAndHasBundledIns = 'HOME_HEALTH_SERVICES_ISSUE_RECEIVED_HHS_AND_HAS_BUNDLED_INS',
  HomeHealthServicesIssueUnableToVerifyHhsStatus = 'HOME_HEALTH_SERVICES_ISSUE_UNABLE_TO_VERIFY_HHS_STATUS',
  ItemsNotCovered = 'ITEMS_NOT_COVERED',
  ItemsNotCoveredCodesNotCovered = 'ITEMS_NOT_COVERED_CODES_NOT_COVERED',
  ItemsNotCoveredOther = 'ITEMS_NOT_COVERED_OTHER',
  ItemsNotCoveredPtHomeHealth = 'ITEMS_NOT_COVERED_PT_HOME_HEALTH',
  ItemsNotCoveredShippedBeforeEligible = 'ITEMS_NOT_COVERED_SHIPPED_BEFORE_ELIGIBLE',
  ItemsNotCoveredWoundCharacteristicsNotCovered = 'ITEMS_NOT_COVERED_WOUND_CHARACTERISTICS_NOT_COVERED',
  NotInNetwork = 'NOT_IN_NETWORK',
  NotInNetworkDifferentInsuranceMedicare = 'NOT_IN_NETWORK_DIFFERENT_INSURANCE_MEDICARE',
  NotInNetworkDifferentInsuranceOther = 'NOT_IN_NETWORK_DIFFERENT_INSURANCE_OTHER',
  NotInNetworkInactiveWasActiveAtService = 'NOT_IN_NETWORK_INACTIVE_WAS_ACTIVE_AT_SERVICE',
  NotInNetworkInactiveWasInactiveAtService = 'NOT_IN_NETWORK_INACTIVE_WAS_INACTIVE_AT_SERVICE',
  NotInNetworkNotContracted = 'NOT_IN_NETWORK_NOT_CONTRACTED',
  NotInNetworkOther = 'NOT_IN_NETWORK_OTHER',
  NotInNetworkPayorGroup = 'NOT_IN_NETWORK_PAYOR_GROUP',
  NoDmeCoverage = 'NO_DME_COVERAGE',
  OrderOlderThanSpecificDate = 'ORDER_OLDER_THAN_SPECIFIC_DATE',
  OrderPastTimelyFiling = 'ORDER_PAST_TIMELY_FILING',
  OrderTooOldToAccept = 'ORDER_TOO_OLD_TO_ACCEPT',
  Other = 'OTHER',
  OtherFixable = 'OTHER_FIXABLE',
  OtherNotFixable = 'OTHER_NOT_FIXABLE',
  PatientInsuranceInactiveAtDos = 'PATIENT_INSURANCE_INACTIVE_AT_DOS',
  PriorAuthorizationNotStartedInTime = 'PRIOR_AUTHORIZATION_NOT_STARTED_IN_TIME',
  PriorAuthNotStartedInTimeCannotBackdate = 'PRIOR_AUTH_NOT_STARTED_IN_TIME_CANNOT_BACKDATE',
  PriorAuthNotStartedInTimeCannotBackdateOld = 'PRIOR_AUTH_NOT_STARTED_IN_TIME_CANNOT_BACKDATE_OLD',
  PriorAuthNotStartedInTimeDoable = 'PRIOR_AUTH_NOT_STARTED_IN_TIME_DOABLE',
  PriorAuthNotStartedInTimeInsuranceRejectedAuth = 'PRIOR_AUTH_NOT_STARTED_IN_TIME_INSURANCE_REJECTED_AUTH',
  ProductLineUnbillable = 'PRODUCT_LINE_UNBILLABLE',
  TimeExpired = 'TIME_EXPIRED',
  UnableToCollectDeductibleCopayCoinsurance = 'UNABLE_TO_COLLECT_DEDUCTIBLE_COPAY_COINSURANCE',
  UnableToCollectLiabilityContactedPtOtherNRp = 'UNABLE_TO_COLLECT_LIABILITY_CONTACTED_PT_OTHER_N_RP',
  UnableToCollectLiabilityContactedPtOtherYRp = 'UNABLE_TO_COLLECT_LIABILITY_CONTACTED_PT_OTHER_Y_RP',
  UnableToCollectLiabilityContactedPtRefusedNRp = 'UNABLE_TO_COLLECT_LIABILITY_CONTACTED_PT_REFUSED_N_RP',
  UnableToCollectLiabilityContactedPtRefusedYRp = 'UNABLE_TO_COLLECT_LIABILITY_CONTACTED_PT_REFUSED_Y_RP',
  UnableToCollectLiabilityContactedPtReturn = 'UNABLE_TO_COLLECT_LIABILITY_CONTACTED_PT_RETURN',
  UnableToCollectLiabilityNocontactPtCannotReach = 'UNABLE_TO_COLLECT_LIABILITY_NOCONTACT_PT_CANNOT_REACH',
  UnableToCollectLiabilityNocontactPtIncorrectContactInfo = 'UNABLE_TO_COLLECT_LIABILITY_NOCONTACT_PT_INCORRECT_CONTACT_INFO',
  UnableToCollectLiabilityNocontactPtLargeDeductible = 'UNABLE_TO_COLLECT_LIABILITY_NOCONTACT_PT_LARGE_DEDUCTIBLE',
  UnableToCollectLiabilityNocontactPtOther = 'UNABLE_TO_COLLECT_LIABILITY_NOCONTACT_PT_OTHER',
  UnableToCollectLiabilityNocontactPtUninterestedCopay = 'UNABLE_TO_COLLECT_LIABILITY_NOCONTACT_PT_UNINTERESTED_COPAY'
}

export type HandOffPortalOrderRevision = {
  __typename?: 'HandOffPortalOrderRevision';
  createdAt: Scalars['DateTime']['output'];
  requests: Array<HandOffPortalOrderRevisionRequest>;
  response?: Maybe<HandOffPortalOrderRevisionResponse>;
};

export type HandOffPortalOrderRevisionRequest = {
  __typename?: 'HandOffPortalOrderRevisionRequest';
  document: HandOffRevisionRequestDocument;
  reasons: Array<HandOffRevisionRequestReason>;
};

export type HandOffPortalOrderRevisionRequestInput = {
  document: HandOffRevisionRequestDocument;
  reasons: Array<HandOffRevisionRequestReason>;
};

export type HandOffPortalOrderRevisionResponse = {
  __typename?: 'HandOffPortalOrderRevisionResponse';
  note?: Maybe<Scalars['String']['output']>;
  respondedAt: Scalars['DateTime']['output'];
  s3DocumentUrl?: Maybe<Scalars['String']['output']>;
};

export enum HandOffPortalOrderStatus {
  Accepted = 'ACCEPTED',
  Delivered = 'DELIVERED',
  PendingAdditionalInfo = 'PENDING_ADDITIONAL_INFO',
  PendingEdits = 'PENDING_EDITS',
  PendingResponse = 'PENDING_RESPONSE',
  PendingVerseReview = 'PENDING_VERSE_REVIEW',
  Rejected = 'REJECTED'
}

export type HandOffPortalOrderStatusInput = {
  deliveryAttestationItems?: InputMaybe<Array<DeliveryAttestationItemInput>>;
  handOffPortalOrderId?: InputMaybe<Scalars['Int']['input']>;
  handOffPortalOrderRef?: InputMaybe<Scalars['String']['input']>;
  newStatus: HandOffPortalOrderStatus;
  otherRejectionReason?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<HandOffPortalOrderRejectionReason>;
  revisionRequest?: InputMaybe<Array<HandOffPortalOrderRevisionRequestInput>>;
  revisionRequestNote?: InputMaybe<Scalars['String']['input']>;
  revisionRespondedBy?: InputMaybe<Scalars['Int']['input']>;
  revisionResponseDocuments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  revisionResponseNote?: InputMaybe<Scalars['String']['input']>;
};

export type HandOffPortalOrderTrackingDetails = {
  __typename?: 'HandOffPortalOrderTrackingDetails';
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export type HandOffPreferredDmeCompanies = {
  __typename?: 'HandOffPreferredDmeCompanies';
  category: Scalars['String']['output'];
  preferredDmeCompany?: Maybe<Scalars['String']['output']>;
};

export enum HandOffRevisionRequestDocument {
  PatientDemographics = 'PATIENT_DEMOGRAPHICS',
  ProgressNote = 'PROGRESS_NOTE',
  StandardWrittenOrder = 'STANDARD_WRITTEN_ORDER'
}

export enum HandOffRevisionRequestReason {
  DobDoesNotMatchInsurance = 'DOB_DOES_NOT_MATCH_INSURANCE',
  DobInsufficient = 'DOB_INSUFFICIENT',
  Icd10CodeInvalid = 'ICD10_CODE_INVALID',
  InsuranceNotActive = 'INSURANCE_NOT_ACTIVE',
  MissingPlanOfCare = 'MISSING_PLAN_OF_CARE',
  MissingSignature = 'MISSING_SIGNATURE',
  MissingWoundAssessment = 'MISSING_WOUND_ASSESSMENT',
  NeedHcpcsCodes = 'NEED_HCPCS_CODES',
  PatientUnderAnotherMembersInsurance = 'PATIENT_UNDER_ANOTHER_MEMBERS_INSURANCE',
  PlanOfCareInvalid = 'PLAN_OF_CARE_INVALID',
  SendCopyOfInsuranceCard = 'SEND_COPY_OF_INSURANCE_CARD',
  SignerNotAccreditedWithInsurance = 'SIGNER_NOT_ACCREDITED_WITH_INSURANCE',
  UnableToVerifyHomeHealthStatus = 'UNABLE_TO_VERIFY_HOME_HEALTH_STATUS',
  WoundAssessmentInvalid = 'WOUND_ASSESSMENT_INVALID'
}

export enum HandOffStatus {
  Failure = 'FAILURE',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  RevisionRequested = 'REVISION_REQUESTED',
  Success = 'SUCCESS'
}

export type HcpcsDepartmentLink = {
  __typename?: 'HcpcsDepartmentLink';
  hospitalId: Scalars['Int']['output'];
  hospitalName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type HcpcsMaxFrequencyEntry = {
  __typename?: 'HcpcsMaxFrequencyEntry';
  frequencyOfUse: Scalars['String']['output'];
  hcpcsCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  insuranceProvider?: Maybe<Scalars['String']['output']>;
};

export type HcpcsMaxQuantityEntry = {
  __typename?: 'HcpcsMaxQuantityEntry';
  hcpcsCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  maxQuantity: Scalars['Int']['output'];
  payorName?: Maybe<Scalars['String']['output']>;
  perWound?: Maybe<Scalars['Boolean']['output']>;
  periodDays: Scalars['Int']['output'];
  stateAbbr?: Maybe<Scalars['String']['output']>;
};

export type HcpcsOpsGuidanceGroup = {
  __typename?: 'HcpcsOpsGuidanceGroup';
  guidanceItems: Array<Scalars['String']['output']>;
  hcpcsCodes: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type Hl7NoteFile = {
  __typename?: 'Hl7NoteFile';
  createdAt: Scalars['DateTime']['output'];
  debugInfo?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  integrationSource: Scalars['String']['output'];
  isLatestPn: Scalars['Boolean']['output'];
  noteCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  pdfBase64?: Maybe<Scalars['String']['output']>;
  s3Url: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visitId: Scalars['String']['output'];
};

export type HolidayResponse = {
  __typename?: 'HolidayResponse';
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type HomeHealthAgency = {
  __typename?: 'HomeHealthAgency';
  acceptedInsurances: Array<Scalars['String']['output']>;
  address: Scalars['String']['output'];
  faxNumber: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type HomeHealthAgencyInput = {
  acceptedInsurances?: InputMaybe<Array<Scalars['String']['input']>>;
  address: Scalars['String']['input'];
  faxNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type HomeHealthCoordinationEvent = {
  __typename?: 'HomeHealthCoordinationEvent';
  createdAt: Scalars['DateTime']['output'];
  eventDescription: Scalars['String']['output'];
  eventStatus?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  homeHealthCoordinationOrderId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type HomeHealthCoordinationMessage = {
  __typename?: 'HomeHealthCoordinationMessage';
  createdAt: Scalars['String']['output'];
  message: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type HomeHealthCoordinationOrder = {
  __typename?: 'HomeHealthCoordinationOrder';
  createdAt: Scalars['DateTime']['output'];
  events: Array<HomeHealthCoordinationEvent>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  homeHealthAgencyName: Scalars['String']['output'];
  hospitalName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  messages: Array<HomeHealthCoordinationMessage>;
  orderNumber: Scalars['String']['output'];
  orderStatus: Scalars['String']['output'];
  orderType: Scalars['String']['output'];
  patientDob?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  remarks: Scalars['String']['output'];
  s3Documents: Array<S3Document>;
};

export enum HomeHealthCoordinationOrderEventStatus {
  OrderUpdateAccepted = 'ORDER_UPDATE_ACCEPTED',
  OrderUpdateDenied = 'ORDER_UPDATE_DENIED',
  OrderUpdateSent = 'ORDER_UPDATE_SENT',
  ReferralAccepted = 'REFERRAL_ACCEPTED',
  ReferralDenied = 'REFERRAL_DENIED',
  ReferralSent = 'REFERRAL_SENT',
  StatusUpdated = 'STATUS_UPDATED'
}

export type HomeHealthCoordinationOrderList = {
  __typename?: 'HomeHealthCoordinationOrderList';
  maxPage: Scalars['Int']['output'];
  numOrders: Scalars['Int']['output'];
  orders: Array<HomeHealthCoordinationOrder>;
  pageSize: Scalars['Int']['output'];
};

export enum HomeHealthCoordinationOrderStatus {
  Accepted = 'ACCEPTED',
  Denied = 'DENIED',
  Discharged = 'DISCHARGED',
  EpisodeStarted = 'EPISODE_STARTED',
  Processing = 'PROCESSING',
  Rerouting = 'REROUTING',
  SentToAgency = 'SENT_TO_AGENCY'
}

export enum HomeHealthOrderType {
  NewReferral = 'NEW_REFERRAL',
  TreatmentPlan = 'TREATMENT_PLAN'
}

export type Hospital = {
  __typename?: 'Hospital';
  accountStatus?: Maybe<HospitalAccountStatus>;
  address?: Maybe<Scalars['String']['output']>;
  allowSignersWithoutFaxNumbers?: Maybe<Scalars['Boolean']['output']>;
  caseManagementPayorName?: Maybe<Scalars['String']['output']>;
  /** @deprecated CSA connection to accounts removed */
  customerAccountId?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  departmentPreferences?: Maybe<Array<DepartmentPreference>>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  hospitalSystem?: Maybe<HospitalSystem>;
  /** @deprecated Moving to full HospitalSystem object */
  hospitalSystemId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isFaxClinic?: Maybe<Scalars['Boolean']['output']>;
  isHandOffAllowed?: Maybe<Scalars['Boolean']['output']>;
  isHomeHealth?: Maybe<Scalars['Boolean']['output']>;
  isManufacturer?: Maybe<Scalars['Boolean']['output']>;
  isRisk?: Maybe<Scalars['Boolean']['output']>;
  isWoundCareRefillOn?: Maybe<Scalars['Boolean']['output']>;
  medicalRecordsDepartmentFaxNumber?: Maybe<Scalars['String']['output']>;
  medicalRecordsDepartmentPhoneNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredDmePartnerIds?: Maybe<Array<Scalars['Int']['output']>>;
  riskNotes?: Maybe<Scalars['String']['output']>;
  salesRepId?: Maybe<Scalars['Int']['output']>;
  salesRepPhone?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  usageType: HospitalUsageType;
};

export enum HospitalAccountStatus {
  Active = 'ACTIVE',
  Churned = 'CHURNED',
  NewOnboarding = 'NEW_ONBOARDING',
  OnboardingFailed = 'ONBOARDING_FAILED',
  RevivedActive = 'REVIVED_ACTIVE',
  RevivedOnboarding = 'REVIVED_ONBOARDING'
}

export type HospitalBedLastXYears = {
  __typename?: 'HospitalBedLastXYears';
  reason?: Maybe<PlanOfCareCondition>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type HospitalBedLastXYearsInput = {
  reason?: InputMaybe<PlanOfCareConditionInput>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HospitalBedRequirementReason = {
  __typename?: 'HospitalBedRequirementReason';
  tractionEquipmentRequiredReason?: Maybe<Array<PlanOfCareCondition>>;
  tractionFrameType?: Maybe<PlanOfCareCondition>;
  values?: Maybe<Array<PlanOfCareCondition>>;
};

export type HospitalBedRequirementReasonInput = {
  tractionEquipmentRequiredReason?: InputMaybe<Array<PlanOfCareConditionInput>>;
  tractionFrameType?: InputMaybe<PlanOfCareConditionInput>;
  values?: InputMaybe<Array<PlanOfCareConditionInput>>;
};

export type HospitalProfile = {
  __typename?: 'HospitalProfile';
  departments: Array<Department>;
  hospital: Hospital;
};

export type HospitalProfileInput = {
  allowSignersWithoutFaxNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  customerAccountId?: InputMaybe<Scalars['Int']['input']>;
  hospitalAddress?: InputMaybe<Scalars['String']['input']>;
  hospitalId?: InputMaybe<Scalars['Int']['input']>;
  hospitalName: Scalars['String']['input'];
  hospitalNotes?: InputMaybe<Scalars['String']['input']>;
  hospitalPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  hospitalSystemId?: InputMaybe<Scalars['Int']['input']>;
  isHandOffAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isHomeHealth?: InputMaybe<Scalars['Boolean']['input']>;
  medicalRecordsDepartmentFaxNumber?: InputMaybe<Scalars['String']['input']>;
  medicalRecordsDepartmentPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredDmePartnerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  salesRepId?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type HospitalSystem = {
  __typename?: 'HospitalSystem';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sharedPatients?: Maybe<Scalars['Boolean']['output']>;
};

export type HospitalSystemInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sharedPatients?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HospitalUsageType {
  AutomatedTest = 'AUTOMATED_TEST',
  Customer = 'CUSTOMER',
  InternalTest = 'INTERNAL_TEST',
  OpsTraining = 'OPS_TRAINING',
  SalesDemo = 'SALES_DEMO'
}

export type HumanField = {
  __typename?: 'HumanField';
  explanation?: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  label: Scalars['String']['output'];
  verdict: Scalars['String']['output'];
};

export type Icd10Description = {
  __typename?: 'ICD10Description';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type IncompleteOrder = {
  __typename?: 'IncompleteOrder';
  departmentId: Scalars['Int']['output'];
  hospitalId: Scalars['Int']['output'];
  hospitalName: Scalars['String']['output'];
  initiatedAt: Scalars['DateTime']['output'];
  orderNumber: Scalars['String']['output'];
  s3Documents: Array<S3Document>;
};

export type InsertNewSegmentError = {
  __typename?: 'InsertNewSegmentError';
  message: Scalars['String']['output'];
};

export enum InsuranceType {
  AutoInsurance = 'AUTO_INSURANCE',
  HealthInsurance = 'HEALTH_INSURANCE',
  WorkersComp = 'WORKERS_COMP'
}

export type IssueNoteResponse = {
  __typename?: 'IssueNoteResponse';
  departmentOrderRemarks: Array<DepartmentOrderRemarkType>;
  orderStatus: ProviderReferralStatus;
};

export type IssuesByLocation = {
  __typename?: 'IssuesByLocation';
  avgResolutionHours?: Maybe<Scalars['Float']['output']>;
  hospitalName: Scalars['String']['output'];
  openIssues: Scalars['Int']['output'];
  ordersWithIssues: Scalars['Int']['output'];
  resolvedIssues: Scalars['Int']['output'];
  totalIssues: Scalars['Int']['output'];
};

export type IssuesByType = {
  __typename?: 'IssuesByType';
  avgResolutionHours?: Maybe<Scalars['Float']['output']>;
  label: Scalars['String']['output'];
  openIssues: Scalars['Int']['output'];
  totalIssues: Scalars['Int']['output'];
};

export type IssuesSummary = {
  __typename?: 'IssuesSummary';
  avgResolutionHours?: Maybe<Scalars['Float']['output']>;
  openIssues: Scalars['Int']['output'];
  ordersWithIssues: Scalars['Int']['output'];
  resolvedIssues: Scalars['Int']['output'];
  totalIssues: Scalars['Int']['output'];
};

export type LineItemAddedPrepError = {
  __typename?: 'LineItemAddedPrepError';
  annotation?: Maybe<SegmentPrepErrorAnnotation>;
  approvedValue?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['Int']['output'];
  errorType: SegmentPrepErrorType;
  preppedValue?: Maybe<Scalars['String']['output']>;
  tableName: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type LineItemField = {
  __typename?: 'LineItemField';
  columnName: Scalars['String']['output'];
  display: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type LineItemRemovedPrepError = {
  __typename?: 'LineItemRemovedPrepError';
  annotation?: Maybe<SegmentPrepErrorAnnotation>;
  approvedValue?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['Int']['output'];
  errorType: SegmentPrepErrorType;
  preppedValue?: Maybe<Scalars['String']['output']>;
  tableName: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type LineItemUpdatedPrepError = {
  __typename?: 'LineItemUpdatedPrepError';
  annotation?: Maybe<SegmentPrepErrorAnnotation>;
  approvedValue?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['Int']['output'];
  errorType: SegmentPrepErrorType;
  fieldName: Scalars['String']['output'];
  preppedValue?: Maybe<Scalars['String']['output']>;
  tableName: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type LineItemUpdatedPrepErrorLineItemAddedPrepErrorLineItemRemovedPrepErrorSegmentAddedPrepErrorSegmentRemovedPrepErrorShippingModePrepError = LineItemAddedPrepError | LineItemRemovedPrepError | LineItemUpdatedPrepError | SegmentAddedPrepError | SegmentRemovedPrepError | ShippingModePrepError;

export type LinkedDepartment = {
  __typename?: 'LinkedDepartment';
  hospitalId: Scalars['Int']['output'];
  hospitalName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type LinkedDistributorOrder = {
  __typename?: 'LinkedDistributorOrder';
  distributorName: Scalars['String']['output'];
  distributorOrderNumber?: Maybe<Scalars['String']['output']>;
  trackingNumbers: Array<LinkedTrackingNumber>;
};

export type LinkedFulfillmentOrder = {
  __typename?: 'LinkedFulfillmentOrder';
  orderNumber: Scalars['String']['output'];
  orderStatus?: Maybe<ProviderReferralStatus>;
  segments: Array<LinkedFulfillmentSegment>;
};

export type LinkedFulfillmentSegment = {
  __typename?: 'LinkedFulfillmentSegment';
  activeDate?: Maybe<Scalars['String']['output']>;
  distributorOrders: Array<LinkedDistributorOrder>;
  segmentNumber: Scalars['Int']['output'];
  segmentType: Scalars['String']['output'];
};

export type LinkedTrackingNumber = {
  __typename?: 'LinkedTrackingNumber';
  carrier?: Maybe<Scalars['String']['output']>;
  trackingNumber: Scalars['String']['output'];
};

export type LivekitCall = {
  __typename?: 'LivekitCall';
  aiRefusal: Scalars['Boolean']['output'];
  answered: Scalars['Boolean']['output'];
  callerHeard: Scalars['Boolean']['output'];
  duration: Scalars['String']['output'];
  externalEventId: Scalars['String']['output'];
  homeHealthAgency?: Maybe<Scalars['String']['output']>;
  needsHumanReview: Scalars['Boolean']['output'];
  orderNumbers: Array<Scalars['String']['output']>;
  orderResults: Array<LivekitOrderResult>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerPhoneNumber?: Maybe<Scalars['String']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  reviewReason?: Maybe<Scalars['String']['output']>;
  time: Scalars['DateTime']['output'];
};

export type LivekitCallList = {
  __typename?: 'LivekitCallList';
  calls: Array<LivekitCall>;
  maxPage: Scalars['Int']['output'];
};

export type LivekitOrderResult = {
  __typename?: 'LivekitOrderResult';
  callbackWindow?: Maybe<Scalars['String']['output']>;
  cannotSignReason?: Maybe<Scalars['String']['output']>;
  correctFaxNumber?: Maybe<Scalars['String']['output']>;
  correctionOffered?: Maybe<Scalars['String']['output']>;
  declineReason?: Maybe<Scalars['String']['output']>;
  eventDescription?: Maybe<Scalars['String']['output']>;
  needsEscalation: Scalars['Boolean']['output'];
  nonReceiptReason?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  orderNumber: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
  signingTimeline?: Maybe<Scalars['String']['output']>;
  wrongProviderInfo?: Maybe<Scalars['String']['output']>;
};

export enum LobDeliverability {
  Deliverable = 'DELIVERABLE',
  DeliverableIncorrectUnit = 'DELIVERABLE_INCORRECT_UNIT',
  DeliverableMissingUnit = 'DELIVERABLE_MISSING_UNIT',
  DeliverableUnnecessaryUnit = 'DELIVERABLE_UNNECESSARY_UNIT',
  Undeliverable = 'UNDELIVERABLE'
}

export type LocationTopProducts = {
  __typename?: 'LocationTopProducts';
  hospitalId: Scalars['Int']['output'];
  hospitalName: Scalars['String']['output'];
  products: Array<ProductCount>;
};

export type MailingAddress = {
  __typename?: 'MailingAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type MailingAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type ManagedManufacturer = {
  __typename?: 'ManagedManufacturer';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ManualEligibilityInput = {
  eligibleForDme?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  liabilities?: Array<ManualLiabilityInput>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['Int']['input'];
  payorId?: InputMaybe<Scalars['Int']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  planStatus?: InputMaybe<Scalars['String']['input']>;
  planType?: InputMaybe<Scalars['String']['input']>;
  policyType?: InputMaybe<Scalars['String']['input']>;
  queryDate?: InputMaybe<Scalars['String']['input']>;
  reportedPayorName?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type ManualLiabilityInput = {
  amountDollars?: InputMaybe<Scalars['Float']['input']>;
  amountPercent?: InputMaybe<Scalars['Float']['input']>;
  coverageLevel?: InputMaybe<Scalars['String']['input']>;
  liabilityType: Scalars['String']['input'];
  networkStatus: Scalars['String']['input'];
};

export type ManualPatientResponsibilityResult = {
  __typename?: 'ManualPatientResponsibilityResult';
  amount?: Maybe<Scalars['Float']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  paymentLinkUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  wasExisting: Scalars['Boolean']['output'];
};

export type ManufacturerMetrics = {
  __typename?: 'ManufacturerMetrics';
  totalOrderCount?: Maybe<Scalars['Int']['output']>;
  totalOrderCountHospitals?: Maybe<Scalars['Int']['output']>;
  totalOrderCountShipped?: Maybe<Scalars['Int']['output']>;
};

export type ManufacturerOrderInfo = {
  __typename?: 'ManufacturerOrderInfo';
  compressionProducts: Array<CompressionLineItem>;
  hospital?: Maybe<Scalars['String']['output']>;
  insurance?: Maybe<Scalars['String']['output']>;
  orderPlaced?: Maybe<Scalars['String']['output']>;
  signer?: Maybe<Scalars['String']['output']>;
  woundCareProducts: Array<WoundCareLineItem>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type ManufacturerPortal = {
  __typename?: 'ManufacturerPortal';
  hospitals: Array<Scalars['String']['output']>;
  keywords: Array<Scalars['String']['output']>;
  metrics: ManufacturerMetrics;
  name?: Maybe<Scalars['String']['output']>;
  orders: Array<ManufacturerOrderInfo>;
};

export type MarginCalculatorValueInput = {
  handOffOrderLineItemId?: InputMaybe<Scalars['Int']['input']>;
  handOffOrderLineItemRef?: InputMaybe<Scalars['String']['input']>;
  handOffPortalOrderId?: InputMaybe<Scalars['Int']['input']>;
  handOffPortalOrderRef?: InputMaybe<Scalars['String']['input']>;
  manualHcpcsCode?: InputMaybe<Scalars['String']['input']>;
  manualQty?: InputMaybe<Scalars['Int']['input']>;
  manualReimbursementRate?: InputMaybe<Scalars['Float']['input']>;
  reimbursementRate?: InputMaybe<Scalars['Float']['input']>;
};

export type MarkOrderAsIncompleteInput = {
  orderNumber: Scalars['String']['input'];
};

export type MarkOrderSegmentAsActiveResult = {
  __typename?: 'MarkOrderSegmentAsActiveResult';
  activeDate: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type MatchedDepartment = {
  __typename?: 'MatchedDepartment';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MatchedHospital = {
  __typename?: 'MatchedHospital';
  departments: Array<MatchedDepartment>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type MedicalNecessityInterview = {
  __typename?: 'MedicalNecessityInterview';
  entryStepId?: Maybe<Scalars['String']['output']>;
  steps: Array<MedicalNecessityStep>;
};

export type MedicalNecessityNarrative = {
  __typename?: 'MedicalNecessityNarrative';
  key: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type MedicalNecessityOutcome = {
  __typename?: 'MedicalNecessityOutcome';
  kind: MedicalNecessityOutcomeKind;
  reason: Scalars['String']['output'];
};

export enum MedicalNecessityOutcomeKind {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Incomplete = 'INCOMPLETE',
  NeedsReview = 'NEEDS_REVIEW',
  Route = 'ROUTE'
}

export type MedicalNecessityRoute = {
  __typename?: 'MedicalNecessityRoute';
  key: Scalars['String']['output'];
  target: MedicalNecessityTarget;
};

export type MedicalNecessityStep = {
  __typename?: 'MedicalNecessityStep';
  field?: Maybe<Scalars['String']['output']>;
  help?: Maybe<Array<Scalars['String']['output']>>;
  narratives: Array<MedicalNecessityNarrative>;
  onUnanswered?: Maybe<MedicalNecessityTarget>;
  routes: Array<MedicalNecessityRoute>;
  source?: Maybe<Scalars['String']['output']>;
  stepId: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type MedicalNecessityTarget = {
  __typename?: 'MedicalNecessityTarget';
  outcome?: Maybe<MedicalNecessityOutcome>;
  stepId?: Maybe<Scalars['String']['output']>;
};

export type MedicareAdvantagePotentialLiabilityNoticeStatus = {
  __typename?: 'MedicareAdvantagePotentialLiabilityNoticeStatus';
  declinedAt?: Maybe<Scalars['DateTime']['output']>;
  declinedByName?: Maybe<Scalars['String']['output']>;
  declinedByUserId?: Maybe<Scalars['Int']['output']>;
  noticedAt: Scalars['DateTime']['output'];
};

export type MedicareBlockingHcpcsCode = {
  __typename?: 'MedicareBlockingHcpcsCode';
  allAuditStateAbbrs: Array<Scalars['String']['output']>;
  auditEndDate?: Maybe<Scalars['DateTime']['output']>;
  auditStartDate: Scalars['DateTime']['output'];
  auditStateAbbr?: Maybe<Scalars['String']['output']>;
  auditStateId?: Maybe<Scalars['Int']['output']>;
  auditVariant?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hcpcsCode: Scalars['String']['output'];
  linkedDepartmentCount: Scalars['Int']['output'];
  payorId?: Maybe<Scalars['Int']['output']>;
  payorName?: Maybe<Scalars['String']['output']>;
};

export type MedicareBlockingHcpcsCodeInput = {
  auditStateId: Scalars['Int']['input'];
  hcpcsCode: Scalars['String']['input'];
  payorId?: InputMaybe<Scalars['Int']['input']>;
};

export type MedicareBlockingInfo = {
  __typename?: 'MedicareBlockingInfo';
  hcpcsAuditLineItems: Array<OrderSegmentLineItem>;
  isHighCostFlaggingEligible: Scalars['Boolean']['output'];
  isMedicareFromEv: Scalars['Boolean']['output'];
};

export type MedicareFrequencyExemptions = {
  __typename?: 'MedicareFrequencyExemptions';
  medicareFrequencyExemptions: Array<Scalars['Int']['output']>;
  medicareWeeklyFrequencyExemptions: Array<Scalars['Int']['output']>;
};

export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  id: Scalars['Int']['output'];
  keys: Array<MessageTemplateKey>;
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  settings: MessageTemplateSettings;
  team: Team;
};

export type MessageTemplateKey = {
  __typename?: 'MessageTemplateKey';
  id: Scalars['Int']['output'];
  isTemplateResponseOption: Scalars['Boolean']['output'];
  maxInstances?: Maybe<Scalars['Int']['output']>;
  minInstances: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  selectorType: TemplateKeySelectorType;
  showAlias: Scalars['Boolean']['output'];
};

export type MessageTemplateKeyInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  selectedOptionId?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

export type MessageTemplateSettings = {
  __typename?: 'MessageTemplateSettings';
  automaticReminders: Scalars['Boolean']['output'];
  blocking: Scalars['Boolean']['output'];
  departmentOrderRemarkTypes: Array<DepartmentOrderRemarkType>;
  departmentOrderStatus?: Maybe<ProviderReferralStatus>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  issue: Scalars['Boolean']['output'];
  needsApproval: Scalars['Boolean']['output'];
  notifyEmail: Scalars['Boolean']['output'];
  notifyFax: Scalars['Boolean']['output'];
  opsOrderStateTypeId?: Maybe<OpsOrderStateType>;
  orderCorrectionsRequested: Scalars['Boolean']['output'];
  otherSupportingFilesRequested: Scalars['Boolean']['output'];
  patientDemographicsRequested: Scalars['Boolean']['output'];
  providerNotesRequested: Scalars['Boolean']['output'];
};

export type MiscellaneousDiagnosis = {
  __typename?: 'MiscellaneousDiagnosis';
  diagnosis?: Maybe<Scalars['String']['output']>;
  icd10Code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type MiscellaneousDiagnosisInput = {
  diagnosis: Scalars['String']['input'];
  icd10Code?: InputMaybe<Scalars['String']['input']>;
};

export type MiscellaneousLineItem = {
  __typename?: 'MiscellaneousLineItem';
  id: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  remarks: Scalars['String']['output'];
  sizeSpecification: Scalars['String']['output'];
};

export type MiscellaneousLineItemInput = {
  productName: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  remarks: Scalars['String']['input'];
  sizeSpecification: Scalars['String']['input'];
};

export type MiscellaneousOrder = {
  __typename?: 'MiscellaneousOrder';
  diagnoses: Array<MiscellaneousDiagnosis>;
  lineItems: Array<MiscellaneousLineItem>;
};

export type MiscellaneousOrderInput = {
  diagnoses: Array<MiscellaneousDiagnosisInput>;
  lineItems: Array<MiscellaneousLineItemInput>;
};

export type MissedSegmentRate = {
  __typename?: 'MissedSegmentRate';
  days: Array<MissedSegmentRateDay>;
  weekToDate: MissedSegmentRateWeekToDate;
};

export type MissedSegmentRateDay = {
  __typename?: 'MissedSegmentRateDay';
  day: Scalars['String']['output'];
  denominator: Scalars['Int']['output'];
  hasStarted: Scalars['Boolean']['output'];
  isHoliday: Scalars['Boolean']['output'];
  missed: Scalars['Int']['output'];
  missedPct: Scalars['Float']['output'];
};

export type MissedSegmentRateWeekToDate = {
  __typename?: 'MissedSegmentRateWeekToDate';
  denominator: Scalars['Int']['output'];
  missed: Scalars['Int']['output'];
  missedPct: Scalars['Float']['output'];
};

export type MissingSignatureInfo = {
  __typename?: 'MissingSignatureInfo';
  count: Scalars['Int']['output'];
  shouldBlockOrders: Scalars['Boolean']['output'];
  shouldShowWarning: Scalars['Boolean']['output'];
};

export type ModernFormItem = {
  __typename?: 'ModernFormItem';
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lineItemFields: Array<LineItemField>;
  name: Scalars['String']['output'];
  optionGroups: Array<ModernFormItemOptionGroup>;
  popularity: Scalars['Int']['output'];
  variants: Array<ModernFormItemVariant>;
};

export type ModernFormItemOption = {
  __typename?: 'ModernFormItemOption';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ModernFormItemOptionGroup = {
  __typename?: 'ModernFormItemOptionGroup';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  options: Array<ModernFormItemOption>;
  required: Scalars['Boolean']['output'];
};

export type ModernFormItemVariant = {
  __typename?: 'ModernFormItemVariant';
  formItemOptionIds: Array<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type ModernIcd10Description = {
  __typename?: 'ModernIcd10Description';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type ModernLineItem = {
  __typename?: 'ModernLineItem';
  bottlesPerMonth?: Maybe<Scalars['Int']['output']>;
  cansPerDay?: Maybe<Scalars['Int']['output']>;
  categoryId: Scalars['Int']['output'];
  customProductName?: Maybe<Scalars['String']['output']>;
  formItemName: Scalars['String']['output'];
  formItemOptions: Array<Scalars['String']['output']>;
  formItemVariantId: Scalars['Int']['output'];
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  pumpHours?: Maybe<Scalars['Int']['output']>;
  pumpRateMlPerHour?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityIsMaximum?: Maybe<Scalars['Boolean']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
};

export type ModernLineItemInput = {
  bottlesPerMonth?: InputMaybe<Scalars['Int']['input']>;
  /** DEPRECATED: use bottles_per_month instead. */
  cansPerDay?: InputMaybe<Scalars['Int']['input']>;
  categoryId: Scalars['Int']['input'];
  customProductName?: InputMaybe<Scalars['String']['input']>;
  formItemVariantId: Scalars['Int']['input'];
  pumpHours?: InputMaybe<Scalars['Int']['input']>;
  pumpRateMlPerHour?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityIsMaximum?: InputMaybe<Scalars['Boolean']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptLobAddress?: Maybe<Scalars['Void']['output']>;
  /** @deprecated Replaced by the document_verification stage. Removed once verseOS stops calling it. */
  activateRetrievalVerificationCheckpoint: CareCoordinationRetrievalStageActions;
  addAdditionalFile?: Maybe<Scalars['Void']['output']>;
  addCareCoordinationTaskTag?: Maybe<Scalars['Void']['output']>;
  addCompressionColorSubcategory: Scalars['Boolean']['output'];
  addDistributorInvoice?: Maybe<Scalars['Void']['output']>;
  addDistributorOrderInvoiceProduct: Scalars['Int']['output'];
  addDocumentCollectionEvent?: Maybe<Scalars['Void']['output']>;
  addDocumentCollectionEventForDepartment?: Maybe<Scalars['Void']['output']>;
  addDocumentCollectionMessage?: Maybe<Scalars['Void']['output']>;
  addFilterAttributeValue: Scalars['Boolean']['output'];
  addHandOffPartnerPolicyRoutingEntry?: Maybe<Scalars['Void']['output']>;
  addHandOffPartnerRoutingHospitalBlocklistEntry?: Maybe<Scalars['Void']['output']>;
  addHcpcsCodeToGroup: HcpcsOpsGuidanceGroup;
  addHcpcsDepartmentLink: Array<HcpcsDepartmentLink>;
  addHomeHealthAgency?: Maybe<Scalars['Void']['output']>;
  addHomeHealthCoordinationEvent?: Maybe<Scalars['Void']['output']>;
  addHomeHealthCoordinationMessage?: Maybe<Scalars['Void']['output']>;
  addHomeHealthCoordinationOrderUpdate?: Maybe<Scalars['Void']['output']>;
  addManualEligibility: Scalars['Int']['output'];
  addMissingWoundInformation?: Maybe<Scalars['Void']['output']>;
  addNewDepartment?: Maybe<Scalars['Void']['output']>;
  addNewSigner: ProviderSigner;
  addNewSignerByHospitalId: ProviderSigner;
  addOpsOrderNote: Array<OpsOrderNote>;
  addPmnHcpcsAccessories: Array<PmnHcpcsAccessory>;
  addPmnHcpcsCodes: Array<PmnHcpcsCode>;
  addProductDiagnosisCode: DistributorOrderInvoiceProductDiagnosis;
  addProviderSignatureHoldExemption?: Maybe<Scalars['Void']['output']>;
  addRetrievalNote?: Maybe<Scalars['Void']['output']>;
  addRetrievalNotes?: Maybe<Scalars['Void']['output']>;
  addRetrievalTag?: Maybe<Scalars['Void']['output']>;
  addRoutedHandoffBlocklistEntry: Scalars['Boolean']['output'];
  addTrackingNumber: TrackingNumber;
  addWorklistCoverageSchedule: Scalars['Int']['output'];
  advanceRetrievalStage: CareCoordinationRetrievalStageSlug;
  advanceRetrievalsStage: Array<Scalars['Int']['output']>;
  approvePriorAuth: Scalars['Boolean']['output'];
  approveVendorOrderValidation: Scalars['Boolean']['output'];
  archiveBillerReview?: Maybe<Scalars['Void']['output']>;
  assignDocumentCollectionCallQueue: Array<DocumentCollectionCallQueueRow>;
  assignHandOffPortalOrder: AssignHandOffPortalOrderResponse;
  assignUserToDocument?: Maybe<Scalars['Int']['output']>;
  assignUserToOrder?: Maybe<Scalars['Int']['output']>;
  attemptPlacementOfCardinalOrderViaApi: OrderPlacementResponse;
  attemptPlacementOfMercyOrderViaApi: OrderPlacementResponse;
  attemptPlacementOfViveOrderViaApi: OrderPlacementResponse;
  batchCopyOrderDocuments: BatchCopyDocumentsResult;
  batchCreateOrders: BatchCreateOrderResult;
  batchSignOrders: Scalars['Boolean']['output'];
  bulkActivateCategories: BulkActivateResult;
  bulkAddSubcontractedPartners?: Maybe<Scalars['Void']['output']>;
  bulkAssignHospitalSalesReps: BulkAssignHospitalSalesRepsResult;
  bulkRemoveSubcontractedPartners?: Maybe<Scalars['Void']['output']>;
  bulkUpsertErrorAnnotations?: Maybe<Scalars['Void']['output']>;
  bypassPatientCharge: PatientCharge;
  callForUpdateHomeHealthCoordinationOrder?: Maybe<Scalars['Void']['output']>;
  cancelAutomaticReminders?: Maybe<Scalars['Void']['output']>;
  cancelBufferedOrderNote: Scalars['Boolean']['output'];
  cancelOrderForDeclinedMedicareAdvantagePotentialLiabilityNotice: MedicareAdvantagePotentialLiabilityNoticeStatus;
  cancelOrderWithAction: UpsertOpsOrderState;
  cancelWorklistCoverageSchedule: Scalars['Boolean']['output'];
  changeOrderSegmentType?: Maybe<Scalars['Void']['output']>;
  claimNextWorklistTasks: ClaimNextWorklistTasksResult;
  claimRetrievals: Array<Scalars['Int']['output']>;
  claimUnassignedTeamNoteResponses: ClaimNextWorklistTasksResult;
  claimWorklistTask: Scalars['Boolean']['output'];
  classifyOrderSegment: Array<EligibilityFlag>;
  classifyOtherFax?: Maybe<Scalars['Void']['output']>;
  clearRetrievalSnooze?: Maybe<Scalars['Void']['output']>;
  clearRetrievalsSnooze: Array<Scalars['Int']['output']>;
  completeOopPrep: OrderSegmentStateUpdate;
  confirmPatientAddress?: Maybe<Scalars['Void']['output']>;
  copyOrderDocumentsToNewOrder?: Maybe<Scalars['Void']['output']>;
  createAppealsPackage: Array<AppealsSectionDocument>;
  createCareCoordinationTaskTag: Scalars['Int']['output'];
  createCompressionColor: Scalars['Int']['output'];
  createDistributor: Scalars['Int']['output'];
  createDistributorOrderDiagnosis: DistributorOrderDiagnosis;
  createDistributorProduct: Scalars['Int']['output'];
  createDmeNetworkSegment?: Maybe<Scalars['Void']['output']>;
  createFilterAttribute: Scalars['Boolean']['output'];
  createFilterRuleset: FilterRuleset;
  createFilterRulesetGroup: FilterRulesetGroup;
  createFormItem: Scalars['Int']['output'];
  createFormItemSize: Scalars['Int']['output'];
  createHandOffOrderSegmentMessage: HandOffOrderSegmentMessage;
  createHandOffPortalPartnerAccount?: Maybe<Scalars['Void']['output']>;
  createHcpcsOpsGuidanceGroup: HcpcsOpsGuidanceGroup;
  createHomeHealthCoordinationOrder?: Maybe<Scalars['String']['output']>;
  createHospitalSystem: HospitalSystem;
  createManualPatientResponsibility: ManualPatientResponsibilityResult;
  createMedicareBlockingHcpcsCode: MedicareBlockingHcpcsCode;
  createNewClinicianAccount: CreateUserResponse;
  createNewHospital: CreateNewHospitalResponse;
  createNewOrderSegment?: Maybe<InsertNewSegmentError>;
  createOopTaskAndMessage?: Maybe<Scalars['Void']['output']>;
  createOpenPmClaim: OpenPmClaim;
  createOpsOrderNote: BufferOrSendResultGql;
  createOpsTask: OpsTask;
  createOpsTaskType: OpsTaskType;
  createOpsUserPositionHistory: Array<OpsUserPositionHistory>;
  createOrderCancellationType: OrderCancellationType;
  createOrderNote: Scalars['Int']['output'];
  createOrderNoteResponse: OrderNoteResponse;
  createPartnerReferringFacility: DepartmentSearchResult;
  createPatientCharge: PatientCharge;
  createPayorConfig: PayorConfig;
  createProviderReferral: Scalars['String']['output'];
  createProviderReferralDraft?: Maybe<Scalars['Void']['output']>;
  createRefillTasks?: Maybe<Scalars['Void']['output']>;
  createReportedOrderIssue?: Maybe<Scalars['Void']['output']>;
  createResetReason: ResetReason;
  createRetrievalTag: Scalars['Int']['output'];
  deactivateFaxOrderFormTemplateOverride: Scalars['Boolean']['output'];
  /** @deprecated Replaced by the document_verification stage. Removed once verseOS stops calling it. */
  deactivateRetrievalVerificationCheckpoint: CareCoordinationRetrievalStageActions;
  deescalateCareCoordinationTask?: Maybe<Scalars['Void']['output']>;
  deferSegment?: Maybe<Scalars['Void']['output']>;
  deleteCanonicalPayor: Scalars['Boolean']['output'];
  deleteCareCoordinationTaskTag?: Maybe<Scalars['Void']['output']>;
  deleteCompressionColor: Scalars['Boolean']['output'];
  deleteDistributorOrderDiagnosis?: Maybe<Scalars['Void']['output']>;
  deleteFixitDistributorOrder: Scalars['String']['output'];
  deleteFormItem: Scalars['Boolean']['output'];
  deleteFormItemSize: Scalars['Boolean']['output'];
  deleteHcpcsMaxFrequency?: Maybe<Scalars['Void']['output']>;
  deleteHcpcsMaxQuantity?: Maybe<Scalars['Void']['output']>;
  deleteHcpcsOpsGuidanceGroup: Scalars['Boolean']['output'];
  deleteHospital: Scalars['Boolean']['output'];
  deleteOpsTaskType: Scalars['Boolean']['output'];
  deleteOpsUserPositionHistory: Scalars['Boolean']['output'];
  deleteOrderFax?: Maybe<Scalars['Void']['output']>;
  deleteOrderSegment: ProviderReferralStatus;
  deleteOrderSegmentLineItem?: Maybe<Scalars['Void']['output']>;
  deleteOrderSignatures: Scalars['Int']['output'];
  deletePayorConfig: Scalars['Boolean']['output'];
  deleteProviderReferralDraft?: Maybe<Scalars['Void']['output']>;
  deleteRetrievalTag?: Maybe<Scalars['Void']['output']>;
  deleteS3Document?: Maybe<Scalars['Void']['output']>;
  deleteSigner?: Maybe<Scalars['Void']['output']>;
  deleteTrackingNumber?: Maybe<Scalars['Void']['output']>;
  denyPriorAuth: Scalars['Boolean']['output'];
  disableMedicareBlockingHcpcsAudit: Scalars['Boolean']['output'];
  editBufferedOrderNote: BufferedOrderNoteGql;
  editCrWorklistNote: Scalars['Boolean']['output'];
  editResetReason: ResetReason;
  eligibilityCheck: EligibilityCheckResponse;
  escalateCareCoordinationTask?: Maybe<Scalars['Void']['output']>;
  /** @deprecated Replaced by the document_verification stage. Removed once verseOS stops calling it. */
  escalateOrCancelRetrievalVerification: CareCoordinationRetrievalStageActions;
  exitSegmentsFromSynapse: Scalars['Boolean']['output'];
  flushBufferedOrderNotes: Scalars['Boolean']['output'];
  forceSendBufferedOrderNote: Scalars['Int']['output'];
  generateAndSaveProgressNotesSummaryPdfs?: Maybe<Scalars['Void']['output']>;
  generateBatchSignatureRequestPdf: Scalars['String']['output'];
  generateLlmBillerReviewResponse: BillerReviewDraft;
  generatePaymentLinkForPatientCharge: GeneratePaymentLinkResult;
  generateProgressNoteRequestPdf: Scalars['String']['output'];
  generateResetPasswordUrl?: Maybe<Scalars['String']['output']>;
  generateSignatureRequestPdf: Scalars['String']['output'];
  generateUnsignedProgressNoteSummaryPdf: Scalars['String']['output'];
  initializeHandOffPortalPartnerAccount?: Maybe<Scalars['Void']['output']>;
  insertContactUsLead?: Maybe<Scalars['Void']['output']>;
  insertOopPaymentLink: GeneratePaymentLinkResult;
  insertSubcontractOrderLineItem: SubcontractOrderLineItem;
  insertTestOrders: Array<Scalars['String']['output']>;
  issueResponse: IssueNoteResponse;
  linkFulfillmentToTelehealthRequest: Scalars['Boolean']['output'];
  markDocumentCollectionOrderSigned: DocumentCollectionOrder;
  markFailedDelivery?: Maybe<Scalars['Void']['output']>;
  markOrderAsIncomplete?: Maybe<Scalars['Void']['output']>;
  markOrderDocumentationUnworkable?: Maybe<Scalars['Void']['output']>;
  markOrderNotUhcMedicare: Scalars['Boolean']['output'];
  markOrderSegmentAsActive: MarkOrderSegmentAsActiveResult;
  markRefillOrderSegmentAsConfirmed?: Maybe<Scalars['DateTime']['output']>;
  markTrackingNumberDelivered?: Maybe<Scalars['Void']['output']>;
  matchInboundFaxToOrder?: Maybe<Scalars['Void']['output']>;
  matchOrderWounds: WoundMatching;
  mutateDepartmentFaxNumber?: Maybe<Scalars['Void']['output']>;
  newPatientCheckInRequest: Scalars['Boolean']['output'];
  offboardHire?: Maybe<Scalars['Void']['output']>;
  onboardNewHire?: Maybe<Scalars['Void']['output']>;
  overrideOrderStatus: Array<Scalars['String']['output']>;
  parkClinicalReviewAwaitingClinic?: Maybe<Scalars['Void']['output']>;
  passRetrievalOutreachConfirmation: CareCoordinationRetrievalStageActions;
  passRetrievalProviderValidation: CareCoordinationRetrievalStageSlug;
  passRetrievalVerification: CareCoordinationRetrievalStageActions;
  passRetrievalsOutreachConfirmation: Array<Scalars['Int']['output']>;
  patientEligibilityCheck: PatientEligibilityCheckResult;
  patientPortalCancelAllRefills: Scalars['JSON']['output'];
  patientPortalConfirmRefill: Scalars['Boolean']['output'];
  patientPortalSkipRefill: Scalars['Boolean']['output'];
  patientPortalUpdateAddress: Scalars['JSON']['output'];
  placeDistributorOrder: OrderPlacementResponse;
  placeSunScientificOrder: OrderPlacementResponse;
  provisionAnalyticsUser: CreateUserResponse;
  publishFaxOrderFormTemplate: FaxOrderFormTemplateVersion;
  reactivateHospital: Scalars['Boolean']['output'];
  reassignOrder?: Maybe<Scalars['Void']['output']>;
  reassignWorklistTask: Scalars['Boolean']['output'];
  recordBillerReviewRequest?: Maybe<Scalars['Void']['output']>;
  recordCheckPayment: PatientCharge;
  recordMedicarePatientOnHha?: Maybe<Scalars['Void']['output']>;
  recordOopCost?: Maybe<Scalars['Void']['output']>;
  recordPatientWillPayOop?: Maybe<Scalars['Void']['output']>;
  referOrderToHomeHealthAgency?: Maybe<Scalars['Void']['output']>;
  refreshNexonOrderPdf: Scalars['Boolean']['output'];
  regenerateRefills: RegenerateRefillsResult;
  releaseInvoicedClaimFilingGraceHold: Scalars['Int']['output'];
  releaseOnHoldClaims: Scalars['Boolean']['output'];
  removeCareCoordinationTaskTag?: Maybe<Scalars['Void']['output']>;
  removeCodeFromCanonicalPayor: Scalars['Boolean']['output'];
  removeCompressionColorSubcategory: Scalars['Boolean']['output'];
  removeHandOffPartnerPolicyRoutingEntry?: Maybe<Scalars['Void']['output']>;
  removeHandOffPartnerRoutingHospitalBlocklistEntry?: Maybe<Scalars['Void']['output']>;
  removeHcpcsCodeFromGroup: HcpcsOpsGuidanceGroup;
  removeHcpcsDepartmentLink: Array<HcpcsDepartmentLink>;
  removePmnHcpcsAccessory: Scalars['Boolean']['output'];
  removePmnHcpcsCode: Scalars['Boolean']['output'];
  removeProductDiagnosisCode?: Maybe<Scalars['Void']['output']>;
  removeProviderSignatureHoldExemption?: Maybe<Scalars['Void']['output']>;
  removeRetrievalTag?: Maybe<Scalars['Void']['output']>;
  removeRoutedHandoffBlocklistEntry: Scalars['Boolean']['output'];
  renameCompressionColor: Scalars['Boolean']['output'];
  renameFilterRuleset: FilterRuleset;
  reprocessDistributorInvoice?: Maybe<Scalars['Void']['output']>;
  requestOrderUpdate: Scalars['Boolean']['output'];
  requestProgressNotes?: Maybe<Scalars['Void']['output']>;
  requestSignatureForOrder?: Maybe<Scalars['Void']['output']>;
  resetHandOffOrderSegment?: Maybe<Scalars['Void']['output']>;
  resetOpsOrder?: Maybe<Scalars['Void']['output']>;
  resolveClinicNoteThread: Scalars['Boolean']['output'];
  resolveOrderNote: ResolveOrderNoteResponse;
  resolvePotentialLiabilityAcknowledgement: PotentialLiabilityAcknowledgement;
  restoreFaxOrderFormTemplateVersion: FaxOrderFormTemplateVersion;
  restoreOpsTaskType: OpsTaskType;
  restoreOpsUser?: Maybe<OpsUser>;
  restoreOrderDocument?: Maybe<Scalars['Void']['output']>;
  restoreOrderFax?: Maybe<Scalars['Void']['output']>;
  restoreOrderSegment: Scalars['Boolean']['output'];
  restoreOrderSegmentLineItem?: Maybe<Scalars['Void']['output']>;
  restoreSpreeUser?: Maybe<SpreeUser>;
  retractRetrievalCancellation: CareCoordinationRetrievalStageSlug;
  retractRetrievalOutreachConfirmation: CareCoordinationRetrievalStageActions;
  retractRetrievalProviderValidation: CareCoordinationRetrievalStageSlug;
  retractRetrievalVerification: CareCoordinationRetrievalStageActions;
  revokeRefillSmsConsent: RefillSmsConsent;
  runProductEligibility: ProductEligibilityReport;
  saveCanonicalPayorAndAssignCodes: CanonicalPayor;
  saveDocumentCollectionProviderContactForDepartment?: Maybe<Scalars['Void']['output']>;
  saveFilterRulesetTree: FilterRuleset;
  sendDocumentCollectionOrderFax?: Maybe<Scalars['Void']['output']>;
  sendHandOffOrderSegmentToPartner?: Maybe<Scalars['Void']['output']>;
  sendHomeHealthCoordinationOrderEmail?: Maybe<Scalars['Void']['output']>;
  sendNewAccountSetPasswordEmail?: Maybe<Scalars['Void']['output']>;
  sendPrPaperStatement: PrPaperStatementSendResult;
  sendSalesRepMessage?: Maybe<Scalars['Void']['output']>;
  setAwaitingClinicalReviewStatus?: Maybe<Scalars['Void']['output']>;
  setCompressionColorHex: Scalars['Boolean']['output'];
  setDepartmentFormItems?: Maybe<Scalars['Void']['output']>;
  setDistributorMappings: Scalars['Boolean']['output'];
  setDistributorUnavailability: Scalars['Boolean']['output'];
  setDocReviewFindingDecision: Scalars['Boolean']['output'];
  setDocReviewFindingFeedback: Scalars['Boolean']['output'];
  setDocReviewFindingsEntered: Scalars['Boolean']['output'];
  setDocReviewNoteDismissed: Scalars['Boolean']['output'];
  setDocReviewNoteFeedback: Scalars['Boolean']['output'];
  setFilterRulesetEnabled: FilterRuleset;
  setFilterRulesetGroupEnabled: FilterRulesetGroup;
  setFilterRulesetOutputCap: FilterRuleset;
  setGuidanceForGroup: HcpcsOpsGuidanceGroup;
  setHandOffPartnerRampVendorId: Scalars['Boolean']['output'];
  setLlmDefaultInvoiceDiagnoses: Scalars['Boolean']['output'];
  setOnlineStatus: Scalars['Boolean']['output'];
  setRemittanceChannel: OpenPmPayorWithRemittanceChannel;
  setVariantDistributorMappings: Scalars['Boolean']['output'];
  setWorklistTaskPin: Scalars['Boolean']['output'];
  setupDevMock: DevMockSetupResult;
  signOrder: Scalars['String']['output'];
  signScopeOfService: Scalars['Boolean']['output'];
  skipRetrievalProviderValidation: CareCoordinationRetrievalStageSlug;
  snoozeRetrieval?: Maybe<Scalars['Void']['output']>;
  snoozeRetrievals: Array<Scalars['Int']['output']>;
  softDeleteDistributor?: Maybe<Scalars['Void']['output']>;
  softDeleteOpsUser: Scalars['Boolean']['output'];
  softDeleteSpreeUser: Scalars['Boolean']['output'];
  splitFax?: Maybe<Scalars['Void']['output']>;
  standAloneIssueResponse: StandaloneIssueResponse;
  startClinicEditLease: ClinicEditWindowStatus;
  startWorklistTask: Scalars['Boolean']['output'];
  stickyOpsOrderNote: Array<OpsOrderNote>;
  suppressDistributorOrderWarning: Scalars['Boolean']['output'];
  toggleProductSelectionForPreview?: Maybe<Scalars['Void']['output']>;
  unassignRetrievals: Array<Scalars['Int']['output']>;
  undoOopPrep: OrderSegmentStateUpdate;
  undoOrderNotUhcMedicare: Scalars['Boolean']['output'];
  undoSplitFax?: Maybe<Scalars['Void']['output']>;
  updateAnalyticsUserScope: AnalyticsUser;
  updateAndSignProviderReferral: ProviderReferral;
  updateAutoAppealPackageSettings: AutoAppealPackageSettingsSchema;
  updateAutoApprovalSettings: AutoApprovalSettingsSchema;
  updateAutoClaimFileSettings: AutoClaimFileSettingsSchema;
  updateBillerReview?: Maybe<Scalars['Void']['output']>;
  updateBillerReviewDraft: BillerReviewDraft;
  updateBillingAuditKeywordsSettings: BillingAuditKeywordsSettingsSchema;
  updateCareCoordinationTaskAssignee?: Maybe<Scalars['Void']['output']>;
  updateCareCoordinationTaskStatus?: Maybe<Scalars['Void']['output']>;
  updateCareCoordinationTaskTag?: Maybe<Scalars['Void']['output']>;
  updateClinicalReviewSettings: ClinicalReviewSettingsSchema;
  updateDepartmentOrderPreferences?: Maybe<Scalars['Void']['output']>;
  updateDepartmentPriorityClinic?: Maybe<Scalars['Void']['output']>;
  updateDepartmentProfile?: Maybe<Scalars['Void']['output']>;
  updateDepartmentStrategicAccount?: Maybe<Scalars['Void']['output']>;
  updateDepartmentZingPreferred?: Maybe<Scalars['Void']['output']>;
  updateDistributorInvoiceProduct?: Maybe<Scalars['Void']['output']>;
  updateDistributorOrderDiagnosis?: Maybe<Scalars['Void']['output']>;
  updateDistributorOrderInvoiceProduct?: Maybe<Scalars['Void']['output']>;
  updateDistributorOrderInvoiceProductDiagnoses?: Maybe<Scalars['Void']['output']>;
  updateDistributorPreferredShippingMode?: Maybe<Scalars['Void']['output']>;
  updateDistributorProductFields: Scalars['Boolean']['output'];
  updateDistributorUndeliverableToPoBox: Scalars['Boolean']['output'];
  updateDocumentCollectionEvent?: Maybe<Scalars['Void']['output']>;
  updateDocumentCollectionOrderStatus?: Maybe<Scalars['Void']['output']>;
  updateFeatureFlag?: Maybe<Scalars['Void']['output']>;
  updateFormItemFields: Scalars['Boolean']['output'];
  updateFormItemName: Scalars['Boolean']['output'];
  updateFormItemSize: Scalars['Boolean']['output'];
  updateHandOffPortalOrderPartnerNote?: Maybe<Scalars['Void']['output']>;
  updateHandOffPortalOrderPartnerStatus: HandOffPortalOrderPartnerStatusResponse;
  updateHandOffPortalOrderPartnerStatusCoordinatedFulfillment: HandOffPortalOrderPartnerStatusCoordinatedFulfillmentResponse;
  updateHandOffPortalOrderStatus?: Maybe<Scalars['Void']['output']>;
  updateHomeHealthAgency?: Maybe<Scalars['Void']['output']>;
  updateHomeHealthCoordinationOrderStatus?: Maybe<Scalars['Void']['output']>;
  updateHomeHealthCoordinationOrderStatusByProvider?: Maybe<Scalars['Void']['output']>;
  updateHospitalPersistentNotes?: Maybe<Scalars['Void']['output']>;
  updateHospitalProfile?: Maybe<Scalars['Void']['output']>;
  updateHospitalSystem?: Maybe<Scalars['Void']['output']>;
  updateInboundFax?: Maybe<Scalars['Void']['output']>;
  updateLineItemAnnotationOverride?: Maybe<Scalars['Void']['output']>;
  updateManagedSpreeUser?: Maybe<SpreeUser>;
  updateOpsDayTypeOverride: OpsDayToType;
  updateOpsTask?: Maybe<Scalars['Void']['output']>;
  updateOpsTaskType: OpsTaskType;
  updateOpsUserFull?: Maybe<OpsUser>;
  updateOpsUserPositionHistory: Array<OpsUserPositionHistory>;
  updateOrderCancellationType: OrderCancellationType;
  updateOrderRemarks?: Maybe<Scalars['Void']['output']>;
  updateOrderSegment?: Maybe<Scalars['Void']['output']>;
  updateOrderSegmentGeneralPrepFeedback: OrderSegment;
  updateOrderSegmentShippingModes: Array<OrderSegmentShippingMode>;
  updateOrderSegmentState: OrderSegmentStateUpdate;
  updatePatientCharge: PatientCharge;
  updatePatientProfile?: Maybe<Scalars['Void']['output']>;
  updatePayorConfig: PayorConfig;
  updateProductDiagnosisCode?: Maybe<Scalars['Void']['output']>;
  updateProviderPersistentNotes?: Maybe<Scalars['Void']['output']>;
  updateProviderReferral: ProviderReferral;
  updateProviderReferralDraft?: Maybe<Scalars['Void']['output']>;
  updateProviderReferralFax?: Maybe<Scalars['Void']['output']>;
  updateProviderUserPhone?: Maybe<Scalars['Void']['output']>;
  updateReportedOrderIssue?: Maybe<Scalars['Void']['output']>;
  updateRetrievalTag?: Maybe<Scalars['Void']['output']>;
  updateS3Document?: Maybe<Scalars['Void']['output']>;
  updateSignerEmails?: Maybe<Scalars['Void']['output']>;
  updateSignerInformation?: Maybe<ProviderSigner>;
  updateSubcontractOrderLineItems?: Maybe<Scalars['Void']['output']>;
  updateTimelyFilingLimits?: Maybe<Scalars['Void']['output']>;
  updateTrackingNumber: TrackingNumber;
  updateUserSettings?: Maybe<Scalars['Void']['output']>;
  updateWorklistSettings: WorklistSettingsSchema;
  updateWorklistTaskPinReason: Scalars['Boolean']['output'];
  updateWoundItemClassification: Scalars['Boolean']['output'];
  updateZingPrSettings: ZingPrSettings;
  uploadAndParseFeeScheduleFile: ParsedFeeScheduleFile;
  uploadDocumentToOrder: Scalars['String']['output'];
  uploadHcpcsMaxFrequencies: UploadHcpcsMaxFrequenciesResult;
  uploadHcpcsMaxQuantities: UploadHcpcsMaxQuantitiesResult;
  uploadOrderDocument: S3DocumentInfo;
  uploadSynapseFulfillDocument: Scalars['String']['output'];
  upsertDepartmentCategory?: Maybe<Scalars['Void']['output']>;
  upsertDistributorOrder: UpsertDistributorOrder;
  upsertEncounterId: Scalars['Int']['output'];
  upsertErrorAnnotation?: Maybe<Scalars['Void']['output']>;
  upsertHandOffOrderSegment?: Maybe<Scalars['Void']['output']>;
  upsertHandOffPartner: HandOffPartner;
  upsertMarginCalculatorValues?: Maybe<Scalars['Void']['output']>;
  upsertOpsOrderState: UpsertOpsOrderState;
  upsertReturnTracking: ReturnTracking;
  verifyAddress: VerifyAddressResult;
};


export type MutationAcceptLobAddressArgs = {
  orderNumber: Scalars['String']['input'];
};


export type MutationActivateRetrievalVerificationCheckpointArgs = {
  retrievalId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationAddAdditionalFileArgs = {
  file: Scalars['Upload']['input'];
  fileType: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
};


export type MutationAddCareCoordinationTaskTagArgs = {
  tagId: Scalars['Int']['input'];
  taskId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationAddCompressionColorSubcategoryArgs = {
  colorId: Scalars['Int']['input'];
  subCategory: ProductSubCategory;
};


export type MutationAddDistributorInvoiceArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationAddDistributorOrderInvoiceProductArgs = {
  distributorOrderId: Scalars['Int']['input'];
  itemsPerPackage?: InputMaybe<Scalars['Int']['input']>;
  numPackages: Scalars['Int']['input'];
  productDescription: Scalars['String']['input'];
  productNumber: Scalars['String']['input'];
};


export type MutationAddDocumentCollectionEventArgs = {
  documentCollectionOrderId: Scalars['Int']['input'];
  eventDescription: Scalars['String']['input'];
  eventType: Scalars['String']['input'];
};


export type MutationAddDocumentCollectionEventForDepartmentArgs = {
  agentCallOutcome?: InputMaybe<Scalars['String']['input']>;
  departmentId: Scalars['Int']['input'];
  documentCollectionOrderId: Scalars['Int']['input'];
  eventDescription: Scalars['String']['input'];
  eventType: Scalars['String']['input'];
};


export type MutationAddDocumentCollectionMessageArgs = {
  departmentId: Scalars['Int']['input'];
  documentCollectionOrderId: Scalars['Int']['input'];
  message: Scalars['String']['input'];
};


export type MutationAddFilterAttributeValueArgs = {
  attributeKey: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationAddHandOffPartnerPolicyRoutingEntryArgs = {
  destinationPartnerId: Scalars['Int']['input'];
  patientState: Scalars['String']['input'];
  payorId: Scalars['Int']['input'];
  policyType: Scalars['String']['input'];
};


export type MutationAddHandOffPartnerRoutingHospitalBlocklistEntryArgs = {
  hospitalId: Scalars['Int']['input'];
};


export type MutationAddHcpcsCodeToGroupArgs = {
  groupId: Scalars['Int']['input'];
  hcpcsCode: Scalars['String']['input'];
};


export type MutationAddHcpcsDepartmentLinkArgs = {
  departmentId: Scalars['Int']['input'];
  hcpcsCode: Scalars['String']['input'];
};


export type MutationAddHomeHealthAgencyArgs = {
  departmentId: Scalars['Int']['input'];
  homeHealthAgency: HomeHealthAgencyInput;
};


export type MutationAddHomeHealthCoordinationEventArgs = {
  description: Scalars['String']['input'];
  homeHealthCoordinationOrderId: Scalars['Int']['input'];
  status: HomeHealthCoordinationOrderEventStatus;
};


export type MutationAddHomeHealthCoordinationMessageArgs = {
  homeHealthCoordinationOrderId: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  spreeUserId: Scalars['Int']['input'];
};


export type MutationAddHomeHealthCoordinationOrderUpdateArgs = {
  departmentId: Scalars['Int']['input'];
  files: Array<Scalars['Upload']['input']>;
  homeHealthCoordinationOrderId: Scalars['Int']['input'];
};


export type MutationAddManualEligibilityArgs = {
  eligibilityInput: ManualEligibilityInput;
};


export type MutationAddMissingWoundInformationArgs = {
  orderNumber: Scalars['String']['input'];
};


export type MutationAddNewDepartmentArgs = {
  departmentProfileInput: DepartmentProfileInput;
};


export type MutationAddNewSignerArgs = {
  departmentId: Scalars['Int']['input'];
  signerInput: SignerInput;
};


export type MutationAddNewSignerByHospitalIdArgs = {
  hospitalId: Scalars['Int']['input'];
  signerInput: SignerInput;
};


export type MutationAddOpsOrderNoteArgs = {
  note: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationAddPmnHcpcsAccessoriesArgs = {
  pairs: Array<PmnHcpcsAccessoryInput>;
  payorId: Scalars['Int']['input'];
};


export type MutationAddPmnHcpcsCodesArgs = {
  hcpcsCodes: Array<Scalars['String']['input']>;
  payorId: Scalars['Int']['input'];
};


export type MutationAddProductDiagnosisCodeArgs = {
  addProductDiagnosisCodeInput: AddProductDiagnosisCodeInput;
};


export type MutationAddProviderSignatureHoldExemptionArgs = {
  npi: Scalars['String']['input'];
  opsUserId: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};


export type MutationAddRetrievalNoteArgs = {
  note: Scalars['String']['input'];
  retrievalId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddRetrievalNotesArgs = {
  note: Scalars['String']['input'];
  retrievalIds: Array<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddRetrievalTagArgs = {
  retrievalId: Scalars['Int']['input'];
  tagId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationAddRoutedHandoffBlocklistEntryArgs = {
  partnerId: Scalars['Int']['input'];
  planName: Scalars['String']['input'];
  stateName: Scalars['String']['input'];
};


export type MutationAddTrackingNumberArgs = {
  trackingNumberInput: TrackingNumberInput;
};


export type MutationAddWorklistCoverageScheduleArgs = {
  input: AddWorklistCoverageScheduleInput;
};


export type MutationAdvanceRetrievalStageArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  retrievalId: Scalars['Int']['input'];
  toSlug: CareCoordinationRetrievalStageSlug;
  userId: Scalars['Int']['input'];
};


export type MutationAdvanceRetrievalsStageArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  retrievalIds: Array<Scalars['Int']['input']>;
  toSlug: CareCoordinationRetrievalStageSlug;
  userId: Scalars['Int']['input'];
};


export type MutationApprovePriorAuthArgs = {
  orderNumber: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
  priorAuthId: Scalars['String']['input'];
  synapseContextHtml?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApproveVendorOrderValidationArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationArchiveBillerReviewArgs = {
  billerReviewId: Scalars['Int']['input'];
};


export type MutationAssignHandOffPortalOrderArgs = {
  assignedToUserId?: InputMaybe<Scalars['Int']['input']>;
  handOffPortalOrderId?: InputMaybe<Scalars['Int']['input']>;
  handOffPortalOrderRef?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAssignUserToDocumentArgs = {
  documentAssignmentInput: DocumentAssignmentInput;
};


export type MutationAssignUserToOrderArgs = {
  orderAssignmentInput: OrderAssignmentInput;
};


export type MutationAttemptPlacementOfCardinalOrderViaApiArgs = {
  opsUserId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationAttemptPlacementOfMercyOrderViaApiArgs = {
  opsUserId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationAttemptPlacementOfViveOrderViaApiArgs = {
  opsUserId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationBatchCopyOrderDocumentsArgs = {
  copies: Array<OrderDocumentCopy>;
};


export type MutationBatchCreateOrdersArgs = {
  hospitalName: Scalars['String']['input'];
  providerReferralInputs: Array<ProviderReferralInput>;
  signerInput: SignerInput;
};


export type MutationBatchSignOrdersArgs = {
  isHomeHealth: Scalars['Boolean']['input'];
};


export type MutationBulkActivateCategoriesArgs = {
  category: ProductCategory;
  departmentIds: Array<Scalars['Int']['input']>;
};


export type MutationBulkAddSubcontractedPartnersArgs = {
  partnerId: Scalars['Int']['input'];
  partnerStateFile: Scalars['Upload']['input'];
};


export type MutationBulkAssignHospitalSalesRepsArgs = {
  updates: Array<BulkAssignHospitalSalesRepsItemInput>;
};


export type MutationBulkRemoveSubcontractedPartnersArgs = {
  partnerId: Scalars['Int']['input'];
  partnerStateFile: Scalars['Upload']['input'];
};


export type MutationBulkUpsertErrorAnnotationsArgs = {
  annotations: Array<SegmentPrepErrorAnnotationInput>;
};


export type MutationBypassPatientChargeArgs = {
  patientChargeId: Scalars['Int']['input'];
  reason?: InputMaybe<BypassReason>;
};


export type MutationCallForUpdateHomeHealthCoordinationOrderArgs = {
  homeHealthCoordinationOrderId: Scalars['Int']['input'];
};


export type MutationCancelAutomaticRemindersArgs = {
  orderNoteId: Scalars['Int']['input'];
};


export type MutationCancelBufferedOrderNoteArgs = {
  bufferedNoteId: Scalars['Int']['input'];
};


export type MutationCancelOrderForDeclinedMedicareAdvantagePotentialLiabilityNoticeArgs = {
  orderNumber: Scalars['String']['input'];
};


export type MutationCancelOrderWithActionArgs = {
  orderCancellationTypeId: Scalars['Int']['input'];
  orderNoteText?: InputMaybe<Scalars['String']['input']>;
  upsertOpsOrderStateInput: UpsertOpsOrderStateInput;
};


export type MutationCancelWorklistCoverageScheduleArgs = {
  scheduleId: Scalars['Int']['input'];
};


export type MutationChangeOrderSegmentTypeArgs = {
  orderSegmentId: Scalars['Int']['input'];
  orderSegmentTypeId: Scalars['Int']['input'];
};


export type MutationClaimNextWorklistTasksArgs = {
  taskSubtype?: InputMaybe<Scalars['String']['input']>;
  taskType: TaskType;
};


export type MutationClaimRetrievalsArgs = {
  retrievalIds: Array<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationClaimUnassignedTeamNoteResponsesArgs = {
  team: NoteResponseTeam;
};


export type MutationClaimWorklistTaskArgs = {
  nodeId: Scalars['Int']['input'];
};


export type MutationClassifyOrderSegmentArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationClassifyOtherFaxArgs = {
  classification: RcmScannedFaxClassification;
  inboundFaxId: Scalars['Int']['input'];
};


export type MutationClearRetrievalSnoozeArgs = {
  retrievalId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationClearRetrievalsSnoozeArgs = {
  retrievalIds: Array<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationCompleteOopPrepArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationConfirmPatientAddressArgs = {
  opsUserId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
};


export type MutationCopyOrderDocumentsToNewOrderArgs = {
  copy: OrderDocumentCopy;
};


export type MutationCreateAppealsPackageArgs = {
  appealsPackageInput: AppealsPackageInput;
  orderNumber: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationCreateCareCoordinationTaskTagArgs = {
  displayString: Scalars['String']['input'];
};


export type MutationCreateCompressionColorArgs = {
  input: CreateCompressionColorInput;
};


export type MutationCreateDistributorArgs = {
  name: Scalars['String']['input'];
  preferredShippingMode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDistributorOrderDiagnosisArgs = {
  code: Scalars['String']['input'];
  distributorOrderId: Scalars['Int']['input'];
};


export type MutationCreateDistributorProductArgs = {
  input: CreateDistributorProductInput;
};


export type MutationCreateDmeNetworkSegmentArgs = {
  handOffOrderSegmentType: HandOffOrderSegmentType;
  opsUserId: Scalars['Int']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationCreateFilterAttributeArgs = {
  attributeKey: Scalars['String']['input'];
  dataType?: AttributeType;
  sourceColumn?: InputMaybe<Scalars['String']['input']>;
  sourceTable?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateFilterRulesetArgs = {
  groupId?: InputMaybe<Scalars['Int']['input']>;
  ruleKey: Scalars['String']['input'];
};


export type MutationCreateFilterRulesetGroupArgs = {
  groupKey: Scalars['String']['input'];
  maintainer?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateFormItemArgs = {
  input: CreateFormItemInput;
};


export type MutationCreateFormItemSizeArgs = {
  input: CreateFormItemSizeInput;
};


export type MutationCreateHandOffOrderSegmentMessageArgs = {
  handOffPortalOrderId: Scalars['Int']['input'];
  message: Scalars['String']['input'];
};


export type MutationCreateHandOffPortalPartnerAccountArgs = {
  email: Scalars['String']['input'];
  handOffPartnerId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateHomeHealthCoordinationOrderArgs = {
  departmentId: Scalars['Int']['input'];
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  homeHealthAgencyId: Scalars['Int']['input'];
  orderType: HomeHealthOrderType;
};


export type MutationCreateHospitalSystemArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateManualPatientResponsibilityArgs = {
  amount: Scalars['Float']['input'];
  amountBasis?: InputMaybe<AmountBasis>;
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationCreateMedicareBlockingHcpcsCodeArgs = {
  input: MedicareBlockingHcpcsCodeInput;
};


export type MutationCreateNewClinicianAccountArgs = {
  departmentId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  hospitalId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  userCreated?: Scalars['Boolean']['input'];
};


export type MutationCreateNewHospitalArgs = {
  createHospitalInput: CreateHospitalInput;
};


export type MutationCreateNewOrderSegmentArgs = {
  newOrderSegmentInput: NewOrderSegmentInput;
};


export type MutationCreateOopTaskAndMessageArgs = {
  eligibilityDate?: InputMaybe<Scalars['String']['input']>;
  opsUserId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
  reason: OopReason;
  sizeRequestedItems?: InputMaybe<Array<SizeRequestedItemInput>>;
};


export type MutationCreateOpenPmClaimArgs = {
  distributorOrderId?: InputMaybe<Scalars['Int']['input']>;
  orderNumber: Scalars['String']['input'];
  orderSegmentId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationCreateOpsOrderNoteArgs = {
  forceSend?: Scalars['Boolean']['input'];
  lastSeenOrderNoteId?: InputMaybe<Scalars['Int']['input']>;
  orderNoteInput: OrderNoteInput;
};


export type MutationCreateOpsTaskArgs = {
  opsTaskInput: OpsTaskInput;
};


export type MutationCreateOpsTaskTypeArgs = {
  input: OpsTaskTypeInput;
};


export type MutationCreateOpsUserPositionHistoryArgs = {
  input: CreateOpsUserPositionHistoryInput;
};


export type MutationCreateOrderCancellationTypeArgs = {
  input: OrderCancellationTypeInput;
};


export type MutationCreateOrderNoteArgs = {
  opsUserId?: InputMaybe<Scalars['Int']['input']>;
  orderNoteInput: OrderNoteInput;
};


export type MutationCreateOrderNoteResponseArgs = {
  departmentOrderId: Scalars['Int']['input'];
  fileAttachments: Array<OrderNoteFileUploads>;
  lastSeenOrderNoteId?: InputMaybe<Scalars['Int']['input']>;
  llmChosenResponse: Scalars['String']['input'];
  opsUserId?: InputMaybe<Scalars['Int']['input']>;
  orderNoteId: Scalars['Int']['input'];
  requireClinicResponse: Scalars['Boolean']['input'];
  responseText: Scalars['String']['input'];
};


export type MutationCreatePartnerReferringFacilityArgs = {
  facility: PartnerReferringFacilityInput;
  handOffPartnerId: Scalars['Int']['input'];
};


export type MutationCreatePatientChargeArgs = {
  patientChargeInput: PatientChargeInput;
};


export type MutationCreatePayorConfigArgs = {
  input: PayorConfigInput;
};


export type MutationCreateProviderReferralArgs = {
  hospitalName?: InputMaybe<Scalars['String']['input']>;
  isOrderFromDraft: Scalars['Boolean']['input'];
  partnerOrderSubmission?: InputMaybe<PartnerOrderSubmissionInput>;
  providerReferralInput: ProviderReferralInput;
  s3DocumentReferences: Array<S3DocumentReference>;
  signerInput: SignerInput;
};


export type MutationCreateProviderReferralDraftArgs = {
  hospitalName?: InputMaybe<Scalars['String']['input']>;
  providerReferralInput: ProviderReferralInput;
  s3DocumentReferences: Array<S3DocumentReference>;
  signerInput: SignerInput;
};


export type MutationCreateRefillTasksArgs = {
  numberOfRefills: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationCreateReportedOrderIssueArgs = {
  reportedOrderIssueInput: ReportedOrderIssueInput;
};


export type MutationCreateResetReasonArgs = {
  enabled?: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
};


export type MutationCreateRetrievalTagArgs = {
  displayString: Scalars['String']['input'];
};


export type MutationDeactivateFaxOrderFormTemplateOverrideArgs = {
  hospitalId: Scalars['Int']['input'];
  productCategory: ProductCategory;
};


export type MutationDeactivateRetrievalVerificationCheckpointArgs = {
  retrievalId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationDeescalateCareCoordinationTaskArgs = {
  reason: Scalars['String']['input'];
  taskId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationDeferSegmentArgs = {
  activeDate: Scalars['DateTime']['input'];
  lastDeliveryDate: Scalars['DateTime']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationDeleteCanonicalPayorArgs = {
  canonicalPayorId: Scalars['Int']['input'];
};


export type MutationDeleteCareCoordinationTaskTagArgs = {
  tagId: Scalars['Int']['input'];
};


export type MutationDeleteCompressionColorArgs = {
  colorId: Scalars['Int']['input'];
};


export type MutationDeleteDistributorOrderDiagnosisArgs = {
  diagnosisId: Scalars['Int']['input'];
};


export type MutationDeleteFixitDistributorOrderArgs = {
  distributorOrderId: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};


export type MutationDeleteFormItemArgs = {
  formItemId: Scalars['Int']['input'];
  replacementFormItemId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteFormItemSizeArgs = {
  formItemSizeId: Scalars['Int']['input'];
};


export type MutationDeleteHcpcsMaxFrequencyArgs = {
  entryId: Scalars['Int']['input'];
};


export type MutationDeleteHcpcsMaxQuantityArgs = {
  entryId: Scalars['Int']['input'];
};


export type MutationDeleteHcpcsOpsGuidanceGroupArgs = {
  groupId: Scalars['Int']['input'];
};


export type MutationDeleteHospitalArgs = {
  hospitalId: Scalars['Int']['input'];
};


export type MutationDeleteOpsTaskTypeArgs = {
  typeId: Scalars['Int']['input'];
};


export type MutationDeleteOpsUserPositionHistoryArgs = {
  positionHistoryId: Scalars['Int']['input'];
};


export type MutationDeleteOrderFaxArgs = {
  input: DeleteOrderFaxInput;
};


export type MutationDeleteOrderSegmentArgs = {
  opsUserId?: InputMaybe<Scalars['Int']['input']>;
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationDeleteOrderSegmentLineItemArgs = {
  deletedBy: Scalars['Int']['input'];
  lineItemId: Scalars['String']['input'];
};


export type MutationDeleteOrderSignaturesArgs = {
  orderNumber: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationDeletePayorConfigArgs = {
  configId: Scalars['Int']['input'];
};


export type MutationDeleteProviderReferralDraftArgs = {
  orderNumber: Scalars['String']['input'];
};


export type MutationDeleteRetrievalTagArgs = {
  tagId: Scalars['Int']['input'];
};


export type MutationDeleteS3DocumentArgs = {
  input: DeleteS3DocumentInput;
};


export type MutationDeleteSignerArgs = {
  signerId: Scalars['Int']['input'];
};


export type MutationDeleteTrackingNumberArgs = {
  trackingNumberId: Scalars['Int']['input'];
};


export type MutationDenyPriorAuthArgs = {
  orderNumber: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
  priorAuthId: Scalars['String']['input'];
};


export type MutationDisableMedicareBlockingHcpcsAuditArgs = {
  input: DisableMedicareBlockingHcpcsAuditInput;
};


export type MutationEditBufferedOrderNoteArgs = {
  input: EditBufferedOrderNoteInput;
};


export type MutationEditCrWorklistNoteArgs = {
  nodeId: Scalars['Int']['input'];
  notes: Scalars['String']['input'];
};


export type MutationEditResetReasonArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  resetReasonId: Scalars['Int']['input'];
};


export type MutationEligibilityCheckArgs = {
  memberId: Scalars['String']['input'];
  opsUserId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
  patientDob: Scalars['String']['input'];
  patientFirstName: Scalars['String']['input'];
  patientLastName: Scalars['String']['input'];
  payorName: Scalars['String']['input'];
};


export type MutationEscalateCareCoordinationTaskArgs = {
  reason: Scalars['String']['input'];
  taskId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationEscalateOrCancelRetrievalVerificationArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  retrievalId: Scalars['Int']['input'];
  toSlug: CareCoordinationRetrievalStageSlug;
  userId: Scalars['Int']['input'];
};


export type MutationExitSegmentsFromSynapseArgs = {
  byBiller?: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  orderSegmentIds: Array<Scalars['Int']['input']>;
  reason: SynapseExitReason;
};


export type MutationFlushBufferedOrderNotesArgs = {
  departmentOrderId: Scalars['Int']['input'];
  nodeId: Scalars['Int']['input'];
};


export type MutationForceSendBufferedOrderNoteArgs = {
  bufferedNoteId: Scalars['Int']['input'];
};


export type MutationGenerateAndSaveProgressNotesSummaryPdfsArgs = {
  departmentId: Scalars['Int']['input'];
};


export type MutationGenerateBatchSignatureRequestPdfArgs = {
  isHomeHealth?: Scalars['Boolean']['input'];
  orderNumber: Scalars['String']['input'];
};


export type MutationGenerateLlmBillerReviewResponseArgs = {
  billerReviewId: Scalars['Int']['input'];
  context: Scalars['String']['input'];
  revision?: Scalars['String']['input'];
};


export type MutationGeneratePaymentLinkForPatientChargeArgs = {
  orderSegmentId: Scalars['Int']['input'];
  patientChargeType: ChargeType;
};


export type MutationGenerateProgressNoteRequestPdfArgs = {
  orderNumber: Scalars['String']['input'];
};


export type MutationGenerateResetPasswordUrlArgs = {
  email: Scalars['String']['input'];
};


export type MutationGenerateSignatureRequestPdfArgs = {
  orderNumber: Scalars['String']['input'];
};


export type MutationGenerateUnsignedProgressNoteSummaryPdfArgs = {
  orderNumber: Scalars['String']['input'];
  orderSegmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationInitializeHandOffPortalPartnerAccountArgs = {
  handOffPartnerId: Scalars['Int']['input'];
};


export type MutationInsertContactUsLeadArgs = {
  contactFormInput: ContactFormInput;
};


export type MutationInsertOopPaymentLinkArgs = {
  externalLinkId: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationInsertSubcontractOrderLineItemArgs = {
  handOffOrderSegmentId: Scalars['Int']['input'];
};


export type MutationInsertTestOrdersArgs = {
  backdateDays?: Scalars['Int']['input'];
  count?: Scalars['Int']['input'];
  departmentId: Scalars['Int']['input'];
  npi?: InputMaybe<Scalars['String']['input']>;
};


export type MutationIssueResponseArgs = {
  approved: Scalars['Boolean']['input'];
  noteId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
  selections?: InputMaybe<Array<NoteResponseSelectionInput>>;
};


export type MutationLinkFulfillmentToTelehealthRequestArgs = {
  fulfillmentDepartmentOrderId: Scalars['Int']['input'];
  telehealthRequestOrderNumber: Scalars['String']['input'];
};


export type MutationMarkDocumentCollectionOrderSignedArgs = {
  departmentId: Scalars['Int']['input'];
  documentCollectionOrderId: Scalars['Int']['input'];
};


export type MutationMarkFailedDeliveryArgs = {
  existingTrackingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  failedTrackingNumberId: Scalars['Int']['input'];
  newOrderSegmentInput?: InputMaybe<NewOrderSegmentInput>;
  newTrackingNumberInputs?: InputMaybe<Array<TrackingNumberInput>>;
  orderNumber: Scalars['String']['input'];
};


export type MutationMarkOrderAsIncompleteArgs = {
  markOrderAsIncompleteInput: MarkOrderAsIncompleteInput;
};


export type MutationMarkOrderDocumentationUnworkableArgs = {
  documentationType: OrderDocumentationType;
  opsUserId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
  reason?: InputMaybe<OrderDocumentationUnworkableReason>;
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkOrderNotUhcMedicareArgs = {
  orderNumber: Scalars['String']['input'];
};


export type MutationMarkOrderSegmentAsActiveArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationMarkRefillOrderSegmentAsConfirmedArgs = {
  orderNumber: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationMarkTrackingNumberDeliveredArgs = {
  deliveredAt?: InputMaybe<Scalars['DateTime']['input']>;
  trackingNumberId: Scalars['Int']['input'];
};


export type MutationMatchInboundFaxToOrderArgs = {
  fax: FaxInput;
  filenameHash: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
};


export type MutationMatchOrderWoundsArgs = {
  matches: Array<WoundMatchInput>;
  orderNumber: Scalars['String']['input'];
};


export type MutationMutateDepartmentFaxNumberArgs = {
  departmentFaxNumberInput: DepartmentFaxNumberInput;
};


export type MutationNewPatientCheckInRequestArgs = {
  note: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOffboardHireArgs = {
  input: OffboardHireInput;
};


export type MutationOnboardNewHireArgs = {
  input: OnboardNewHireInput;
};


export type MutationOverrideOrderStatusArgs = {
  input: OverrideOrderStatusInput;
};


export type MutationParkClinicalReviewAwaitingClinicArgs = {
  orderNumber: Scalars['String']['input'];
};


export type MutationPassRetrievalOutreachConfirmationArgs = {
  retrievalId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationPassRetrievalProviderValidationArgs = {
  retrievalId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationPassRetrievalVerificationArgs = {
  retrievalId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
  verificationSlug: CareCoordinationRetrievalStageSlug;
};


export type MutationPassRetrievalsOutreachConfirmationArgs = {
  retrievalIds: Array<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationPatientEligibilityCheckArgs = {
  canonicalPayorId: Scalars['Int']['input'];
  dateOfService: Scalars['Date']['input'];
  memberId: Scalars['String']['input'];
  opsUserId: Scalars['Int']['input'];
  patientId: Scalars['Int']['input'];
};


export type MutationPatientPortalCancelAllRefillsArgs = {
  orderSegmentId: Scalars['Int']['input'];
  patientId: Scalars['Int']['input'];
};


export type MutationPatientPortalConfirmRefillArgs = {
  itemKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  orderSegmentId: Scalars['Int']['input'];
  patientId: Scalars['Int']['input'];
  quantities?: InputMaybe<Scalars['JSON']['input']>;
  shownItemKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationPatientPortalSkipRefillArgs = {
  orderSegmentId: Scalars['Int']['input'];
  patientId: Scalars['Int']['input'];
};


export type MutationPatientPortalUpdateAddressArgs = {
  address: PatientPortalAddressInput;
  orderSegmentId?: InputMaybe<Scalars['Int']['input']>;
  patientId: Scalars['Int']['input'];
};


export type MutationPlaceDistributorOrderArgs = {
  distributorId: Scalars['Int']['input'];
  opsUserId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationPlaceSunScientificOrderArgs = {
  opsUserId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationProvisionAnalyticsUserArgs = {
  input: ProvisionAnalyticsUserInput;
};


export type MutationPublishFaxOrderFormTemplateArgs = {
  file: Scalars['Upload']['input'];
  hospitalId?: InputMaybe<Scalars['Int']['input']>;
  productCategory: ProductCategory;
};


export type MutationReactivateHospitalArgs = {
  hospitalId: Scalars['Int']['input'];
};


export type MutationReassignOrderArgs = {
  newDepartmentId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
};


export type MutationReassignWorklistTaskArgs = {
  newAssigneeId?: InputMaybe<Scalars['Int']['input']>;
  nodeId: Scalars['Int']['input'];
};


export type MutationRecordBillerReviewRequestArgs = {
  assigneeId?: InputMaybe<Scalars['Int']['input']>;
  billerReviewReasonType: BillerReviewReasonType;
  orderNumber: Scalars['String']['input'];
  requestedBy: Scalars['Int']['input'];
};


export type MutationRecordCheckPaymentArgs = {
  recordInput: RecordCheckPaymentInput;
};


export type MutationRecordMedicarePatientOnHhaArgs = {
  departmentId: Scalars['Int']['input'];
  patientDob: Scalars['String']['input'];
};


export type MutationRecordOopCostArgs = {
  orderNumber: Scalars['String']['input'];
  price: Scalars['String']['input'];
};


export type MutationRecordPatientWillPayOopArgs = {
  orderNumber: Scalars['String']['input'];
  patientOopDecision: PatientOopDecisionInput;
};


export type MutationReferOrderToHomeHealthAgencyArgs = {
  departmentId: Scalars['Int']['input'];
  fileKeys: Array<Scalars['String']['input']>;
  homeHealthAgencyId: Scalars['Int']['input'];
  homeHealthCoordinationOrderId: Scalars['Int']['input'];
};


export type MutationRefreshNexonOrderPdfArgs = {
  departmentId: Scalars['Int']['input'];
  documentCollectionOrderId: Scalars['Int']['input'];
};


export type MutationRegenerateRefillsArgs = {
  opsUserId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
};


export type MutationRemoveCareCoordinationTaskTagArgs = {
  tagId: Scalars['Int']['input'];
  taskId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationRemoveCodeFromCanonicalPayorArgs = {
  apiCodeId: Scalars['Int']['input'];
};


export type MutationRemoveCompressionColorSubcategoryArgs = {
  colorId: Scalars['Int']['input'];
  subCategory: ProductSubCategory;
};


export type MutationRemoveHandOffPartnerPolicyRoutingEntryArgs = {
  routingEntryId: Scalars['Int']['input'];
};


export type MutationRemoveHandOffPartnerRoutingHospitalBlocklistEntryArgs = {
  routingHospitalEntryId: Scalars['Int']['input'];
};


export type MutationRemoveHcpcsCodeFromGroupArgs = {
  groupId: Scalars['Int']['input'];
  hcpcsCode: Scalars['String']['input'];
};


export type MutationRemoveHcpcsDepartmentLinkArgs = {
  departmentId: Scalars['Int']['input'];
  hcpcsCode: Scalars['String']['input'];
};


export type MutationRemovePmnHcpcsAccessoryArgs = {
  pmnHcpcsAccessoryId: Scalars['Int']['input'];
};


export type MutationRemovePmnHcpcsCodeArgs = {
  pmnHcpcsCodeId: Scalars['Int']['input'];
};


export type MutationRemoveProductDiagnosisCodeArgs = {
  removeProductDiagnosisCodeInput: RemoveProductDiagnosisCodeInput;
};


export type MutationRemoveProviderSignatureHoldExemptionArgs = {
  npi: Scalars['String']['input'];
  opsUserId: Scalars['Int']['input'];
};


export type MutationRemoveRetrievalTagArgs = {
  retrievalId: Scalars['Int']['input'];
  tagId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationRemoveRoutedHandoffBlocklistEntryArgs = {
  blocklistEntryId: Scalars['Int']['input'];
};


export type MutationRenameCompressionColorArgs = {
  input: RenameCompressionColorInput;
};


export type MutationRenameFilterRulesetArgs = {
  ruleKey: Scalars['String']['input'];
  rulesetId: Scalars['Int']['input'];
};


export type MutationReprocessDistributorInvoiceArgs = {
  s3DocumentId?: InputMaybe<Scalars['Int']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestOrderUpdateArgs = {
  fromEmail: Scalars['Boolean']['input'];
  orderNumber: Scalars['String']['input'];
  patientName: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestProgressNotesArgs = {
  opsUserId: Scalars['Int']['input'];
  orders: Array<Scalars['String']['input']>;
};


export type MutationRequestSignatureForOrderArgs = {
  faxNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  faxRecipientPracticeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  opsUserId?: InputMaybe<Scalars['Int']['input']>;
  orderNumber: Scalars['String']['input'];
  providerAsTarget: Scalars['Boolean']['input'];
  toEmail: Scalars['Boolean']['input'];
  toFax: Scalars['Boolean']['input'];
};


export type MutationResetHandOffOrderSegmentArgs = {
  handOffOrderSegmentId: Scalars['Int']['input'];
};


export type MutationResetOpsOrderArgs = {
  orderNumber: Scalars['String']['input'];
  resetReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResolveClinicNoteThreadArgs = {
  noteId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
};


export type MutationResolveOrderNoteArgs = {
  noteId: Scalars['Int']['input'];
};


export type MutationResolvePotentialLiabilityAcknowledgementArgs = {
  orderNumber: Scalars['String']['input'];
  response: PatientResponse;
};


export type MutationRestoreFaxOrderFormTemplateVersionArgs = {
  versionId: Scalars['Int']['input'];
};


export type MutationRestoreOpsTaskTypeArgs = {
  typeId: Scalars['Int']['input'];
};


export type MutationRestoreOpsUserArgs = {
  opsUserId: Scalars['Int']['input'];
};


export type MutationRestoreOrderDocumentArgs = {
  input: RestoreOrderDocumentInput;
};


export type MutationRestoreOrderFaxArgs = {
  input: RestoreOrderFaxInput;
};


export type MutationRestoreOrderSegmentArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationRestoreOrderSegmentLineItemArgs = {
  orderSegmentLineItemId: Scalars['Int']['input'];
};


export type MutationRestoreSpreeUserArgs = {
  spreeUserId: Scalars['Int']['input'];
};


export type MutationRetractRetrievalCancellationArgs = {
  reopenTo?: CareCoordinationRetrievalStageSlug;
  retrievalId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationRetractRetrievalOutreachConfirmationArgs = {
  retrievalId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationRetractRetrievalProviderValidationArgs = {
  retrievalId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationRetractRetrievalVerificationArgs = {
  reopenTo?: CareCoordinationRetrievalStageSlug;
  retrievalId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
  verificationSlug: CareCoordinationRetrievalStageSlug;
};


export type MutationRevokeRefillSmsConsentArgs = {
  orderNumber: Scalars['String']['input'];
};


export type MutationRunProductEligibilityArgs = {
  departmentOrderId: Scalars['Int']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationSaveCanonicalPayorAndAssignCodesArgs = {
  payorInput: CanonicalPayorInput;
};


export type MutationSaveDocumentCollectionProviderContactForDepartmentArgs = {
  departmentId: Scalars['Int']['input'];
  documentCollectionOrderId: Scalars['Int']['input'];
  field: ProviderContactField;
  value: Scalars['String']['input'];
};


export type MutationSaveFilterRulesetTreeArgs = {
  ruleTree?: InputMaybe<Scalars['JSON']['input']>;
  rulesetId: Scalars['Int']['input'];
};


export type MutationSendDocumentCollectionOrderFaxArgs = {
  departmentId: Scalars['Int']['input'];
  documentCollectionOrderId: Scalars['Int']['input'];
  eventDescription: Scalars['String']['input'];
  faxNumber: Scalars['String']['input'];
};


export type MutationSendHandOffOrderSegmentToPartnerArgs = {
  sendHandOffOrderSegmentInput: SendHandOffOrderSegmentInput;
};


export type MutationSendHomeHealthCoordinationOrderEmailArgs = {
  homeHealthCoordinationOrderId: Scalars['Int']['input'];
};


export type MutationSendNewAccountSetPasswordEmailArgs = {
  email: Scalars['String']['input'];
  ordinal: Scalars['Int']['input'];
};


export type MutationSendPrPaperStatementArgs = {
  orderNumber: Scalars['String']['input'];
  recipientAddress?: InputMaybe<MailingAddressInput>;
};


export type MutationSendSalesRepMessageArgs = {
  salesRepInput: SalesRepMessageInput;
};


export type MutationSetAwaitingClinicalReviewStatusArgs = {
  orderNumber: Scalars['String']['input'];
  status: DagNodeStatus;
};


export type MutationSetCompressionColorHexArgs = {
  colorId: Scalars['Int']['input'];
  hex: Scalars['String']['input'];
};


export type MutationSetDepartmentFormItemsArgs = {
  category: ProductCategory;
  departmentId: Scalars['Int']['input'];
  formItemIds: Array<Scalars['Int']['input']>;
};


export type MutationSetDistributorMappingsArgs = {
  input: SetDistributorMappingsInput;
};


export type MutationSetDistributorUnavailabilityArgs = {
  input: SetDistributorUnavailabilityInput;
};


export type MutationSetDocReviewFindingDecisionArgs = {
  decision?: InputMaybe<Scalars['String']['input']>;
  decisionText?: InputMaybe<Scalars['String']['input']>;
  findingId: Scalars['String']['input'];
};


export type MutationSetDocReviewFindingFeedbackArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  findingId: Scalars['String']['input'];
  rating: Scalars['String']['input'];
};


export type MutationSetDocReviewFindingsEnteredArgs = {
  entered: Scalars['Boolean']['input'];
  findingIds: Array<Scalars['String']['input']>;
};


export type MutationSetDocReviewNoteDismissedArgs = {
  dismissed: Scalars['Boolean']['input'];
  noteId: Scalars['String']['input'];
};


export type MutationSetDocReviewNoteFeedbackArgs = {
  comment: Scalars['String']['input'];
  noteId: Scalars['String']['input'];
};


export type MutationSetFilterRulesetEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  rulesetId: Scalars['Int']['input'];
};


export type MutationSetFilterRulesetGroupEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  groupId: Scalars['Int']['input'];
};


export type MutationSetFilterRulesetOutputCapArgs = {
  outputCap?: InputMaybe<Scalars['Int']['input']>;
  rulesetId: Scalars['Int']['input'];
};


export type MutationSetGuidanceForGroupArgs = {
  groupId: Scalars['Int']['input'];
  guidanceTexts: Array<Scalars['String']['input']>;
};


export type MutationSetHandOffPartnerRampVendorIdArgs = {
  handOffPartnerId: Scalars['Int']['input'];
  rampVendorId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationSetLlmDefaultInvoiceDiagnosesArgs = {
  distributorOrderId: Scalars['Int']['input'];
};


export type MutationSetOnlineStatusArgs = {
  isOffline: Scalars['Boolean']['input'];
  offlineReason?: InputMaybe<OfflineReason>;
};


export type MutationSetRemittanceChannelArgs = {
  input: SetRemittanceChannelInput;
};


export type MutationSetVariantDistributorMappingsArgs = {
  input: SetVariantDistributorMappingsInput;
};


export type MutationSetWorklistTaskPinArgs = {
  nodeId: Scalars['Int']['input'];
  pinned: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetupDevMockArgs = {
  mockType: DevMockType;
  options?: InputMaybe<DevMockOptions>;
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationSignOrderArgs = {
  email: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  reviewAll?: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};


export type MutationSignScopeOfServiceArgs = {
  accessToken: Scalars['String']['input'];
  patientDob: Scalars['String']['input'];
};


export type MutationSkipRetrievalProviderValidationArgs = {
  retrievalId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationSnoozeRetrievalArgs = {
  duration: Scalars['Int']['input'];
  retrievalId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationSnoozeRetrievalsArgs = {
  duration: Scalars['Int']['input'];
  retrievalIds: Array<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationSoftDeleteDistributorArgs = {
  distributorId: Scalars['Int']['input'];
};


export type MutationSoftDeleteOpsUserArgs = {
  opsUserId: Scalars['Int']['input'];
};


export type MutationSoftDeleteSpreeUserArgs = {
  spreeUserId: Scalars['Int']['input'];
};


export type MutationSplitFaxArgs = {
  filenameHash: Scalars['String']['input'];
  pageRanges: Array<PageRangeInput>;
};


export type MutationStandAloneIssueResponseArgs = {
  approved: Scalars['Boolean']['input'];
  captchaToken?: InputMaybe<Scalars['String']['input']>;
  fromEmail: Scalars['Boolean']['input'];
  orderNumber: Scalars['String']['input'];
  providerNoteId: Scalars['Int']['input'];
  selections?: InputMaybe<Array<NoteResponseSelectionInput>>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartClinicEditLeaseArgs = {
  orderNumber: Scalars['String']['input'];
};


export type MutationStartWorklistTaskArgs = {
  nodeId: Scalars['Int']['input'];
};


export type MutationStickyOpsOrderNoteArgs = {
  opsOrderNoteId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
  sticky: Scalars['Boolean']['input'];
};


export type MutationSuppressDistributorOrderWarningArgs = {
  distributorId?: InputMaybe<Scalars['Int']['input']>;
  distributorOrderId?: InputMaybe<Scalars['Int']['input']>;
  orderSegmentId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationToggleProductSelectionForPreviewArgs = {
  toggleProductSelectionForPreviewInput: ToggleProductSelectionForPreviewInput;
};


export type MutationUnassignRetrievalsArgs = {
  retrievalIds: Array<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationUndoOopPrepArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type MutationUndoOrderNotUhcMedicareArgs = {
  orderNumber: Scalars['String']['input'];
};


export type MutationUndoSplitFaxArgs = {
  filenameHash: Scalars['String']['input'];
  parentId: Scalars['Int']['input'];
};


export type MutationUpdateAnalyticsUserScopeArgs = {
  input: UpdateAnalyticsUserScopeInput;
};


export type MutationUpdateAndSignProviderReferralArgs = {
  providerReferralInput: ProviderReferralInput;
};


export type MutationUpdateAutoAppealPackageSettingsArgs = {
  input: AutoAppealPackageSettingsInput;
};


export type MutationUpdateAutoApprovalSettingsArgs = {
  input: AutoApprovalSettingsInput;
};


export type MutationUpdateAutoClaimFileSettingsArgs = {
  input: AutoClaimFileSettingsInput;
};


export type MutationUpdateBillerReviewArgs = {
  billerNotes?: InputMaybe<BillerReviewOrderNoteInput>;
  billerResponseType: BillerReviewResponseType;
  billerReviewId: Scalars['Int']['input'];
  completedBy: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  orderNumber: Scalars['String']['input'];
  pnSwoMatchingIssues?: InputMaybe<Array<PnswoMatchingIssueInput>>;
};


export type MutationUpdateBillerReviewDraftArgs = {
  billerReviewDraftId: Scalars['Int']['input'];
  response: Scalars['String']['input'];
};


export type MutationUpdateBillingAuditKeywordsSettingsArgs = {
  input: BillingAuditKeywordsSettingsInput;
};


export type MutationUpdateCareCoordinationTaskAssigneeArgs = {
  assigneeId?: InputMaybe<Scalars['Int']['input']>;
  taskId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUpdateCareCoordinationTaskStatusArgs = {
  notes?: Scalars['String']['input'];
  numAttempts?: InputMaybe<Scalars['Int']['input']>;
  status: CareCoordinationTaskStatus;
  taskId: Scalars['Int']['input'];
  userId?: Scalars['Int']['input'];
};


export type MutationUpdateCareCoordinationTaskTagArgs = {
  displayString: Scalars['String']['input'];
  tagId: Scalars['Int']['input'];
};


export type MutationUpdateClinicalReviewSettingsArgs = {
  input: ClinicalReviewSettingsInput;
};


export type MutationUpdateDepartmentOrderPreferencesArgs = {
  departmentId: Scalars['Int']['input'];
  optionId: Scalars['Int']['input'];
  questionId: Scalars['Int']['input'];
};


export type MutationUpdateDepartmentPriorityClinicArgs = {
  departmentId: Scalars['Int']['input'];
  isPriorityClinic: Scalars['Boolean']['input'];
};


export type MutationUpdateDepartmentProfileArgs = {
  departmentProfileInput: DepartmentProfileInput;
};


export type MutationUpdateDepartmentStrategicAccountArgs = {
  departmentId: Scalars['Int']['input'];
  isStrategicAccount: Scalars['Boolean']['input'];
};


export type MutationUpdateDepartmentZingPreferredArgs = {
  departmentId: Scalars['Int']['input'];
  isZingPreferred: Scalars['Boolean']['input'];
};


export type MutationUpdateDistributorInvoiceProductArgs = {
  distributorInvoiceProductInput: DistributorInvoiceProductInput;
};


export type MutationUpdateDistributorOrderDiagnosisArgs = {
  code: Scalars['String']['input'];
  diagnosisId: Scalars['Int']['input'];
};


export type MutationUpdateDistributorOrderInvoiceProductArgs = {
  distributorOrderInvoiceProductInput: DistributorOrderInvoiceProductInput;
};


export type MutationUpdateDistributorOrderInvoiceProductDiagnosesArgs = {
  distributorOrderInvoiceProductDiagnosesInput: DistributorOrderInvoiceProductDiagnosesInput;
};


export type MutationUpdateDistributorPreferredShippingModeArgs = {
  distributorId: Scalars['Int']['input'];
  preferredShippingMode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDistributorProductFieldsArgs = {
  input: UpdateDistributorProductFieldsInput;
};


export type MutationUpdateDistributorUndeliverableToPoBoxArgs = {
  distributorId: Scalars['Int']['input'];
  undeliverableToPoBox: Scalars['Boolean']['input'];
};


export type MutationUpdateDocumentCollectionEventArgs = {
  departmentId: Scalars['Int']['input'];
  eventDescription: Scalars['String']['input'];
  eventId: Scalars['Int']['input'];
  eventType: Scalars['String']['input'];
};


export type MutationUpdateDocumentCollectionOrderStatusArgs = {
  departmentId: Scalars['Int']['input'];
  documentCollectionOrderId: Scalars['Int']['input'];
  orderStatus: Scalars['String']['input'];
  providerFax?: InputMaybe<Scalars['String']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  providerNpi?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateFeatureFlagArgs = {
  active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateFormItemFieldsArgs = {
  input: UpdateFormItemFieldsInput;
};


export type MutationUpdateFormItemNameArgs = {
  input: UpdateFormItemNameInput;
};


export type MutationUpdateFormItemSizeArgs = {
  input: UpdateFormItemSizeInput;
};


export type MutationUpdateHandOffPortalOrderPartnerNoteArgs = {
  handOffPortalOrderPartnerNoteInput: HandOffPortalOrderPartnerNoteInput;
};


export type MutationUpdateHandOffPortalOrderPartnerStatusArgs = {
  handOffPortalOrderId?: InputMaybe<Scalars['Int']['input']>;
  handOffPortalOrderRef?: InputMaybe<Scalars['String']['input']>;
  priorAuthorizationApproved?: InputMaybe<Scalars['Boolean']['input']>;
  status: HandOffPortalOrderPartnerStatus;
};


export type MutationUpdateHandOffPortalOrderPartnerStatusCoordinatedFulfillmentArgs = {
  handOffPortalOrderId?: InputMaybe<Scalars['Int']['input']>;
  handOffPortalOrderRef?: InputMaybe<Scalars['String']['input']>;
  status: CoordinatedFulfillmentStatus;
};


export type MutationUpdateHandOffPortalOrderStatusArgs = {
  handOffPortalOrderStatusInput: HandOffPortalOrderStatusInput;
};


export type MutationUpdateHomeHealthAgencyArgs = {
  homeHealthAgency: HomeHealthAgencyInput;
  homeHealthAgencyId: Scalars['Int']['input'];
};


export type MutationUpdateHomeHealthCoordinationOrderStatusArgs = {
  homeHealthCoordinationOrderId: Scalars['Int']['input'];
  remarks: Scalars['String']['input'];
  status: HomeHealthCoordinationOrderStatus;
};


export type MutationUpdateHomeHealthCoordinationOrderStatusByProviderArgs = {
  departmentId: Scalars['Int']['input'];
  homeHealthCoordinationOrderId: Scalars['Int']['input'];
  remarks: Scalars['String']['input'];
  status: HomeHealthCoordinationOrderStatus;
};


export type MutationUpdateHospitalPersistentNotesArgs = {
  hospitalId: Scalars['Int']['input'];
  notes: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUpdateHospitalProfileArgs = {
  assignedByUserId: Scalars['Int']['input'];
  hospitalProfileInput: HospitalProfileInput;
};


export type MutationUpdateHospitalSystemArgs = {
  hospitalSystemInput: HospitalSystemInput;
};


export type MutationUpdateInboundFaxArgs = {
  faxInput: FaxInput;
};


export type MutationUpdateLineItemAnnotationOverrideArgs = {
  isError?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemId: Scalars['Int']['input'];
};


export type MutationUpdateManagedSpreeUserArgs = {
  input: UpdateSpreeUserInput;
};


export type MutationUpdateOpsDayTypeOverrideArgs = {
  day: Scalars['Date']['input'];
  opsTypeOverride?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOpsTaskArgs = {
  id: Scalars['Int']['input'];
  opsTaskInput: OpsTaskInput;
};


export type MutationUpdateOpsTaskTypeArgs = {
  input: OpsTaskTypeInput;
  typeId: Scalars['Int']['input'];
};


export type MutationUpdateOpsUserFullArgs = {
  input: UpdateOpsUserFullInput;
};


export type MutationUpdateOpsUserPositionHistoryArgs = {
  input: UpdateOpsUserPositionHistoryInput;
};


export type MutationUpdateOrderCancellationTypeArgs = {
  input: OrderCancellationTypeInput;
  orderCancellationTypeId: Scalars['Int']['input'];
};


export type MutationUpdateOrderRemarksArgs = {
  orderNumber: Scalars['String']['input'];
  orderRemarks: Array<DepartmentOrderRemarkType>;
};


export type MutationUpdateOrderSegmentArgs = {
  orderSegmentInput: OrderSegmentInput;
  updatedBy: Scalars['Int']['input'];
};


export type MutationUpdateOrderSegmentGeneralPrepFeedbackArgs = {
  editReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  generalPrepFeedback?: InputMaybe<Scalars['String']['input']>;
  orderSegmentId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUpdateOrderSegmentShippingModesArgs = {
  default: Scalars['Boolean']['input'];
  departmentOrderId: Scalars['Int']['input'];
  orderSegmentShippingModesInput: Array<OrderSegmentShippingModeInput>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateOrderSegmentStateArgs = {
  orderSegmentStateUpdateInput: OrderSegmentStateUpdateInput;
};


export type MutationUpdatePatientChargeArgs = {
  patientChargeId: Scalars['Int']['input'];
  patientChargeInput: PatientChargeInput;
};


export type MutationUpdatePatientProfileArgs = {
  patientDataInput: PatientDataInput;
};


export type MutationUpdatePayorConfigArgs = {
  configId: Scalars['Int']['input'];
  input: PayorConfigInput;
};


export type MutationUpdateProductDiagnosisCodeArgs = {
  updateProductDiagnosisCodeInput: UpdateProductDiagnosisCodeInput;
};


export type MutationUpdateProviderPersistentNotesArgs = {
  notes: Scalars['String']['input'];
  npiNumber: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUpdateProviderReferralArgs = {
  hospitalName?: InputMaybe<Scalars['String']['input']>;
  providerReferralInput: ProviderReferralInput;
  signerInput: SignerInput;
};


export type MutationUpdateProviderReferralDraftArgs = {
  orderDocuments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  providerReferralInput: ProviderReferralInput;
  signerInput: SignerInput;
};


export type MutationUpdateProviderReferralFaxArgs = {
  faxInput: FaxInput;
};


export type MutationUpdateProviderUserPhoneArgs = {
  phone: Scalars['String']['input'];
  spreeUserId: Scalars['Int']['input'];
};


export type MutationUpdateReportedOrderIssueArgs = {
  reportedOrderIssueInput: ReportedOrderIssueInput;
};


export type MutationUpdateRetrievalTagArgs = {
  displayString: Scalars['String']['input'];
  tagId: Scalars['Int']['input'];
};


export type MutationUpdateS3DocumentArgs = {
  description: Scalars['String']['input'];
  s3DocumentId: Scalars['Int']['input'];
};


export type MutationUpdateSignerEmailsArgs = {
  emails: Array<Scalars['String']['input']>;
  signerId: Scalars['Int']['input'];
};


export type MutationUpdateSignerInformationArgs = {
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  signerInput: SignerInput;
};


export type MutationUpdateSubcontractOrderLineItemsArgs = {
  deletedLineItemIds: Array<Scalars['Int']['input']>;
  handOffOrderSegmentId: Scalars['Int']['input'];
  subcontractOrderLineItems: Array<SubcontractOrderLineItemInput>;
};


export type MutationUpdateTimelyFilingLimitsArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUpdateTrackingNumberArgs = {
  trackingNumberInput: TrackingNumberInput;
};


export type MutationUpdateUserSettingsArgs = {
  userSettings: UserSettingsInput;
};


export type MutationUpdateWorklistSettingsArgs = {
  input: WorklistSettingsInput;
};


export type MutationUpdateWorklistTaskPinReasonArgs = {
  nodeId: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};


export type MutationUpdateWoundItemClassificationArgs = {
  input: UpdateWoundItemClassificationInput;
};


export type MutationUpdateZingPrSettingsArgs = {
  input: ZingPrSettingsInput;
};


export type MutationUploadAndParseFeeScheduleFileArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadDocumentToOrderArgs = {
  file: Scalars['Upload']['input'];
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  spreeOrderId: Scalars['Int']['input'];
};


export type MutationUploadHcpcsMaxFrequenciesArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadHcpcsMaxQuantitiesArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadOrderDocumentArgs = {
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  orderDocument?: InputMaybe<Scalars['Upload']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUploadSynapseFulfillDocumentArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUpsertDepartmentCategoryArgs = {
  active?: Scalars['Boolean']['input'];
  category: ProductCategory;
  departmentId: Scalars['Int']['input'];
};


export type MutationUpsertDistributorOrderArgs = {
  distributorOrderInput: DistributorOrderInput;
};


export type MutationUpsertEncounterIdArgs = {
  billingTaskId?: InputMaybe<Scalars['Int']['input']>;
  distributorOrderId: Scalars['Int']['input'];
  encounterId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertErrorAnnotationArgs = {
  annotation: SegmentPrepErrorAnnotationInput;
};


export type MutationUpsertHandOffOrderSegmentArgs = {
  handOffOrderSegmentInput: HandOffOrderSegmentInput;
};


export type MutationUpsertHandOffPartnerArgs = {
  feeSchedule?: InputMaybe<Array<FeeScheduleRateInput>>;
  handOffPartnerInput: HandOffPartnerInput;
  operatingZipCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  productCategories?: InputMaybe<Array<ProductCategory>>;
};


export type MutationUpsertMarginCalculatorValuesArgs = {
  marginCalculatorValues: Array<MarginCalculatorValueInput>;
};


export type MutationUpsertOpsOrderStateArgs = {
  upsertOpsOrderStateInput: UpsertOpsOrderStateInput;
};


export type MutationUpsertReturnTrackingArgs = {
  returnTrackingInput: ReturnTrackingInput;
};


export type MutationVerifyAddressArgs = {
  verifyAddressInput: VerifyAddressInput;
};

export type NpiRegistryResponse = {
  __typename?: 'NPIRegistryResponse';
  faxNumbers?: Maybe<Array<Scalars['String']['output']>>;
  isSuccess: Scalars['Boolean']['output'];
};

export enum NebulizerAdministrationSetType {
  FaceMask = 'FACE_MASK',
  Mouthpiece = 'MOUTHPIECE',
  Other = 'OTHER',
  TracheostomyMask = 'TRACHEOSTOMY_MASK'
}

export enum NebulizerCompressorType {
  LargeVolume = 'LARGE_VOLUME',
  Other = 'OTHER',
  SmallVolume = 'SMALL_VOLUME',
  SuppliesOnly = 'SUPPLIES_ONLY',
  Ultrasonic = 'ULTRASONIC'
}

export enum NebulizerCurrentDevice {
  E0565 = 'E0565',
  E0570 = 'E0570',
  E0572 = 'E0572',
  E0574 = 'E0574',
  E0575 = 'E0575',
  E0585 = 'E0585',
  K0730 = 'K0730',
  NoneOfTheAbove = 'NONE_OF_THE_ABOVE',
  Other = 'OTHER'
}

export type NebulizerDiagnosis = {
  __typename?: 'NebulizerDiagnosis';
  diagnosis?: Maybe<Scalars['String']['output']>;
  icd10Code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  qualifyingGroups: Array<Scalars['Int']['output']>;
};

export type NebulizerDiagnosisInput = {
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  icd10Code?: InputMaybe<Scalars['String']['input']>;
  qualifyingGroups?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NebulizerLineItem = {
  __typename?: 'NebulizerLineItem';
  formItemId?: Maybe<Scalars['Int']['output']>;
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  size?: Maybe<Scalars['String']['output']>;
};

export enum NebulizerMedication {
  Acetylcysteine = 'ACETYLCYSTEINE',
  AlbuterolIpratropium = 'ALBUTEROL_IPRATROPIUM',
  AlbuterolSulfate = 'ALBUTEROL_SULFATE',
  Arformoterol = 'ARFORMOTEROL',
  Budesonide = 'BUDESONIDE',
  Cromolyn = 'CROMOLYN',
  DornaseAlfa = 'DORNASE_ALFA',
  Ensifentrine = 'ENSIFENTRINE',
  Formoterol = 'FORMOTEROL',
  HypertonicSaline = 'HYPERTONIC_SALINE',
  Iloprost = 'ILOPROST',
  IpratropiumBromide = 'IPRATROPIUM_BROMIDE',
  Levalbuterol = 'LEVALBUTEROL',
  Metaproterenol = 'METAPROTERENOL',
  Other = 'OTHER',
  Pentamidine = 'PENTAMIDINE',
  Revefenacin = 'REVEFENACIN',
  Tobramycin = 'TOBRAMYCIN',
  Treprostinil = 'TREPROSTINIL'
}

export type NebulizerOrder = {
  __typename?: 'NebulizerOrder';
  administrationSetType?: Maybe<NebulizerAdministrationSetType>;
  alreadyHasCoveredCompressor?: Maybe<Scalars['Boolean']['output']>;
  compressorType?: Maybe<NebulizerCompressorType>;
  currentNebulizerDevice?: Maybe<NebulizerCurrentDevice>;
  currentlyUsesNebulizer?: Maybe<Scalars['Boolean']['output']>;
  dosingInstructions?: Maybe<Scalars['String']['output']>;
  hasDocumentedThickSecretions?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ildConfirmedByHrct?: Maybe<Scalars['Boolean']['output']>;
  ildHasSignificantSymptoms?: Maybe<Scalars['Boolean']['output']>;
  ildMeetsPressureThreshold?: Maybe<Scalars['Boolean']['output']>;
  ildMeetsVascularResistanceThreshold?: Maybe<Scalars['Boolean']['output']>;
  ildMeetsWedgePressureThreshold?: Maybe<Scalars['Boolean']['output']>;
  includesDisposableFilter: Scalars['Boolean']['output'];
  includesDisposableNebulizerSet: Scalars['Boolean']['output'];
  isLifetimeLengthOfNeed?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedInMonths?: Maybe<Scalars['Int']['output']>;
  medication?: Maybe<NebulizerMedication>;
  nebulizerDiagnoses: Array<NebulizerDiagnosis>;
  nebulizerLineItems: Array<NebulizerLineItem>;
  noseToChinCm?: Maybe<Scalars['Float']['output']>;
  otherAdministrationSet?: Maybe<Scalars['String']['output']>;
  otherCompressor?: Maybe<Scalars['String']['output']>;
  otherCurrentNebulizerDevice?: Maybe<Scalars['String']['output']>;
  otherMedication?: Maybe<Scalars['String']['output']>;
  pahCalciumChannelBlockersExhausted?: Maybe<Scalars['Boolean']['output']>;
  pahHasQualifyingSecondaryCause?: Maybe<Scalars['Boolean']['output']>;
  pahHasSignificantSymptoms?: Maybe<Scalars['Boolean']['output']>;
  pahIsPrimary?: Maybe<Scalars['Boolean']['output']>;
  pahMeetsPressureThreshold?: Maybe<Scalars['Boolean']['output']>;
  pahProgressedDespiteTreatment?: Maybe<Scalars['Boolean']['output']>;
  phIsSecondaryToVenousOrRespiratory?: Maybe<Scalars['Boolean']['output']>;
  tracheostomyInnerDiameterMm?: Maybe<Scalars['Float']['output']>;
  tracheostomyLengthMm?: Maybe<Scalars['Float']['output']>;
  tracheostomyOuterDiameterMm?: Maybe<Scalars['Float']['output']>;
  usesSterileSalineOrWater: Scalars['Boolean']['output'];
};

export type NebulizerOrderInput = {
  administrationSetType?: InputMaybe<NebulizerAdministrationSetType>;
  alreadyHasCoveredCompressor?: InputMaybe<Scalars['Boolean']['input']>;
  compressorType?: InputMaybe<NebulizerCompressorType>;
  currentNebulizerDevice?: InputMaybe<NebulizerCurrentDevice>;
  currentlyUsesNebulizer?: InputMaybe<Scalars['Boolean']['input']>;
  dosingInstructions?: InputMaybe<Scalars['String']['input']>;
  hasDocumentedThickSecretions?: InputMaybe<Scalars['Boolean']['input']>;
  ildConfirmedByHrct?: InputMaybe<Scalars['Boolean']['input']>;
  ildHasSignificantSymptoms?: InputMaybe<Scalars['Boolean']['input']>;
  ildMeetsPressureThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  ildMeetsVascularResistanceThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  ildMeetsWedgePressureThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  includesDisposableFilter?: Scalars['Boolean']['input'];
  includesDisposableNebulizerSet?: Scalars['Boolean']['input'];
  isLifetimeLengthOfNeed?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedInMonths?: InputMaybe<Scalars['Int']['input']>;
  medication?: InputMaybe<NebulizerMedication>;
  nebulizerDiagnoses?: InputMaybe<Array<NebulizerDiagnosisInput>>;
  noseToChinCm?: InputMaybe<Scalars['Float']['input']>;
  otherAdministrationSet?: InputMaybe<Scalars['String']['input']>;
  otherCompressor?: InputMaybe<Scalars['String']['input']>;
  otherCurrentNebulizerDevice?: InputMaybe<Scalars['String']['input']>;
  otherMedication?: InputMaybe<Scalars['String']['input']>;
  pahCalciumChannelBlockersExhausted?: InputMaybe<Scalars['Boolean']['input']>;
  pahHasQualifyingSecondaryCause?: InputMaybe<Scalars['Boolean']['input']>;
  pahHasSignificantSymptoms?: InputMaybe<Scalars['Boolean']['input']>;
  pahIsPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  pahMeetsPressureThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  pahProgressedDespiteTreatment?: InputMaybe<Scalars['Boolean']['input']>;
  phIsSecondaryToVenousOrRespiratory?: InputMaybe<Scalars['Boolean']['input']>;
  tracheostomyInnerDiameterMm?: InputMaybe<Scalars['Float']['input']>;
  tracheostomyLengthMm?: InputMaybe<Scalars['Float']['input']>;
  tracheostomyOuterDiameterMm?: InputMaybe<Scalars['Float']['input']>;
  usesSterileSalineOrWater?: Scalars['Boolean']['input'];
};

export type NebulizerQualifyingDiagnosisCode = {
  __typename?: 'NebulizerQualifyingDiagnosisCode';
  icd10Code: Scalars['String']['output'];
  qualifyingGroups: Array<Scalars['Int']['output']>;
};

export type NewOrderSegmentInput = {
  activeDate?: InputMaybe<Scalars['DateTime']['input']>;
  compressionLineItemIds: Array<Scalars['Int']['input']>;
  currentOrderSegmentId: Scalars['Int']['input'];
  departmentOrderId: Scalars['Int']['input'];
  lineItemIds: Array<Scalars['Int']['input']>;
  miscLineItemIds?: Array<Scalars['Int']['input']>;
  opsUserId: Scalars['Int']['input'];
  orderSegmentTypeId: Scalars['Int']['input'];
  ostomyLineItemIds: Array<Scalars['Int']['input']>;
  overrideECheck: Scalars['Boolean']['input'];
  reasonForSegmentMembership?: InputMaybe<Array<OrderSegmentLineItemReasonInput>>;
  reasonsForTypeOthers?: InputMaybe<Array<OrderSegmentReasonsForTypeOthers>>;
  removeOrderSegmentLineItems: Scalars['Boolean']['input'];
  urologyLineItemIds: Array<Scalars['Int']['input']>;
  waitingOnPatientOrClinic: Scalars['Boolean']['input'];
  woundLineItemIds: Array<Scalars['Int']['input']>;
};

export type NoteResponseSelectionInput = {
  messageTemplateKeyReplacementId?: InputMaybe<Scalars['Int']['input']>;
  responseOptionSpecId: Scalars['Int']['input'];
};

export enum NoteResponseTeam {
  CaseManagement = 'CASE_MANAGEMENT',
  ClinicalReview = 'CLINICAL_REVIEW',
  CoordinatedFulfillment = 'COORDINATED_FULFILLMENT',
  Dme = 'DME',
  ECheck = 'E_CHECK',
  OpsPrep = 'OPS_PREP',
  OpsSupport = 'OPS_SUPPORT'
}

export type NoteTemplateResponseOption = {
  __typename?: 'NoteTemplateResponseOption';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  responseOptionSpecId?: Maybe<Scalars['Int']['output']>;
};

export type NppesNpiValidation = {
  __typename?: 'NppesNpiValidation';
  address?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<Scalars['String']['output']>;
  dmeEligible?: Maybe<Scalars['Boolean']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  npi: Scalars['String']['output'];
  nppesStatus?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  providerType?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<ValidateNpiReasonCode>;
  taxonomyDescriptions?: Maybe<Array<Scalars['String']['output']>>;
  validationStatus: ValidationStatus;
};

export type OopCost = {
  __typename?: 'OOPCost';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
  paymentLinkCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  paymentLinkId?: Maybe<Scalars['String']['output']>;
  paymentReceived: Scalars['Boolean']['output'];
  paymentReceivedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OopCostPreview = {
  __typename?: 'OOPCostPreview';
  calculatedAmount?: Maybe<Scalars['Float']['output']>;
  canSendPaymentLink: Scalars['Boolean']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  orderSegmentId: Scalars['Int']['output'];
};

export enum OopReason {
  DiagnosisRequirementRuleNotMet = 'DIAGNOSIS_REQUIREMENT_RULE_NOT_MET',
  FrequencyMismatch = 'FREQUENCY_MISMATCH',
  FrequencyNotCovered = 'FREQUENCY_NOT_COVERED',
  HomeHealthAgency = 'HOME_HEALTH_AGENCY',
  InsuranceNotActive = 'INSURANCE_NOT_ACTIVE',
  InsuranceNotEligible = 'INSURANCE_NOT_ELIGIBLE',
  MaxAllowedQuantityReached = 'MAX_ALLOWED_QUANTITY_REACHED',
  MedicareWound = 'MEDICARE_WOUND',
  NonCoveredItemPartial = 'NON_COVERED_ITEM_PARTIAL',
  PatientSelectedSelfPay = 'PATIENT_SELECTED_SELF_PAY',
  RefillTooSoon = 'REFILL_TOO_SOON',
  SizeRequestedTooLarge = 'SIZE_REQUESTED_TOO_LARGE',
  Substitution = 'SUBSTITUTION',
  WoundIsBiggerThanDressing = 'WOUND_IS_BIGGER_THAN_DRESSING'
}

export type OffTheShelfOrthoticsDiagnosis = {
  __typename?: 'OffTheShelfOrthoticsDiagnosis';
  diagnosis?: Maybe<Scalars['String']['output']>;
  icd10Code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type OffTheShelfOrthoticsDiagnosisInput = {
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  icd10Code?: InputMaybe<Scalars['String']['input']>;
};

export type OffTheShelfOrthoticsLineItem = {
  __typename?: 'OffTheShelfOrthoticsLineItem';
  calfCircumferenceInches?: Maybe<Scalars['Float']['output']>;
  chestCircumferenceInches?: Maybe<Scalars['Float']['output']>;
  forearmCircumferenceInches?: Maybe<Scalars['Float']['output']>;
  formItemId?: Maybe<Scalars['Int']['output']>;
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  laterality?: Maybe<Scalars['String']['output']>;
  legCircumferenceAboveKneeInches?: Maybe<Scalars['Float']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sizeWithMeasurements?: Maybe<Scalars['String']['output']>;
  thighCircumferenceInches?: Maybe<Scalars['Float']['output']>;
  waistCircumferenceInches?: Maybe<Scalars['Float']['output']>;
  wristCircumferenceInches?: Maybe<Scalars['Float']['output']>;
};

export type OffTheShelfOrthoticsLineItemInput = {
  calfCircumferenceInches?: InputMaybe<Scalars['Float']['input']>;
  chestCircumferenceInches?: InputMaybe<Scalars['Float']['input']>;
  forearmCircumferenceInches?: InputMaybe<Scalars['Float']['input']>;
  formItemId?: InputMaybe<Scalars['Int']['input']>;
  laterality?: InputMaybe<Scalars['String']['input']>;
  legCircumferenceAboveKneeInches?: InputMaybe<Scalars['Float']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  thighCircumferenceInches?: InputMaybe<Scalars['Float']['input']>;
  waistCircumferenceInches?: InputMaybe<Scalars['Float']['input']>;
  wristCircumferenceInches?: InputMaybe<Scalars['Float']['input']>;
};

export type OffTheShelfOrthoticsOrder = {
  __typename?: 'OffTheShelfOrthoticsOrder';
  id?: Maybe<Scalars['ID']['output']>;
  isLifetimeLengthOfNeed?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedInMonths?: Maybe<Scalars['Int']['output']>;
  offTheShelfOrthoticsDiagnoses: Array<OffTheShelfOrthoticsDiagnosis>;
  offTheShelfOrthoticsLineItems: Array<OffTheShelfOrthoticsLineItem>;
};

export type OffTheShelfOrthoticsOrderInput = {
  isLifetimeLengthOfNeed?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedInMonths?: InputMaybe<Scalars['Int']['input']>;
  offTheShelfOrthoticsDiagnoses?: InputMaybe<Array<OffTheShelfOrthoticsDiagnosisInput>>;
  offTheShelfOrthoticsLineItems?: InputMaybe<Array<OffTheShelfOrthoticsLineItemInput>>;
};

export type OffboardHireInput = {
  email: Scalars['String']['input'];
};

export enum OfflineReason {
  Emergency = 'EMERGENCY',
  EndOfDay = 'END_OF_DAY',
  Lunch = 'LUNCH',
  Meeting = 'MEETING',
  TimedOut = 'TIMED_OUT'
}

export type OnHoldClaimPreview = {
  __typename?: 'OnHoldClaimPreview';
  claimId?: Maybe<Scalars['Int']['output']>;
  encounterId: Scalars['Int']['output'];
  insuranceBalance?: Maybe<Scalars['Decimal']['output']>;
  onHold: Scalars['Boolean']['output'];
  payorName?: Maybe<Scalars['String']['output']>;
  procedureDate?: Maybe<Scalars['Date']['output']>;
  transactionCharge?: Maybe<Scalars['Decimal']['output']>;
};

export type OnboardNewHireInput = {
  auth0Roles?: InputMaybe<Array<Scalars['String']['input']>>;
  createVerseMedicalAccount: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  isOps: Scalars['Boolean']['input'];
  linkedAccount: Scalars['Boolean']['input'];
  onShore: Scalars['Boolean']['input'];
  salesRep: Scalars['Boolean']['input'];
  slackId: Scalars['String']['input'];
  vosAccess?: Scalars['Boolean']['input'];
};

export type OnlineStatusResult = {
  __typename?: 'OnlineStatusResult';
  isOffline: Scalars['Boolean']['output'];
  offlineReason?: Maybe<OfflineReason>;
};

export type OopWorkflowStatus = {
  __typename?: 'OopWorkflowStatus';
  hasManualLinkTask: Scalars['Boolean']['output'];
  isAwaitingPayment: Scalars['Boolean']['output'];
  isOopWorkflowManaged: Scalars['Boolean']['output'];
  orderSegmentId: Scalars['Int']['output'];
};

export type OpenPmClaim = {
  __typename?: 'OpenPmClaim';
  id: Scalars['String']['output'];
};

export type OpenPmPayorWithRemittanceChannel = {
  __typename?: 'OpenPmPayorWithRemittanceChannel';
  appealHandler: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  openPmId: Scalars['Int']['output'];
  remittanceChannel?: Maybe<RemittanceChannelEnum>;
};

export type OpsDayToType = {
  __typename?: 'OpsDayToType';
  day: Scalars['Date']['output'];
  opsTypeOverride?: Maybe<OpsDayType>;
  type: OpsDayType;
};

export enum OpsDayType {
  Holiday = 'HOLIDAY',
  Weekday = 'WEEKDAY',
  Weekend = 'WEEKEND'
}

export type OpsGroup = {
  __typename?: 'OpsGroup';
  groupTag: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slackId?: Maybe<Scalars['String']['output']>;
};

export type OpsOrderNote = {
  __typename?: 'OpsOrderNote';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  noteType?: Maybe<Scalars['String']['output']>;
  sticky?: Maybe<Scalars['Boolean']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type OpsOrderState = {
  __typename?: 'OpsOrderState';
  category: OpsOrderStateCategory;
  display: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  type: OpsOrderStateType;
};

export enum OpsOrderStateCategory {
  Error = 'ERROR',
  Flag = 'FLAG',
  Procedural = 'PROCEDURAL'
}

export enum OpsOrderStateType {
  AutomatedRoutedOrder = 'AUTOMATED_ROUTED_ORDER',
  AwaitingPriorAuth = 'AWAITING_PRIOR_AUTH',
  BillerReview = 'BILLER_REVIEW',
  Canceled = 'CANCELED',
  Handoff = 'HANDOFF',
  HcpcsAudit = 'HCPCS_AUDIT',
  HighCost = 'HIGH_COST',
  IssueWorklist = 'ISSUE_WORKLIST',
  OnHold = 'ON_HOLD',
  OnShorePayor = 'ON_SHORE_PAYOR',
  OopPaymentDeclined = 'OOP_PAYMENT_DECLINED',
  PatientRejectedPayment = 'PATIENT_REJECTED_PAYMENT',
  PatientResponsibility = 'PATIENT_RESPONSIBILITY',
  Pending = 'PENDING',
  PmnAwaitingClinic = 'PMN_AWAITING_CLINIC',
  PmnFailed = 'PMN_FAILED',
  PmnReview = 'PMN_REVIEW',
  PotentialHandoff = 'POTENTIAL_HANDOFF',
  PotentialLiabilityAcknowledgementDeclined = 'POTENTIAL_LIABILITY_ACKNOWLEDGEMENT_DECLINED',
  PriorAuthDenied = 'PRIOR_AUTH_DENIED',
  UpicAudit = 'UPIC_AUDIT'
}

export type OpsTask = {
  __typename?: 'OpsTask';
  assignee: OpsUser;
  createdAt: Scalars['DateTime']['output'];
  distributor?: Maybe<Distributor>;
  dueDate: Scalars['DateTime']['output'];
  hospital: Hospital;
  id: Scalars['Int']['output'];
  notes: Scalars['String']['output'];
  orderInfo: TaskOrderInfo;
  status: OpsTaskStatus;
  type: OpsTaskType;
};

export type OpsTaskHistoryObject = {
  __typename?: 'OpsTaskHistoryObject';
  changedKey: Scalars['String']['output'];
  changedValue: Scalars['String']['output'];
  eventTime: Scalars['String']['output'];
  updater: Scalars['String']['output'];
};

export type OpsTaskInput = {
  assigneeId: Scalars['Int']['input'];
  dueDate: Scalars['DateTime']['input'];
  notes: Scalars['String']['input'];
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  orderNumber: Scalars['String']['input'];
  status: OpsTaskStatus;
  typeId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type OpsTaskListInput = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  distributorIds: Array<Scalars['Int']['input']>;
  groupIds: Array<Scalars['Int']['input']>;
  hospitalName: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
  patientName: Scalars['String']['input'];
  statuses: Array<OpsTaskStatus>;
  typeIds: Array<Scalars['Int']['input']>;
};

export type OpsTaskOptions = {
  __typename?: 'OpsTaskOptions';
  assignees: Array<OpsUser>;
  groups: Array<OpsGroup>;
  types: Array<OpsTaskType>;
};

export enum OpsTaskStatus {
  Assigned = 'ASSIGNED',
  Blocked = 'BLOCKED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type OpsTaskType = {
  __typename?: 'OpsTaskType';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  primary: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type OpsTaskTypeInput = {
  primary?: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export enum OpsTitle {
  L1 = 'L1',
  L2 = 'L2',
  OpsManager = 'OPS_MANAGER',
  TeamLead = 'TEAM_LEAD'
}

export type OpsUser = {
  __typename?: 'OpsUser';
  authProviderUserId?: Maybe<Scalars['String']['output']>;
  calendarPageUrl?: Maybe<Scalars['String']['output']>;
  canAccessVos?: Maybe<Scalars['Boolean']['output']>;
  canApproveOrderNotes?: Maybe<Scalars['Boolean']['output']>;
  canPlaceOrders?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customerSuccessTeam?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  formAutofill?: Maybe<Scalars['Boolean']['output']>;
  groupTag?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  onShore?: Maybe<Scalars['Boolean']['output']>;
  permissions?: Maybe<Array<Permission>>;
  phone?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  salesRep?: Maybe<Scalars['Boolean']['output']>;
  slackId?: Maybe<Scalars['String']['output']>;
};

export type OpsUserPositionHistory = {
  __typename?: 'OpsUserPositionHistory';
  createdAt: Scalars['String']['output'];
  effectiveFrom: Scalars['String']['output'];
  effectiveTo?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  opsManager: OpsUser;
  opsUser: OpsUser;
  title: OpsTitle;
};

export type OpsWorklistUser = {
  __typename?: 'OpsWorklistUser';
  isOffline: Scalars['Boolean']['output'];
  isTeamLead: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  opsUserId: Scalars['Int']['output'];
};

export type OrderAssemblyDashboard = {
  __typename?: 'OrderAssemblyDashboard';
  approval: Scalars['Int']['output'];
  commsReview: Scalars['Int']['output'];
  eCheck: Scalars['Int']['output'];
  newOrders: Scalars['Int']['output'];
  placement: Scalars['Int']['output'];
  prep: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  transcription: Scalars['Int']['output'];
};

export type OrderAssemblyDashboardFilter = {
  deadlineCutoffOnly?: Scalars['Boolean']['input'];
};

export type OrderAssemblyThroughputToday = {
  __typename?: 'OrderAssemblyThroughputToday';
  approvedToday: Scalars['Int']['output'];
  placedToday: Scalars['Int']['output'];
  preppedToday: Scalars['Int']['output'];
};

export type OrderAssignmentInput = {
  needToAssign: Scalars['Boolean']['input'];
  opsUserId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
};

export type OrderCancellationType = {
  __typename?: 'OrderCancellationType';
  cancelType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultRemarkTypes: Array<DepartmentOrderRemarkType>;
  hasProductsToCancel?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  orderNoteTemplateId?: Maybe<Scalars['Int']['output']>;
  orderNoteTemplateName?: Maybe<Scalars['String']['output']>;
  shouldAddRemark: Scalars['Boolean']['output'];
  shouldSendOrderNote: Scalars['Boolean']['output'];
  shouldSendTextMessage: Scalars['Boolean']['output'];
  textMessage?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderCancellationTypeInput = {
  cancelType: Scalars['String']['input'];
  defaultRemarkTypes?: InputMaybe<Array<DepartmentOrderRemarkType>>;
  isEnabled: Scalars['Boolean']['input'];
  orderNoteTemplateId?: InputMaybe<Scalars['Int']['input']>;
  shouldAddRemark: Scalars['Boolean']['input'];
  shouldSendOrderNote: Scalars['Boolean']['input'];
  shouldSendTextMessage: Scalars['Boolean']['input'];
};

export type OrderCategoryKpis = {
  __typename?: 'OrderCategoryKpis';
  distinctCategories: Scalars['Int']['output'];
  topCategory?: Maybe<Scalars['String']['output']>;
  topCategoryPct: Scalars['Float']['output'];
  totalOrders: Scalars['Int']['output'];
};

export type OrderCategorySlice = {
  __typename?: 'OrderCategorySlice';
  category: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
};

export type OrderDagStateSummary = {
  __typename?: 'OrderDagStateSummary';
  blockedSteps: Array<BlockedStep>;
  blockingNodes: Array<BlockingNode>;
  cancelled: Scalars['Boolean']['output'];
  suspended: Scalars['Boolean']['output'];
};

export type OrderDisplayModel = {
  __typename?: 'OrderDisplayModel';
  category: ProductCategory;
  sections: Array<DisplaySection>;
  title: Scalars['String']['output'];
};

export type OrderDocumentCopy = {
  sourceOrderNumber: Scalars['String']['input'];
  targetOrderNumber: Scalars['String']['input'];
};

export type OrderDocumentInput = {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export enum OrderDocumentationStatus {
  MarkedUnworkable = 'MARKED_UNWORKABLE'
}

export type OrderDocumentationStatusRecord = {
  __typename?: 'OrderDocumentationStatusRecord';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<OpsUser>;
  documentationStatus: OrderDocumentationStatus;
  documentationType: OrderDocumentationType;
  id: Scalars['Int']['output'];
  reason?: Maybe<OrderDocumentationUnworkableReason>;
  reasonDescription?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<OpsUser>;
};

export enum OrderDocumentationType {
  ProgressNote = 'PROGRESS_NOTE',
  Signature = 'SIGNATURE'
}

export enum OrderDocumentationUnworkableReason {
  NoDocumentsWithinRequestedDateRange = 'NO_DOCUMENTS_WITHIN_REQUESTED_DATE_RANGE',
  Other = 'OTHER',
  ProviderRefusedToSign = 'PROVIDER_REFUSED_TO_SIGN',
  ThirdPartyPortalRequested = 'THIRD_PARTY_PORTAL_REQUESTED',
  UnableToDetermineProvider = 'UNABLE_TO_DETERMINE_PROVIDER'
}

export type OrderDocuments = {
  __typename?: 'OrderDocuments';
  faxes: Array<Fax>;
  s3Documents: Array<S3Document>;
};

export type OrderEvent = {
  __typename?: 'OrderEvent';
  createdAt: Scalars['DateTime']['output'];
  eventData?: Maybe<Scalars['JSON']['output']>;
  eventParam1?: Maybe<Scalars['String']['output']>;
  eventParam2?: Maybe<Scalars['String']['output']>;
  eventParam3?: Maybe<Scalars['String']['output']>;
  eventParam4?: Maybe<Scalars['String']['output']>;
  eventParam5?: Maybe<Scalars['String']['output']>;
  eventParam6?: Maybe<Scalars['String']['output']>;
  eventParam7?: Maybe<Scalars['String']['output']>;
  eventParam8?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderInsightsIssues = {
  __typename?: 'OrderInsightsIssues';
  byIssueType: Array<IssuesByType>;
  byLocation: Array<IssuesByLocation>;
  summary: IssuesSummary;
};

export type OrderInsightsRefill = {
  __typename?: 'OrderInsightsRefill';
  byLocation: Array<RefillByLocation>;
  summary: Array<RefillSlice>;
};

export type OrderListPage = {
  __typename?: 'OrderListPage';
  maxPage: Scalars['Int']['output'];
  numOrders: Scalars['Int']['output'];
  orders: Array<ProviderReferral>;
  pageSize: Scalars['Int']['output'];
};

export enum OrderListSortMethod {
  OrderDate = 'ORDER_DATE',
  OrderStatus = 'ORDER_STATUS'
}

export type OrderNote = {
  __typename?: 'OrderNote';
  approved?: Maybe<Scalars['Boolean']['output']>;
  approvedOrRejectedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedOrRejectedBy?: Maybe<ClinicianUser>;
  automaticClinicReminders?: Maybe<Scalars['Boolean']['output']>;
  clinicNoteThreadResolved: Scalars['Boolean']['output'];
  clinicRemindersDaysApart?: Maybe<Scalars['Int']['output']>;
  clinicRemindersSent?: Maybe<Scalars['Int']['output']>;
  clinicResponseRequiredAt?: Maybe<Scalars['DateTime']['output']>;
  clinicianEmail?: Maybe<Scalars['String']['output']>;
  clinicianName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  departmentOrderId: Scalars['Int']['output'];
  fileAttachments: Array<OrderNoteFileAttachment>;
  followupTaskAssignee?: Maybe<OpsUser>;
  hasClinicNoteNode: Scalars['Boolean']['output'];
  isActionItem: Scalars['Boolean']['output'];
  isIssue?: Maybe<Scalars['Boolean']['output']>;
  maxClinicReminders?: Maybe<Scalars['Int']['output']>;
  messageTemplateNames?: Maybe<Array<Scalars['String']['output']>>;
  needsApproval?: Maybe<Scalars['Boolean']['output']>;
  note: Scalars['String']['output'];
  notifyEmail?: Maybe<Scalars['Boolean']['output']>;
  notifyFax?: Maybe<Scalars['Boolean']['output']>;
  opsResolvedAt?: Maybe<Scalars['DateTime']['output']>;
  opsResolvedByName?: Maybe<Scalars['String']['output']>;
  opsUserName?: Maybe<Scalars['String']['output']>;
  orderCorrectionsRequested?: Maybe<Scalars['Boolean']['output']>;
  otherSupportingFilesRequested?: Maybe<Scalars['Boolean']['output']>;
  patientDemographicsRequested?: Maybe<Scalars['Boolean']['output']>;
  postgresId: Scalars['Int']['output'];
  providerNotesRequested?: Maybe<Scalars['Boolean']['output']>;
  requestedFilesUploaded?: Maybe<Scalars['Boolean']['output']>;
  responses: Array<OrderNoteResponse>;
  selectedTemplateKeyReplacementLabel?: Maybe<Scalars['String']['output']>;
  signatureRequested?: Maybe<Scalars['Boolean']['output']>;
  templateResponseOptions: Array<NoteTemplateResponseOption>;
};

export type OrderNoteFileAttachment = {
  __typename?: 'OrderNoteFileAttachment';
  fileName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
};

export type OrderNoteFileUploads = {
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  file: Scalars['Upload']['input'];
  fileType: OrderNoteUploadFileTypes;
};

export type OrderNoteInput = {
  automaticAccountRepReminders?: InputMaybe<Scalars['Boolean']['input']>;
  automaticClinicReminders: Scalars['Boolean']['input'];
  clinicRemindersDaysApart: Scalars['Int']['input'];
  clinicStatus?: InputMaybe<ProviderReferralStatus>;
  daysUntilAccountRepReminded?: InputMaybe<Scalars['Int']['input']>;
  fileAttachments: Array<OrderNoteFileUploads>;
  followupTaskAssigneeId?: InputMaybe<Scalars['Int']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  isIssue: Scalars['Boolean']['input'];
  maxClinicReminders: Scalars['Int']['input'];
  messageTemplateContextData?: InputMaybe<Array<Scalars['JSON']['input']>>;
  messageTemplateIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  messageTemplateKeyReplacements?: InputMaybe<Array<MessageTemplateKeyInput>>;
  needsApproval: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
  notifyEmail: Scalars['Boolean']['input'];
  notifyFax: Scalars['Boolean']['input'];
  opsOrderStateType?: InputMaybe<OpsOrderStateType>;
  orderCorrectionsRequested?: InputMaybe<Scalars['Boolean']['input']>;
  orderEventData?: InputMaybe<Scalars['JSON']['input']>;
  orderEventType?: InputMaybe<Scalars['String']['input']>;
  orderNumber: Scalars['String']['input'];
  orderSegmentId?: InputMaybe<Scalars['Int']['input']>;
  otherSupportingFilesRequested?: InputMaybe<Scalars['Boolean']['input']>;
  patientDemographicsRequested?: InputMaybe<Scalars['Boolean']['input']>;
  providerNotesRequested?: InputMaybe<Scalars['Boolean']['input']>;
  remarks?: InputMaybe<Array<DepartmentOrderRemarkType>>;
  signatureRequested?: InputMaybe<Scalars['Boolean']['input']>;
  stopRemindersOnDocUpload?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderNoteResponse = {
  __typename?: 'OrderNoteResponse';
  approved?: Maybe<Scalars['Boolean']['output']>;
  authorId: Scalars['Int']['output'];
  clinicianName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  departmentOrderRemarks?: Maybe<Array<DepartmentOrderRemarkType>>;
  email: Scalars['String']['output'];
  fileAttachments: Array<OrderNoteFileAttachment>;
  id: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  opsUserName?: Maybe<Scalars['String']['output']>;
  orderStatus?: Maybe<ProviderReferralStatus>;
};

export enum OrderNoteUploadFileTypes {
  OrderCorrections = 'ORDER_CORRECTIONS',
  OtherSupportingFiles = 'OTHER_SUPPORTING_FILES',
  PatientDemographics = 'PATIENT_DEMOGRAPHICS',
  ProgressNote = 'PROGRESS_NOTE',
  Signature = 'SIGNATURE',
  Unspecified = 'UNSPECIFIED'
}

export type OrderNumber = {
  __typename?: 'OrderNumber';
  orderNumber: Scalars['String']['output'];
};

export type OrderPlacementResponse = {
  __typename?: 'OrderPlacementResponse';
  messages: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedOrderSegmentStatus?: Maybe<VerseOsOrderSearchSegmentStatus>;
};

export type OrderPreferencesQuestion = {
  __typename?: 'OrderPreferencesQuestion';
  id: Scalars['ID']['output'];
  options: Array<OrderPreferencesQuestionOption>;
  position?: Maybe<Scalars['Int']['output']>;
  subTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type OrderPreferencesQuestionOption = {
  __typename?: 'OrderPreferencesQuestionOption';
  canDelayOrder: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  opsCoverageMessage?: Maybe<Scalars['String']['output']>;
  optionRef: DepartmentOrderPreferenceOption;
  patientCoverageMessage?: Maybe<Scalars['String']['output']>;
  patientCoverageOption?: Maybe<Scalars['String']['output']>;
  subTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type OrderProduct = {
  __typename?: 'OrderProduct';
  durationOfUse: Scalars['String']['output'];
  frequencyOfUse: Scalars['String']['output'];
  productName: Scalars['String']['output'];
};

export type OrderRemark = {
  __typename?: 'OrderRemark';
  relevantNoteId?: Maybe<Scalars['Int']['output']>;
  remarkType: DepartmentOrderRemarkType;
};

export type OrderSegment = {
  __typename?: 'OrderSegment';
  activeDate?: Maybe<Scalars['DateTime']['output']>;
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<OpsUser>;
  cancellationReason?: Maybe<OrderSegmentCancellationReason>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  departmentOrderId: Scalars['Int']['output'];
  distributorOrders?: Maybe<Array<DistributorOrder>>;
  eCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  eCheckedBy?: Maybe<Scalars['Int']['output']>;
  editReasons?: Maybe<Array<Scalars['String']['output']>>;
  flags?: Maybe<Array<OrderSegmentFlagType>>;
  fulfillmentType?: Maybe<Scalars['String']['output']>;
  generalPrepFeedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCoordinatedFulfillment: Scalars['Boolean']['output'];
  lineItems?: Maybe<Array<OrderSegmentLineItem>>;
  patientCharges?: Maybe<Array<PatientCharge>>;
  preppedAt?: Maybe<Scalars['DateTime']['output']>;
  preppedBy?: Maybe<OpsUser>;
  segmentType: OrderSegmentTypes;
  shippingModes?: Maybe<Array<OrderSegmentShippingMode>>;
};

export enum OrderSegmentCancellationReason {
  AutoCancelledOop = 'AUTO_CANCELLED_OOP',
  AutoDeletedOriginal = 'AUTO_DELETED_ORIGINAL',
  DuplicateOrder = 'DUPLICATE_ORDER',
  ExpiredDocumentation = 'EXPIRED_DOCUMENTATION',
  HhaTraditionalMedicare = 'HHA_TRADITIONAL_MEDICARE',
  MissingDocumentation = 'MISSING_DOCUMENTATION',
  OpsManualDeletion = 'OPS_MANUAL_DELETION',
  OrderCanceled = 'ORDER_CANCELED',
  PatientCancelledAllRefills = 'PATIENT_CANCELLED_ALL_REFILLS',
  PatientDeclinedOop = 'PATIENT_DECLINED_OOP',
  PatientDeclinedRefill = 'PATIENT_DECLINED_REFILL',
  ResetRefillsViaEv = 'RESET_REFILLS_VIA_EV',
  Unknown = 'UNKNOWN'
}

export enum OrderSegmentFlagType {
  HcpcsAudit = 'HCPCS_AUDIT',
  HighCost = 'HIGH_COST',
  PatientResponsibility = 'PATIENT_RESPONSIBILITY',
  UpicAudit = 'UPIC_AUDIT'
}

export type OrderSegmentFrequencyViolations = {
  __typename?: 'OrderSegmentFrequencyViolations';
  violations: Array<FrequencyViolationInfo>;
};

export type OrderSegmentInput = {
  departmentOrderId: Scalars['Int']['input'];
  editReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  generalPrepFeedback?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lineItems: Array<OrderSegmentLineItemInput>;
};

export type OrderSegmentLineItem = {
  __typename?: 'OrderSegmentLineItem';
  additionalProductId?: Maybe<Scalars['String']['output']>;
  annotationOverrideIsError?: Maybe<Scalars['Boolean']['output']>;
  calculatedSizeId?: Maybe<Scalars['Int']['output']>;
  calculatedSizeName?: Maybe<Scalars['String']['output']>;
  distributorId: Scalars['Int']['output'];
  distributorProductId?: Maybe<Scalars['Int']['output']>;
  durationOfUse?: Maybe<Scalars['String']['output']>;
  enteredFormItemId?: Maybe<Scalars['Int']['output']>;
  enteredProductName?: Maybe<Scalars['String']['output']>;
  externalManufacturerProductId?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  frequencyPreferenceId?: Maybe<Scalars['Int']['output']>;
  guessed: Scalars['Boolean']['output'];
  hcpcs?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isHazmat?: Maybe<Scalars['Boolean']['output']>;
  isMedicareWoundOop?: Maybe<Scalars['Boolean']['output']>;
  isPartialFocOop?: Maybe<Scalars['Boolean']['output']>;
  isSubstitutionOop?: Maybe<Scalars['Boolean']['output']>;
  mercyOnlineLink?: Maybe<Scalars['String']['output']>;
  productCategory?: Maybe<ProductCategory>;
  productNameFromFax?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  reasonForSegmentMembership?: Maybe<Array<OopReason>>;
  recentMeanUnitPrice?: Maybe<Scalars['Float']['output']>;
  recentP95UnitPrice?: Maybe<Scalars['Float']['output']>;
  selectedProductLink?: Maybe<Scalars['String']['output']>;
  selectedProductName?: Maybe<Scalars['String']['output']>;
  selectedWounds?: Maybe<Array<Scalars['Int']['output']>>;
  selectedWoundsPreferenceIds?: Maybe<Array<Scalars['Int']['output']>>;
  sendSmallerSize?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sizeFromClinic?: Maybe<Scalars['String']['output']>;
  sizePreferenceId?: Maybe<Scalars['Int']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  substituted?: Maybe<Scalars['Boolean']['output']>;
  substitutedProductName?: Maybe<Scalars['String']['output']>;
  substitutionPreferenceId?: Maybe<Scalars['Int']['output']>;
};

export type OrderSegmentLineItemInput = {
  additionalProductId?: InputMaybe<Scalars['String']['input']>;
  calculatedSizeId?: InputMaybe<Scalars['Int']['input']>;
  distributorId: Scalars['Int']['input'];
  distributorProductId?: InputMaybe<Scalars['Int']['input']>;
  durationOfUse?: InputMaybe<Scalars['String']['input']>;
  enteredProductName?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  frequencyPreferenceId?: InputMaybe<Scalars['Int']['input']>;
  guessed: Scalars['Boolean']['input'];
  hcpcs?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isMedicareWoundOop?: InputMaybe<Scalars['Boolean']['input']>;
  isPartialFocOop?: InputMaybe<Scalars['Boolean']['input']>;
  isSubstitutionOop?: InputMaybe<Scalars['Boolean']['input']>;
  productCategory?: InputMaybe<ProductCategory>;
  productNameFromFax?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  reasonForSegmentMembership?: InputMaybe<Array<OopReason>>;
  selectedProductLink?: InputMaybe<Scalars['String']['input']>;
  selectedProductName?: InputMaybe<Scalars['String']['input']>;
  selectedWounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  selectedWoundsPreferenceIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sendSmallerSize?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  sizePreferenceId?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  substituted?: InputMaybe<Scalars['Boolean']['input']>;
  substitutedProductName?: InputMaybe<Scalars['String']['input']>;
  substitutionPreferenceId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderSegmentLineItemReasonInput = {
  category: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  reasonForSegmentMembership: OopReason;
};

export type OrderSegmentPreCheck = {
  __typename?: 'OrderSegmentPreCheck';
  lineItems: Array<OrderSegmentPreCheckLineItem>;
  /** @deprecated No longer used. Frontend checks directly for notes/lineItems presence. */
  needsCheck: Scalars['Boolean']['output'];
  notes?: Maybe<OrderSegmentPreCheckNotes>;
  patientResponsibility?: Maybe<PatientResponsibilityHoldInfo>;
  poBoxBlock?: Maybe<PoBoxBlockInfo>;
  woundSelection?: Maybe<WoundSelectionInfo>;
};

export type OrderSegmentPreCheckLineItem = {
  __typename?: 'OrderSegmentPreCheckLineItem';
  availableQuantity: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderedQuantity: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
};

export type OrderSegmentPreCheckNotes = {
  __typename?: 'OrderSegmentPreCheckNotes';
  hospitalNote?: Maybe<Scalars['String']['output']>;
  patientNote?: Maybe<Scalars['String']['output']>;
};

export enum OrderSegmentReasonsForTypeOthers {
  ClinicRequest = 'CLINIC_REQUEST',
  CourtesyShipment = 'COURTESY_SHIPMENT',
  Hazmat = 'HAZMAT',
  MissingSupplies = 'MISSING_SUPPLIES',
  PatientRequest = 'PATIENT_REQUEST',
  PrepError = 'PREP_ERROR'
}

export type OrderSegmentReasonsForTypeOthersDetails = {
  __typename?: 'OrderSegmentReasonsForTypeOthersDetails';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OrderSegmentShippingMode = {
  __typename?: 'OrderSegmentShippingMode';
  distributorId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  shippingMode: Scalars['String']['output'];
};

export type OrderSegmentShippingModeInput = {
  distributorId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  orderSegmentId: Scalars['Int']['input'];
  shippingMode: Scalars['String']['input'];
};

export type OrderSegmentStateUpdate = {
  __typename?: 'OrderSegmentStateUpdate';
  isOrderOnHold: Scalars['Boolean']['output'];
  orderSegmentFlags?: Maybe<Array<OrderSegmentFlagType>>;
  state: OrderSegmentStates;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedOrderSegmentStatus: VerseOsOrderSearchSegmentStatus;
};

export type OrderSegmentStateUpdateInput = {
  orderSegmentId: Scalars['Int']['input'];
  sendPoBoxComms?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSkipMedicareBlocking?: Scalars['Boolean']['input'];
  state: OrderSegmentStates;
  value: Scalars['Boolean']['input'];
};

export enum OrderSegmentStates {
  Approved = 'APPROVED',
  EChecked = 'E_CHECKED',
  Prepped = 'PREPPED'
}

export type OrderSegmentSynapseStatus = {
  __typename?: 'OrderSegmentSynapseStatus';
  orderSegmentId: Scalars['Int']['output'];
  status: SynapseSegmentStatusEnum;
};

export type OrderSegmentType = {
  __typename?: 'OrderSegmentType';
  activeDateRequired: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  overrideECheckAllowed: Scalars['Boolean']['output'];
  removeFromCurrentSegAllowed: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  waitingOnPatientOrClinic: Scalars['Boolean']['output'];
};

export enum OrderSegmentTypes {
  DmeNetworkRemainder = 'DME_NETWORK_REMAINDER',
  DmeNetworkWeek_2 = 'DME_NETWORK_WEEK_2',
  Eligibility = 'ELIGIBILITY',
  Handoff = 'HANDOFF',
  Oop = 'OOP',
  OriginalSegment = 'ORIGINAL_SEGMENT',
  Others = 'OTHERS',
  Refill = 'REFILL',
  Reshipment = 'RESHIPMENT',
  Unknown = 'UNKNOWN'
}

export type OrderSynapseDocumentationHold = {
  __typename?: 'OrderSynapseDocumentationHold';
  hold: SynapseDocumentationHold;
  orderNumber: Scalars['String']['output'];
};

export type OrderSynapseHoldStatus = {
  __typename?: 'OrderSynapseHoldStatus';
  hasConfirmedSegment: Scalars['Boolean']['output'];
  hold: SynapseDocumentationHold;
  overridden: Scalars['Boolean']['output'];
};

export enum OrderTag {
  Compression = 'COMPRESSION',
  Handoff = 'HANDOFF',
  HasRefill = 'HAS_REFILL'
}

export type OrderWorkflowDag = {
  __typename?: 'OrderWorkflowDag';
  cancelled: Scalars['Boolean']['output'];
  edges: Array<OrderWorkflowDagEdge>;
  id: Scalars['Int']['output'];
  nodes: Array<OrderWorkflowDagNode>;
  suspended: Scalars['Boolean']['output'];
  templateSlug?: Maybe<Scalars['String']['output']>;
};

export type OrderWorkflowDagEdge = {
  __typename?: 'OrderWorkflowDagEdge';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fromNodeId: Scalars['Int']['output'];
  fromNodeSlug: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  toNodeId: Scalars['Int']['output'];
  toNodeSlug: Scalars['String']['output'];
  tokenPassed: Scalars['Boolean']['output'];
};

export type OrderWorkflowDagNode = {
  __typename?: 'OrderWorkflowDagNode';
  activateAfter?: Maybe<Scalars['DateTime']['output']>;
  assigneeId?: Maybe<Scalars['Int']['output']>;
  assigneeName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  history: Array<OrderWorkflowDagNodeHistory>;
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  nodeType: DagNodeType;
  orderSegmentId?: Maybe<Scalars['Int']['output']>;
  pinReason?: Maybe<Scalars['String']['output']>;
  pinnedAt?: Maybe<Scalars['DateTime']['output']>;
  segmentType?: Maybe<OrderSegmentTypes>;
  slug: Scalars['String']['output'];
  source: DagNodeSource;
  status: DagNodeStatus;
  taskType?: Maybe<DagTaskType>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderWorkflowDagNodeHistory = {
  __typename?: 'OrderWorkflowDagNodeHistory';
  assigneeId?: Maybe<Scalars['Int']['output']>;
  assigneeName?: Maybe<Scalars['String']['output']>;
  changedById?: Maybe<Scalars['Int']['output']>;
  changedByName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  newStatus: DagNodeStatus;
  oldStatus?: Maybe<DagNodeStatus>;
};

export type OrdersByHospitalSlice = {
  __typename?: 'OrdersByHospitalSlice';
  hospitalId: Scalars['Int']['output'];
  hospitalName: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
};

export type OrdersOverTimePoint = {
  __typename?: 'OrdersOverTimePoint';
  orderCount: Scalars['Int']['output'];
  period: Scalars['Date']['output'];
};

export type OstomyCheckboxAttributeInput = {
  bagTwoThousandCc?: InputMaybe<Scalars['Boolean']['input']>;
  bottle?: InputMaybe<Scalars['Boolean']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  cloth?: InputMaybe<Scalars['Boolean']['input']>;
  drain?: InputMaybe<Scalars['Boolean']['input']>;
  fourInch?: InputMaybe<Scalars['Boolean']['input']>;
  karayaFourHalfOz?: InputMaybe<Scalars['Boolean']['input']>;
  large?: InputMaybe<Scalars['Boolean']['input']>;
  medium?: InputMaybe<Scalars['Boolean']['input']>;
  oneInch?: InputMaybe<Scalars['Boolean']['input']>;
  paper?: InputMaybe<Scalars['Boolean']['input']>;
  pectinTwoOz?: InputMaybe<Scalars['Boolean']['input']>;
  pink?: InputMaybe<Scalars['Boolean']['input']>;
  twoInch?: InputMaybe<Scalars['Boolean']['input']>;
  urostomy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OstomyCheckboxAttributes = {
  __typename?: 'OstomyCheckboxAttributes';
  bagTwoThousandCc?: Maybe<Scalars['Boolean']['output']>;
  bottle?: Maybe<Scalars['Boolean']['output']>;
  closed?: Maybe<Scalars['Boolean']['output']>;
  cloth?: Maybe<Scalars['Boolean']['output']>;
  drain?: Maybe<Scalars['Boolean']['output']>;
  fourInch?: Maybe<Scalars['Boolean']['output']>;
  karayaFourHalfOz?: Maybe<Scalars['Boolean']['output']>;
  large?: Maybe<Scalars['Boolean']['output']>;
  medium?: Maybe<Scalars['Boolean']['output']>;
  oneInch?: Maybe<Scalars['Boolean']['output']>;
  paper?: Maybe<Scalars['Boolean']['output']>;
  pectinTwoOz?: Maybe<Scalars['Boolean']['output']>;
  pink?: Maybe<Scalars['Boolean']['output']>;
  twoInch?: Maybe<Scalars['Boolean']['output']>;
  urostomy?: Maybe<Scalars['Boolean']['output']>;
};

export type OstomyLineItem = {
  __typename?: 'OstomyLineItem';
  brandPreference?: Maybe<Scalars['String']['output']>;
  checkboxAttributes: OstomyCheckboxAttributes;
  createdAt: Scalars['DateTime']['output'];
  dailyFrequencyOfUse?: Maybe<Scalars['String']['output']>;
  formItemId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  productNum?: Maybe<Scalars['String']['output']>;
  qtyMo?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OstomyLineItemInput = {
  brandPreference?: InputMaybe<Scalars['String']['input']>;
  checkboxAttributes: OstomyCheckboxAttributeInput;
  dailyFrequencyOfUse?: InputMaybe<Scalars['String']['input']>;
  formItemId?: InputMaybe<Scalars['Int']['input']>;
  productName: Scalars['String']['input'];
  productNum?: InputMaybe<Scalars['String']['input']>;
  qtyMo?: InputMaybe<Scalars['String']['input']>;
};

export type OstomyOrder = {
  __typename?: 'OstomyOrder';
  additionalJustification?: Maybe<Scalars['String']['output']>;
  bladderCancer?: Maybe<Scalars['Boolean']['output']>;
  bowelObstruction?: Maybe<Scalars['Boolean']['output']>;
  colonCancer?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  crohnsDisease?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  latexAllergy?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedLifetime?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedOther?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedOtherMonths?: Maybe<Scalars['Int']['output']>;
  ostomyLineItems: Array<OstomyLineItem>;
  perforatedBowel?: Maybe<Scalars['Boolean']['output']>;
  primaryDiagnosisOther?: Maybe<Scalars['String']['output']>;
  primaryDiagnosisOtherActive?: Maybe<Scalars['Boolean']['output']>;
  secondaryDiagnosisOther?: Maybe<Scalars['String']['output']>;
  secondaryDiagnosisOtherActive?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  ulcerativeColitis?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  z932Ileostomy?: Maybe<Scalars['Boolean']['output']>;
  z933Colostomy?: Maybe<Scalars['Boolean']['output']>;
  z936Urostomy?: Maybe<Scalars['Boolean']['output']>;
};

export type OstomyOrderInput = {
  additionalJustification?: InputMaybe<Scalars['String']['input']>;
  bladderCancer?: InputMaybe<Scalars['Boolean']['input']>;
  bowelObstruction?: InputMaybe<Scalars['Boolean']['input']>;
  colonCancer?: InputMaybe<Scalars['Boolean']['input']>;
  crohnsDisease?: InputMaybe<Scalars['Boolean']['input']>;
  latexAllergy?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedLifetime?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedOther?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedOtherMonths?: InputMaybe<Scalars['Int']['input']>;
  ostomyLineItems: Array<OstomyLineItemInput>;
  perforatedBowel?: InputMaybe<Scalars['Boolean']['input']>;
  primaryDiagnosisOther?: InputMaybe<Scalars['String']['input']>;
  primaryDiagnosisOtherActive?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryDiagnosisOther?: InputMaybe<Scalars['String']['input']>;
  secondaryDiagnosisOtherActive?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  ulcerativeColitis?: InputMaybe<Scalars['Boolean']['input']>;
  z932Ileostomy?: InputMaybe<Scalars['Boolean']['input']>;
  z933Colostomy?: InputMaybe<Scalars['Boolean']['input']>;
  z936Urostomy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OutboundFaxDetail = {
  __typename?: 'OutboundFaxDetail';
  createdAt: Scalars['DateTime']['output'];
  externalFaxId?: Maybe<Scalars['String']['output']>;
  faxType: Scalars['String']['output'];
  fromNumber: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  presignedUrl?: Maybe<Scalars['String']['output']>;
  scheduledSendTimestamp?: Maybe<Scalars['DateTime']['output']>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  submissionStatus: Scalars['String']['output'];
  toNumber: Scalars['String']['output'];
};

export enum OutreachOutcome {
  Failed = 'FAILED',
  Fallback = 'FALLBACK',
  Retry = 'RETRY',
  Sent = 'SENT',
  Skipped = 'SKIPPED'
}

export enum OutreachReason {
  AlreadySent = 'ALREADY_SENT',
  BelowThreshold = 'BELOW_THRESHOLD',
  DailyCapReached = 'DAILY_CAP_REACHED',
  Exception = 'EXCEPTION',
  FlagOff = 'FLAG_OFF',
  GroupPaymentLinkMismatch = 'GROUP_PAYMENT_LINK_MISMATCH',
  NotDelivered = 'NOT_DELIVERED',
  NotFinalized = 'NOT_FINALIZED',
  NoAddress = 'NO_ADDRESS',
  NoEligibleOrders = 'NO_ELIGIBLE_ORDERS',
  NoLongerQualifies = 'NO_LONGER_QUALIFIES',
  NoPaymentLink = 'NO_PAYMENT_LINK',
  NoPhone = 'NO_PHONE',
  NoTimeAvailable = 'NO_TIME_AVAILABLE',
  PdfBuildFailed = 'PDF_BUILD_FAILED',
  PostgridFailed = 'POSTGRID_FAILED',
  SecondaryInsurance = 'SECONDARY_INSURANCE',
  SmsFailed = 'SMS_FAILED',
  SmsSuppressed = 'SMS_SUPPRESSED',
  StripeFailed = 'STRIPE_FAILED',
  Waived = 'WAIVED'
}

export type OverrideOrderStatusInput = {
  newStatus: ProviderReferralStatus;
  orderNumbers: Array<Scalars['String']['input']>;
};

export type OxygenContinuousMeasurement = {
  __typename?: 'OxygenContinuousMeasurement';
  roomAir?: Maybe<Scalars['Int']['output']>;
};

export type OxygenContinuousMeasurementInput = {
  roomAir?: InputMaybe<Scalars['Int']['input']>;
};

export type OxygenExerciseMeasurement = {
  __typename?: 'OxygenExerciseMeasurement';
  onO2Post?: Maybe<Scalars['Int']['output']>;
  roomAirDuring?: Maybe<Scalars['Int']['output']>;
  roomAirPre?: Maybe<Scalars['Int']['output']>;
};

export type OxygenExerciseMeasurementInput = {
  onO2Post?: InputMaybe<Scalars['Int']['input']>;
  roomAirDuring?: InputMaybe<Scalars['Int']['input']>;
  roomAirPre?: InputMaybe<Scalars['Int']['input']>;
};

export type OxygenMeasurements = {
  __typename?: 'OxygenMeasurements';
  continuous?: Maybe<OxygenContinuousMeasurement>;
  exercise?: Maybe<OxygenExerciseMeasurement>;
  nocturnal?: Maybe<OxygenNocturnalMeasurement>;
};

export type OxygenMeasurementsInput = {
  continuous?: InputMaybe<OxygenContinuousMeasurementInput>;
  exercise?: InputMaybe<OxygenExerciseMeasurementInput>;
  nocturnal?: InputMaybe<OxygenNocturnalMeasurementInput>;
};

export type OxygenNocturnalMeasurement = {
  __typename?: 'OxygenNocturnalMeasurement';
  asleep?: Maybe<Scalars['Int']['output']>;
  awake?: Maybe<Scalars['Int']['output']>;
  baselineAsleep?: Maybe<Scalars['Int']['output']>;
};

export type OxygenNocturnalMeasurementInput = {
  asleep?: InputMaybe<Scalars['Int']['input']>;
  awake?: InputMaybe<Scalars['Int']['input']>;
  baselineAsleep?: InputMaybe<Scalars['Int']['input']>;
};

export enum PnswoIssueCategory {
  IncorrectMedicalRecords = 'INCORRECT_MEDICAL_RECORDS',
  PlanOfCare = 'PLAN_OF_CARE',
  Wound = 'WOUND'
}

export enum PnswoIssueDetail {
  DateOfDebridement = 'DATE_OF_DEBRIDEMENT',
  Debrided = 'DEBRIDED',
  Depth = 'DEPTH',
  Drainage = 'DRAINAGE',
  IcdDescription = 'ICD_DESCRIPTION',
  Length = 'LENGTH',
  Location = 'LOCATION',
  Thickness = 'THICKNESS',
  Width = 'WIDTH'
}

export enum PnswoIssueType {
  Mismatch = 'MISMATCH',
  Missing = 'MISSING'
}

export type PnswoMatchingIssue = {
  __typename?: 'PNSWOMatchingIssue';
  billerReviewId: Scalars['Int']['output'];
  category: PnswoIssueCategory;
  detail?: Maybe<PnswoIssueDetail>;
  id: Scalars['Int']['output'];
  providerReferralWoundId?: Maybe<Scalars['Int']['output']>;
  type: PnswoIssueType;
};

export type PnswoMatchingIssueInput = {
  billerReviewId: Scalars['Int']['input'];
  category: PnswoIssueCategory;
  detail?: InputMaybe<PnswoIssueDetail>;
  productDetail?: InputMaybe<Scalars['String']['input']>;
  productWounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  providerReferralProductId?: InputMaybe<Scalars['Int']['input']>;
  providerReferralWoundId?: InputMaybe<Scalars['Int']['input']>;
  type: PnswoIssueType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PageRangeInput = {
  coverPageRange?: InputMaybe<Scalars['String']['input']>;
  pageRange: Scalars['String']['input'];
};

export type ParsedFeeScheduleFile = {
  __typename?: 'ParsedFeeScheduleFile';
  errors: Array<Scalars['String']['output']>;
  rows: Array<HandOffPartnerFeeScheduleRate>;
};

export enum PartnerDeliveryReason {
  Consignment = 'CONSIGNMENT',
  EmergencyDelivery = 'EMERGENCY_DELIVERY',
  WalkIn = 'WALK_IN'
}

export type PartnerOrderSubmissionInput = {
  alreadyDelivered: Scalars['Boolean']['input'];
  deliveryReason?: InputMaybe<PartnerDeliveryReason>;
  handOffPartnerId: Scalars['Int']['input'];
};

export type PartnerReferringFacilityInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  facilityFax: Scalars['String']['input'];
  facilityName: Scalars['String']['input'];
  facilityPhone: Scalars['String']['input'];
  facilityTypeId: Scalars['Int']['input'];
  secondaryFacilityFax?: InputMaybe<Scalars['String']['input']>;
  stateAbbr: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type PatientCharge = {
  __typename?: 'PatientCharge';
  billableAmount?: Maybe<Scalars['Float']['output']>;
  bypassReason?: Maybe<BypassReason>;
  bypassedAt?: Maybe<Scalars['DateTime']['output']>;
  bypassedBy?: Maybe<Scalars['Int']['output']>;
  bypassedByName?: Maybe<Scalars['String']['output']>;
  chargeType: ChargeType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  orderSegmentId: Scalars['String']['output'];
  patientContactedQuoteId?: Maybe<Scalars['Int']['output']>;
  patientHasPaid: Scalars['Boolean']['output'];
  patientResponse: PatientResponse;
};

export type PatientChargeInput = {
  chargeType: ChargeType;
  manualAmount?: InputMaybe<Scalars['Float']['input']>;
  orderSegmentId: Scalars['String']['input'];
  patientContactedQuoteId?: InputMaybe<Scalars['Int']['input']>;
  patientHasPaid: Scalars['Boolean']['input'];
  patientResponse: PatientResponse;
};

export type PatientChargeQuote = {
  __typename?: 'PatientChargeQuote';
  amount: Scalars['Float']['output'];
  chargeType: ChargeType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  orderSegmentId: Scalars['String']['output'];
  paymentLink?: Maybe<PaymentLink>;
  paymentLinkId?: Maybe<Scalars['Int']['output']>;
  paymentLinkUrl?: Maybe<Scalars['String']['output']>;
  smsDeliveryFailed: Scalars['Boolean']['output'];
};

export type PatientChargeSegmentContext = {
  __typename?: 'PatientChargeSegmentContext';
  currentPrLedgerBalance?: Maybe<Scalars['Float']['output']>;
  isPostFulfillment: Scalars['Boolean']['output'];
  orderSegmentId: Scalars['Int']['output'];
  policyType?: Maybe<PolicyType>;
  policyTypeLabel?: Maybe<Scalars['String']['output']>;
};

export type PatientCheckAllocation = {
  __typename?: 'PatientCheckAllocation';
  allocatedAmount: Scalars['Float']['output'];
  allocationId: Scalars['Int']['output'];
  checkPayment: PatientCheckPayment;
  orderSegmentId: Scalars['String']['output'];
};

export type PatientCheckPayment = {
  __typename?: 'PatientCheckPayment';
  checkNumber: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  nameOnCheck?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  paymentAmount: Scalars['Float']['output'];
  paymentDate: Scalars['Date']['output'];
  status: Scalars['String']['output'];
};

export type PatientControlCriteria = {
  __typename?: 'PatientControlCriteria';
  brainDamageDiagnoses?: Maybe<Array<PatientControlCriteriaDiagnosis>>;
  patientCanOperateControls?: Maybe<Scalars['Boolean']['output']>;
  traumaticBrainInjuryDiagnoses?: Maybe<Array<PatientControlCriteriaDiagnosis>>;
};

export type PatientControlCriteriaDiagnosis = {
  __typename?: 'PatientControlCriteriaDiagnosis';
  description?: Maybe<Scalars['String']['output']>;
  icd10Code?: Maybe<Scalars['String']['output']>;
  isCustom?: Maybe<Scalars['Boolean']['output']>;
};

export type PatientControlCriteriaDiagnosisInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icd10Code?: InputMaybe<Scalars['String']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientControlCriteriaInput = {
  brainDamageDiagnoses?: InputMaybe<Array<PatientControlCriteriaDiagnosisInput>>;
  patientCanOperateControls?: InputMaybe<Scalars['Boolean']['input']>;
  traumaticBrainInjuryDiagnoses?: InputMaybe<Array<PatientControlCriteriaDiagnosisInput>>;
};

export type PatientData = {
  __typename?: 'PatientData';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  autoInsuranceInfo?: Maybe<AutoInsuranceInfo>;
  city?: Maybe<Scalars['String']['output']>;
  clinic?: Maybe<Scalars['String']['output']>;
  eligibilityHistory?: Maybe<Array<EligibilityHistoryEntry>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  insuranceInfo?: Maybe<PatientInsuranceInfo>;
  insuranceType?: Maybe<InsuranceType>;
  lastName?: Maybe<Scalars['String']['output']>;
  mostRecentOrderNumber?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  openpmId?: Maybe<Scalars['String']['output']>;
  patientDob: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberSmsCapable?: Maybe<Scalars['Boolean']['output']>;
  secondaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  secondaryPhoneNumberSmsCapable?: Maybe<Scalars['Boolean']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  workersCompInfo?: Maybe<WorkersCompInfo>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type PatientDataInput = {
  autoInsuranceInfo?: InputMaybe<AutoInsuranceInfoInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  insuranceInfo?: InputMaybe<PatientInsuranceInfoInput>;
  insuranceType?: InputMaybe<InsuranceType>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  secondaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  workersCompInfo?: InputMaybe<WorkersCompInfoInput>;
};

export type PatientEligibilityCheckResult = {
  __typename?: 'PatientEligibilityCheckResult';
  message?: Maybe<Scalars['String']['output']>;
  pverifySuccess: Scalars['Boolean']['output'];
  stediSuccess: Scalars['Boolean']['output'];
};

export type PatientInsuranceInfo = {
  __typename?: 'PatientInsuranceInfo';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  primaryGroupNumber?: Maybe<Scalars['String']['output']>;
  primaryInsurance?: Maybe<Scalars['String']['output']>;
  primaryInsuranceType?: Maybe<Scalars['String']['output']>;
  primaryPolicyNumber?: Maybe<Scalars['String']['output']>;
  secondaryGroupNumber?: Maybe<Scalars['String']['output']>;
  secondaryInsurance?: Maybe<Scalars['String']['output']>;
  secondaryPolicyNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PatientInsuranceInfoInput = {
  primaryGroupNumber?: InputMaybe<Scalars['String']['input']>;
  primaryInsurance?: InputMaybe<Scalars['String']['input']>;
  primaryInsuranceType?: InputMaybe<Scalars['String']['input']>;
  primaryPolicyNumber?: InputMaybe<Scalars['String']['input']>;
  secondaryGroupNumber?: InputMaybe<Scalars['String']['input']>;
  secondaryInsurance?: InputMaybe<Scalars['String']['input']>;
  secondaryPolicyNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PatientLiabilityHistoryEntry = {
  __typename?: 'PatientLiabilityHistoryEntry';
  amountDollars?: Maybe<Scalars['Float']['output']>;
  amountPercent?: Maybe<Scalars['Float']['output']>;
  benefitScope?: Maybe<Scalars['String']['output']>;
  coverageLevel?: Maybe<Scalars['String']['output']>;
  liabilityType: Scalars['String']['output'];
  networkStatus: Scalars['String']['output'];
};

export type PatientOopDecisionInput = {
  patientWillPayOop?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientOpenCharge = {
  __typename?: 'PatientOpenCharge';
  amount: Scalars['Float']['output'];
  orderNumber: Scalars['String']['output'];
  orderSegmentId: Scalars['Int']['output'];
  orderSegmentType: Scalars['String']['output'];
};

export type PatientOrder = {
  __typename?: 'PatientOrder';
  activeOpsOrderStates: Array<OpsOrderStateType>;
  initiatedAt: Scalars['DateTime']['output'];
  orderNumber: Scalars['String']['output'];
  orderStatus: ProviderReferralStatus;
  tags: Array<OrderTag>;
};

export type PatientOrderHistoryItem = {
  __typename?: 'PatientOrderHistoryItem';
  approvalDate: Scalars['DateTime']['output'];
  category: Scalars['String']['output'];
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  durationOfUse?: Maybe<Scalars['String']['output']>;
  enteredProductName?: Maybe<Scalars['String']['output']>;
  hcpcs?: Maybe<Scalars['String']['output']>;
  orderDate: Scalars['DateTime']['output'];
  orderNumber: Scalars['String']['output'];
  productLink?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  segmentType: Scalars['String']['output'];
  selectedProductName?: Maybe<Scalars['String']['output']>;
  statusDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PatientOrdersSearchOrder = {
  __typename?: 'PatientOrdersSearchOrder';
  date: Scalars['DateTime']['output'];
  departmentOrderId: Scalars['Int']['output'];
  hasMedicalRecordsIssue: Scalars['Boolean']['output'];
  hasProgressNote: Scalars['Boolean']['output'];
  isSigned: Scalars['Boolean']['output'];
  orderNumber: Scalars['String']['output'];
  patientDob?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['Int']['output']>;
  patientName: Scalars['String']['output'];
};

export type PatientPortalAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type PatientPortalPatientMatch = {
  __typename?: 'PatientPortalPatientMatch';
  dateOfBirth: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  patientId: Scalars['Int']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export enum PatientResponse {
  Confirmed = 'CONFIRMED',
  NoResponse = 'NO_RESPONSE',
  Rejected = 'REJECTED'
}

export type PatientResponsibilityHoldInfo = {
  __typename?: 'PatientResponsibilityHoldInfo';
  amount?: Maybe<Scalars['Float']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  patientHasBeenContacted: Scalars['Boolean']['output'];
  wasBypassed?: Maybe<Scalars['Boolean']['output']>;
  wouldApply: Scalars['Boolean']['output'];
};

export type PatientResponsibilityMockOptions = {
  deductibleAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type PatientRow = {
  __typename?: 'PatientRow';
  clinic: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  mostRecentOrderNumber: Scalars['String']['output'];
  orderCreatedAt: Scalars['String']['output'];
  patientDob?: Maybe<Scalars['String']['output']>;
};

export type PaymentLink = {
  __typename?: 'PaymentLink';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  paymentLinkUrl: Scalars['String']['output'];
  processor: Scalars['String']['output'];
  transactionStatus?: Maybe<Scalars['String']['output']>;
  transactionStatusMessage?: Maybe<Scalars['String']['output']>;
  transactionUpdateTimestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type PayorApiCode = {
  __typename?: 'PayorApiCode';
  aliasCodes: Array<Scalars['String']['output']>;
  aliasNames: Array<Scalars['String']['output']>;
  apiCode: Scalars['String']['output'];
  canonicalPayorId?: Maybe<Scalars['Int']['output']>;
  claimPayorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  source: PayorApiCodeSource;
  usageCount: Scalars['Int']['output'];
};

export enum PayorApiCodeSource {
  OpenPm = 'OPEN_PM',
  Pverify = 'PVERIFY',
  Stedi = 'STEDI'
}

export enum PayorAppealHandler {
  RedSky = 'RED_SKY',
  Verse = 'VERSE'
}

export type PayorConfig = {
  __typename?: 'PayorConfig';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  paDollarThreshold?: Maybe<Scalars['Decimal']['output']>;
  paRequired: Scalars['Boolean']['output'];
  payorId: Scalars['Int']['output'];
  payorName: Scalars['String']['output'];
  policyType?: Maybe<PolicyType>;
  stateAbbr?: Maybe<Scalars['String']['output']>;
  stateId?: Maybe<Scalars['Int']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PayorConfigFilterInput = {
  paDollarThresholdMax?: InputMaybe<Scalars['Decimal']['input']>;
  paDollarThresholdMin?: InputMaybe<Scalars['Decimal']['input']>;
  paRequired?: InputMaybe<Scalars['Boolean']['input']>;
  payorId?: InputMaybe<Scalars['Int']['input']>;
  policyType?: InputMaybe<PolicyType>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
};

export type PayorConfigInput = {
  paDollarThreshold?: InputMaybe<Scalars['Decimal']['input']>;
  paRequired?: Scalars['Boolean']['input'];
  payorId: Scalars['Int']['input'];
  policyType?: InputMaybe<PolicyType>;
  stateId?: InputMaybe<Scalars['Int']['input']>;
};

export type PayorMember = {
  __typename?: 'PayorMember';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  memberId?: Maybe<Scalars['String']['output']>;
  memberKey: Scalars['Int']['output'];
  mostRecentOrder: PayorMemberMostRecentOrder;
};

export type PayorMemberMostRecentOrder = {
  __typename?: 'PayorMemberMostRecentOrder';
  placedAt: Scalars['DateTime']['output'];
  status?: Maybe<ProviderReferralStatus>;
};

export type PayorMemberOrder = {
  __typename?: 'PayorMemberOrder';
  clinicName?: Maybe<Scalars['String']['output']>;
  clinicPhone?: Maybe<Scalars['String']['output']>;
  hospitalName?: Maybe<Scalars['String']['output']>;
  items: Array<PayorMemberOrderItem>;
  number: Scalars['String']['output'];
  placedAt: Scalars['DateTime']['output'];
  providerName?: Maybe<Scalars['String']['output']>;
  shipTo: PayorMemberOrderShipTo;
  status?: Maybe<ProviderReferralStatus>;
  statusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PayorMemberOrderItem = {
  __typename?: 'PayorMemberOrderItem';
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
};

export type PayorMemberOrderShipTo = {
  __typename?: 'PayorMemberOrderShipTo';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  stateAbbr?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type PayorMemberOrdersResult = {
  __typename?: 'PayorMemberOrdersResult';
  dateOfBirth: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  memberId?: Maybe<Scalars['String']['output']>;
  orders: Array<PayorMemberOrder>;
};

export type PayorMemberPackage = {
  __typename?: 'PayorMemberPackage';
  carrier?: Maybe<Scalars['String']['output']>;
  failedDelivery: Scalars['Boolean']['output'];
  reshipmentInitiated: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export type PayorMemberSearchResult = {
  __typename?: 'PayorMemberSearchResult';
  hasNextPage: Scalars['Boolean']['output'];
  members: Array<PayorMember>;
  totalCount: Scalars['Int']['output'];
};

export type PayorMemberShipment = {
  __typename?: 'PayorMemberShipment';
  eligibleAfter?: Maybe<Scalars['DateTime']['output']>;
  isRefill: Scalars['Boolean']['output'];
  items: Array<PayorMemberOrderItem>;
  packages: Array<PayorMemberPackage>;
  status: PayorMemberShipmentStatus;
};

export enum PayorMemberShipmentStatus {
  AwaitingEligibilityDate = 'AWAITING_ELIGIBILITY_DATE',
  CancelledByPatient = 'CANCELLED_BY_PATIENT',
  InFulfillment = 'IN_FULFILLMENT'
}

export type PayorMixKpis = {
  __typename?: 'PayorMixKpis';
  distinctPayors: Scalars['Int']['output'];
  topPayor?: Maybe<Scalars['String']['output']>;
  topPayorPct: Scalars['Float']['output'];
  totalOrders: Scalars['Int']['output'];
};

export type PayorMixSlice = {
  __typename?: 'PayorMixSlice';
  orderCount: Scalars['Int']['output'];
  payorName: Scalars['String']['output'];
  policyType: Scalars['String']['output'];
};

export type PayorToBill = {
  __typename?: 'PayorToBill';
  displayName?: Maybe<Scalars['String']['output']>;
  isBlues: Scalars['Boolean']['output'];
  openPmPayorId?: Maybe<Scalars['Int']['output']>;
  openPmPayorName?: Maybe<Scalars['String']['output']>;
};

export enum Permission {
  AdminPageView = 'ADMIN_PAGE_VIEW',
  AutoAppealPackageAdmin = 'AUTO_APPEAL_PACKAGE_ADMIN',
  AutoApprovalAdmin = 'AUTO_APPROVAL_ADMIN',
  AutoClaimFileAdmin = 'AUTO_CLAIM_FILE_ADMIN',
  BillingAuditKeywordsAdmin = 'BILLING_AUDIT_KEYWORDS_ADMIN',
  BulkActivateCategories = 'BULK_ACTIVATE_CATEGORIES',
  CancellationActionsAdmin = 'CANCELLATION_ACTIONS_ADMIN',
  CareCoordinationExemptionManage = 'CARE_COORDINATION_EXEMPTION_MANAGE',
  CatalogUpdate = 'CATALOG_UPDATE',
  CatalogUpdatePrompt = 'CATALOG_UPDATE_PROMPT',
  DistributorAdmin = 'DISTRIBUTOR_ADMIN',
  DistributorInvoiceProductUpdate = 'DISTRIBUTOR_INVOICE_PRODUCT_UPDATE',
  DistributorOrderWarningSuppress = 'DISTRIBUTOR_ORDER_WARNING_SUPPRESS',
  DmeNetworkSegmentUpdate = 'DME_NETWORK_SEGMENT_UPDATE',
  DocumentCollection = 'DOCUMENT_COLLECTION',
  FaxOrderFormTemplateAdmin = 'FAX_ORDER_FORM_TEMPLATE_ADMIN',
  FinancialMetricsAdmin = 'FINANCIAL_METRICS_ADMIN',
  FixitUpdate = 'FIXIT_UPDATE',
  FixitView = 'FIXIT_VIEW',
  HcpcsOpsGuidanceAdmin = 'HCPCS_OPS_GUIDANCE_ADMIN',
  HomeHealthCoordination = 'HOME_HEALTH_COORDINATION',
  HospitalBulkAssignSalesReps = 'HOSPITAL_BULK_ASSIGN_SALES_REPS',
  HospitalDelete = 'HOSPITAL_DELETE',
  HospitalReactivate = 'HOSPITAL_REACTIVATE',
  ManualPatientResponsibilityCreate = 'MANUAL_PATIENT_RESPONSIBILITY_CREATE',
  MedicalRecordRequestDelete = 'MEDICAL_RECORD_REQUEST_DELETE',
  OnHoldClaimsFilterRulesetAdmin = 'ON_HOLD_CLAIMS_FILTER_RULESET_ADMIN',
  OpsDayTypeOverrideAdmin = 'OPS_DAY_TYPE_OVERRIDE_ADMIN',
  OpsUserCreate = 'OPS_USER_CREATE',
  OpsUserDelete = 'OPS_USER_DELETE',
  OrdersOnshoreRead = 'ORDERS_ONSHORE_READ',
  OrdersUnlimitedAssign = 'ORDERS_UNLIMITED_ASSIGN',
  OrdersValidationsIgnore = 'ORDERS_VALIDATIONS_IGNORE',
  OrderDocumentDelete = 'ORDER_DOCUMENT_DELETE',
  OrderResetReasonAdmin = 'ORDER_RESET_REASON_ADMIN',
  OrderSegmentOriginalDelete = 'ORDER_SEGMENT_ORIGINAL_DELETE',
  OrderStatusForceUpdate = 'ORDER_STATUS_FORCE_UPDATE',
  PatientResponsibilityStatementDownload = 'PATIENT_RESPONSIBILITY_STATEMENT_DOWNLOAD',
  PayorAssociationsAdmin = 'PAYOR_ASSOCIATIONS_ADMIN',
  PayorConfigAdmin = 'PAYOR_CONFIG_ADMIN',
  PortalOrdersAllRead = 'PORTAL_ORDERS_ALL_READ',
  PriorityClinicAdmin = 'PRIORITY_CLINIC_ADMIN',
  RcmAppealChannelUpdate = 'RCM_APPEAL_CHANNEL_UPDATE',
  RcmAppealFilingUpdate = 'RCM_APPEAL_FILING_UPDATE',
  RcmAppealFollowUpUpdate = 'RCM_APPEAL_FOLLOW_UP_UPDATE',
  RcmAppealPrepUpdate = 'RCM_APPEAL_PREP_UPDATE',
  RcmArUpdate = 'RCM_AR_UPDATE',
  RcmBillerSpecializationUpdate = 'RCM_BILLER_SPECIALIZATION_UPDATE',
  RcmBulkAssignUpdate = 'RCM_BULK_ASSIGN_UPDATE',
  RcmClaimAuditUpdate = 'RCM_CLAIM_AUDIT_UPDATE',
  RcmEligibilityUpdate = 'RCM_ELIGIBILITY_UPDATE',
  RcmHcpcsDefaultModifiersUpdate = 'RCM_HCPCS_DEFAULT_MODIFIERS_UPDATE',
  RcmMedicalRecordsUpdate = 'RCM_MEDICAL_RECORDS_UPDATE',
  RcmOpenPmEligibilityHistoryUpload = 'RCM_OPEN_PM_ELIGIBILITY_HISTORY_UPLOAD',
  RcmPriorAuthUpdate = 'RCM_PRIOR_AUTH_UPDATE',
  RcmReasonCodeUpdate = 'RCM_REASON_CODE_UPDATE',
  RcmRejectionsUpdate = 'RCM_REJECTIONS_UPDATE',
  RcmRemittanceChannelUpdate = 'RCM_REMITTANCE_CHANNEL_UPDATE',
  RcmToolsView = 'RCM_TOOLS_VIEW',
  RcmUnassignClaimReviewUpdate = 'RCM_UNASSIGN_CLAIM_REVIEW_UPDATE',
  RcmView = 'RCM_VIEW',
  RcmWriteOffReviewUpdate = 'RCM_WRITE_OFF_REVIEW_UPDATE',
  RcmWriteOffUpdate = 'RCM_WRITE_OFF_UPDATE',
  StrategicClassificationUpdate = 'STRATEGIC_CLASSIFICATION_UPDATE',
  TeamDashboardView = 'TEAM_DASHBOARD_VIEW',
  TrackingNumberDelete = 'TRACKING_NUMBER_DELETE',
  TrackingNumberMarkDelivered = 'TRACKING_NUMBER_MARK_DELIVERED',
  UserManagementUpdate = 'USER_MANAGEMENT_UPDATE',
  UserManagementView = 'USER_MANAGEMENT_VIEW',
  WorklistSettingsAdmin = 'WORKLIST_SETTINGS_ADMIN',
  ZingPrSettingsAdmin = 'ZING_PR_SETTINGS_ADMIN'
}

export type PlanOfCare = {
  __typename?: 'PlanOfCare';
  carePlanEstablished?: Maybe<Scalars['Boolean']['output']>;
  categoryId: Scalars['Int']['output'];
  crutchesCanesAndWalkersAloneInsufficient?: Maybe<Array<Scalars['String']['output']>>;
  deliveryLocationType: DeliveryLocationType;
  difficultyWithMobilityLimitation?: Maybe<Array<Scalars['String']['output']>>;
  dischargeDatetime?: Maybe<Scalars['DateTime']['output']>;
  electricBedRequirement?: Maybe<Array<PlanOfCareCondition>>;
  group2SupportSurfaceCriteria?: Maybe<Group2SupportSurfaceSurgicalDates>;
  homeAssessmentConditions?: Maybe<Array<Scalars['String']['output']>>;
  hospitalBedLastXYears?: Maybe<HospitalBedLastXYears>;
  hospitalBedRequirementReason?: Maybe<HospitalBedRequirementReason>;
  id: Scalars['Int']['output'];
  injectionsPerDay?: Maybe<Scalars['Int']['output']>;
  insulinTreatmentType?: Maybe<Scalars['String']['output']>;
  isPatientOnCgmTherapy?: Maybe<Scalars['Boolean']['output']>;
  isPatientOnInsulin?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedInMonths?: Maybe<Scalars['Int']['output']>;
  liftRequirement?: Maybe<Array<PlanOfCareCondition>>;
  mobilityLimitationImpact?: Maybe<Scalars['String']['output']>;
  mobilityLimitedWithoutWheelchair?: Maybe<Array<Scalars['String']['output']>>;
  mobilityRelatedActivitiesOfDailyLiving?: Maybe<Array<Scalars['String']['output']>>;
  oxygenAdditionalSpecifications?: Maybe<Scalars['String']['output']>;
  oxygenConservingDeviceSetAt?: Maybe<Scalars['Int']['output']>;
  oxygenContinuousOptions?: Maybe<Array<Scalars['String']['output']>>;
  oxygenHasHypoxiaSymptoms?: Maybe<Scalars['Boolean']['output']>;
  oxygenHypoxiaImprovesWithO2Confirmed?: Maybe<Scalars['Boolean']['output']>;
  oxygenLengthOfNeedMonths?: Maybe<Scalars['Int']['output']>;
  oxygenLengthOfNeedType?: Maybe<Scalars['String']['output']>;
  oxygenMethod?: Maybe<Scalars['String']['output']>;
  oxygenPatientMobileInHome?: Maybe<Scalars['Boolean']['output']>;
  oxygenPerMinute?: Maybe<Scalars['Int']['output']>;
  oxygenPo2Measurements?: Maybe<OxygenMeasurements>;
  oxygenPo2MmHg?: Maybe<Scalars['Int']['output']>;
  oxygenPortableType?: Maybe<Scalars['String']['output']>;
  oxygenPrescription?: Maybe<Scalars['String']['output']>;
  oxygenRespiratoryTestingDate?: Maybe<Scalars['Date']['output']>;
  oxygenSpo2Measurements?: Maybe<OxygenMeasurements>;
  oxygenSpo2Percent?: Maybe<Scalars['Int']['output']>;
  oxygenTestPerformedMethods?: Maybe<Array<Scalars['String']['output']>>;
  oxygenTestType?: Maybe<Scalars['String']['output']>;
  oxygenTypes?: Maybe<Array<Scalars['String']['output']>>;
  patientControlCriteria?: Maybe<PatientControlCriteria>;
  patientHasConsented?: Maybe<Scalars['Boolean']['output']>;
  patientHeightFeet?: Maybe<Scalars['Int']['output']>;
  patientHeightInches?: Maybe<Scalars['Int']['output']>;
  patientWeight?: Maybe<Scalars['Int']['output']>;
  preferredDmeCompany?: Maybe<Scalars['String']['output']>;
  pressureUlcerLocationStage?: Maybe<Array<PressureUlcerLocationStage>>;
  smbgPerDay?: Maybe<Scalars['Int']['output']>;
  supportSurfaceCoverageCriteria?: Maybe<SupportSurfaceCoverageCriteria>;
  symptomsFromDiagnosis?: Maybe<Array<PlanOfCareCondition>>;
  trapezeBarRequirement?: Maybe<Array<PlanOfCareCondition>>;
  variableHeightBedConditions?: Maybe<VariableHeightBedConditions>;
  walkerConfirmation?: Maybe<Array<Scalars['String']['output']>>;
  wheelchairConfirmation?: Maybe<Array<Scalars['String']['output']>>;
  wheelchairLastXYears?: Maybe<WheelchairLastXYears>;
};

export type PlanOfCareCondition = {
  __typename?: 'PlanOfCareCondition';
  isCustom: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type PlanOfCareConditionInput = {
  isCustom?: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};

export type PlanOfCareField = {
  __typename?: 'PlanOfCareField';
  columnName: Scalars['String']['output'];
  display: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  visibleInSummary?: Maybe<Scalars['Boolean']['output']>;
};

export type PlanOfCareInput = {
  carePlanEstablished?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId: Scalars['Int']['input'];
  crutchesCanesAndWalkersAloneInsufficient?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryLocationType?: DeliveryLocationType;
  difficultyWithMobilityLimitation?: InputMaybe<Array<Scalars['String']['input']>>;
  dischargeDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  electricBedRequirement?: InputMaybe<Array<PlanOfCareConditionInput>>;
  group2SupportSurfaceCriteria?: InputMaybe<Group2SupportSurfaceSurgicalDatesInput>;
  homeAssessmentConditions?: InputMaybe<Array<Scalars['String']['input']>>;
  hospitalBedLastXYears?: InputMaybe<HospitalBedLastXYearsInput>;
  hospitalBedRequirementReason?: InputMaybe<HospitalBedRequirementReasonInput>;
  injectionsPerDay?: InputMaybe<Scalars['Int']['input']>;
  insulinTreatmentType?: InputMaybe<Scalars['String']['input']>;
  isPatientOnCgmTherapy?: InputMaybe<Scalars['Boolean']['input']>;
  isPatientOnInsulin?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedInMonths?: InputMaybe<Scalars['Int']['input']>;
  liftRequirement?: InputMaybe<Array<PlanOfCareConditionInput>>;
  mobilityLimitationImpact?: InputMaybe<Scalars['String']['input']>;
  mobilityLimitedWithoutWheelchair?: InputMaybe<Array<Scalars['String']['input']>>;
  mobilityRelatedActivitiesOfDailyLiving?: InputMaybe<Array<Scalars['String']['input']>>;
  oxygenAdditionalSpecifications?: InputMaybe<Scalars['String']['input']>;
  oxygenConservingDeviceSetAt?: InputMaybe<Scalars['Int']['input']>;
  oxygenContinuousOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  oxygenHasHypoxiaSymptoms?: InputMaybe<Scalars['Boolean']['input']>;
  oxygenHypoxiaImprovesWithO2Confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  oxygenLengthOfNeedMonths?: InputMaybe<Scalars['Int']['input']>;
  oxygenLengthOfNeedType?: InputMaybe<Scalars['String']['input']>;
  oxygenMethod?: InputMaybe<Scalars['String']['input']>;
  oxygenPatientMobileInHome?: InputMaybe<Scalars['Boolean']['input']>;
  oxygenPerMinute?: InputMaybe<Scalars['Int']['input']>;
  oxygenPo2Measurements?: InputMaybe<OxygenMeasurementsInput>;
  oxygenPo2MmHg?: InputMaybe<Scalars['Int']['input']>;
  oxygenPortableType?: InputMaybe<Scalars['String']['input']>;
  oxygenPrescription?: InputMaybe<Scalars['String']['input']>;
  oxygenRespiratoryTestingDate?: InputMaybe<Scalars['Date']['input']>;
  oxygenSpo2Measurements?: InputMaybe<OxygenMeasurementsInput>;
  oxygenSpo2Percent?: InputMaybe<Scalars['Int']['input']>;
  oxygenTestPerformedMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  oxygenTestType?: InputMaybe<Scalars['String']['input']>;
  oxygenTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  patientControlCriteria?: InputMaybe<PatientControlCriteriaInput>;
  patientHasConsented?: InputMaybe<Scalars['Boolean']['input']>;
  patientHeightFeet?: InputMaybe<Scalars['Int']['input']>;
  patientHeightInches?: InputMaybe<Scalars['Int']['input']>;
  patientWeight?: InputMaybe<Scalars['Int']['input']>;
  preferredDmeCompany?: InputMaybe<Scalars['String']['input']>;
  pressureUlcerLocationStage?: InputMaybe<Array<PressureUlcerLocationStageInput>>;
  smbgPerDay?: InputMaybe<Scalars['Int']['input']>;
  supportSurfaceCoverageCriteria?: InputMaybe<SupportSurfaceCoverageCriteriaInput>;
  symptomsFromDiagnosis?: InputMaybe<Array<PlanOfCareConditionInput>>;
  trapezeBarRequirement?: InputMaybe<Array<PlanOfCareConditionInput>>;
  variableHeightBedConditions?: InputMaybe<VariableHeightBedConditionsInput>;
  walkerConfirmation?: InputMaybe<Array<Scalars['String']['input']>>;
  wheelchairConfirmation?: InputMaybe<Array<Scalars['String']['input']>>;
  wheelchairLastXYears?: InputMaybe<WheelchairLastXYearsInput>;
};

export enum PlanType {
  Hmo = 'HMO',
  Ppo = 'PPO'
}

export type PmnHcpcsAccessory = {
  __typename?: 'PmnHcpcsAccessory';
  accessoryHcpcsCode: Scalars['String']['output'];
  baseHcpcsCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['Int']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  payorId: Scalars['Int']['output'];
};

export type PmnHcpcsAccessoryInput = {
  accessoryHcpcsCode: Scalars['String']['input'];
  baseHcpcsCode: Scalars['String']['input'];
};

export type PmnHcpcsCode = {
  __typename?: 'PmnHcpcsCode';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['Int']['output'];
  createdByName?: Maybe<Scalars['String']['output']>;
  hcpcsCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  payorId: Scalars['Int']['output'];
};

export type PoBoxBlockInfo = {
  __typename?: 'PoBoxBlockInfo';
  blockedProductNames: Array<Scalars['String']['output']>;
  commsAlreadySent: Scalars['Boolean']['output'];
  isBlocked: Scalars['Boolean']['output'];
};

export enum PolicyType {
  AutoInsurance = 'AUTO_INSURANCE',
  Commercial = 'COMMERCIAL',
  ManagedMedicaid = 'MANAGED_MEDICAID',
  Medicaid = 'MEDICAID',
  Medicare = 'MEDICARE',
  MedicareAdv = 'MEDICARE_ADV',
  SelfPay = 'SELF_PAY',
  Tricare = 'TRICARE',
  Unknown = 'UNKNOWN',
  Veterans = 'VETERANS',
  WorkersComp = 'WORKERS_COMP',
  WorkerCompensation = 'WORKER_COMPENSATION'
}

export type PotentialLiabilityAcknowledgement = {
  __typename?: 'PotentialLiabilityAcknowledgement';
  inheritedFromOrder?: Maybe<Scalars['String']['output']>;
  linkedPendingOrderNumbers?: Maybe<Array<Scalars['String']['output']>>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedByName?: Maybe<Scalars['String']['output']>;
  resolvedByUserId?: Maybe<Scalars['Int']['output']>;
  response: PatientResponse;
  textedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum PowerWheelchairClass {
  Advanced = 'ADVANCED',
  Pediatric = 'PEDIATRIC',
  Standard = 'STANDARD'
}

export enum PowerWheelchairSeating {
  Multiple = 'MULTIPLE',
  None = 'NONE',
  One = 'ONE'
}

export type PrPaperStatementSendResult = {
  __typename?: 'PrPaperStatementSendResult';
  detail?: Maybe<Scalars['String']['output']>;
  orderNumber: Scalars['String']['output'];
  outcome: OutreachOutcome;
  reason?: Maybe<OutreachReason>;
};

export type Practice = {
  __typename?: 'Practice';
  fax?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  validationStatus: PracticeValidationStatus;
};

export type PracticeIdAndIsDeleted = {
  __typename?: 'PracticeIdAndIsDeleted';
  isDeleted: Scalars['Boolean']['output'];
  practiceId: Scalars['Int']['output'];
};

export type PracticeInput = {
  fax?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  validationStatus?: InputMaybe<PracticeValidationStatus>;
};

export enum PracticeValidationStatus {
  Unreviewed = 'UNREVIEWED',
  Validated = 'VALIDATED',
  Wrong = 'WRONG'
}

export type PressureUlcerLocationStage = {
  __typename?: 'PressureUlcerLocationStage';
  location?: Maybe<Scalars['String']['output']>;
  sizeD?: Maybe<Scalars['String']['output']>;
  sizeL?: Maybe<Scalars['String']['output']>;
  sizeW?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  thickness?: Maybe<Scalars['String']['output']>;
};

export type PressureUlcerLocationStageInput = {
  location?: InputMaybe<Scalars['String']['input']>;
  sizeD?: InputMaybe<Scalars['String']['input']>;
  sizeL?: InputMaybe<Scalars['String']['input']>;
  sizeW?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  thickness?: InputMaybe<Scalars['String']['input']>;
};

export type Product = {
  __typename?: 'Product';
  clinicianQuantityRuleDescription?: Maybe<Scalars['String']['output']>;
  disableQuantityAutocalculationDefaultQuantity?: Maybe<Scalars['Int']['output']>;
  displayUnitLabel?: Maybe<Scalars['String']['output']>;
  dressingCategory?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isBordered: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  popularity?: Maybe<Scalars['Int']['output']>;
  woundSizeAgnostic: Scalars['Boolean']['output'];
};

export enum ProductCategory {
  BathingAndBathroom = 'BATHING_AND_BATHROOM',
  Compression = 'COMPRESSION',
  CoughStimulating = 'COUGH_STIMULATING',
  Cpap = 'CPAP',
  CustomOrthotics = 'CUSTOM_ORTHOTICS',
  Diabetes = 'DIABETES',
  DiabeticSupplies = 'DIABETIC_SUPPLIES',
  ElectricalStimulators = 'ELECTRICAL_STIMULATORS',
  EnteralNutrition = 'ENTERAL_NUTRITION',
  HospitalBed = 'HOSPITAL_BED',
  Incontinence = 'INCONTINENCE',
  LivingAid = 'LIVING_AID',
  Miscellaneous = 'MISCELLANEOUS',
  Nebulizer = 'NEBULIZER',
  OffTheShelfOrthotics = 'OFF_THE_SHELF_ORTHOTICS',
  Ostomy = 'OSTOMY',
  Oxygen = 'OXYGEN',
  PneumaticCompression = 'PNEUMATIC_COMPRESSION',
  PostMastectomy = 'POST_MASTECTOMY',
  Prosthetics = 'PROSTHETICS',
  ProstheticsAndOrthotics = 'PROSTHETICS_AND_ORTHOTICS',
  TherapeuticDevice = 'THERAPEUTIC_DEVICE',
  Tracheostomy = 'TRACHEOSTOMY',
  Urology = 'UROLOGY',
  Ventilator = 'VENTILATOR',
  Walker = 'WALKER',
  Wheelchair = 'WHEELCHAIR',
  WheelchairsAndScooters = 'WHEELCHAIRS_AND_SCOOTERS',
  WoundCare = 'WOUND_CARE',
  WoundSuction = 'WOUND_SUCTION'
}

export type ProductCount = {
  __typename?: 'ProductCount';
  orderCount: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
};

export enum ProductEligibilityClassification {
  CheckSize = 'CHECK_SIZE',
  GoodNow = 'GOOD_NOW',
  ReorderTooSoonFull = 'REORDER_TOO_SOON_FULL',
  ReorderTooSoonPartial = 'REORDER_TOO_SOON_PARTIAL',
  Superseded = 'SUPERSEDED',
  UpdatedFrequency = 'UPDATED_FREQUENCY'
}

export type ProductEligibilityItem = {
  __typename?: 'ProductEligibilityItem';
  bordered: Scalars['Boolean']['output'];
  cappedFrequency?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<ProductEligibilityClassification>;
  decidingPriorLineItemId?: Maybe<Scalars['Int']['output']>;
  defer: Scalars['Int']['output'];
  deferDays?: Maybe<Scalars['Int']['output']>;
  eligibilityDate?: Maybe<Scalars['Date']['output']>;
  lineItem: ProductEligibilityLineItem;
  planOfCarePriors: Array<ProductEligibilityLineItem>;
  priors: Array<ProductEligibilityLineItem>;
  requestedFrequency?: Maybe<Scalars['String']['output']>;
  shipNow: Scalars['Int']['output'];
  shipNowDays?: Maybe<Scalars['Int']['output']>;
  unknownReason?: Maybe<ProductEligibilityUnknownReason>;
  wounds: Array<ProductEligibilityWoundVerdict>;
};

export type ProductEligibilityLineItem = {
  __typename?: 'ProductEligibilityLineItem';
  deliveredOn?: Maybe<Scalars['Date']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  lineItemId: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  removed: Scalars['Boolean']['output'];
  woundNumbers: Array<Scalars['Int']['output']>;
};

export type ProductEligibilityReport = {
  __typename?: 'ProductEligibilityReport';
  classifications: Array<ProductEligibilityClassification>;
  couldNotRun?: Maybe<Scalars['String']['output']>;
  items: Array<ProductEligibilityItem>;
  orderNumber: Scalars['String']['output'];
  ranAt?: Maybe<Scalars['DateTime']['output']>;
  runId?: Maybe<Scalars['Int']['output']>;
};

export enum ProductEligibilityUnknownReason {
  ItemNotDerivable = 'ITEM_NOT_DERIVABLE',
  ItemNoRuleForType = 'ITEM_NO_RULE_FOR_TYPE',
  ItemUnclassified = 'ITEM_UNCLASSIFIED',
  ItemUnresolved = 'ITEM_UNRESOLVED',
  MissingDuration = 'MISSING_DURATION',
  MissingFrequency = 'MISSING_FREQUENCY',
  MissingQuantity = 'MISSING_QUANTITY',
  PriorWoundLinkBroken = 'PRIOR_WOUND_LINK_BROKEN',
  UnparseableDuration = 'UNPARSEABLE_DURATION',
  UnparseableFrequency = 'UNPARSEABLE_FREQUENCY',
  UnparseableQuantity = 'UNPARSEABLE_QUANTITY'
}

export type ProductEligibilityWoundVerdict = {
  __typename?: 'ProductEligibilityWoundVerdict';
  classification?: Maybe<ProductEligibilityClassification>;
  decidingPriorLineItemId?: Maybe<Scalars['Int']['output']>;
  defer: Scalars['Int']['output'];
  deferDays?: Maybe<Scalars['Int']['output']>;
  eligibilityDate?: Maybe<Scalars['Date']['output']>;
  planOfCarePriors: Array<ProductEligibilityLineItem>;
  priors: Array<ProductEligibilityLineItem>;
  shipNow: Scalars['Int']['output'];
  shipNowDays?: Maybe<Scalars['Int']['output']>;
  unknownReason?: Maybe<ProductEligibilityUnknownReason>;
  woundLabel: Scalars['String']['output'];
};

export type ProductFrequency = {
  __typename?: 'ProductFrequency';
  coverageDetail?: Maybe<CoverageDetail>;
  frequencyOfUse?: Maybe<Scalars['String']['output']>;
};

export type ProductSize = {
  __typename?: 'ProductSize';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductSizeDetails = {
  __typename?: 'ProductSizeDetails';
  formItemId?: Maybe<Scalars['Int']['output']>;
  formItemName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductSizeInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductSubCategory {
  ArmSleeve = 'ARM_SLEEVE',
  CompressionBra = 'COMPRESSION_BRA',
  Stocking = 'STOCKING',
  Wrap = 'WRAP'
}

export type ProgressNoteOrderList = {
  __typename?: 'ProgressNoteOrderList';
  maxPage: Scalars['Int']['output'];
  numOrders: Scalars['Int']['output'];
  orders: Array<ProviderReferral>;
};

export type ProgressNoteVerificationResult = {
  __typename?: 'ProgressNoteVerificationResult';
  confidence: Scalars['Float']['output'];
  metricsId: Scalars['Int']['output'];
  passed: Scalars['Boolean']['output'];
  reasons: Array<Scalars['String']['output']>;
};

export type PromptBadge = {
  __typename?: 'PromptBadge';
  humanValidation?: Maybe<Scalars['String']['output']>;
  promptId: Scalars['String']['output'];
  shortLabel: Scalars['String']['output'];
  validation?: Maybe<Scalars['String']['output']>;
};

export type PromptDetail = {
  __typename?: 'PromptDetail';
  content: Scalars['String']['output'];
  evidence?: Maybe<Array<EvidenceQuote>>;
  humanExplanation?: Maybe<Scalars['String']['output']>;
  humanVerdict?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  promptId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  validation?: Maybe<Scalars['String']['output']>;
};

export type PromptMetrics = {
  __typename?: 'PromptMetrics';
  agreements: Scalars['Int']['output'];
  fnCount: Scalars['Int']['output'];
  fpCount: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  promptId: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type ProofOfDeliveryDocument = {
  __typename?: 'ProofOfDeliveryDocument';
  carrier: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  distributorOrderNumber?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  s3Key: Scalars['String']['output'];
  trackingNumber: Scalars['String']['output'];
};

export type ProstheticsDiagnosis = {
  __typename?: 'ProstheticsDiagnosis';
  diagnosis?: Maybe<Scalars['String']['output']>;
  icd10Code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use qualifyingLcdGroups. */
  qualifyingGroups: Array<Scalars['Int']['output']>;
  qualifyingLcdGroups: Array<ProstheticsQualifyingGroup>;
};

export type ProstheticsDiagnosisInput = {
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  icd10Code?: InputMaybe<Scalars['String']['input']>;
  qualifyingGroups?: InputMaybe<Array<Scalars['Int']['input']>>;
  qualifyingLcdGroups?: InputMaybe<Array<ProstheticsQualifyingGroupInput>>;
};

export type ProstheticsLineItem = {
  __typename?: 'ProstheticsLineItem';
  formItemId?: Maybe<Scalars['Int']['output']>;
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  subcategory: Scalars['String']['output'];
  systemKey?: Maybe<Scalars['String']['output']>;
};

export type ProstheticsLineItemInput = {
  formItemId?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  subcategory: Scalars['String']['input'];
  systemKey?: InputMaybe<Scalars['String']['input']>;
};

export type ProstheticsOrder = {
  __typename?: 'ProstheticsOrder';
  conditionChangeDescription?: Maybe<Scalars['String']['output']>;
  diabeticFootConditions?: Maybe<Array<DiabeticFootCondition>>;
  functionalLevel?: Maybe<Scalars['String']['output']>;
  hasConditionChangeForNewType?: Maybe<Scalars['Boolean']['output']>;
  hasCoveredFormForBraPocket?: Maybe<Scalars['Boolean']['output']>;
  hasOwnedBreastProsthesis?: Maybe<Scalars['Boolean']['output']>;
  hasOwnedSameProsthesisType?: Maybe<Scalars['Boolean']['output']>;
  hasReceivedPermanentProsthesis?: Maybe<Scalars['Boolean']['output']>;
  hasUndergoneMastectomy?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isDiabetesUnderComprehensivePlanOfCare?: Maybe<Scalars['Boolean']['output']>;
  isGarmentAlternativeToBra?: Maybe<Scalars['Boolean']['output']>;
  isLifetimeLengthOfNeed?: Maybe<Scalars['Boolean']['output']>;
  isMotivatedToAmbulate?: Maybe<Scalars['Boolean']['output']>;
  isPreviousProsthesisLostOrDamaged?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedInMonths?: Maybe<Scalars['Int']['output']>;
  lowerLimbLeftAmputationSite?: Maybe<Scalars['String']['output']>;
  lowerLimbLeftAttachmentMechanism?: Maybe<Scalars['String']['output']>;
  lowerLimbLeftCircumference?: Maybe<Scalars['String']['output']>;
  lowerLimbRightAmputationSite?: Maybe<Scalars['String']['output']>;
  lowerLimbRightAttachmentMechanism?: Maybe<Scalars['String']['output']>;
  lowerLimbRightCircumference?: Maybe<Scalars['String']['output']>;
  mastectomyAmputationSite?: Maybe<Scalars['String']['output']>;
  mastectomyBandSize?: Maybe<Scalars['String']['output']>;
  mastectomyCupSize?: Maybe<Scalars['String']['output']>;
  needsDiabeticShoes?: Maybe<Scalars['Boolean']['output']>;
  preferredDmeCompany?: Maybe<Scalars['String']['output']>;
  prostheticsDiagnoses: Array<ProstheticsDiagnosis>;
  prostheticsLineItems: Array<ProstheticsLineItem>;
  toeFillersAge?: Maybe<Scalars['String']['output']>;
  toeFillersLeftToesMissing?: Maybe<Scalars['String']['output']>;
  toeFillersRightToesMissing?: Maybe<Scalars['String']['output']>;
  toeFillersShoeSize?: Maybe<Scalars['String']['output']>;
  toeFillersShoeWidth?: Maybe<Scalars['String']['output']>;
  toeFillersWeight?: Maybe<Scalars['String']['output']>;
};

export type ProstheticsOrderInput = {
  conditionChangeDescription?: InputMaybe<Scalars['String']['input']>;
  diabeticFootConditions?: InputMaybe<Array<DiabeticFootCondition>>;
  functionalLevel?: InputMaybe<Scalars['String']['input']>;
  hasConditionChangeForNewType?: InputMaybe<Scalars['Boolean']['input']>;
  hasCoveredFormForBraPocket?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnedBreastProsthesis?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnedSameProsthesisType?: InputMaybe<Scalars['Boolean']['input']>;
  hasReceivedPermanentProsthesis?: InputMaybe<Scalars['Boolean']['input']>;
  hasUndergoneMastectomy?: InputMaybe<Scalars['Boolean']['input']>;
  isDiabetesUnderComprehensivePlanOfCare?: InputMaybe<Scalars['Boolean']['input']>;
  isGarmentAlternativeToBra?: InputMaybe<Scalars['Boolean']['input']>;
  isLifetimeLengthOfNeed?: InputMaybe<Scalars['Boolean']['input']>;
  isMotivatedToAmbulate?: InputMaybe<Scalars['Boolean']['input']>;
  isPreviousProsthesisLostOrDamaged?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedInMonths?: InputMaybe<Scalars['Int']['input']>;
  lowerLimbLeftAmputationSite?: InputMaybe<Scalars['String']['input']>;
  lowerLimbLeftAttachmentMechanism?: InputMaybe<Scalars['String']['input']>;
  lowerLimbLeftCircumference?: InputMaybe<Scalars['String']['input']>;
  lowerLimbRightAmputationSite?: InputMaybe<Scalars['String']['input']>;
  lowerLimbRightAttachmentMechanism?: InputMaybe<Scalars['String']['input']>;
  lowerLimbRightCircumference?: InputMaybe<Scalars['String']['input']>;
  mastectomyAmputationSite?: InputMaybe<Scalars['String']['input']>;
  mastectomyBandSize?: InputMaybe<Scalars['String']['input']>;
  mastectomyCupSize?: InputMaybe<Scalars['String']['input']>;
  needsDiabeticShoes?: InputMaybe<Scalars['Boolean']['input']>;
  preferredDmeCompany?: InputMaybe<Scalars['String']['input']>;
  prostheticsDiagnoses?: InputMaybe<Array<ProstheticsDiagnosisInput>>;
  prostheticsLineItems?: InputMaybe<Array<ProstheticsLineItemInput>>;
  toeFillersAge?: InputMaybe<Scalars['String']['input']>;
  toeFillersLeftToesMissing?: InputMaybe<Scalars['String']['input']>;
  toeFillersRightToesMissing?: InputMaybe<Scalars['String']['input']>;
  toeFillersShoeSize?: InputMaybe<Scalars['String']['input']>;
  toeFillersShoeWidth?: InputMaybe<Scalars['String']['input']>;
  toeFillersWeight?: InputMaybe<Scalars['String']['input']>;
};

export type ProstheticsQualifyingDiagnosisCode = {
  __typename?: 'ProstheticsQualifyingDiagnosisCode';
  icd10Code: Scalars['String']['output'];
  lcdCode: Scalars['String']['output'];
  qualifyingGroup: Scalars['Int']['output'];
};

export type ProstheticsQualifyingGroup = {
  __typename?: 'ProstheticsQualifyingGroup';
  lcdCode: Scalars['String']['output'];
  qualifyingGroup: Scalars['Int']['output'];
};

export type ProstheticsQualifyingGroupInput = {
  lcdCode: Scalars['String']['input'];
  qualifyingGroup: Scalars['Int']['input'];
};

export enum ProviderContactField {
  Fax = 'FAX',
  Phone = 'PHONE'
}

export type ProviderReferral = {
  __typename?: 'ProviderReferral';
  allowedToEdit?: Maybe<Scalars['Boolean']['output']>;
  assigned?: Maybe<Scalars['Boolean']['output']>;
  autoInsuranceInfo?: Maybe<AutoInsuranceInfo>;
  bundledOrder?: Maybe<Scalars['Boolean']['output']>;
  careBridgeOrder?: Maybe<CareBridgeOrder>;
  careCoordinatorEmail?: Maybe<Scalars['String']['output']>;
  careInternalId?: Maybe<Scalars['String']['output']>;
  careMco?: Maybe<Scalars['String']['output']>;
  clinicDelivery?: Maybe<ClinicDelivery>;
  clinicInfo?: Maybe<ClinicInfo>;
  collectShipInfo?: Maybe<Scalars['Boolean']['output']>;
  compressionOrder: CompressionOrder;
  coordinatedFulfillmentStatuses?: Maybe<Array<CoordinatedFulfillmentSegmentStatus>>;
  cpapOrder: CpapOrder;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  customOrthoticsOrder: CustomOrthoticsOrder;
  departmentId: Scalars['Int']['output'];
  diabetesOrder: DiabetesOrder;
  diagnoses?: Maybe<Array<Diagnosis>>;
  encounterDate?: Maybe<Scalars['String']['output']>;
  extensionOrderToken?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insuranceInfo?: Maybe<PatientInsuranceInfo>;
  insuranceType?: Maybe<InsuranceType>;
  isFaxOrder: Scalars['Boolean']['output'];
  isHandOff?: Maybe<Scalars['Boolean']['output']>;
  isHighCostFlaggingEligible: Scalars['Boolean']['output'];
  isMarkAsIncompleteEligible: Scalars['Boolean']['output'];
  isMedicareBlockingEligible: Scalars['Boolean']['output'];
  miscellaneousOrder: MiscellaneousOrder;
  modernLineItems?: Maybe<Array<ModernLineItem>>;
  nebulizerOrder: NebulizerOrder;
  offTheShelfOrthoticsOrder: OffTheShelfOrthoticsOrder;
  orderDisplayModels: Array<OrderDisplayModel>;
  orderDocuments?: Maybe<OrderDocuments>;
  orderNote?: Maybe<Scalars['String']['output']>;
  orderNotes?: Maybe<Array<OrderNote>>;
  orderProductSummary?: Maybe<Array<OrderProduct>>;
  orderRemarks?: Maybe<Array<OrderRemark>>;
  orderStatus: ProviderReferralStatus;
  orderStatusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  originatingDepartmentOrderId?: Maybe<Scalars['Int']['output']>;
  originatingOrderNumber?: Maybe<Scalars['String']['output']>;
  ostomyOrder: OstomyOrder;
  patientAddress?: Maybe<ShippingAddress>;
  patientDob?: Maybe<Scalars['String']['output']>;
  patientEmailAddress?: Maybe<Scalars['String']['output']>;
  patientWillPayOop?: Maybe<Scalars['Boolean']['output']>;
  planOfCares?: Maybe<Array<PlanOfCare>>;
  prostheticsOrder: ProstheticsOrder;
  reorderNumber?: Maybe<Scalars['String']['output']>;
  selectedPracticeIds: Array<PracticeIdAndIsDeleted>;
  selfPay?: Maybe<Scalars['Boolean']['output']>;
  shellFormOrders: Array<ShellFormOrder>;
  shouldBeTreatedAsLikelyToFail?: Maybe<Scalars['Boolean']['output']>;
  signNow?: Maybe<Scalars['Boolean']['output']>;
  signatureRequestedFromSignerId?: Maybe<Scalars['Int']['output']>;
  signerInfo?: Maybe<SignerInfo>;
  signerName?: Maybe<Scalars['String']['output']>;
  spreeOrder: SpreeOrder;
  telehealthOrder?: Maybe<TelehealthOrder>;
  transcriptionInternalNote?: Maybe<OpsOrderNote>;
  urologyOrder: UrologyOrder;
  ventilatorOrder: VentilatorOrder;
  wheelchairsAndScootersOrder: WheelchairsAndScootersOrder;
  workersCompInfo?: Maybe<WorkersCompInfo>;
  woundOrder: WoundOrder;
  woundSuctionOrder: WoundSuctionOrder;
};

export type ProviderReferralInput = {
  autoInsuranceInfo?: InputMaybe<AutoInsuranceInfoInput>;
  bundledOrder?: InputMaybe<Scalars['Boolean']['input']>;
  careBridgeOrder?: InputMaybe<CareBridgeOrderInput>;
  careCoordinatorEmail?: InputMaybe<Scalars['String']['input']>;
  careInternalId?: InputMaybe<Scalars['String']['input']>;
  careMco?: InputMaybe<Scalars['String']['input']>;
  clinicDelivery?: InputMaybe<ClinicDeliveryInput>;
  collectShipInfo?: InputMaybe<Scalars['Boolean']['input']>;
  compressionOrder?: InputMaybe<CompressionOrderInput>;
  cpapOrder?: InputMaybe<CpapOrderInput>;
  customOrthoticsOrder?: InputMaybe<CustomOrthoticsOrderInput>;
  departmentId: Scalars['Int']['input'];
  diabetesOrder?: InputMaybe<DiabetesOrderInput>;
  diagnosisInputs?: InputMaybe<Array<DiagnosisInput>>;
  encounterDate?: InputMaybe<Scalars['String']['input']>;
  faxInput?: InputMaybe<FaxInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  insuranceInfo?: InputMaybe<PatientInsuranceInfoInput>;
  insuranceType?: InputMaybe<InsuranceType>;
  isFaxOrder: Scalars['Boolean']['input'];
  isHighCostFlaggingEligible: Scalars['Boolean']['input'];
  isHomeHealthOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isMedicareBlockingEligible: Scalars['Boolean']['input'];
  miscellaneousOrder?: InputMaybe<MiscellaneousOrderInput>;
  modernLineItemInputs?: InputMaybe<Array<ModernLineItemInput>>;
  nebulizerOrder?: InputMaybe<NebulizerOrderInput>;
  offTheShelfOrthoticsOrder?: InputMaybe<OffTheShelfOrthoticsOrderInput>;
  orderDocumentsInfo?: InputMaybe<Array<OrderDocumentInput>>;
  orderNote?: InputMaybe<Scalars['String']['input']>;
  orderStatus?: InputMaybe<ProviderReferralStatus>;
  ostomyOrder?: InputMaybe<OstomyOrderInput>;
  patientAddress?: InputMaybe<ShippingAddressInput>;
  patientDob?: InputMaybe<Scalars['String']['input']>;
  patientEmailAddress?: InputMaybe<Scalars['String']['input']>;
  patientWillPayOop?: InputMaybe<Scalars['Boolean']['input']>;
  planOfCareInputs?: InputMaybe<Array<PlanOfCareInput>>;
  prostheticsOrder?: InputMaybe<ProstheticsOrderInput>;
  reorderNumber?: InputMaybe<Scalars['String']['input']>;
  selectedPracticeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  selfPay?: InputMaybe<Scalars['Boolean']['input']>;
  shellFormOrders?: InputMaybe<Array<ShellFormOrderInput>>;
  signNow?: InputMaybe<Scalars['Boolean']['input']>;
  signatureRequestedFromSignerId?: InputMaybe<Scalars['Int']['input']>;
  spreeOrder?: InputMaybe<SpreeOrderInput>;
  telehealthOrder?: InputMaybe<TelehealthOrderInput>;
  transcriptionInternalNote?: InputMaybe<Scalars['String']['input']>;
  uploadProgressNoteNow?: InputMaybe<Scalars['Boolean']['input']>;
  urologyOrder?: InputMaybe<UrologyOrderInput>;
  ventilatorOrder?: InputMaybe<VentilatorOrderInput>;
  wheelchairsAndScootersOrder?: InputMaybe<WheelchairsAndScootersOrderInput>;
  workersCompInfo?: InputMaybe<WorkersCompInfoInput>;
  woundOrder?: InputMaybe<WoundOrderInput>;
  woundSuctionOrder?: InputMaybe<WoundSuctionOrderInput>;
};

export enum ProviderReferralStatus {
  Canceled = 'CANCELED',
  Delivered = 'DELIVERED',
  DocsReview = 'DOCS_REVIEW',
  InTransit = 'IN_TRANSIT',
  Issue = 'ISSUE',
  NoResponse = 'NO_RESPONSE',
  PartiallyDelivered = 'PARTIALLY_DELIVERED',
  PartnerFulfillment = 'PARTNER_FULFILLMENT',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  ReadyToShip = 'READY_TO_SHIP'
}

export type ProviderRiskInfo = {
  __typename?: 'ProviderRiskInfo';
  missingSignatureCount: Scalars['Int']['output'];
  status: ProviderRiskStatus;
};

export enum ProviderRiskStatus {
  AtRisk = 'AT_RISK',
  Blocked = 'BLOCKED',
  NoRisk = 'NO_RISK'
}

export type ProviderSignatureHoldExemption = {
  __typename?: 'ProviderSignatureHoldExemption';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<OpsUser>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  npiNumber: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type ProviderSigner = {
  __typename?: 'ProviderSigner';
  emails: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isHeld: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  npiNumber?: Maybe<Scalars['String']['output']>;
  practices: Array<Practice>;
};

export type ProvisionAnalyticsUserInput = {
  email: Scalars['String']['input'];
  hospitalIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hospitalSystemId?: InputMaybe<Scalars['Int']['input']>;
};

export type PverifyEligiblePayor = {
  __typename?: 'PverifyEligiblePayor';
  eligibilityApi?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  payor: Scalars['String']['output'];
  payorCode?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  activeAuditStatesForHcpcs: Array<UsState>;
  activeSynapseSegments: Array<OrderSegment>;
  allCanonicalPayors: Array<CanonicalPayor>;
  allFormItemSubstitutions: Array<DepartmentFormItemSubstitution>;
  allOpsOrderStateTypes: Array<OpsOrderState>;
  allOrderCancellationTypes: Array<OrderCancellationType>;
  allProductSizes: Array<ProductSizeDetails>;
  allResetReasons: Array<ResetReason>;
  allUsStates: Array<UsState>;
  allWoundCareFormItems: Array<Product>;
  analyticsFulfillment: AnalyticsFulfillment;
  analyticsHospitalSystems: Array<AnalyticsHospitalSystem>;
  analyticsHospitals: Array<AnalyticsHospital>;
  analyticsOrderCategory: AnalyticsOrderCategory;
  analyticsOrderInsights: AnalyticsOrderInsights;
  analyticsOverview: AnalyticsOverview;
  analyticsPayorMix: AnalyticsPayorMix;
  analyticsSavings: AnalyticsSavings;
  analyticsTopProducts: AnalyticsTopProducts;
  assignableClinicalReviewers: Array<OpsWorklistUser>;
  assignableHandOffPortalUsers: Array<HandOffPortalAssignableUser>;
  autoAppealPackageSettings: AutoAppealPackageSettingsSchema;
  autoApprovalSettings: AutoApprovalSettingsSchema;
  autoClaimFileEligibility: AutoFileEligibility;
  autoClaimFileSettings: AutoClaimFileSettingsSchema;
  autofillGuess: AutofillGuess;
  availableDepartmentProfiles: Array<DepartmentProfileOption>;
  batchGetOrders: Array<BatchOrderResult>;
  billerReviewDrafts: Array<BillerReviewDraft>;
  billerReviewReasons: Array<BillerReviewReason>;
  billerReviewResponseOptions: Array<BillerReviewParentResponseOption>;
  billerReviews: Array<BillerReview>;
  billingAuditKeywordsSettings: BillingAuditKeywordsSettingsSchema;
  billingDataForOrderSegment: BillingDataForOrderSegment;
  bufferedOrderNotes: Array<BufferedOrderNoteGql>;
  calculateFormItemSizeAndQuantity?: Maybe<CalculatedSizeAndQuantitySetListResponse>;
  canCreatePartnerReferringFacility: Scalars['Boolean']['output'];
  canShowClaimInfo: Scalars['Boolean']['output'];
  cardinalSubtotal: CardinalOrderPlacementResponse;
  careBridgeFormItems: Array<CareBridgeFormItem>;
  careCoordinationTaskAssignees: Array<OpsUser>;
  careCoordinationTaskById: CareCoordinationTask;
  careCoordinationTaskTags: Array<CareCoordinationTaskTag>;
  careCoordinationTaskTypes: Array<CareCoordinationTaskType>;
  careCoordinationTasks: CareCoordinationTaskListResponse;
  careCoordinationTasksForProvider: Array<CareCoordinationTask>;
  categoryDisplayNames: Array<CategoryDisplayName>;
  checkDuplicateHospital: Array<DuplicateHospital>;
  checkMedicareBlockingEligibility: Scalars['Boolean']['output'];
  checkMedicareBlockingInfo: MedicareBlockingInfo;
  checkOrderExistsByReorderNumber: Scalars['Boolean']['output'];
  checksForSegment: Array<PatientCheckAllocation>;
  claimExternalIds: Array<Scalars['String']['output']>;
  claimInfo?: Maybe<UnitedHealthcareClaim>;
  claimPreview: Array<ClaimPreviewLineItem>;
  clinicEditWindow: ClinicEditWindowStatus;
  clinicalReviewHub: ClinicalReviewHubData;
  clinicalReviewOrderDetail?: Maybe<ClinicalReviewOrderDetail>;
  clinicalReviewSettings: ClinicalReviewSettingsSchema;
  commsGateNode?: Maybe<CommsGateNodeInfo>;
  /** @deprecated Use worklistTabCounts.finishedCount instead. */
  completedTodayCount: Scalars['Int']['output'];
  compressionColorCatalog: Array<CompressionColor>;
  compressionColors: Array<CompressionColor>;
  countOfHandOffPortalOrders: HandOffPortalOrderCount;
  createHandOffOrderSegmentPdf: Scalars['String']['output'];
  currentDepartmentProducts: DepartmentProducts;
  currentFaxOrderFormTemplateUrls: Array<FaxOrderFormTemplateCategoryUrl>;
  currentUserInfo?: Maybe<UserInfo>;
  customOrthoticsQualifyingDiagnosisCodes: Array<CustomOrthoticsQualifyingDiagnosisCode>;
  dayToType: OpsDayToType;
  defaultHandOffPartnerProductCategories: Array<ProductCategory>;
  deletedClinicEnteredLineItems: Array<DeletedClinicEnteredLineItem>;
  deletedOrderDocuments: Array<DeletedOrderDocument>;
  deletedOrderFaxes: Array<DeletedOrderFax>;
  deliveryAttestableItems: Array<DeliveryAttestableItem>;
  department: Department;
  departmentCategories: DepartmentCategories;
  departmentDesignations: Array<DepartmentDesignation>;
  departmentFormItems: Array<DepartmentFormItem>;
  departmentOrderPreferences: Array<DepartmentOrderPreferences>;
  diabetesQualifyingDiagnosisCodes: Array<Scalars['String']['output']>;
  distributorInvoiceProductMappings: DistributorInvoiceProductMappingsPage;
  distributorInvoiceProductSearch: Array<DistributorInvoiceProductSearchResult>;
  distributorInvoiceProducts: Array<DistributorInvoiceProduct>;
  distributorOrderDiagnoses: Array<DistributorOrderDiagnosis>;
  distributorOrderLineItems: Array<OrderSegmentLineItem>;
  distributorOrders: Array<DistributorOrder>;
  distributorOrdersBySegment: Array<DistributorOrder>;
  distributorProductGroups: Array<DistributorProductGroup>;
  distributors: Array<Distributor>;
  docReviewDocument: DocReviewDocument;
  docReviewNote: DocReviewNote;
  docReviewQueue: DocReviewQueueResult;
  documentCollectionProviderContactNumbers: Array<DocumentCollectionProviderContactNumber>;
  documentNeededOrders: DocumentNeededOrders;
  draftOpsNoteAutocomplete: Scalars['String']['output'];
  draftOrders: DraftOrdersPage;
  eligibility?: Maybe<EligibilityResponse>;
  eligibilitySources: Array<EligibilitySource>;
  eligiblePayors: Array<EligiblePayor>;
  enabledOrderCancellationTypes: Array<OrderCancellationType>;
  enabledResetReasons: Array<ResetReason>;
  events: Array<OrderEvent>;
  faxOrderFormTemplateActiveOverrides: Array<FaxOrderFormTemplateVersion>;
  faxOrderFormTemplateVersions: Array<FaxOrderFormTemplateVersion>;
  featureFlags: Array<FeatureFlag>;
  filledMessageTemplate: Scalars['String']['output'];
  filterAttributes: Array<FilterAttribute>;
  filterRulesetGroups: Array<FilterRulesetGroup>;
  filterRulesets: Array<FilterRuleset>;
  formItemFrequencyRules: Array<ProductFrequency>;
  formItemPinnedClinicCount: Scalars['Int']['output'];
  formItemTemplates: Array<FormItemTemplate>;
  frequentPayors: Array<Scalars['String']['output']>;
  generateBatchPnRequest?: Maybe<Scalars['String']['output']>;
  generateCombinedBillerReviewTemplate?: Maybe<RenderedBillerReviewNote>;
  generateFixableBillerReviewTemplate?: Maybe<RenderedBillerReviewNote>;
  /** @deprecated Use generateNonfixableMedicalRecordsNote instead */
  generateNonfixableBillerReviewTemplate: Scalars['String']['output'];
  generateNonfixableMedicalRecordsNote?: Maybe<RenderedBillerReviewNote>;
  getAccountRep?: Maybe<OpsUser>;
  getAddendumDocument: Scalars['String']['output'];
  getAllDocumentCollectionOrders: DocumentCollectionOrderList;
  getAllPverifyPayors: Array<PverifyEligiblePayor>;
  getAutofillEligibleCategories: Array<ProductCategory>;
  getBatchSignatureRequestOrderData: Array<BatchSignatureRequestOrderData>;
  getCalculatedTapeQuantity?: Maybe<Scalars['Int']['output']>;
  getDepartmentFaxNumbers: Array<DepartmentFaxNumber>;
  getDoNotBillOrderFlag: DoNotBillOrderFlag;
  getDocumentCollectionOrders: DocumentCollectionOrderList;
  getDocumentCollectionProviderNames: Array<Scalars['String']['output']>;
  getDocumentCollectionStats: DocumentCollectionStats;
  getExtractedAppealFields?: Maybe<ExtractedAppealFields>;
  /** @deprecated Use getExtractedPatientDemographicsWithValidation instead */
  getExtractedPatientDemographics?: Maybe<ExtractedPatientDemographicsComparison>;
  getExtractedPatientDemographicsWithValidation?: Maybe<ExtractedPatientDemographicsComparison>;
  getExtractedWoundLineItems?: Maybe<Array<ExtractedWoundLineItemComparison>>;
  getExtractedWounds?: Maybe<Array<ExtractedWoundInfoComparison>>;
  getHoliday?: Maybe<HolidayResponse>;
  getHomeHealthAgencies: Array<HomeHealthAgency>;
  getHomeHealthCoordinationOrders: HomeHealthCoordinationOrderList;
  getHomeHealthCoordinationOrdersByStatus: HomeHealthCoordinationOrderList;
  getIsHighCostOrder: Scalars['Boolean']['output'];
  getLivekitCallTranscript: Array<TranscriptTurn>;
  getLivekitCalls: LivekitCallList;
  getMedicareFrequencyExemptions: MedicareFrequencyExemptions;
  getNewerOrdersForPatient: Array<OrderNumber>;
  getNextMercyOrderNumber: Scalars['String']['output'];
  getPartnerInsuranceOptions: Array<Scalars['String']['output']>;
  getPatientRows: Array<PatientRow>;
  getPatientStateOptions: Array<Scalars['String']['output']>;
  getPatientWillPayOop?: Maybe<Scalars['Boolean']['output']>;
  getProviderAccounts: Array<ClinicianUser>;
  /** @deprecated Use getAccountRep instead */
  getSalesRep: SalesReps;
  /** @deprecated Use teamMemberTasks instead. */
  getUserTasks: Array<WorklistTask>;
  handOffFailureReasons: Array<HandOffFailureReason>;
  handOffOrderSegment?: Maybe<HandOffOrderSegment>;
  handOffOrderSegmentMessages: Array<HandOffOrderSegmentMessage>;
  handOffOrderSegmentTabs: Array<HandOffOrderSegmentTab>;
  handOffPartnerFeeSchedule: Array<HandOffPartnerFeeScheduleRate>;
  handOffPartnerFromUserId?: Maybe<HandOffPartner>;
  handOffPartnerInsurers: Array<HandOffPartnerInsurer>;
  handOffPartnerOperatingZipCodes: Array<Scalars['String']['output']>;
  handOffPartnerPolicyRoutingEntries: Array<HandOffPartnerPolicyRoutingEntry>;
  handOffPartnerProductCategories: Array<ProductCategory>;
  handOffPartnerRampVendors: Array<HandOffPartnerRampVendor>;
  handOffPartnerRoutingHospitalBlocklistEntries: Array<HandOffPartnerRoutingHospitalBlocklistEntry>;
  handOffPartners: Array<HandOffPartner>;
  handOffPortalOrder?: Maybe<HandOffPortalOrder>;
  handOffPortalOrders: Array<HandOffPortalOrder>;
  hcpcsData: Array<HcpcsData>;
  hcpcsMaxFrequencies: Array<HcpcsMaxFrequencyEntry>;
  hcpcsMaxQuantities: Array<HcpcsMaxQuantityEntry>;
  hcpcsOpsGuidanceGroups: Array<HcpcsOpsGuidanceGroup>;
  hospitalOrdersCount: Scalars['Int']['output'];
  hospitalProfile: HospitalProfile;
  icd10CodeSearch: Array<ModernIcd10Description>;
  icd10DescriptionsByCodes: Array<Icd10Description>;
  icd10DescriptionsById: Array<Icd10Description>;
  icd10DescriptionsSearch: Array<ModernIcd10Description>;
  inviteUserBlockedReason?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use onlineStatus instead. */
  isOffline: Scalars['Boolean']['output'];
  isPatientPortalPilot: Scalars['Boolean']['output'];
  isScopeOfServiceLocked: Scalars['Boolean']['output'];
  isTeamLead: Scalars['Boolean']['output'];
  isUhcPayor: Scalars['Boolean']['output'];
  issueOrders: Array<ProviderReferral>;
  linkedDepartments: Array<Department>;
  linkedDepartmentsForHcpcs: Array<HcpcsDepartmentLink>;
  linkedDepartmentsLite: Array<LinkedDepartment>;
  linkedFulfillmentOrderNumbers: Array<Scalars['String']['output']>;
  linkedFulfillmentOrders: Array<LinkedFulfillmentOrder>;
  linkedHandOffPartners: Array<HandOffPartner>;
  lookupFaxNumbersFromNpi: NpiRegistryResponse;
  managedAnalyticsUsers: Array<AnalyticsUser>;
  managedManufacturers: Array<ManagedManufacturer>;
  managedOpsUser?: Maybe<OpsUser>;
  managedOpsUsers: Array<OpsUser>;
  managedSpreeUser?: Maybe<SpreeUser>;
  managedSpreeUsers: Array<SpreeUser>;
  medicalNecessityInterview?: Maybe<MedicalNecessityInterview>;
  medicareAdvantagePotentialLiabilityNoticeStatus?: Maybe<MedicareAdvantagePotentialLiabilityNoticeStatus>;
  medicareBlockingHcpcsCodes: Array<MedicareBlockingHcpcsCode>;
  medicareProtocolsWarningMessages: Array<Array<WarningMessage>>;
  mercySubtotal: OrderPlacementResponse;
  messageTemplateSettings: Array<MessageTemplateSettings>;
  messageTemplates: Array<MessageTemplate>;
  missingProgressNoteOrders: ProgressNoteOrderList;
  missingSignatureOrders: ProgressNoteOrderList;
  modernFormItemVariantCatalog: Array<CatalogModernFormItem>;
  nebulizerQualifyingDiagnosisCodes: Array<NebulizerQualifyingDiagnosisCode>;
  nextDraftOrderNumber: Scalars['String']['output'];
  nppesNpiValidation?: Maybe<NppesNpiValidation>;
  onlineStatus: OnlineStatusResult;
  oopCostPreview: OopCostPreview;
  oopCosts: Array<OopCost>;
  oopWorkflowStatus: OopWorkflowStatus;
  openChargesForPatient: Array<PatientOpenCharge>;
  openPmPayorsWithRemittanceChannel: Array<OpenPmPayorWithRemittanceChannel>;
  opsTaskById: OpsTask;
  opsTaskHistory: Array<OpsTaskHistoryObject>;
  opsTaskOptions: OpsTaskOptions;
  opsTaskTypes: Array<OpsTaskType>;
  opsTasks: Array<OpsTask>;
  opsTasksForOrder: Array<OpsTask>;
  opsUser: OpsUser;
  opsUserPositionHistory: Array<OpsUserPositionHistory>;
  opsUsers: Array<OpsUser>;
  orderAssemblyDashboard: OrderAssemblyDashboard;
  orderAssemblyFaxIncompleteBacklog: Scalars['Int']['output'];
  orderAssemblyMissedSegmentRate: MissedSegmentRate;
  orderAssemblyThroughputToday: OrderAssemblyThroughputToday;
  orderCancellationType?: Maybe<OrderCancellationType>;
  orderDagStateSummary?: Maybe<OrderDagStateSummary>;
  orderDocumentationStatuses: Array<OrderDocumentationStatusRecord>;
  orderDocuments: OrderDocuments;
  orderList: OrderListPage;
  orderProgressNotes: Scalars['String']['output'];
  orderSegmentFrequencyViolations: OrderSegmentFrequencyViolations;
  orderSegmentLineItems: Array<OrderSegmentLineItem>;
  orderSegmentPreCheck: OrderSegmentPreCheck;
  orderSegmentReasonsForTypeOthers: Array<OrderSegmentReasonsForTypeOthersDetails>;
  orderSegmentTypes: Array<OrderSegmentType>;
  orderSegments: Array<OrderSegment>;
  orderSegmentsWithCreation: Array<OrderSegment>;
  orderSynapseHoldStatus: OrderSynapseHoldStatus;
  orderSynapseSegmentStatuses: Array<OrderSegmentSynapseStatus>;
  orderWorkflowDag?: Maybe<OrderWorkflowDag>;
  ordersForPaymentLink: Array<Scalars['String']['output']>;
  ordersSynapseDocumentationHolds: Array<OrderSynapseDocumentationHold>;
  otherAvailableChecksForSegment: Array<AvailableCheckPayment>;
  outboundFaxesForOrder: Array<OutboundFaxDetail>;
  partnerOrderPlacerNames: Array<Scalars['String']['output']>;
  patientChargeQuotes: Array<PatientChargeQuote>;
  patientChargeSegmentContext: Array<PatientChargeSegmentContext>;
  patientCharges: Array<PatientCharge>;
  patientData: PatientData;
  patientDataById: PatientData;
  patientMailingAddress: MailingAddress;
  patientOrderHistory: Array<PatientOrderHistoryItem>;
  patientOrders: Array<PatientOrder>;
  patientOrdersSearch: Array<PatientOrdersSearchOrder>;
  patientPortalAddress?: Maybe<Scalars['JSON']['output']>;
  patientPortalBalances: Scalars['JSON']['output'];
  patientPortalHomeView: Scalars['JSON']['output'];
  patientPortalOrderDetail: Scalars['JSON']['output'];
  patientPortalOrderPage: Scalars['JSON']['output'];
  patientPortalPatientSearch: Array<PatientPortalPatientMatch>;
  patientPortalPaymentLink: Scalars['JSON']['output'];
  patientPortalRefillAddress: Scalars['JSON']['output'];
  patientPortalRefillSheet: Scalars['JSON']['output'];
  payorApiCodes: Array<PayorApiCode>;
  payorConfig?: Maybe<PayorConfig>;
  payorConfigs: Array<PayorConfig>;
  payorMemberOrderShipments: Array<PayorMemberShipment>;
  payorMemberOrders?: Maybe<PayorMemberOrdersResult>;
  payorMembers: PayorMemberSearchResult;
  payorToBill?: Maybe<PayorToBill>;
  payorToBillForOrderNumber: Array<PayorToBill>;
  pmnHcpcsAccessories: Array<PmnHcpcsAccessory>;
  pmnHcpcsCodes: Array<PmnHcpcsCode>;
  pnSwoMatchingIssues: Array<Array<PnswoMatchingIssue>>;
  potentialLiabilityAcknowledgement?: Maybe<PotentialLiabilityAcknowledgement>;
  presignedS3Urls: Array<Scalars['String']['output']>;
  previewDocumentCollectionProviderContactForDepartment: Array<DocumentCollectionProviderContactChange>;
  previewOnHoldClaimsRule: Array<OnHoldClaimPreview>;
  priorAuthorizationNumbers: Array<Maybe<Scalars['String']['output']>>;
  productEligibilityReport?: Maybe<ProductEligibilityReport>;
  productSearch: Array<Product>;
  progressNotesForLatestHl7AdtVisit: Array<Hl7NoteFile>;
  proofOfDeliveryDocuments: Array<ProofOfDeliveryDocument>;
  prostheticsQualifyingDiagnosesByLcd: Array<ProstheticsQualifyingDiagnosisCode>;
  /** @deprecated Use prostheticsQualifyingDiagnosesByLcd. */
  prostheticsQualifyingDiagnosisCodes: Array<Scalars['String']['output']>;
  providerReferral: ProviderReferral;
  providerRiskStatus?: Maybe<ProviderRiskInfo>;
  providerSignatureHoldExemptions: Array<ProviderSignatureHoldExemption>;
  providerSigner?: Maybe<ProviderSigner>;
  providerSigners: Array<ProviderSigner>;
  providerSignersByHospital: Array<ProviderSigner>;
  pverifyEligiblePayors: Array<PverifyEligiblePayor>;
  quotesForSegment: Array<PatientChargeQuote>;
  rcmEvents: Array<RcmEvent>;
  readAddressAutocomplete: Array<AddressAutoCompleteSuggestion>;
  readAutomaticRoutedOrder?: Maybe<HandOffPartner>;
  readCareBridgeCsvExport: Scalars['String']['output'];
  readDrainageLevelWarnings: WarningMessagesGroup;
  readManufacturerOrders: ManufacturerPortal;
  readOrderInsuranceTypeFromOrderNumber: InsuranceType;
  readPatientNames: Array<PatientData>;
  readTemplateHospitalOrderNumbers: Array<OrderNumber>;
  readWoundSubcategoryFormItems: Array<WoundCareLineItem>;
  refillEstimates: Array<RefillSeriesEstimate>;
  refillSmsConsent: RefillSmsConsent;
  relatedClinicalReviews: Array<RelatedClinicalReview>;
  reportedOrderIssues: Array<ReportedOrderIssue>;
  retrievalAssignees: Array<OpsUser>;
  retrievalById: CareCoordinationRetrieval;
  retrievalEvents: Array<CareCoordinationRetrievalEvent>;
  retrievalStageActions: CareCoordinationRetrievalStageActions;
  retrievalTags: Array<CareCoordinationRetrievalTag>;
  retrievals: CareCoordinationRetrievalListResponse;
  retrievalsByGroupKey: Array<CareCoordinationRetrieval>;
  retrievalsByOrderNumber: Array<CareCoordinationRetrieval>;
  retrievalsStageActions: Array<CareCoordinationRetrievalStageActionsForRetrieval>;
  reviewUnsignedOrders: Array<ProviderReferral>;
  routedHandoffBlocklist: Array<RoutedHandoffBlocklistEntry>;
  sameDayShippingStatus: SameDayShippingStatus;
  scopeOfServiceDocument?: Maybe<ScopeOfServiceDocument>;
  searchDistributorProducts: Array<DistributorProductSearchResult>;
  searchOpsUsers: Array<OpsWorklistUser>;
  searchReferringFacilityDepartments: DepartmentSearchResults;
  segmentErrors: Array<LineItemUpdatedPrepErrorLineItemAddedPrepErrorLineItemRemovedPrepErrorSegmentAddedPrepErrorSegmentRemovedPrepErrorShippingModePrepError>;
  signerInformation: SignerInfo;
  subcontractOrderLineItems: SubcontractOrderLineItems;
  subcontractablePartners: Array<HandOffPartner>;
  suggestedPayorMatches: Array<SuggestedPayorMatch>;
  synapseOrderLookup: Array<Scalars['String']['output']>;
  teamDashboard?: Maybe<TeamDashboardResult>;
  teamLeads: Array<OpsWorklistUser>;
  teamMemberTasks: Array<WorklistTask>;
  templateKeyOptions: Array<TemplateKeyOption>;
  timelineOrderEvents: Array<TimelineOrderEvent>;
  timelineOrderEventsInternal: Array<TimelineOrderEvent>;
  unassignedApiCodes: Array<PayorApiCode>;
  unknownDepartments: Array<UnknownDepartment>;
  unmatchedFaxesAndIncompleteOrders: FaxTab;
  usStates: Array<UsState>;
  userAuthInfo: UserAuthInfo;
  validateEmail: Scalars['Boolean']['output'];
  validateNpi: ValidateNpiResponse;
  validateOxygenForm: Array<FieldValidationError>;
  validatePhoneNumber: Scalars['Boolean']['output'];
  validationWarningMessagesForAllLineItems: Array<WarningMessagesGroup>;
  verifyProgressNote?: Maybe<ProgressNoteVerificationResult>;
  verseOsOrderInfo: VerseOsOrderInfo;
  verseOsOrderSearch: VerseOsOrderSearch;
  verseOsSingleOrderInfo: VerseOsOrderSearchOrderInfo;
  worklistCoverage: Array<WorklistCoverage>;
  worklistCoverageSchedules: Array<CoverageSchedule>;
  worklistPeers: Array<OpsWorklistUser>;
  worklistQueueCounts: WorklistQueueCounts;
  worklistSettings: WorklistSettingsSchema;
  worklistTabCounts: WorklistTabCounts;
  woundCareCatalogItems: Array<CatalogFormItem>;
  woundItemTypes: Array<WoundItemType>;
  woundMatching?: Maybe<WoundMatching>;
  zingPrSettings: ZingPrSettings;
};


export type QueryActiveAuditStatesForHcpcsArgs = {
  hcpcsCode: Scalars['String']['input'];
  payorId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryActiveSynapseSegmentsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryAllFormItemSubstitutionsArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryAnalyticsFulfillmentArgs = {
  filter: AnalyticsFilter;
};


export type QueryAnalyticsOrderCategoryArgs = {
  filter: AnalyticsFilter;
};


export type QueryAnalyticsOrderInsightsArgs = {
  filter: AnalyticsFilter;
};


export type QueryAnalyticsOverviewArgs = {
  filter: AnalyticsFilter;
};


export type QueryAnalyticsPayorMixArgs = {
  filter: AnalyticsFilter;
};


export type QueryAnalyticsSavingsArgs = {
  filter: AnalyticsFilter;
};


export type QueryAnalyticsTopProductsArgs = {
  filter: AnalyticsFilter;
};


export type QueryAssignableHandOffPortalUsersArgs = {
  handOffPartnerId?: InputMaybe<Scalars['Int']['input']>;
  handOffPartnerRef?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAutoClaimFileEligibilityArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryAutofillGuessArgs = {
  enteredProductName: Scalars['String']['input'];
};


export type QueryBatchGetOrdersArgs = {
  orderNumbers: Array<Scalars['String']['input']>;
};


export type QueryBillerReviewDraftsArgs = {
  billerReviewId: Scalars['Int']['input'];
};


export type QueryBillerReviewResponseOptionsArgs = {
  reasonType: BillerReviewReasonType;
};


export type QueryBillerReviewsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryBillingDataForOrderSegmentArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryBufferedOrderNotesArgs = {
  departmentOrderId: Scalars['Int']['input'];
  nodeId: Scalars['Int']['input'];
};


export type QueryCalculateFormItemSizeAndQuantityArgs = {
  colocatedItems?: InputMaybe<Array<ColocatedLineItemInput>>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  formItemId?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  wounds?: InputMaybe<Array<WoundInput>>;
};


export type QueryCanCreatePartnerReferringFacilityArgs = {
  handOffPartnerId: Scalars['Int']['input'];
};


export type QueryCanShowClaimInfoArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryCardinalSubtotalArgs = {
  orderNumber: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryCareBridgeFormItemsArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryCareCoordinationTaskByIdArgs = {
  taskId: Scalars['Int']['input'];
};


export type QueryCareCoordinationTasksArgs = {
  careCoordinationTaskListInput: CareCoordinationTaskListInput;
};


export type QueryCareCoordinationTasksForProviderArgs = {
  providerId: Scalars['Int']['input'];
};


export type QueryCheckDuplicateHospitalArgs = {
  address: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type QueryCheckMedicareBlockingEligibilityArgs = {
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  hospitalId?: InputMaybe<Scalars['Int']['input']>;
  insuranceType?: InputMaybe<Scalars['String']['input']>;
  primaryInsurance?: InputMaybe<Scalars['String']['input']>;
  userEmail: Scalars['String']['input'];
};


export type QueryCheckMedicareBlockingInfoArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryCheckOrderExistsByReorderNumberArgs = {
  hospitalId: Scalars['Int']['input'];
  reorderNumber: Scalars['String']['input'];
};


export type QueryChecksForSegmentArgs = {
  chargeType: ChargeType;
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryClaimExternalIdsArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryClaimInfoArgs = {
  distributorOrderId: Scalars['Int']['input'];
};


export type QueryClaimPreviewArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryClinicEditWindowArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryClinicalReviewHubArgs = {
  benchmarkOnly?: Scalars['Boolean']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  pipelineVersion?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClinicalReviewOrderDetailArgs = {
  orderNumber: Scalars['String']['input'];
  pipelineVersion?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommsGateNodeArgs = {
  departmentOrderId: Scalars['Int']['input'];
};


export type QueryCountOfHandOffPortalOrdersArgs = {
  handOffPartnerId?: InputMaybe<Scalars['Int']['input']>;
  handOffPartnerRef?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCreateHandOffOrderSegmentPdfArgs = {
  customNotes: Scalars['String']['input'];
  handOffOrderSegmentId: Scalars['Int']['input'];
  hideBranding: Scalars['Boolean']['input'];
  includeProgressNoteSummary: Scalars['Boolean']['input'];
  subcontracted: Scalars['Boolean']['input'];
};


export type QueryCurrentDepartmentProductsArgs = {
  departmentId: Scalars['Int']['input'];
  payorName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCurrentFaxOrderFormTemplateUrlsArgs = {
  hospitalId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDayToTypeArgs = {
  day: Scalars['Date']['input'];
};


export type QueryDeletedClinicEnteredLineItemsArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryDeletedOrderDocumentsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryDeletedOrderFaxesArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryDeliveryAttestableItemsArgs = {
  handOffPortalOrderId?: InputMaybe<Scalars['Int']['input']>;
  handOffPortalOrderRef?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDepartmentArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryDepartmentCategoriesArgs = {
  departmentId: Scalars['Int']['input'];
  orderNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDepartmentFormItemsArgs = {
  hospitalId: Scalars['Int']['input'];
};


export type QueryDepartmentOrderPreferencesArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryDistributorInvoiceProductMappingsArgs = {
  distributorId: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDistributorInvoiceProductSearchArgs = {
  distributorId: Scalars['Int']['input'];
  search: Scalars['String']['input'];
};


export type QueryDistributorInvoiceProductsArgs = {
  distributorOrderId: Scalars['Int']['input'];
};


export type QueryDistributorOrderDiagnosesArgs = {
  distributorOrderId: Scalars['Int']['input'];
};


export type QueryDistributorOrderLineItemsArgs = {
  distributorId: Scalars['Int']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryDistributorOrdersArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryDistributorOrdersBySegmentArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryDistributorProductGroupsArgs = {
  distributorId: Scalars['Int']['input'];
  searchQuery: Scalars['String']['input'];
};


export type QueryDocReviewDocumentArgs = {
  documentId: Scalars['String']['input'];
  noteId: Scalars['String']['input'];
};


export type QueryDocReviewNoteArgs = {
  noteId: Scalars['String']['input'];
};


export type QueryDocReviewQueueArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryDocumentCollectionProviderContactNumbersArgs = {
  departmentId: Scalars['Int']['input'];
  documentCollectionOrderId: Scalars['Int']['input'];
};


export type QueryDocumentNeededOrdersArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryDraftOpsNoteAutocompleteArgs = {
  currentDraftMessage: Scalars['String']['input'];
  orderNoteId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
};


export type QueryDraftOrdersArgs = {
  departmentId: Scalars['Int']['input'];
  query: Scalars['String']['input'];
};


export type QueryEligibilityArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryEligiblePayorsArgs = {
  search?: Scalars['String']['input'];
};


export type QueryEnabledOrderCancellationTypesArgs = {
  orderNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryFaxOrderFormTemplateActiveOverridesArgs = {
  productCategory: ProductCategory;
};


export type QueryFaxOrderFormTemplateVersionsArgs = {
  hospitalId?: InputMaybe<Scalars['Int']['input']>;
  productCategory: ProductCategory;
};


export type QueryFilledMessageTemplateArgs = {
  keyInputs: Array<MessageTemplateKeyInput>;
  messageTemplateId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
};


export type QueryFormItemFrequencyRulesArgs = {
  formItemId: Scalars['Int']['input'];
  payorName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFormItemPinnedClinicCountArgs = {
  formItemId: Scalars['Int']['input'];
};


export type QueryGenerateBatchPnRequestArgs = {
  hospitalId: Scalars['Int']['input'];
  opsUserId: Scalars['Int']['input'];
};


export type QueryGenerateCombinedBillerReviewTemplateArgs = {
  medicalRecordsIssues?: InputMaybe<Array<PnswoMatchingIssueInput>>;
  orderNumber: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
  patientName?: InputMaybe<Scalars['String']['input']>;
  selectedProducts: BillerReviewProductInput;
};


export type QueryGenerateFixableBillerReviewTemplateArgs = {
  medicalRecordsIssues?: InputMaybe<Array<PnswoMatchingIssueInput>>;
  orderNumber: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
  patientName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGenerateNonfixableBillerReviewTemplateArgs = {
  orderNumber: Scalars['String']['input'];
  patientName?: InputMaybe<Scalars['String']['input']>;
  selectedProducts: BillerReviewProductInput;
};


export type QueryGenerateNonfixableMedicalRecordsNoteArgs = {
  orderNumber: Scalars['String']['input'];
  patientName?: InputMaybe<Scalars['String']['input']>;
  selectedProducts: BillerReviewProductInput;
};


export type QueryGetAccountRepArgs = {
  hospitalId: Scalars['Int']['input'];
};


export type QueryGetAddendumDocumentArgs = {
  addendumReason: Scalars['String']['input'];
  exampleFix: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  sendFax: Scalars['Boolean']['input'];
  visitDate: Scalars['String']['input'];
};


export type QueryGetAutofillEligibleCategoriesArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryGetBatchSignatureRequestOrderDataArgs = {
  orderNumbers: Array<Scalars['String']['input']>;
};


export type QueryGetCalculatedTapeQuantityArgs = {
  orderSegmentLineItemInput: Array<OrderSegmentLineItemInput>;
  tape: OrderSegmentLineItemInput;
  wounds: Array<WoundInput>;
};


export type QueryGetDepartmentFaxNumbersArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryGetDoNotBillOrderFlagArgs = {
  distributorOrderId?: InputMaybe<Scalars['Int']['input']>;
  orderSegmentId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDocumentCollectionOrdersArgs = {
  awaitingClinicResponseFilter?: InputMaybe<Scalars['Boolean']['input']>;
  departmentId: Scalars['Int']['input'];
  orderStatusFilter?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: Scalars['Int']['input'];
  providerFilter?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDocumentCollectionProviderNamesArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryGetDocumentCollectionStatsArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryGetExtractedAppealFieldsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryGetExtractedPatientDemographicsArgs = {
  fileName: Scalars['String']['input'];
  s3DocumentId: Scalars['Int']['input'];
};


export type QueryGetExtractedPatientDemographicsWithValidationArgs = {
  departmentId: Scalars['Int']['input'];
  fileName: Scalars['String']['input'];
  isFaxTranscription?: Scalars['Boolean']['input'];
  patientId?: InputMaybe<Scalars['Int']['input']>;
  s3DocumentId: Scalars['Int']['input'];
};


export type QueryGetExtractedWoundLineItemsArgs = {
  fileName: Scalars['String']['input'];
  orderTraceId: Scalars['String']['input'];
  s3DocumentId: Scalars['Int']['input'];
};


export type QueryGetExtractedWoundsArgs = {
  fileName: Scalars['String']['input'];
  orderTraceId: Scalars['String']['input'];
  s3DocumentId: Scalars['Int']['input'];
};


export type QueryGetHomeHealthAgenciesArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryGetHomeHealthCoordinationOrdersArgs = {
  departmentId: Scalars['Int']['input'];
  orderStatusFilter?: InputMaybe<Scalars['String']['input']>;
  orderTypeFilter?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: Scalars['Int']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetHomeHealthCoordinationOrdersByStatusArgs = {
  statuses?: InputMaybe<Array<HomeHealthCoordinationOrderStatus>>;
};


export type QueryGetIsHighCostOrderArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryGetLivekitCallTranscriptArgs = {
  externalEventId: Scalars['String']['input'];
};


export type QueryGetLivekitCallsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  needsHumanReview?: InputMaybe<Scalars['Boolean']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: Scalars['Int']['input'];
};


export type QueryGetMedicareFrequencyExemptionsArgs = {
  departmentId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetNewerOrdersForPatientArgs = {
  afterDate: Scalars['DateTime']['input'];
  patientId: Scalars['Int']['input'];
};


export type QueryGetNextMercyOrderNumberArgs = {
  orderNumber: Scalars['String']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryGetPartnerInsuranceOptionsArgs = {
  handOffPartnerId?: InputMaybe<Scalars['Int']['input']>;
  handOffPartnerRef?: InputMaybe<Scalars['String']['input']>;
  orderStatuses?: InputMaybe<Array<HandOffPortalOrderStatus>>;
};


export type QueryGetPatientRowsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPatientStateOptionsArgs = {
  handOffPartnerId?: InputMaybe<Scalars['Int']['input']>;
  handOffPartnerRef?: InputMaybe<Scalars['String']['input']>;
  orderStatuses?: InputMaybe<Array<HandOffPortalOrderStatus>>;
  subcontracted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetPatientWillPayOopArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryGetProviderAccountsArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryGetSalesRepArgs = {
  hospitalId: Scalars['Int']['input'];
};


export type QueryGetUserTasksArgs = {
  view: WorklistView;
};


export type QueryHandOffOrderSegmentArgs = {
  handOffOrderSegmentId: Scalars['Int']['input'];
};


export type QueryHandOffOrderSegmentMessagesArgs = {
  handOffPortalOrderId: Scalars['Int']['input'];
};


export type QueryHandOffOrderSegmentTabsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryHandOffPartnerFeeScheduleArgs = {
  handOffPartnerId: Scalars['Int']['input'];
};


export type QueryHandOffPartnerFromUserIdArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryHandOffPartnerInsurersArgs = {
  handOffPartnerId: Scalars['Int']['input'];
};


export type QueryHandOffPartnerOperatingZipCodesArgs = {
  handOffPartnerId: Scalars['Int']['input'];
};


export type QueryHandOffPartnerProductCategoriesArgs = {
  handOffPartnerId: Scalars['Int']['input'];
};


export type QueryHandOffPortalOrderArgs = {
  handOffPortalOrderId?: InputMaybe<Scalars['Int']['input']>;
  handOffPortalOrderRef?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHandOffPortalOrdersArgs = {
  assignmentFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  handOffPartnerId?: InputMaybe<Scalars['Int']['input']>;
  handOffPartnerRef?: InputMaybe<Scalars['String']['input']>;
  handOffPortal?: InputMaybe<HandOffPortal>;
  insuranceFilters: Array<Scalars['String']['input']>;
  lastMessageFromVerseFilter?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderStatus: HandOffPortalOrderStatus;
  orderStatusFilters: Array<Scalars['String']['input']>;
  partnerStatusCfFilters?: InputMaybe<Array<CoordinatedFulfillmentStatus>>;
  patientStateFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  search: Scalars['String']['input'];
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortMethod?: InputMaybe<Scalars['String']['input']>;
  subcontracted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHcpcsDataArgs = {
  hcpcsCode?: Scalars['String']['input'];
  searchQuery?: Scalars['String']['input'];
};


export type QueryHospitalOrdersCountArgs = {
  hospitalId: Scalars['Int']['input'];
};


export type QueryHospitalProfileArgs = {
  hospitalId?: Scalars['Int']['input'];
  orderNumber?: Scalars['String']['input'];
};


export type QueryIcd10CodeSearchArgs = {
  codeInput: Scalars['String']['input'];
};


export type QueryIcd10DescriptionsByCodesArgs = {
  codes: Array<Scalars['String']['input']>;
};


export type QueryIcd10DescriptionsByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryIcd10DescriptionsSearchArgs = {
  hospitalId: Scalars['Int']['input'];
  query: Scalars['String']['input'];
};


export type QueryInviteUserBlockedReasonArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryIsPatientPortalPilotArgs = {
  orderNumbers: Array<Scalars['String']['input']>;
};


export type QueryIsScopeOfServiceLockedArgs = {
  accessToken: Scalars['String']['input'];
};


export type QueryIsUhcPayorArgs = {
  payorName: Scalars['String']['input'];
};


export type QueryIssueOrdersArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryLinkedDepartmentsForHcpcsArgs = {
  hcpcsCode: Scalars['String']['input'];
};


export type QueryLinkedFulfillmentOrderNumbersArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryLinkedFulfillmentOrdersArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryLookupFaxNumbersFromNpiArgs = {
  npi: Scalars['String']['input'];
};


export type QueryManagedAnalyticsUsersArgs = {
  includeDeleted?: Scalars['Boolean']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryManagedOpsUserArgs = {
  opsUserId: Scalars['Int']['input'];
};


export type QueryManagedOpsUsersArgs = {
  includeDeleted?: Scalars['Boolean']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryManagedSpreeUserArgs = {
  spreeUserId: Scalars['Int']['input'];
};


export type QueryManagedSpreeUsersArgs = {
  includeDeleted?: Scalars['Boolean']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMedicalNecessityInterviewArgs = {
  category: ProductCategory;
};


export type QueryMedicareAdvantagePotentialLiabilityNoticeStatusArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryMedicareProtocolsWarningMessagesArgs = {
  lineItems: Array<OrderSegmentLineItemInput>;
  originalLineItems: Array<WoundCareLineItemInput>;
  wounds: Array<WoundInput>;
};


export type QueryMercySubtotalArgs = {
  departmentOrderId: Scalars['Int']['input'];
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryMessageTemplatesArgs = {
  orderNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMissingProgressNoteOrdersArgs = {
  departmentId: Scalars['Int']['input'];
  orderPlacedByFilters?: Array<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  providerFilters?: Array<Scalars['String']['input']>;
  sortMethod?: OrderListSortMethod;
};


export type QueryMissingSignatureOrdersArgs = {
  departmentId: Scalars['Int']['input'];
  orderPlacedByFilters?: Array<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  providerFilters?: Array<Scalars['String']['input']>;
  sortMethod?: OrderListSortMethod;
};


export type QueryNextDraftOrderNumberArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryNppesNpiValidationArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryOopCostPreviewArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryOopCostsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryOopWorkflowStatusArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryOpenChargesForPatientArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryOpsTaskByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOpsTaskHistoryArgs = {
  taskId: Scalars['Int']['input'];
};


export type QueryOpsTasksArgs = {
  opsTaskListInput: OpsTaskListInput;
};


export type QueryOpsTasksForOrderArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryOpsUserArgs = {
  authProviderUserId: Scalars['String']['input'];
};


export type QueryOrderAssemblyDashboardArgs = {
  filter?: InputMaybe<OrderAssemblyDashboardFilter>;
};


export type QueryOrderCancellationTypeArgs = {
  orderCancellationTypeId: Scalars['Int']['input'];
};


export type QueryOrderDagStateSummaryArgs = {
  departmentOrderId?: InputMaybe<Scalars['Int']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderDocumentationStatusesArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryOrderDocumentsArgs = {
  orderNumber: Scalars['String']['input'];
  tabType?: TabType;
};


export type QueryOrderListArgs = {
  departmentId: Scalars['Int']['input'];
  orderPlacedByFilters: Array<Scalars['String']['input']>;
  orderStatusFilters: Array<Scalars['String']['input']>;
  pageNumber: Scalars['Int']['input'];
  providerFilters: Array<Scalars['String']['input']>;
  remarkFilters: Array<Scalars['String']['input']>;
  searchQuery: Scalars['String']['input'];
  sortMethod: Scalars['String']['input'];
};


export type QueryOrderProgressNotesArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryOrderSegmentFrequencyViolationsArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryOrderSegmentLineItemsArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryOrderSegmentPreCheckArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryOrderSegmentsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryOrderSegmentsWithCreationArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryOrderSynapseHoldStatusArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryOrderSynapseSegmentStatusesArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryOrderWorkflowDagArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryOrdersForPaymentLinkArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryOrdersSynapseDocumentationHoldsArgs = {
  orderNumbers: Array<Scalars['String']['input']>;
};


export type QueryOtherAvailableChecksForSegmentArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryOutboundFaxesForOrderArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryPartnerOrderPlacerNamesArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryPatientChargeQuotesArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryPatientChargeSegmentContextArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryPatientChargesArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryPatientDataArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryPatientDataByIdArgs = {
  patientId: Scalars['Int']['input'];
};


export type QueryPatientMailingAddressArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryPatientOrderHistoryArgs = {
  daysAfterCutoff?: Scalars['Int']['input'];
  daysCutoff?: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
};


export type QueryPatientOrdersArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryPatientOrdersSearchArgs = {
  hospitalName: Scalars['String']['input'];
  patientName: Scalars['String']['input'];
};


export type QueryPatientPortalAddressArgs = {
  patientId: Scalars['Int']['input'];
};


export type QueryPatientPortalBalancesArgs = {
  patientId: Scalars['Int']['input'];
};


export type QueryPatientPortalHomeViewArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  patientId: Scalars['Int']['input'];
};


export type QueryPatientPortalOrderDetailArgs = {
  orderNumber: Scalars['String']['input'];
  patientId: Scalars['Int']['input'];
};


export type QueryPatientPortalOrderPageArgs = {
  beforeId?: InputMaybe<Scalars['Int']['input']>;
  departmentId: Scalars['Int']['input'];
  patientId: Scalars['Int']['input'];
};


export type QueryPatientPortalPatientSearchArgs = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPatientPortalPaymentLinkArgs = {
  orderSegmentId: Scalars['Int']['input'];
  patientId: Scalars['Int']['input'];
};


export type QueryPatientPortalRefillAddressArgs = {
  orderSegmentId: Scalars['Int']['input'];
  patientId: Scalars['Int']['input'];
};


export type QueryPatientPortalRefillSheetArgs = {
  orderNumber: Scalars['String']['input'];
  patientId: Scalars['Int']['input'];
};


export type QueryPayorApiCodesArgs = {
  query: Scalars['String']['input'];
  source?: InputMaybe<PayorApiCodeSource>;
};


export type QueryPayorConfigArgs = {
  configId: Scalars['Int']['input'];
};


export type QueryPayorConfigsArgs = {
  filters?: InputMaybe<PayorConfigFilterInput>;
};


export type QueryPayorMemberOrderShipmentsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryPayorMemberOrdersArgs = {
  memberKey: Scalars['Int']['input'];
  providerFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  sortMethod?: OrderListSortMethod;
  statusFilters?: InputMaybe<Array<ProviderReferralStatus>>;
};


export type QueryPayorMembersArgs = {
  page: Scalars['Int']['input'];
  search: Scalars['String']['input'];
};


export type QueryPayorToBillArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryPayorToBillForOrderNumberArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryPmnHcpcsAccessoriesArgs = {
  payorId: Scalars['Int']['input'];
};


export type QueryPmnHcpcsCodesArgs = {
  payorId: Scalars['Int']['input'];
};


export type QueryPnSwoMatchingIssuesArgs = {
  billerReviewIds: Array<Scalars['Int']['input']>;
};


export type QueryPotentialLiabilityAcknowledgementArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryPresignedS3UrlsArgs = {
  keys: Array<Scalars['String']['input']>;
};


export type QueryPreviewDocumentCollectionProviderContactForDepartmentArgs = {
  departmentId: Scalars['Int']['input'];
  documentCollectionOrderId: Scalars['Int']['input'];
  field: ProviderContactField;
  value: Scalars['String']['input'];
};


export type QueryPreviewOnHoldClaimsRuleArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  outputCap?: InputMaybe<Scalars['Int']['input']>;
  ruleTree?: InputMaybe<Scalars['JSON']['input']>;
  rulesetId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPriorAuthorizationNumbersArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryProductEligibilityReportArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryProductSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryProgressNotesForLatestHl7AdtVisitArgs = {
  patientId: Scalars['Int']['input'];
};


export type QueryProofOfDeliveryDocumentsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryProviderReferralArgs = {
  formDepartmentId?: InputMaybe<Scalars['Int']['input']>;
  isAutofill?: Scalars['Boolean']['input'];
  isRefillOrder?: Scalars['Boolean']['input'];
  isReorder?: Scalars['Boolean']['input'];
  orderNumber: Scalars['String']['input'];
  selectedLineItemCategories?: InputMaybe<Array<ProductCategory>>;
};


export type QueryProviderRiskStatusArgs = {
  npi: Scalars['String']['input'];
};


export type QueryProviderSignerArgs = {
  accessToken: Scalars['String']['input'];
  email: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
};


export type QueryProviderSignersArgs = {
  departmentId: Scalars['Int']['input'];
};


export type QueryProviderSignersByHospitalArgs = {
  hospitalId: Scalars['Int']['input'];
};


export type QueryPverifyEligiblePayorsArgs = {
  query: Scalars['String']['input'];
};


export type QueryQuotesForSegmentArgs = {
  chargeType: ChargeType;
  orderSegmentId: Scalars['Int']['input'];
};


export type QueryRcmEventsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryReadAddressAutocompleteArgs = {
  address: AddressAutoCompleteInput;
};


export type QueryReadAutomaticRoutedOrderArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryReadCareBridgeCsvExportArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryReadDrainageLevelWarningsArgs = {
  billerReviewHeading: Scalars['Boolean']['input'];
  isMedicareBlockingEligible: Scalars['Boolean']['input'];
  woundCareLineItemInput: Array<WoundCareLineItemInput>;
  wounds: Array<WoundInput>;
};


export type QueryReadManufacturerOrdersArgs = {
  geographicStates?: Array<Scalars['String']['input']>;
  hospital?: Scalars['String']['input'];
  orderBy?: Scalars['String']['input'];
  orderDir?: Scalars['String']['input'];
  pageNumber?: Scalars['Int']['input'];
  signer?: Scalars['String']['input'];
  zipCode?: Scalars['String']['input'];
};


export type QueryReadOrderInsuranceTypeFromOrderNumberArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryReadPatientNamesArgs = {
  dateOfBirthQuery?: InputMaybe<Scalars['String']['input']>;
  departmentId: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  requireMostRecentOrderNumber?: Scalars['Boolean']['input'];
};


export type QueryReadWoundSubcategoryFormItemsArgs = {
  subcategory: Scalars['String']['input'];
};


export type QueryRefillEstimatesArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryRefillSmsConsentArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryRelatedClinicalReviewsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryReportedOrderIssuesArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryRetrievalByIdArgs = {
  retrievalId: Scalars['Int']['input'];
};


export type QueryRetrievalEventsArgs = {
  retrievalId: Scalars['Int']['input'];
};


export type QueryRetrievalStageActionsArgs = {
  retrievalId: Scalars['Int']['input'];
};


export type QueryRetrievalsArgs = {
  retrievalListInput: CareCoordinationRetrievalListInput;
};


export type QueryRetrievalsByGroupKeyArgs = {
  groupKey: Scalars['String']['input'];
  stageSlugs?: InputMaybe<Array<CareCoordinationRetrievalStageSlug>>;
};


export type QueryRetrievalsByOrderNumberArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryRetrievalsStageActionsArgs = {
  retrievalIds: Array<Scalars['Int']['input']>;
};


export type QueryReviewUnsignedOrdersArgs = {
  isHomeHealth?: Scalars['Boolean']['input'];
};


export type QueryRoutedHandoffBlocklistArgs = {
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySameDayShippingStatusArgs = {
  clinicTimezone: Scalars['String']['input'];
};


export type QueryScopeOfServiceDocumentArgs = {
  accessToken: Scalars['String']['input'];
  patientDob: Scalars['String']['input'];
};


export type QuerySearchDistributorProductsArgs = {
  distributorId: Scalars['Int']['input'];
  searchQuery: Scalars['String']['input'];
};


export type QuerySearchOpsUsersArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchReferringFacilityDepartmentsArgs = {
  handOffPartnerId: Scalars['Int']['input'];
  searchText: Scalars['String']['input'];
};


export type QuerySegmentErrorsArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QuerySignerInformationArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QuerySubcontractOrderLineItemsArgs = {
  handOffOrderSegmentId: Scalars['Int']['input'];
};


export type QuerySubcontractablePartnersArgs = {
  orderSegmentId: Scalars['Int']['input'];
};


export type QuerySynapseOrderLookupArgs = {
  synapseId: Scalars['String']['input'];
};


export type QueryTeamDashboardArgs = {
  team?: InputMaybe<Scalars['String']['input']>;
  teamLeadOpsUserId?: InputMaybe<Scalars['Int']['input']>;
  worklist?: InputMaybe<WorklistTeam>;
};


export type QueryTeamMemberTasksArgs = {
  opsUserId?: InputMaybe<Scalars['Int']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  teamLeadOpsUserId?: InputMaybe<Scalars['Int']['input']>;
  view: WorklistView;
  worklist?: InputMaybe<WorklistTeam>;
};


export type QueryTemplateKeyOptionsArgs = {
  orderNumber: Scalars['String']['input'];
  templateId: Scalars['Int']['input'];
};


export type QueryTimelineOrderEventsArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryTimelineOrderEventsInternalArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryUsStatesArgs = {
  search?: Scalars['String']['input'];
};


export type QueryUserAuthInfoArgs = {
  username: Scalars['String']['input'];
};


export type QueryValidateEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryValidateNpiArgs = {
  checkDepartmentIdForDuplicate?: InputMaybe<Scalars['Int']['input']>;
  existingSignerId?: InputMaybe<Scalars['Int']['input']>;
  npi: Scalars['String']['input'];
  providerName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateOxygenFormArgs = {
  diagnoses: Array<DiagnosisInput>;
  planOfCare: PlanOfCareInput;
};


export type QueryValidatePhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryValidationWarningMessagesForAllLineItemsArgs = {
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  insuranceType?: InputMaybe<Scalars['String']['input']>;
  isMedicareBlockingEligible: Scalars['Boolean']['input'];
  payor?: InputMaybe<Scalars['String']['input']>;
  stateName?: InputMaybe<Scalars['String']['input']>;
  woundProductRow: Array<WoundCareLineItemInput>;
  wounds: Array<WoundInput>;
};


export type QueryVerifyProgressNoteArgs = {
  fileName: Scalars['String']['input'];
  s3DocumentId: Scalars['Int']['input'];
};


export type QueryVerseOsOrderInfoArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryVerseOsOrderSearchArgs = {
  searchInput: VerseOsOrderSearchInput;
};


export type QueryVerseOsSingleOrderInfoArgs = {
  orderNumber: Scalars['String']['input'];
};


export type QueryWorklistCoverageArgs = {
  worklist?: InputMaybe<WorklistTeam>;
};


export type QueryWorklistCoverageSchedulesArgs = {
  worklist: WorklistTeam;
};


export type QueryWorklistPeersArgs = {
  team?: InputMaybe<Scalars['String']['input']>;
  worklist?: InputMaybe<WorklistTeam>;
};


export type QueryWorklistQueueCountsArgs = {
  team?: InputMaybe<Scalars['String']['input']>;
  worklist?: InputMaybe<WorklistTeam>;
};


export type QueryWorklistTabCountsArgs = {
  opsUserId?: InputMaybe<Scalars['Int']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  teamLeadOpsUserId?: InputMaybe<Scalars['Int']['input']>;
  worklist?: InputMaybe<WorklistTeam>;
};


export type QueryWoundMatchingArgs = {
  orderNumber: Scalars['String']['input'];
};

export type RcmEvent = {
  __typename?: 'RcmEvent';
  createdAt: Scalars['DateTime']['output'];
  distributorOrderId?: Maybe<Scalars['Int']['output']>;
  eventType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  orderNumber: Scalars['String']['output'];
  orderSegmentId: Scalars['Int']['output'];
  rcmTaskId?: Maybe<Scalars['Int']['output']>;
};

export enum RcmScannedFaxClassification {
  Audit = 'AUDIT',
  MedicalRecordRequest = 'MEDICAL_RECORD_REQUEST'
}

export type RecordCheckPaymentInput = {
  allocatedAmount: Scalars['Float']['input'];
  chargeAmount: Scalars['Float']['input'];
  chargeId?: InputMaybe<Scalars['Int']['input']>;
  chargeType: ChargeType;
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  existingCheckPaymentId?: InputMaybe<Scalars['Int']['input']>;
  nameOnCheck?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderSegmentId: Scalars['String']['input'];
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentDate?: InputMaybe<Scalars['Date']['input']>;
};

export type RefillByLocation = {
  __typename?: 'RefillByLocation';
  hospitalId: Scalars['Int']['output'];
  hospitalName: Scalars['String']['output'];
  newOrders: Scalars['Int']['output'];
  refillOrders: Scalars['Int']['output'];
};

export type RefillSeriesEstimate = {
  __typename?: 'RefillSeriesEstimate';
  itemNames: Array<Scalars['String']['output']>;
  refillSeriesId: Scalars['Int']['output'];
  refills: Array<EstimatedRefill>;
  status: Scalars['String']['output'];
  supplyDays: Scalars['Int']['output'];
};

export type RefillSlice = {
  __typename?: 'RefillSlice';
  orderCount: Scalars['Int']['output'];
  orderType: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export type RefillSmsConsent = {
  __typename?: 'RefillSmsConsent';
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  state: RefillSmsConsentState;
};

export enum RefillSmsConsentState {
  NotRevoked = 'NOT_REVOKED',
  Revoked = 'REVOKED'
}

export type RegenerateRefillsResult = {
  __typename?: 'RegenerateRefillsResult';
  message: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  refillSegmentCount: Scalars['Int']['output'];
};

export enum ReimbursementType {
  PerFluidOunce = 'PER_FLUID_OUNCE',
  PerGram = 'PER_GRAM',
  PerInch = 'PER_INCH',
  PerLinearYard = 'PER_LINEAR_YARD',
  PerMilliliter = 'PER_MILLILITER',
  PerOunce = 'PER_OUNCE',
  PerSquareInch = 'PER_SQUARE_INCH',
  PerUnit = 'PER_UNIT',
  PerYard = 'PER_YARD'
}

export type RelatedClinicalReview = {
  __typename?: 'RelatedClinicalReview';
  assigneeId?: Maybe<Scalars['Int']['output']>;
  assigneeName?: Maybe<Scalars['String']['output']>;
  blockers: Array<TaskType>;
  inheritedFrom: Scalars['Boolean']['output'];
  openedAt: Scalars['DateTime']['output'];
  orderNumber: Scalars['String']['output'];
  response?: Maybe<BillerReviewResponseType>;
  status: Scalars['String']['output'];
};

export enum RemittanceChannelEnum {
  Era = 'ERA',
  Paper = 'PAPER',
  Portal = 'PORTAL',
  VirtualCard = 'VIRTUAL_CARD'
}

export type RemoveProductDiagnosisCodeInput = {
  diagnosisId: Scalars['Int']['input'];
};

export type RenameCompressionColorInput = {
  colorId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type RenderedBillerReviewNote = {
  __typename?: 'RenderedBillerReviewNote';
  message: Scalars['String']['output'];
  templateId: Scalars['Int']['output'];
};

export type ReportedOrderIssue = {
  __typename?: 'ReportedOrderIssue';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orderNumber: Scalars['String']['output'];
  reportedBy: OpsUser;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedBy?: Maybe<OpsUser>;
  status: Scalars['String']['output'];
  type: ReportedOrderIssueType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReportedOrderIssueInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderNumber: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportedOrderIssueType = {
  __typename?: 'ReportedOrderIssueType';
  category: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ResetReason = {
  __typename?: 'ResetReason';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ResolveOrderNoteResponse = {
  __typename?: 'ResolveOrderNoteResponse';
  departmentOrderRemarks: Array<DepartmentOrderRemarkType>;
  orderStatus?: Maybe<ProviderReferralStatus>;
};

export type RestoreOrderDocumentInput = {
  orderDocumentId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
};

export type RestoreOrderFaxInput = {
  orderFaxId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
};

export type ReturnTracking = {
  __typename?: 'ReturnTracking';
  dateRequested: Scalars['DateTime']['output'];
  details: Scalars['String']['output'];
  distributorOrderId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  productIds: Array<Scalars['Int']['output']>;
  returnType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updateSentMethod?: Maybe<Scalars['String']['output']>;
};

export type ReturnTrackingInput = {
  dateRequested: Scalars['DateTime']['input'];
  details: Scalars['String']['input'];
  distributorOrderId: Scalars['Int']['input'];
  productIds: Array<Scalars['Int']['input']>;
  returnType: Scalars['String']['input'];
  status: Scalars['String']['input'];
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  updateSentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type RoutedHandoffBlocklistEntry = {
  __typename?: 'RoutedHandoffBlocklistEntry';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  partnerId: Scalars['Int']['output'];
  planName: Scalars['String']['output'];
  stateAbbr: Scalars['String']['output'];
};

export enum RuleOperator {
  Contains = 'CONTAINS',
  DoesNotContain = 'DOES_NOT_CONTAIN',
  DoesNotEndWith = 'DOES_NOT_END_WITH',
  DoesNotInclude = 'DOES_NOT_INCLUDE',
  DoesNotStartWith = 'DOES_NOT_START_WITH',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  Includes = 'INCLUDES',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotEquals = 'NOT_EQUALS',
  StartsWith = 'STARTS_WITH'
}

export type S3Document = {
  __typename?: 'S3Document';
  bucket?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  opsUserId?: Maybe<Scalars['Int']['output']>;
  opsUserName?: Maybe<Scalars['String']['output']>;
  orderDocumentId: Scalars['Int']['output'];
  orderSegmentId?: Maybe<Scalars['Int']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
  receivedAt: Scalars['String']['output'];
};

export type S3DocumentInfo = {
  __typename?: 'S3DocumentInfo';
  id: Scalars['Int']['output'];
  metricsId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type S3DocumentReference = {
  documentType: Array<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  metricsId?: InputMaybe<Scalars['Int']['input']>;
  s3DocumentId: Scalars['Int']['input'];
};

export type SalesRepMessageInput = {
  customerAccountId?: InputMaybe<Scalars['Int']['input']>;
  hospitalId: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  method: Scalars['String']['input'];
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  salesRepId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type SalesReps = {
  __typename?: 'SalesReps';
  /** @deprecated CSA connection to accounts removed */
  customerAccount?: Maybe<OpsUser>;
  salesRep?: Maybe<OpsUser>;
};

export type SameDayShippingStatus = {
  __typename?: 'SameDayShippingStatus';
  available: Scalars['Boolean']['output'];
  cutoffLocalTime: Scalars['String']['output'];
  timezoneLabel: Scalars['String']['output'];
};

export type SavingsByHospital = {
  __typename?: 'SavingsByHospital';
  estimatedSavings: Scalars['Int']['output'];
  hospitalId: Scalars['Int']['output'];
  hospitalName: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
};

export type SavingsKpis = {
  __typename?: 'SavingsKpis';
  avgPerLocation: Scalars['Float']['output'];
  orderCount: Scalars['Int']['output'];
  topLocation?: Maybe<Scalars['String']['output']>;
  totalSavings: Scalars['Int']['output'];
};

export enum ScooterSeatSize {
  Eighteen = 'EIGHTEEN',
  Sixteen = 'SIXTEEN',
  Twenty = 'TWENTY',
  TwentyFour = 'TWENTY_FOUR',
  TwentySix = 'TWENTY_SIX',
  TwentyTwo = 'TWENTY_TWO'
}

export enum ScooterSteeringHandle {
  DeltaTiller = 'DELTA_TILLER',
  THandle = 'T_HANDLE'
}

export enum ScooterWheels {
  Four = 'FOUR',
  Three = 'THREE'
}

export type ScopeOfServiceDocument = {
  __typename?: 'ScopeOfServiceDocument';
  isLocked: Scalars['Boolean']['output'];
  isSigned: Scalars['Boolean']['output'];
};

export enum SearchOrderState {
  Approved = 'APPROVED',
  BillerReview = 'BILLER_REVIEW',
  Canceled = 'CANCELED',
  EligibilityChecked = 'ELIGIBILITY_CHECKED',
  Handoff = 'HANDOFF',
  IssueWorklist = 'ISSUE_WORKLIST',
  New = 'NEW',
  OnHold = 'ON_HOLD',
  OnShorePayor = 'ON_SHORE_PAYOR',
  Ordered = 'ORDERED',
  Pending = 'PENDING',
  PotentialHandoff = 'POTENTIAL_HANDOFF',
  Prepped = 'PREPPED',
  Unsigned = 'UNSIGNED'
}

export enum SearchSortOrder {
  NewestFirst = 'NEWEST_FIRST',
  OldestFirst = 'OLDEST_FIRST',
  OldestFirstLocal = 'OLDEST_FIRST_LOCAL',
  WorkingQueue = 'WORKING_QUEUE'
}

export type SegmentAddedPrepError = {
  __typename?: 'SegmentAddedPrepError';
  annotation?: Maybe<SegmentPrepErrorAnnotation>;
  approvedValue?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['Int']['output'];
  errorType: SegmentPrepErrorType;
  preppedValue?: Maybe<Scalars['String']['output']>;
  segmentTypeId?: Maybe<Scalars['Int']['output']>;
  tableName: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type SegmentPrepErrorAnnotation = {
  __typename?: 'SegmentPrepErrorAnnotation';
  annotation: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  entityId: Scalars['Int']['output'];
  errorType: SegmentPrepErrorType;
  fieldName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isError: Scalars['Boolean']['output'];
  orderNumber: Scalars['String']['output'];
  reasons: Array<Scalars['String']['output']>;
  tableName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SegmentPrepErrorAnnotationInput = {
  annotation: Scalars['String']['input'];
  entityId: Scalars['Int']['input'];
  errorType: SegmentPrepErrorType;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isError?: Scalars['Boolean']['input'];
  orderNumber: Scalars['String']['input'];
  reasons: Array<Scalars['String']['input']>;
  tableName: Scalars['String']['input'];
  updatedBy: Scalars['Int']['input'];
};

export enum SegmentPrepErrorType {
  LineItemAdded = 'LINE_ITEM_ADDED',
  LineItemRemoved = 'LINE_ITEM_REMOVED',
  LineItemUpdated = 'LINE_ITEM_UPDATED',
  SegmentAdded = 'SEGMENT_ADDED',
  SegmentRemoved = 'SEGMENT_REMOVED',
  ShippingModeChanged = 'SHIPPING_MODE_CHANGED'
}

export type SegmentRemovedPrepError = {
  __typename?: 'SegmentRemovedPrepError';
  annotation?: Maybe<SegmentPrepErrorAnnotation>;
  approvedValue?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['Int']['output'];
  errorType: SegmentPrepErrorType;
  preppedValue?: Maybe<Scalars['String']['output']>;
  segmentTypeId?: Maybe<Scalars['Int']['output']>;
  tableName: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type SendHandOffOrderSegmentInput = {
  communicateToPatientAndClinic: Scalars['Boolean']['input'];
  customNotes?: InputMaybe<Scalars['String']['input']>;
  handOffOrderSegmentId: Scalars['Int']['input'];
  hideBranding: Scalars['Boolean']['input'];
  includeProgressNoteSummary: Scalars['Boolean']['input'];
  orderSegmentSentBy: Scalars['Int']['input'];
  partnerId: Scalars['Int']['input'];
  portalOrderNote?: InputMaybe<Scalars['String']['input']>;
  sendToVersePayorPortal?: Scalars['Boolean']['input'];
  subcontracted: Scalars['Boolean']['input'];
};

export type SetDistributorMappingsInput = {
  distributorId: Scalars['Int']['input'];
  distributorProductIds: Array<Scalars['Int']['input']>;
  formItemSizeId: Scalars['Int']['input'];
};

export type SetDistributorUnavailabilityInput = {
  distributorId: Scalars['Int']['input'];
  formItemSizeId: Scalars['Int']['input'];
  isUnavailable: Scalars['Boolean']['input'];
};

export type SetRemittanceChannelInput = {
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  openPmPayorId: Scalars['Int']['input'];
  remittanceChannel: RemittanceChannelEnum;
};

export type SetVariantDistributorMappingsInput = {
  distributorId: Scalars['Int']['input'];
  distributorProductIds: Array<Scalars['Int']['input']>;
  modernFormItemVariantId: Scalars['Int']['input'];
};

export type ShellFormDiagnosis = {
  __typename?: 'ShellFormDiagnosis';
  diagnosis?: Maybe<Scalars['String']['output']>;
  icd10Code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ShellFormDiagnosisInput = {
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  icd10Code?: InputMaybe<Scalars['String']['input']>;
};

export type ShellFormLineItem = {
  __typename?: 'ShellFormLineItem';
  formItemId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  productCategory: ProductCategory;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  sizeOrSpecifications?: Maybe<Scalars['String']['output']>;
};

export type ShellFormLineItemInput = {
  formItemId?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  sizeOrSpecifications?: InputMaybe<Scalars['String']['input']>;
};

export type ShellFormOrder = {
  __typename?: 'ShellFormOrder';
  diagnoses: Array<ShellFormDiagnosis>;
  id: Scalars['ID']['output'];
  isLifetimeLengthOfNeed?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedInMonths?: Maybe<Scalars['Int']['output']>;
  lineItems: Array<ShellFormLineItem>;
  meetsMedicalNecessity: Scalars['Boolean']['output'];
  preferredDmeCompany?: Maybe<Scalars['String']['output']>;
  productCategory: ProductCategory;
};

export type ShellFormOrderInput = {
  diagnoses?: InputMaybe<Array<ShellFormDiagnosisInput>>;
  isLifetimeLengthOfNeed?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedInMonths?: InputMaybe<Scalars['Int']['input']>;
  lineItems?: InputMaybe<Array<ShellFormLineItemInput>>;
  meetsMedicalNecessity?: Scalars['Boolean']['input'];
  preferredDmeCompany?: InputMaybe<Scalars['String']['input']>;
  productCategory: ProductCategory;
};

export type ShippingAddress = {
  __typename?: 'ShippingAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  stateAbbr?: Maybe<Scalars['String']['output']>;
  stateId?: Maybe<Scalars['Int']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type ShippingAddressInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  stateName?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingModePrepError = {
  __typename?: 'ShippingModePrepError';
  annotation?: Maybe<SegmentPrepErrorAnnotation>;
  approvedValue?: Maybe<Scalars['String']['output']>;
  distributorId: Scalars['Int']['output'];
  entityId: Scalars['Int']['output'];
  errorType: SegmentPrepErrorType;
  preppedValue?: Maybe<Scalars['String']['output']>;
  tableName: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type SignerInfo = {
  __typename?: 'SignerInfo';
  missingSignatureInfo?: Maybe<MissingSignatureInfo>;
  npiNumber?: Maybe<Scalars['String']['output']>;
  practices: Array<Practice>;
  providerAccountEmail?: Maybe<Scalars['String']['output']>;
  providerAccountName?: Maybe<Scalars['String']['output']>;
  signatureTime?: Maybe<Scalars['DateTime']['output']>;
  signatureTimezone?: Maybe<Scalars['String']['output']>;
  signed?: Maybe<Scalars['Int']['output']>;
  signerDegree?: Maybe<Scalars['String']['output']>;
  signerEmails: Array<Scalars['String']['output']>;
  signerId?: Maybe<Scalars['Int']['output']>;
  signerName?: Maybe<Scalars['String']['output']>;
  transcriberEmail?: Maybe<Scalars['String']['output']>;
  transcriberName?: Maybe<Scalars['String']['output']>;
  transcriptionProcess?: Maybe<TranscriptionProcess>;
};

export type SignerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  npi?: InputMaybe<Scalars['String']['input']>;
  practices: Array<PracticeInput>;
  signerId?: InputMaybe<Scalars['Int']['input']>;
};

export type SizeRequestedItemInput = {
  coveredSize: Scalars['String']['input'];
  requestedItem: Scalars['String']['input'];
  requestedSize: Scalars['String']['input'];
};

export type SpreeOrder = {
  __typename?: 'SpreeOrder';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  departmentOrderId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  initiatedAt: Scalars['DateTime']['output'];
  number: Scalars['String']['output'];
  patientName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  progressNoteExtractionUsed: Scalars['Boolean']['output'];
  secondaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  shippingAddress: ShippingAddress;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type SpreeOrderInput = {
  datadogReplayTimestamp?: InputMaybe<Scalars['String']['input']>;
  datadogSessionId?: InputMaybe<Scalars['String']['input']>;
  isDraft?: Scalars['Boolean']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  progressNoteExtractionUsed?: Scalars['Boolean']['input'];
  secondaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<ShippingAddressInput>;
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type SpreeUser = {
  __typename?: 'SpreeUser';
  auth0MigrationEnabledAt?: Maybe<Scalars['DateTime']['output']>;
  authProvider?: Maybe<Scalars['String']['output']>;
  authProviderUserId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  handOffPartnerIds?: Maybe<Array<Scalars['Int']['output']>>;
  id: Scalars['Int']['output'];
  lockedAt?: Maybe<Scalars['String']['output']>;
  manufacturerIds?: Maybe<Array<Scalars['Int']['output']>>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
};

export type StandaloneIssueResponse = {
  __typename?: 'StandaloneIssueResponse';
  message: Scalars['String']['output'];
  response: StandaloneIssueResponseType;
};

export enum StandaloneIssueResponseType {
  InvalidToken = 'INVALID_TOKEN',
  NeedsConfirmation = 'NEEDS_CONFIRMATION',
  Retry = 'RETRY',
  Success = 'SUCCESS'
}

export type Subcategory = {
  __typename?: 'Subcategory';
  formItems: Array<ModernFormItem>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SubcontractOrderLineItem = {
  __typename?: 'SubcontractOrderLineItem';
  feeSchedule?: Maybe<HcpcFeeSchedule>;
  hcpcsCode: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  manufacturer: Scalars['String']['output'];
  manufacturerProductId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numPackages: Scalars['Int']['output'];
  packageAmount: Scalars['Int']['output'];
  packagePrice: Scalars['Float']['output'];
  ref?: Maybe<Scalars['String']['output']>;
  size: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type SubcontractOrderLineItemInput = {
  hcpcsCode: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  manufacturer: Scalars['String']['input'];
  manufacturerProductId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  numPackages: Scalars['Int']['input'];
  packageAmount: Scalars['Int']['input'];
  packagePrice: Scalars['Float']['input'];
  size: Scalars['String']['input'];
  totalAmount: Scalars['Float']['input'];
};

export type SubcontractOrderLineItems = {
  __typename?: 'SubcontractOrderLineItems';
  excluded: Array<SubcontractOrderLineItem>;
  included: Array<SubcontractOrderLineItem>;
};

export type SuggestedPayorMatch = {
  __typename?: 'SuggestedPayorMatch';
  codes: Array<PayorApiCode>;
};

export type SupportSurfaceCoverageCriteria = {
  __typename?: 'SupportSurfaceCoverageCriteria';
  doesThePatientHaveTheseConditions?: Maybe<Array<PlanOfCareCondition>>;
  icd10ForImmobile?: Maybe<Array<PlanOfCareCondition>>;
  icd10ForTheseConditions?: Maybe<Array<PlanOfCareCondition>>;
  values?: Maybe<Array<PlanOfCareCondition>>;
};

export type SupportSurfaceCoverageCriteriaInput = {
  doesThePatientHaveTheseConditions?: InputMaybe<Array<PlanOfCareConditionInput>>;
  icd10ForImmobile?: InputMaybe<Array<PlanOfCareConditionInput>>;
  icd10ForTheseConditions?: InputMaybe<Array<PlanOfCareConditionInput>>;
  values?: InputMaybe<Array<PlanOfCareConditionInput>>;
};

export enum SynapseDocumentationHold {
  AwaitingSignature = 'AWAITING_SIGNATURE',
  MissingProgressNote = 'MISSING_PROGRESS_NOTE',
  None = 'NONE'
}

export enum SynapseExitReason {
  AlternateInsurance = 'ALTERNATE_INSURANCE',
  NonSynapseCapitatedPlan = 'NON_SYNAPSE_CAPITATED_PLAN',
  OutOfScopeHcpcs = 'OUT_OF_SCOPE_HCPCS',
  Reshipment = 'RESHIPMENT'
}

export enum SynapseSegmentStatusEnum {
  AwaitingApproval = 'AWAITING_APPROVAL',
  AwaitingDelivery = 'AWAITING_DELIVERY',
  AwaitingDocumentation = 'AWAITING_DOCUMENTATION',
  AwaitingOrderPlacement = 'AWAITING_ORDER_PLACEMENT',
  AwaitingResponse = 'AWAITING_RESPONSE',
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  MissingConnectId = 'MISSING_CONNECT_ID',
  NotYetFiled = 'NOT_YET_FILED',
  RequiresFollowUp = 'REQUIRES_FOLLOW_UP',
  Unknown = 'UNKNOWN'
}

export enum TabType {
  Billing = 'BILLING',
  Dme = 'DME',
  Order = 'ORDER',
  Sms = 'SMS',
  Tasks = 'TASKS'
}

export type TaskOrderInfo = {
  __typename?: 'TaskOrderInfo';
  createdAt: Scalars['DateTime']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  orderNumber: Scalars['String']['output'];
  patientId?: Maybe<Scalars['Int']['output']>;
  patientName: Scalars['String']['output'];
  spreeOrderId: Scalars['Int']['output'];
};

export enum TaskType {
  Approval = 'APPROVAL',
  ClinicalReview = 'CLINICAL_REVIEW',
  CommsReview = 'COMMS_REVIEW',
  EligibilityIssue = 'ELIGIBILITY_ISSUE',
  ECheck = 'E_CHECK',
  GenericHold = 'GENERIC_HOLD',
  OopPayment = 'OOP_PAYMENT',
  OrderNoteResponse = 'ORDER_NOTE_RESPONSE',
  PatientResponsibility = 'PATIENT_RESPONSIBILITY',
  Placement = 'PLACEMENT',
  PmnReview = 'PMN_REVIEW',
  PotentialLiabilityAcknowledgement = 'POTENTIAL_LIABILITY_ACKNOWLEDGEMENT',
  PoBoxBlock = 'PO_BOX_BLOCK',
  Prep = 'PREP',
  Transcription = 'TRANSCRIPTION',
  VendorOrderValidationApproval = 'VENDOR_ORDER_VALIDATION_APPROVAL',
  WoundMatching = 'WOUND_MATCHING'
}

export enum Team {
  Dme = 'DME',
  Operations = 'OPERATIONS'
}

export type TeamDashboardResult = {
  __typename?: 'TeamDashboardResult';
  teamMembers: Array<TeamMemberStat>;
};

export type TeamMemberStat = {
  __typename?: 'TeamMemberStat';
  awaitingClinic: Scalars['Int']['output'];
  completedToday: Scalars['Int']['output'];
  currentlyAssigned: Scalars['Int']['output'];
  isOffline: Scalars['Boolean']['output'];
  lastSeen?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  offlineReason?: Maybe<Scalars['String']['output']>;
  openDocumentFollowups: Scalars['Int']['output'];
  openMessageFollowups: Scalars['Int']['output'];
  openNewOrderReviews: Scalars['Int']['output'];
  opsUserId: Scalars['Int']['output'];
  pinnedCount: Scalars['Int']['output'];
  pinnedTasks: Scalars['Int']['output'];
};

export type TelehealthOrder = {
  __typename?: 'TelehealthOrder';
  selectedItemNames: Array<Scalars['String']['output']>;
};

export type TelehealthOrderInput = {
  selectedItemNames: Array<Scalars['String']['input']>;
};

export type TemplateKeyOption = {
  __typename?: 'TemplateKeyOption';
  defaultAlias: Scalars['String']['output'];
  groupLabel: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isSelectable: Scalars['Boolean']['output'];
  keyId: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  orderSegmentId: Scalars['Int']['output'];
  segmentActivationDate?: Maybe<Scalars['DateTime']['output']>;
};

export enum TemplateKeySelectorType {
  Legacy = 'legacy',
  SegmentProduct = 'segment_product'
}

export type TimelineOrderEvent = {
  __typename?: 'TimelineOrderEvent';
  createdAt: Scalars['DateTime']['output'];
  eventType: TimelineOrderEventType;
  requestedByUserName?: Maybe<Scalars['String']['output']>;
};

export enum TimelineOrderEventType {
  AwaitingEligibility = 'AWAITING_ELIGIBILITY',
  DeliveryFailed = 'DELIVERY_FAILED',
  DeliveryFailedInitiatingReshipment = 'DELIVERY_FAILED_INITIATING_RESHIPMENT',
  ItemsCanceledAfterFailedDelivery = 'ITEMS_CANCELED_AFTER_FAILED_DELIVERY',
  MedicareAdvantagePotentialLiabilityNoticeDeclined = 'MEDICARE_ADVANTAGE_POTENTIAL_LIABILITY_NOTICE_DECLINED',
  OrderCanceled = 'ORDER_CANCELED',
  OrderDelivered = 'ORDER_DELIVERED',
  OrderNoteApproved = 'ORDER_NOTE_APPROVED',
  OrderNoteCreated = 'ORDER_NOTE_CREATED',
  OrderNoteRejected = 'ORDER_NOTE_REJECTED',
  OrderNoteReminder = 'ORDER_NOTE_REMINDER',
  OrderNoteReply = 'ORDER_NOTE_REPLY',
  OrderPartiallyDelivered = 'ORDER_PARTIALLY_DELIVERED',
  OrderShipped = 'ORDER_SHIPPED',
  OrderUncanceled = 'ORDER_UNCANCELED',
  OrderUpdateRequested = 'ORDER_UPDATE_REQUESTED',
  PartialDeliveryFailed = 'PARTIAL_DELIVERY_FAILED',
  PartialDeliveryFailedInitiatingReshipment = 'PARTIAL_DELIVERY_FAILED_INITIATING_RESHIPMENT',
  PatientAcceptsOop = 'PATIENT_ACCEPTS_OOP',
  PatientCheckInRequested = 'PATIENT_CHECK_IN_REQUESTED',
  PatientRejectsOop = 'PATIENT_REJECTS_OOP',
  PnSummaryRequestedViaFax = 'PN_SUMMARY_REQUESTED_VIA_FAX',
  ProgressNotesRequested = 'PROGRESS_NOTES_REQUESTED',
  ProviderOrderCreated = 'PROVIDER_ORDER_CREATED',
  ProviderOrderSigned = 'PROVIDER_ORDER_SIGNED',
  SignatureRequested = 'SIGNATURE_REQUESTED',
  SignatureRequestedViaEmail = 'SIGNATURE_REQUESTED_VIA_EMAIL',
  SignatureRequestedViaFax = 'SIGNATURE_REQUESTED_VIA_FAX'
}

export type ToggleProductSelectionForPreviewInput = {
  distributorOrderInvoiceProductId: Scalars['Int']['input'];
  selectedForPreview: Scalars['Boolean']['input'];
};

export type TopProductSummarySlice = {
  __typename?: 'TopProductSummarySlice';
  orderCount: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  productName: Scalars['String']['output'];
};

export type TopProductsKpis = {
  __typename?: 'TopProductsKpis';
  distinctProducts: Scalars['Int']['output'];
  topProduct?: Maybe<Scalars['String']['output']>;
  topProductPct: Scalars['Float']['output'];
  totalProductsOrdered: Scalars['Int']['output'];
};

export type TrackingNumber = {
  __typename?: 'TrackingNumber';
  carrier: Scalars['String']['output'];
  createdBy?: Maybe<OpsUser>;
  failedDelivery?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isReshipment?: Maybe<Scalars['Boolean']['output']>;
  markedForReshipment?: Maybe<Scalars['Boolean']['output']>;
  shipDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusDetail?: Maybe<Scalars['String']['output']>;
  statusDetailDate?: Maybe<Scalars['DateTime']['output']>;
  trackerId?: Maybe<Scalars['String']['output']>;
  trackingNumber: Scalars['String']['output'];
};

export type TrackingNumberInput = {
  carrier: Scalars['String']['input'];
  createdBy: Scalars['Int']['input'];
  distributorOrderId: Scalars['Int']['input'];
  isReshipment: Scalars['Boolean']['input'];
  orderNumber: Scalars['String']['input'];
  reshipmentForTrackingId?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber: Scalars['String']['input'];
};

export type TranscriptTurn = {
  __typename?: 'TranscriptTurn';
  createdAt: Scalars['Float']['output'];
  interrupted: Scalars['Boolean']['output'];
  role: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export enum TranscriptionProcess {
  Fax = 'FAX',
  IncompleteOrder = 'INCOMPLETE_ORDER',
  None = 'NONE'
}

export type UnassignedSlugCount = {
  __typename?: 'UnassignedSlugCount';
  count: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};

export type UnitedHealthcareAppeal = {
  __typename?: 'UnitedHealthcareAppeal';
  appealId: Scalars['String']['output'];
  outcomeDescription?: Maybe<Scalars['String']['output']>;
  statusDescription: Scalars['String']['output'];
};

export type UnitedHealthcareClaim = {
  __typename?: 'UnitedHealthcareClaim';
  appeals: Array<UnitedHealthcareAppeal>;
  claimNumber: Scalars['String']['output'];
  claimStatus: Scalars['String']['output'];
  documents: Array<UnitedHealthcareDocument>;
  lines: Array<UnitedHealthcareClaimDetailsLine>;
  processedDate: Scalars['String']['output'];
  reconsideration?: Maybe<UnitedHealthcareReconsideration>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type UnitedHealthcareClaimDetailsLine = {
  __typename?: 'UnitedHealthcareClaimDetailsLine';
  paidAmt: Scalars['Float']['output'];
  srvcCode: Scalars['String']['output'];
};

export type UnitedHealthcareDocument = {
  __typename?: 'UnitedHealthcareDocument';
  cloudSpaceId: Scalars['String']['output'];
  createdDt: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  fdsDocumentId: Scalars['String']['output'];
  repoId: Scalars['String']['output'];
};

export type UnitedHealthcareReconsideration = {
  __typename?: 'UnitedHealthcareReconsideration';
  ticketNumber: Scalars['String']['output'];
  ticketStatus: Scalars['String']['output'];
};

export type UnknownDepartment = {
  __typename?: 'UnknownDepartment';
  accountName?: Maybe<Scalars['String']['output']>;
  accountNumber: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  emergencyContactName?: Maybe<Scalars['String']['output']>;
  emergencyContactPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastSeenAt: Scalars['DateTime']['output'];
  orderingNurseEmail?: Maybe<Scalars['String']['output']>;
  orderingNursePhone?: Maybe<Scalars['String']['output']>;
  orderingUserFirstName?: Maybe<Scalars['String']['output']>;
  orderingUserLastName?: Maybe<Scalars['String']['output']>;
  partner: Scalars['String']['output'];
  requestCount: Scalars['Int']['output'];
};

export type UnmatchedFax = {
  __typename?: 'UnmatchedFax';
  assigneeId: Scalars['Int']['output'];
  deptFaxMatchedHospitals: Array<MatchedHospital>;
  documentId?: Maybe<Scalars['Int']['output']>;
  faxType: FaxType;
  filename: Scalars['String']['output'];
  filenameHash: Scalars['String']['output'];
  fromNumber: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  ingestionFailed: Scalars['Boolean']['output'];
  pageCount: Scalars['Int']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  priorityFax: Scalars['Boolean']['output'];
  receivedAt: Scalars['DateTime']['output'];
  remoteId?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
};

export type UpdateAnalyticsUserScopeInput = {
  hospitalIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hospitalSystemId?: InputMaybe<Scalars['Int']['input']>;
  spreeUserId: Scalars['Int']['input'];
};

export type UpdateDistributorProductFieldsInput = {
  costPrice?: InputMaybe<Scalars['Float']['input']>;
  distributorProductId: Scalars['Int']['input'];
  externalManufacturerProductId?: InputMaybe<Scalars['String']['input']>;
  externalProductId?: InputMaybe<Scalars['String']['input']>;
  hcpcsCode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isHazmat?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturerPartNumber?: InputMaybe<Scalars['String']['input']>;
  modernFormItemVariantId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numInSale?: InputMaybe<Scalars['Int']['input']>;
  packageAmount?: InputMaybe<Scalars['Int']['input']>;
  packageAmountString?: InputMaybe<Scalars['String']['input']>;
  salUnitMsr?: InputMaybe<Scalars['String']['input']>;
  undeliverableToPoBox?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFormItemFieldsInput = {
  canBeAutoPrepped?: InputMaybe<Scalars['Boolean']['input']>;
  clinicianQuantityRuleDescription?: InputMaybe<Scalars['String']['input']>;
  displayUnitLabel?: InputMaybe<Scalars['String']['input']>;
  dressingCategory?: InputMaybe<Scalars['String']['input']>;
  formItemId: Scalars['Int']['input'];
  isBordered?: InputMaybe<Scalars['Boolean']['input']>;
  isGeneric?: InputMaybe<Scalars['Boolean']['input']>;
  llmQuantityRuleDescription?: InputMaybe<Scalars['String']['input']>;
  llmSizeRuleDescription?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFormItemNameInput = {
  formItemId: Scalars['Int']['input'];
  newName: Scalars['String']['input'];
};

export type UpdateFormItemSizeInput = {
  formItemSizeId: Scalars['Int']['input'];
  newDisplay?: InputMaybe<Scalars['String']['input']>;
  newDisplayPad?: InputMaybe<Scalars['String']['input']>;
  newHcpcsCode?: InputMaybe<Scalars['String']['input']>;
  newPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOpsUserFullInput = {
  authProviderUserId?: InputMaybe<Scalars['String']['input']>;
  calendarPageUrl?: InputMaybe<Scalars['String']['input']>;
  canAccessVos?: InputMaybe<Scalars['Boolean']['input']>;
  canApproveOrderNotes?: InputMaybe<Scalars['Boolean']['input']>;
  canPlaceOrders?: InputMaybe<Scalars['Boolean']['input']>;
  customerSuccessTeam?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  formAutofill?: InputMaybe<Scalars['Boolean']['input']>;
  groupTag?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onShore?: InputMaybe<Scalars['Boolean']['input']>;
  opsUserId: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  salesRep?: InputMaybe<Scalars['Boolean']['input']>;
  slackId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOpsUserPositionHistoryInput = {
  effectiveFrom?: InputMaybe<Scalars['String']['input']>;
  effectiveTo?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  opsManagerId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<OpsTitle>;
};

export type UpdateProductDiagnosisCodeInput = {
  diagnosisId: Scalars['Int']['input'];
  newDiagnosisCode: Scalars['String']['input'];
};

export type UpdateSpreeUserInput = {
  auth0MigrationEnabledAt?: InputMaybe<Scalars['String']['input']>;
  authProvider?: InputMaybe<Scalars['String']['input']>;
  authProviderUserId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  handOffPartnerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  lockedAt?: InputMaybe<Scalars['String']['input']>;
  manufacturerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  spreeUserId: Scalars['Int']['input'];
};

export type UpdateWoundItemClassificationInput = {
  formItemId: Scalars['Int']['input'];
  traits: WoundItemTraitsInput;
  woundItemTypeId: Scalars['Int']['input'];
};

export type UploadHcpcsMaxFrequenciesResult = {
  __typename?: 'UploadHcpcsMaxFrequenciesResult';
  errors: Array<Scalars['String']['output']>;
  inserted: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type UploadHcpcsMaxQuantitiesResult = {
  __typename?: 'UploadHcpcsMaxQuantitiesResult';
  errors: Array<Scalars['String']['output']>;
  inserted: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type UpsertDistributorOrder = {
  __typename?: 'UpsertDistributorOrder';
  distributorOrder: DistributorOrder;
  updatedOrderSegmentStatus?: Maybe<VerseOsOrderSearchSegmentStatus>;
};

export type UpsertOpsOrderState = {
  __typename?: 'UpsertOpsOrderState';
  clinicFacingStatus?: Maybe<ProviderReferralStatus>;
  opsOrderStateType: OpsOrderStateType;
  orderNumber: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type UpsertOpsOrderStateInput = {
  clinicFacingStatus?: InputMaybe<ProviderReferralStatus>;
  opsOrderStateType: OpsOrderStateType;
  opsUserId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};

export type UrologyCheckboxAttributeInput = {
  balloon5ml?: InputMaybe<Scalars['Boolean']['input']>;
  balloon10ml?: InputMaybe<Scalars['Boolean']['input']>;
  balloon30ml?: InputMaybe<Scalars['Boolean']['input']>;
  cloth?: InputMaybe<Scalars['Boolean']['input']>;
  coude?: InputMaybe<Scalars['Boolean']['input']>;
  hydrophilic?: InputMaybe<Scalars['Boolean']['input']>;
  large4000ml?: InputMaybe<Scalars['Boolean']['input']>;
  latex?: InputMaybe<Scalars['Boolean']['input']>;
  oneInch?: InputMaybe<Scalars['Boolean']['input']>;
  packets?: InputMaybe<Scalars['Boolean']['input']>;
  paper?: InputMaybe<Scalars['Boolean']['input']>;
  pink?: InputMaybe<Scalars['Boolean']['input']>;
  pvc?: InputMaybe<Scalars['Boolean']['input']>;
  redRubber?: InputMaybe<Scalars['Boolean']['input']>;
  regular2000ml?: InputMaybe<Scalars['Boolean']['input']>;
  silicone?: InputMaybe<Scalars['Boolean']['input']>;
  straight?: InputMaybe<Scalars['Boolean']['input']>;
  threeWay?: InputMaybe<Scalars['Boolean']['input']>;
  tube?: InputMaybe<Scalars['Boolean']['input']>;
  twoInch?: InputMaybe<Scalars['Boolean']['input']>;
  twoWay?: InputMaybe<Scalars['Boolean']['input']>;
  withBag?: InputMaybe<Scalars['Boolean']['input']>;
  withoutBag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UrologyCheckboxAttributes = {
  __typename?: 'UrologyCheckboxAttributes';
  balloon5ml?: Maybe<Scalars['Boolean']['output']>;
  balloon10ml?: Maybe<Scalars['Boolean']['output']>;
  balloon30ml?: Maybe<Scalars['Boolean']['output']>;
  cloth?: Maybe<Scalars['Boolean']['output']>;
  coude?: Maybe<Scalars['Boolean']['output']>;
  hydrophilic?: Maybe<Scalars['Boolean']['output']>;
  large4000ml?: Maybe<Scalars['Boolean']['output']>;
  latex?: Maybe<Scalars['Boolean']['output']>;
  oneInch?: Maybe<Scalars['Boolean']['output']>;
  packets?: Maybe<Scalars['Boolean']['output']>;
  paper?: Maybe<Scalars['Boolean']['output']>;
  pink?: Maybe<Scalars['Boolean']['output']>;
  pvc?: Maybe<Scalars['Boolean']['output']>;
  redRubber?: Maybe<Scalars['Boolean']['output']>;
  regular2000ml?: Maybe<Scalars['Boolean']['output']>;
  silicone?: Maybe<Scalars['Boolean']['output']>;
  straight?: Maybe<Scalars['Boolean']['output']>;
  threeWay?: Maybe<Scalars['Boolean']['output']>;
  tube?: Maybe<Scalars['Boolean']['output']>;
  twoInch?: Maybe<Scalars['Boolean']['output']>;
  twoWay?: Maybe<Scalars['Boolean']['output']>;
  withBag?: Maybe<Scalars['Boolean']['output']>;
  withoutBag?: Maybe<Scalars['Boolean']['output']>;
};

export type UrologyLineItem = {
  __typename?: 'UrologyLineItem';
  brandPreference?: Maybe<Scalars['String']['output']>;
  checkboxAttributes: UrologyCheckboxAttributes;
  createdAt: Scalars['DateTime']['output'];
  formItemId?: Maybe<Scalars['Int']['output']>;
  frenchSizeLength?: Maybe<Scalars['String']['output']>;
  frequencyOfUse?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  qtyMo?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type UrologyLineItemInput = {
  brandPreference?: InputMaybe<Scalars['String']['input']>;
  checkboxAttributes: UrologyCheckboxAttributeInput;
  formItemId?: InputMaybe<Scalars['Int']['input']>;
  frenchSizeLength?: InputMaybe<Scalars['String']['input']>;
  frequencyOfUse?: InputMaybe<Scalars['String']['input']>;
  productName: Scalars['String']['input'];
  qtyMo?: InputMaybe<Scalars['String']['input']>;
};

export type UrologyOrder = {
  __typename?: 'UrologyOrder';
  createdAt: Scalars['DateTime']['output'];
  ensuresisF980?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  latexAllergy?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedLifetime?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedOther?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedOtherMonths?: Maybe<Scalars['Int']['output']>;
  nephrostomyZ436?: Maybe<Scalars['Boolean']['output']>;
  neuromuscularN319?: Maybe<Scalars['Boolean']['output']>;
  primaryCasualDiagnosis?: Maybe<Scalars['String']['output']>;
  retentionR339?: Maybe<Scalars['Boolean']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  urologyLineItems: Array<UrologyLineItem>;
  utiHistory?: Maybe<Scalars['Boolean']['output']>;
};

export type UrologyOrderInput = {
  ensuresisF980?: InputMaybe<Scalars['Boolean']['input']>;
  latexAllergy?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedLifetime?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedOther?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedOtherMonths?: InputMaybe<Scalars['Int']['input']>;
  nephrostomyZ436?: InputMaybe<Scalars['Boolean']['input']>;
  neuromuscularN319?: InputMaybe<Scalars['Boolean']['input']>;
  primaryCasualDiagnosis?: InputMaybe<Scalars['String']['input']>;
  retentionR339?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  urologyLineItems: Array<UrologyLineItemInput>;
  utiHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UsState = {
  __typename?: 'UsState';
  abbr: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UserAuthInfo = {
  __typename?: 'UserAuthInfo';
  authProvider: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type UserInfo = {
  __typename?: 'UserInfo';
  authProvider: Scalars['String']['output'];
  canViewPayorMembers: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  permissions: Array<Permission>;
  role: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
  userDepartments: Array<Department>;
  userSettings: UserSettings;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  createdEmailNotificationsEnabled: Scalars['Boolean']['output'];
  deliveredEmailNotificationsEnabled: Scalars['Boolean']['output'];
  emailNotificationsEnabled: Scalars['Boolean']['output'];
  emailOnlyUserCreatedOrders?: Maybe<Scalars['Boolean']['output']>;
  inTransitEmailNotificationsEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type UserSettingsInput = {
  createdEmailNotificationsEnabled: Scalars['Boolean']['input'];
  deliveredEmailNotificationsEnabled: Scalars['Boolean']['input'];
  emailNotificationsEnabled: Scalars['Boolean']['input'];
  emailOnlyUserCreatedOrders?: InputMaybe<Scalars['Boolean']['input']>;
  inTransitEmailNotificationsEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum ValidateNpiReasonCode {
  DuplicateNpi = 'DUPLICATE_NPI',
  InactiveNpi = 'INACTIVE_NPI',
  MalformedNpi = 'MALFORMED_NPI',
  NameMismatch = 'NAME_MISMATCH',
  NotFound = 'NOT_FOUND',
  ProviderType = 'PROVIDER_TYPE',
  ScopeOfPractice = 'SCOPE_OF_PRACTICE',
  Unknown = 'UNKNOWN'
}

export type ValidateNpiResponse = {
  __typename?: 'ValidateNpiResponse';
  credential?: Maybe<Scalars['String']['output']>;
  isHeld: Scalars['Boolean']['output'];
  providerNames: Array<Scalars['String']['output']>;
  reasonCode?: Maybe<ValidateNpiReasonCode>;
  status: ValidationStatus;
  taxonomyDescriptions: Array<Scalars['String']['output']>;
};

export enum ValidationStatus {
  Duplicate = 'DUPLICATE',
  Invalid = 'INVALID',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  Valid = 'VALID'
}

export type VariableHeightBedConditions = {
  __typename?: 'VariableHeightBedConditions';
  functionalAndSupportNeeds?: Maybe<Array<PlanOfCareCondition>>;
  injuriesToLowerExtremity?: Maybe<Array<PlanOfCareCondition>>;
  limbAmputations?: Maybe<Array<PlanOfCareCondition>>;
  other?: Maybe<Array<PlanOfCareCondition>>;
  severeArthritis?: Maybe<Array<PlanOfCareCondition>>;
  severeCardiacConditions?: Maybe<Array<PlanOfCareCondition>>;
  spinalCordInjuryOrNeurologicalImpairment?: Maybe<Array<PlanOfCareCondition>>;
};

export type VariableHeightBedConditionsInput = {
  functionalAndSupportNeeds?: InputMaybe<Array<PlanOfCareConditionInput>>;
  injuriesToLowerExtremity?: InputMaybe<Array<PlanOfCareConditionInput>>;
  limbAmputations?: InputMaybe<Array<PlanOfCareConditionInput>>;
  other?: InputMaybe<Array<PlanOfCareConditionInput>>;
  severeArthritis?: InputMaybe<Array<PlanOfCareConditionInput>>;
  severeCardiacConditions?: InputMaybe<Array<PlanOfCareConditionInput>>;
  spinalCordInjuryOrNeurologicalImpairment?: InputMaybe<Array<PlanOfCareConditionInput>>;
};

export type VentilatorDiagnosis = {
  __typename?: 'VentilatorDiagnosis';
  diagnosis?: Maybe<Scalars['String']['output']>;
  icd10Code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type VentilatorDiagnosisInput = {
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  icd10Code?: InputMaybe<Scalars['String']['input']>;
};

export enum VentilatorInterfaceType {
  ChestShell = 'CHEST_SHELL',
  FaceMask = 'FACE_MASK',
  Tracheostomy = 'TRACHEOSTOMY'
}

export type VentilatorLineItem = {
  __typename?: 'VentilatorLineItem';
  formItemId: Scalars['Int']['output'];
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  size?: Maybe<Scalars['String']['output']>;
};

export type VentilatorOrder = {
  __typename?: 'VentilatorOrder';
  chestShellCircumferenceCm?: Maybe<Scalars['Float']['output']>;
  chestShellWeightLb?: Maybe<Scalars['Float']['output']>;
  conditionNarrative?: Maybe<Scalars['String']['output']>;
  hasQualifyingCondition?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  interfaceType?: Maybe<VentilatorInterfaceType>;
  isLifetimeLengthOfNeed?: Maybe<Scalars['Boolean']['output']>;
  isPrimarilyCpapOrBilevel?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedInMonths?: Maybe<Scalars['Int']['output']>;
  maskNoseToChinCm?: Maybe<Scalars['Float']['output']>;
  preferredDmeCompany?: Maybe<Scalars['String']['output']>;
  tracheostomyInnerDiameterMm?: Maybe<Scalars['Float']['output']>;
  tracheostomyLengthMm?: Maybe<Scalars['Float']['output']>;
  tracheostomyOuterDiameterMm?: Maybe<Scalars['Float']['output']>;
  ventilatorDiagnoses: Array<VentilatorDiagnosis>;
  ventilatorLineItems: Array<VentilatorLineItem>;
  ventilatorType?: Maybe<VentilatorType>;
};

export type VentilatorOrderInput = {
  chestShellCircumferenceCm?: InputMaybe<Scalars['Float']['input']>;
  chestShellWeightLb?: InputMaybe<Scalars['Float']['input']>;
  conditionNarrative?: InputMaybe<Scalars['String']['input']>;
  hasQualifyingCondition?: InputMaybe<Scalars['Boolean']['input']>;
  interfaceType?: InputMaybe<VentilatorInterfaceType>;
  isLifetimeLengthOfNeed?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimarilyCpapOrBilevel?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedInMonths?: InputMaybe<Scalars['Int']['input']>;
  maskNoseToChinCm?: InputMaybe<Scalars['Float']['input']>;
  preferredDmeCompany?: InputMaybe<Scalars['String']['input']>;
  tracheostomyInnerDiameterMm?: InputMaybe<Scalars['Float']['input']>;
  tracheostomyLengthMm?: InputMaybe<Scalars['Float']['input']>;
  tracheostomyOuterDiameterMm?: InputMaybe<Scalars['Float']['input']>;
  ventilatorDiagnoses?: InputMaybe<Array<VentilatorDiagnosisInput>>;
  ventilatorType?: InputMaybe<VentilatorType>;
};

export enum VentilatorType {
  Invasive = 'INVASIVE',
  NonInvasive = 'NON_INVASIVE'
}

export type VerifyAddressInput = {
  address1: Scalars['String']['input'];
  address2: Scalars['String']['input'];
  city: Scalars['String']['input'];
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  recipient: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type VerifyAddressResult = {
  __typename?: 'VerifyAddressResult';
  equivalent: Scalars['Boolean']['output'];
  result: AddressVerificationResult;
};

export type VerseOsOrderInfo = {
  __typename?: 'VerseOSOrderInfo';
  clinicDeliveryCategories: Array<ProductCategory>;
  collectShipInfo: Scalars['Boolean']['output'];
  departmentOrderId: Scalars['Int']['output'];
  departmentType: DepartmentType;
  hasConfirmedZingCoverage: Scalars['Boolean']['output'];
  homeHealth: Scalars['Boolean']['output'];
  hospitalName: Scalars['String']['output'];
  integrationSource?: Maybe<Scalars['String']['output']>;
  isEnterpriseOrder: Scalars['Boolean']['output'];
  isStrategicAccount: Scalars['Boolean']['output'];
  orderNote?: Maybe<Scalars['String']['output']>;
  orderRemarks?: Maybe<Array<DepartmentOrderRemarkType>>;
  patientDob?: Maybe<Scalars['String']['output']>;
  processingDeadline?: Maybe<Scalars['DateTime']['output']>;
  selfPay: Scalars['Boolean']['output'];
  shippingAddress: ShippingAddress;
};

export type VerseOsOrderSearch = {
  __typename?: 'VerseOSOrderSearch';
  keysetApprovalPriority?: Maybe<Scalars['Int']['output']>;
  keysetDate?: Maybe<Scalars['String']['output']>;
  keysetMatchRank?: Maybe<Scalars['Int']['output']>;
  keysetOrderNumber?: Maybe<Scalars['String']['output']>;
  keysetPriorityScore0?: Maybe<Scalars['Int']['output']>;
  keysetPriorityScore1?: Maybe<Scalars['Int']['output']>;
  keysetProcessingDeadline?: Maybe<Scalars['String']['output']>;
  orders: Array<VerseOsOrderSearchOrderInfo>;
};

export type VerseOsOrderSearchInput = {
  assignedFilter?: InputMaybe<AssignedFilterInput>;
  billerReviewReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  clinicVisibleStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  handoffFailureReasons: Array<HandOffPortalOrderRejectionReason>;
  handoffStatus?: InputMaybe<Array<HandOffStatus>>;
  handoffTags: Array<HandOffOrderSegmentPartnerTag>;
  hospitalNames?: InputMaybe<Array<Scalars['String']['input']>>;
  internalOrderStates?: InputMaybe<Array<SearchOrderState>>;
  isTelehealth?: Scalars['Boolean']['input'];
  keysetApprovalPriority?: InputMaybe<Scalars['Int']['input']>;
  keysetDate?: InputMaybe<Scalars['String']['input']>;
  keysetMatchRank?: InputMaybe<Scalars['Int']['input']>;
  keysetOrderNumber?: InputMaybe<Scalars['String']['input']>;
  keysetPriorityScore0?: InputMaybe<Scalars['Int']['input']>;
  keysetPriorityScore1?: InputMaybe<Scalars['Int']['input']>;
  keysetProcessingDeadline?: InputMaybe<Scalars['String']['input']>;
  orderCount?: InputMaybe<Array<Scalars['String']['input']>>;
  pageSize: Scalars['Int']['input'];
  policyTypes?: InputMaybe<Array<PolicyType>>;
  progressNotesStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortOrder: SearchSortOrder;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type VerseOsOrderSearchOrderInfo = {
  __typename?: 'VerseOSOrderSearchOrderInfo';
  activeOpsOrderStates: Array<OpsOrderStateType>;
  assignedUser?: Maybe<Scalars['Int']['output']>;
  awaitingProgressNote?: Maybe<Scalars['Boolean']['output']>;
  departmentId: Scalars['Int']['output'];
  eligibilityPolicyType?: Maybe<Scalars['String']['output']>;
  expiredPrescription?: Maybe<Scalars['Boolean']['output']>;
  hasPurchaseOrderItems?: Maybe<Scalars['Boolean']['output']>;
  insuranceType?: Maybe<InsuranceType>;
  isSlaUrgent: Scalars['Boolean']['output'];
  isSynapseFulfill: Scalars['Boolean']['output'];
  localTimezone: Scalars['String']['output'];
  opsOrderNotes: Array<OpsOrderNote>;
  orderInitiationLocalTime: Scalars['DateTime']['output'];
  orderInitiationTime: Scalars['DateTime']['output'];
  orderNumber: Scalars['String']['output'];
  orderSegmentInfos: Array<VerseOsOrderSearchSegmentInfo>;
  orderStatus: ProviderReferralStatus;
  patientName: Scalars['String']['output'];
  processingDeadline: Scalars['DateTime']['output'];
};

export type VerseOsOrderSearchSegmentInfo = {
  __typename?: 'VerseOSOrderSearchSegmentInfo';
  activeDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  handOffOrderSegmentType?: Maybe<HandOffOrderSegmentType>;
  segmentId: Scalars['Int']['output'];
  segmentStatus: VerseOsOrderSearchSegmentStatus;
  segmentType: OrderSegmentTypes;
};

export enum VerseOsOrderSearchSegmentStatus {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  EChecked = 'E_CHECKED',
  Inactive = 'INACTIVE',
  New = 'NEW',
  Prepped = 'PREPPED'
}

export enum WaiverOfLiabilityType {
  Aetna = 'AETNA',
  AetnaVirginia = 'AETNA_VIRGINIA',
  AlohaCare = 'ALOHA_CARE',
  Generic = 'GENERIC',
  Humana = 'HUMANA',
  VillageCareMax = 'VILLAGE_CARE_MAX',
  ZingHealth = 'ZING_HEALTH'
}

export type WarningMessage = {
  __typename?: 'WarningMessage';
  actual?: Maybe<Array<Scalars['String']['output']>>;
  details?: Maybe<Array<Scalars['String']['output']>>;
  empty: Scalars['Boolean']['output'];
  error: Scalars['Boolean']['output'];
  formItemId?: Maybe<Scalars['Int']['output']>;
  heading: Scalars['String']['output'];
  key: Scalars['String']['output'];
  maxAllowedQuantity?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  woundIndex?: Maybe<Scalars['Int']['output']>;
};

export type WarningMessagesGroup = {
  __typename?: 'WarningMessagesGroup';
  warnings: Array<WarningMessage>;
};

export enum WheelchairHeight {
  HemiHeight = 'HEMI_HEIGHT',
  Standard = 'STANDARD'
}

export type WheelchairLastXYears = {
  __typename?: 'WheelchairLastXYears';
  reason?: Maybe<PlanOfCareCondition>;
  value?: Maybe<Scalars['Boolean']['output']>;
  years?: Maybe<Scalars['Int']['output']>;
};

export type WheelchairLastXYearsInput = {
  reason?: InputMaybe<PlanOfCareConditionInput>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
  years?: InputMaybe<Scalars['Int']['input']>;
};

export enum WheelchairSeatSize {
  Eighteen = 'EIGHTEEN',
  Sixteen = 'SIXTEEN',
  Twenty = 'TWENTY',
  TwentyFour = 'TWENTY_FOUR',
  TwentySix = 'TWENTY_SIX',
  TwentyTwo = 'TWENTY_TWO'
}

export enum WheelchairsAndScootersAdlDifficulty {
  Bathing = 'BATHING',
  Dressing = 'DRESSING',
  Feeding = 'FEEDING',
  Grooming = 'GROOMING',
  Toileting = 'TOILETING',
  WalkingIndependently = 'WALKING_INDEPENDENTLY'
}

export enum WheelchairsAndScootersDeviceType {
  BariatricManual = 'BARIATRIC_MANUAL',
  BariatricTransport = 'BARIATRIC_TRANSPORT',
  CushionOnly = 'CUSHION_ONLY',
  LightweightManual = 'LIGHTWEIGHT_MANUAL',
  OtherScooter = 'OTHER_SCOOTER',
  OtherWheelchair = 'OTHER_WHEELCHAIR',
  PortablePowerWheelchair = 'PORTABLE_POWER_WHEELCHAIR',
  PowerAssist = 'POWER_ASSIST',
  PowerWheelchair = 'POWER_WHEELCHAIR',
  Scooter = 'SCOOTER',
  StandardManual = 'STANDARD_MANUAL',
  Transport = 'TRANSPORT'
}

export type WheelchairsAndScootersDiagnosis = {
  __typename?: 'WheelchairsAndScootersDiagnosis';
  diagnosis?: Maybe<Scalars['String']['output']>;
  icd10Code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type WheelchairsAndScootersDiagnosisInput = {
  diagnosis?: InputMaybe<Scalars['String']['input']>;
  icd10Code?: InputMaybe<Scalars['String']['input']>;
};

export type WheelchairsAndScootersLineItem = {
  __typename?: 'WheelchairsAndScootersLineItem';
  formItemId?: Maybe<Scalars['Int']['output']>;
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  size?: Maybe<Scalars['String']['output']>;
};

export type WheelchairsAndScootersLineItemInput = {
  formItemId?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
};

export enum WheelchairsAndScootersMobilityLimitationReason {
  HighFallRisk = 'HIGH_FALL_RISK',
  NonAmbulatory = 'NON_AMBULATORY',
  PoorBalance = 'POOR_BALANCE',
  ReliesOnCaregiverAssistance = 'RELIES_ON_CAREGIVER_ASSISTANCE',
  SevereDifficultyWalking = 'SEVERE_DIFFICULTY_WALKING',
  TooWeakToWalkIndependently = 'TOO_WEAK_TO_WALK_INDEPENDENTLY'
}

export enum WheelchairsAndScootersMradlBenefit {
  CompleteMradlsSitting = 'COMPLETE_MRADLS_SITTING',
  LessCaregiverAssistance = 'LESS_CAREGIVER_ASSISTANCE',
  MobileLongerDistances = 'MOBILE_LONGER_DISTANCES',
  ReducedFallRisk = 'REDUCED_FALL_RISK',
  RegainIndependence = 'REGAIN_INDEPENDENCE'
}

export enum WheelchairsAndScootersNewWheelchairReasonCategory {
  DeviceNoLongerMedicallyAppropriate = 'DEVICE_NO_LONGER_MEDICALLY_APPROPRIATE',
  IrreparablyDamaged = 'IRREPARABLY_DAMAGED',
  LostOrStolen = 'LOST_OR_STOLEN',
  Other = 'OTHER',
  PatientConditionChanged = 'PATIENT_CONDITION_CHANGED'
}

export type WheelchairsAndScootersOrder = {
  __typename?: 'WheelchairsAndScootersOrder';
  adlDifficulties?: Maybe<Array<WheelchairsAndScootersAdlDifficulty>>;
  altDriveControlRequired?: Maybe<Scalars['Boolean']['output']>;
  caneOrWalkerWouldResolve?: Maybe<Scalars['Boolean']['output']>;
  caregiverAvailableToPropel?: Maybe<Scalars['Boolean']['output']>;
  consentToUseDevice?: Maybe<Scalars['Boolean']['output']>;
  deliveryLocationType?: Maybe<DeliveryLocationType>;
  deviceType?: Maybe<WheelchairsAndScootersDeviceType>;
  dischargeDatetime?: Maybe<Scalars['DateTime']['output']>;
  expectedToGrow?: Maybe<Scalars['Boolean']['output']>;
  hadWheelchairPast5Years?: Maybe<Scalars['Boolean']['output']>;
  homeAccommodatesDevice?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isLifetimeLengthOfNeed?: Maybe<Scalars['Boolean']['output']>;
  lengthOfNeedInMonths?: Maybe<Scalars['Int']['output']>;
  mobilityLimitationReasons?: Maybe<Array<WheelchairsAndScootersMobilityLimitationReason>>;
  mradlBenefits?: Maybe<Array<WheelchairsAndScootersMradlBenefit>>;
  neuroEtiology?: Maybe<Scalars['Boolean']['output']>;
  newWheelchairReason?: Maybe<Scalars['String']['output']>;
  newWheelchairReasonCategory?: Maybe<WheelchairsAndScootersNewWheelchairReasonCategory>;
  otherDeviceDescription?: Maybe<Scalars['String']['output']>;
  patientHeightFeet?: Maybe<Scalars['Int']['output']>;
  patientHeightInches?: Maybe<Scalars['Int']['output']>;
  patientWeightLbs?: Maybe<Scalars['Int']['output']>;
  povCognitionAndVisionAdequate?: Maybe<Scalars['Boolean']['output']>;
  povTransferAndOperateCapable?: Maybe<Scalars['Boolean']['output']>;
  powerWheelchairClass?: Maybe<PowerWheelchairClass>;
  powerWheelchairSeating?: Maybe<PowerWheelchairSeating>;
  preferredDmeCompany?: Maybe<Scalars['String']['output']>;
  priorDeliveryDate?: Maybe<Scalars['String']['output']>;
  priorHcpcsCode?: Maybe<Scalars['String']['output']>;
  pwcCaregiverCanOperate?: Maybe<Scalars['Boolean']['output']>;
  pwcOperateIndependently?: Maybe<Scalars['Boolean']['output']>;
  scooterSeatWidth?: Maybe<ScooterSeatSize>;
  scooterSteeringHandle?: Maybe<ScooterSteeringHandle>;
  scooterSwivelSeat?: Maybe<Scalars['Boolean']['output']>;
  scooterWheels?: Maybe<ScooterWheels>;
  seatDepth?: Maybe<WheelchairSeatSize>;
  selfPropelCapable?: Maybe<Scalars['Boolean']['output']>;
  selfPropellingPastYear?: Maybe<Scalars['Boolean']['output']>;
  specialtyEvaluationCompleted?: Maybe<Scalars['Boolean']['output']>;
  tiltAndReclineQualifies?: Maybe<Scalars['Boolean']['output']>;
  tiltOrReclineQualifies?: Maybe<Scalars['Boolean']['output']>;
  ventilatorMounted?: Maybe<Scalars['Boolean']['output']>;
  weightWithinCapacity?: Maybe<Scalars['Boolean']['output']>;
  wheelchairHeight?: Maybe<WheelchairHeight>;
  wheelchairSeatWidth?: Maybe<WheelchairSeatSize>;
  wheelchairsAndScootersDiagnoses: Array<WheelchairsAndScootersDiagnosis>;
  wheelchairsAndScootersLineItems: Array<WheelchairsAndScootersLineItem>;
};

export type WheelchairsAndScootersOrderInput = {
  adlDifficulties?: InputMaybe<Array<WheelchairsAndScootersAdlDifficulty>>;
  altDriveControlRequired?: InputMaybe<Scalars['Boolean']['input']>;
  caneOrWalkerWouldResolve?: InputMaybe<Scalars['Boolean']['input']>;
  caregiverAvailableToPropel?: InputMaybe<Scalars['Boolean']['input']>;
  consentToUseDevice?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryLocationType?: InputMaybe<DeliveryLocationType>;
  deviceType?: InputMaybe<WheelchairsAndScootersDeviceType>;
  dischargeDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  expectedToGrow?: InputMaybe<Scalars['Boolean']['input']>;
  hadWheelchairPast5Years?: InputMaybe<Scalars['Boolean']['input']>;
  homeAccommodatesDevice?: InputMaybe<Scalars['Boolean']['input']>;
  isLifetimeLengthOfNeed?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfNeedInMonths?: InputMaybe<Scalars['Int']['input']>;
  mobilityLimitationReasons?: InputMaybe<Array<WheelchairsAndScootersMobilityLimitationReason>>;
  mradlBenefits?: InputMaybe<Array<WheelchairsAndScootersMradlBenefit>>;
  neuroEtiology?: InputMaybe<Scalars['Boolean']['input']>;
  newWheelchairReason?: InputMaybe<Scalars['String']['input']>;
  newWheelchairReasonCategory?: InputMaybe<WheelchairsAndScootersNewWheelchairReasonCategory>;
  otherDeviceDescription?: InputMaybe<Scalars['String']['input']>;
  patientHeightFeet?: InputMaybe<Scalars['Int']['input']>;
  patientHeightInches?: InputMaybe<Scalars['Int']['input']>;
  patientWeightLbs?: InputMaybe<Scalars['Int']['input']>;
  povCognitionAndVisionAdequate?: InputMaybe<Scalars['Boolean']['input']>;
  povTransferAndOperateCapable?: InputMaybe<Scalars['Boolean']['input']>;
  powerWheelchairClass?: InputMaybe<PowerWheelchairClass>;
  powerWheelchairSeating?: InputMaybe<PowerWheelchairSeating>;
  preferredDmeCompany?: InputMaybe<Scalars['String']['input']>;
  priorDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  priorHcpcsCode?: InputMaybe<Scalars['String']['input']>;
  pwcCaregiverCanOperate?: InputMaybe<Scalars['Boolean']['input']>;
  pwcOperateIndependently?: InputMaybe<Scalars['Boolean']['input']>;
  scooterSeatWidth?: InputMaybe<ScooterSeatSize>;
  scooterSteeringHandle?: InputMaybe<ScooterSteeringHandle>;
  scooterSwivelSeat?: InputMaybe<Scalars['Boolean']['input']>;
  scooterWheels?: InputMaybe<ScooterWheels>;
  seatDepth?: InputMaybe<WheelchairSeatSize>;
  selfPropelCapable?: InputMaybe<Scalars['Boolean']['input']>;
  selfPropellingPastYear?: InputMaybe<Scalars['Boolean']['input']>;
  specialtyEvaluationCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  tiltAndReclineQualifies?: InputMaybe<Scalars['Boolean']['input']>;
  tiltOrReclineQualifies?: InputMaybe<Scalars['Boolean']['input']>;
  ventilatorMounted?: InputMaybe<Scalars['Boolean']['input']>;
  weightWithinCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  wheelchairHeight?: InputMaybe<WheelchairHeight>;
  wheelchairSeatWidth?: InputMaybe<WheelchairSeatSize>;
  wheelchairsAndScootersDiagnoses?: InputMaybe<Array<WheelchairsAndScootersDiagnosisInput>>;
  wheelchairsAndScootersLineItems?: InputMaybe<Array<WheelchairsAndScootersLineItemInput>>;
};

export type WorkersCompInfo = {
  __typename?: 'WorkersCompInfo';
  caseManagerName?: Maybe<Scalars['String']['output']>;
  caseManagerPhone?: Maybe<Scalars['String']['output']>;
  claimAddress?: Maybe<Scalars['String']['output']>;
  claimNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dateOfAccident?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insuranceName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type WorkersCompInfoInput = {
  caseManagerName?: InputMaybe<Scalars['String']['input']>;
  caseManagerPhone?: InputMaybe<Scalars['String']['input']>;
  claimAddress?: InputMaybe<Scalars['String']['input']>;
  claimNumber?: InputMaybe<Scalars['String']['input']>;
  dateOfAccident?: InputMaybe<Scalars['String']['input']>;
  insuranceName?: InputMaybe<Scalars['String']['input']>;
};

export type WorklistCategory = {
  __typename?: 'WorklistCategory';
  label: Scalars['String']['output'];
  value: ProductCategory;
};

export type WorklistCoverage = {
  __typename?: 'WorklistCoverage';
  name: Scalars['String']['output'];
  opsUserId: Scalars['Int']['output'];
  todosCount: Scalars['Int']['output'];
};

export type WorklistQueueCounts = {
  __typename?: 'WorklistQueueCounts';
  assignedInProgress: Scalars['Int']['output'];
  awaitingClinicOrders: Scalars['Int']['output'];
  unassigned: Scalars['Int']['output'];
  unassignedBySlug: Array<UnassignedSlugCount>;
};

export type WorklistSettingsInput = {
  clinicalReviewBatchSize?: InputMaybe<Scalars['Int']['input']>;
  defaultBatchSize?: InputMaybe<Scalars['Int']['input']>;
  noteResponseBatchSize?: InputMaybe<Scalars['Int']['input']>;
  orphanNoteResponseBatchSize?: InputMaybe<Scalars['Int']['input']>;
};

export type WorklistSettingsSchema = {
  __typename?: 'WorklistSettingsSchema';
  clinicalReviewBatchSize: Scalars['Int']['output'];
  defaultBatchSize: Scalars['Int']['output'];
  noteResponseBatchSize: Scalars['Int']['output'];
  orphanNoteResponseBatchSize: Scalars['Int']['output'];
};

export type WorklistTabCounts = {
  __typename?: 'WorklistTabCounts';
  awaitingClinicCount: Scalars['Int']['output'];
  finishedCount: Scalars['Int']['output'];
  pinnedCount: Scalars['Int']['output'];
  todosCount: Scalars['Int']['output'];
};

export type WorklistTask = {
  __typename?: 'WorklistTask';
  actionDate?: Maybe<Scalars['String']['output']>;
  assignedAt?: Maybe<Scalars['String']['output']>;
  assigneeId?: Maybe<Scalars['Int']['output']>;
  assigneeIsOffline: Scalars['Boolean']['output'];
  assigneeName?: Maybe<Scalars['String']['output']>;
  assigneeOfflineReason?: Maybe<Scalars['String']['output']>;
  categories: Array<WorklistCategory>;
  dagId: Scalars['Int']['output'];
  daysPending?: Maybe<Scalars['Int']['output']>;
  distributorId?: Maybe<Scalars['Int']['output']>;
  distributorName?: Maybe<Scalars['String']['output']>;
  distributorPortalUrl?: Maybe<Scalars['String']['output']>;
  hasReassignSiblings: Scalars['Boolean']['output'];
  isSlaUrgent: Scalars['Boolean']['output'];
  isSynapseFulfill: Scalars['Boolean']['output'];
  messageReceived?: Maybe<Scalars['String']['output']>;
  messageTemplateNames?: Maybe<Array<Scalars['String']['output']>>;
  nodeCreatedAt?: Maybe<Scalars['String']['output']>;
  nodeId: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  orderReceived?: Maybe<Scalars['String']['output']>;
  orderSegmentId?: Maybe<Scalars['Int']['output']>;
  orderTimezoneAbbrev?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  pinReason?: Maybe<Scalars['String']['output']>;
  pinnedAt?: Maybe<Scalars['String']['output']>;
  processingDeadline?: Maybe<Scalars['String']['output']>;
  segmentActiveDate?: Maybe<Scalars['String']['output']>;
  segmentType?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  taskType: TaskType;
};

export enum WorklistTeam {
  ClinicalReview = 'CLINICAL_REVIEW',
  Ops = 'OPS'
}

export enum WorklistView {
  AwaitingClinic = 'AWAITING_CLINIC',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  Pinned = 'PINNED',
  Todos = 'TODOS',
  TodosAndInProgress = 'TODOS_AND_IN_PROGRESS'
}

export type Wound = {
  __typename?: 'Wound';
  amountExudate?: Maybe<Scalars['String']['output']>;
  debrided?: Maybe<Scalars['String']['output']>;
  departmentOrderId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dimensionDepth?: Maybe<Scalars['Float']['output']>;
  dimensionLength?: Maybe<Scalars['Float']['output']>;
  dimensionWidth?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  location?: Maybe<Scalars['String']['output']>;
  thickness?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type WoundAssessment = {
  __typename?: 'WoundAssessment';
  assessedOn: Scalars['DateTime']['output'];
  orderNumber: Scalars['String']['output'];
  wound: WoundMatchingWound;
};

export type WoundCareLineItem = {
  __typename?: 'WoundCareLineItem';
  calculatedSizeData?: Maybe<WoundCareLineItemCalculatedSizeAndQuantity>;
  createdAt: Scalars['DateTime']['output'];
  disableQuantityAutocalculationDefaultQuantity?: Maybe<Scalars['Int']['output']>;
  displayUnitLabel?: Maybe<Scalars['String']['output']>;
  durationOfUse?: Maybe<Scalars['String']['output']>;
  formItemId?: Maybe<Scalars['Int']['output']>;
  frequencyOfUse?: Maybe<Scalars['String']['output']>;
  frequencyPreferenceId?: Maybe<Scalars['Int']['output']>;
  frequencyPreferenceRef?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAiExtracted?: Maybe<Scalars['Boolean']['output']>;
  isMedicareWoundOop?: Maybe<Scalars['Boolean']['output']>;
  isPartialFocOop?: Maybe<Scalars['Boolean']['output']>;
  isSubstitutionOop?: Maybe<Scalars['Boolean']['output']>;
  maxAllowedQuantity?: Maybe<Scalars['Int']['output']>;
  productName: Scalars['String']['output'];
  productNameFromFax?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['String']['output'];
  sendSmallerSize?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<ProductSize>;
  sizePreferenceId?: Maybe<Scalars['Int']['output']>;
  substitutionPreferenceId?: Maybe<Scalars['Int']['output']>;
  substitutionPreferenceRef?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  woundId?: Maybe<Scalars['Int']['output']>;
  woundPreferenceId?: Maybe<Scalars['Int']['output']>;
};

export type WoundCareLineItemCalculatedSizeAndQuantity = {
  __typename?: 'WoundCareLineItemCalculatedSizeAndQuantity';
  clinicEnteredSize?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  formItemId?: Maybe<Scalars['Int']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sets?: Maybe<Array<WoundCareLineItemCalculatedSizeAndQuantitySet>>;
  woundIds: Array<Scalars['Int']['output']>;
};

export type WoundCareLineItemCalculatedSizeAndQuantityInput = {
  clinicEnteredSize?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  formItemId?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sets?: InputMaybe<Array<WoundCareLineItemCalculatedSizeAndQuantitySetInput>>;
  wounds: Array<WoundInput>;
};

export type WoundCareLineItemCalculatedSizeAndQuantitySet = {
  __typename?: 'WoundCareLineItemCalculatedSizeAndQuantitySet';
  calculatedQuantity?: Maybe<Scalars['Int']['output']>;
  calculatedSizeId?: Maybe<Scalars['Int']['output']>;
  calculatedSizeName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  status: WoundCareLineItemCalculatedSizeAndQuantityStatus;
  statusChangedAt?: Maybe<Scalars['DateTime']['output']>;
  statusChangedBySpreeUserId?: Maybe<Scalars['String']['output']>;
  woundUuids?: Maybe<Array<Scalars['String']['output']>>;
  wounds: Array<Scalars['Int']['output']>;
};

export type WoundCareLineItemCalculatedSizeAndQuantitySetInput = {
  calculatedQuantity?: InputMaybe<Scalars['Int']['input']>;
  calculatedSizeId?: InputMaybe<Scalars['Int']['input']>;
  calculatedSizeName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: WoundCareLineItemCalculatedSizeAndQuantityStatus;
  statusChangedAt?: InputMaybe<Scalars['DateTime']['input']>;
  statusChangedBySpreeUserId?: InputMaybe<Scalars['String']['input']>;
  woundUuids?: InputMaybe<Array<Scalars['String']['input']>>;
  wounds: Array<Scalars['Int']['input']>;
};

export enum WoundCareLineItemCalculatedSizeAndQuantityStatus {
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type WoundCareLineItemInput = {
  calculatedSizeData?: InputMaybe<WoundCareLineItemCalculatedSizeAndQuantityInput>;
  disableQuantityAutocalculationDefaultQuantity?: InputMaybe<Scalars['Int']['input']>;
  dressingCategory?: InputMaybe<Scalars['String']['input']>;
  durationOfUse?: InputMaybe<Scalars['String']['input']>;
  extracted?: InputMaybe<Scalars['Boolean']['input']>;
  formItemId?: InputMaybe<Scalars['Int']['input']>;
  frequencyOfUse?: InputMaybe<Scalars['String']['input']>;
  frequencyPreferenceId?: InputMaybe<Scalars['Int']['input']>;
  isBordered?: InputMaybe<Scalars['Boolean']['input']>;
  maxAllowedQuantity?: InputMaybe<Scalars['Int']['input']>;
  offerExcessAsOop?: InputMaybe<Scalars['Boolean']['input']>;
  pinItem?: InputMaybe<Scalars['Boolean']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productNameFromFax?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  quantityAutoSetToMaxAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  selectedWoundsPreferenceIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sendSmallerSize?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<ProductSizeInput>;
  sizePreferenceId?: InputMaybe<Scalars['Int']['input']>;
  substitutionPreferenceId?: InputMaybe<Scalars['Int']['input']>;
  woundIndicesUsed?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type WoundInput = {
  amountExudate?: InputMaybe<Scalars['String']['input']>;
  debrided?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dimensionDepth?: InputMaybe<Scalars['String']['input']>;
  dimensionLength?: InputMaybe<Scalars['String']['input']>;
  dimensionWidth?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  thickness?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type WoundItemTraits = {
  __typename?: 'WoundItemTraits';
  isBordered?: Maybe<Scalars['Boolean']['output']>;
  isCourtesy?: Maybe<Scalars['Boolean']['output']>;
  isFiller?: Maybe<Scalars['Boolean']['output']>;
  isGelFiller?: Maybe<Scalars['Boolean']['output']>;
  isHeel?: Maybe<Scalars['Boolean']['output']>;
  isImpregnated?: Maybe<Scalars['Boolean']['output']>;
  isNonCovered?: Maybe<Scalars['Boolean']['output']>;
  isNonSterile?: Maybe<Scalars['Boolean']['output']>;
  isNonWoven?: Maybe<Scalars['Boolean']['output']>;
  isPowderFiller?: Maybe<Scalars['Boolean']['output']>;
  isRopeFiller?: Maybe<Scalars['Boolean']['output']>;
  isSacral?: Maybe<Scalars['Boolean']['output']>;
  isSilicone?: Maybe<Scalars['Boolean']['output']>;
  isSilver?: Maybe<Scalars['Boolean']['output']>;
  isSuperAbsorber?: Maybe<Scalars['Boolean']['output']>;
};

export type WoundItemTraitsInput = {
  isBordered: Scalars['Boolean']['input'];
  isCourtesy: Scalars['Boolean']['input'];
  isFiller: Scalars['Boolean']['input'];
  isGelFiller: Scalars['Boolean']['input'];
  isHeel: Scalars['Boolean']['input'];
  isImpregnated: Scalars['Boolean']['input'];
  isNonCovered: Scalars['Boolean']['input'];
  isNonSterile: Scalars['Boolean']['input'];
  isNonWoven: Scalars['Boolean']['input'];
  isPowderFiller: Scalars['Boolean']['input'];
  isRopeFiller: Scalars['Boolean']['input'];
  isSacral: Scalars['Boolean']['input'];
  isSilicone: Scalars['Boolean']['input'];
  isSilver: Scalars['Boolean']['input'];
  isSuperAbsorber: Scalars['Boolean']['input'];
};

export type WoundItemType = {
  __typename?: 'WoundItemType';
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type WoundMatchCandidate = {
  __typename?: 'WoundMatchCandidate';
  assessedOn: Scalars['DateTime']['output'];
  history: Array<WoundAssessment>;
  kind: WoundMatchKind;
  orderNumber: Scalars['String']['output'];
  patientWoundId?: Maybe<Scalars['Int']['output']>;
  wound: WoundMatchingWound;
};

export type WoundMatchInput = {
  kind: WoundMatchKind;
  orderWoundId: Scalars['Int']['input'];
  patientWoundId?: InputMaybe<Scalars['Int']['input']>;
  targetOrderWoundId?: InputMaybe<Scalars['Int']['input']>;
};

export enum WoundMatchKind {
  New = 'NEW',
  OrderWound = 'ORDER_WOUND',
  PatientWound = 'PATIENT_WOUND'
}

export type WoundMatching = {
  __typename?: 'WoundMatching';
  allMatched: Scalars['Boolean']['output'];
  candidates: Array<WoundMatchCandidate>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedBy?: Maybe<Scalars['String']['output']>;
  currentWounds: Array<WoundMatchingWound>;
  isEligibilityOrder: Scalars['Boolean']['output'];
};

export type WoundMatchingWound = {
  __typename?: 'WoundMatchingWound';
  amountExudate?: Maybe<Scalars['String']['output']>;
  debrided?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensionDepth?: Maybe<Scalars['Float']['output']>;
  dimensionLength?: Maybe<Scalars['Float']['output']>;
  dimensionWidth?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  matchedPatientWoundId?: Maybe<Scalars['Int']['output']>;
  orderWoundId: Scalars['Int']['output'];
  thickness?: Maybe<Scalars['String']['output']>;
};

export type WoundOrder = {
  __typename?: 'WoundOrder';
  woundCareLineItems: Array<WoundCareLineItem>;
  wounds: Array<Wound>;
};

export type WoundOrderInput = {
  woundCareLineItems: Array<WoundCareLineItemInput>;
  wounds: Array<WoundInput>;
};

export type WoundSelectionInfo = {
  __typename?: 'WoundSelectionInfo';
  isBlocked: Scalars['Boolean']['output'];
  lineItems: Array<WoundSelectionLineItem>;
};

export type WoundSelectionLineItem = {
  __typename?: 'WoundSelectionLineItem';
  id: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
};

export enum WoundSuctionCanisterType {
  Ml_500WithGel = 'ML_500_WITH_GEL',
  Ml_1000WithGel = 'ML_1000_WITH_GEL',
  Other = 'OTHER'
}

export enum WoundSuctionCriterionAnswer {
  No = 'NO',
  NotApplicable = 'NOT_APPLICABLE',
  Yes = 'YES'
}

export type WoundSuctionLineItem = {
  __typename?: 'WoundSuctionLineItem';
  formItemId?: Maybe<Scalars['Int']['output']>;
  hcpcsCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export enum WoundSuctionMachineType {
  Portable = 'PORTABLE',
  Stationary = 'STATIONARY',
  SuppliesOnly = 'SUPPLIES_ONLY'
}

export type WoundSuctionOrder = {
  __typename?: 'WoundSuctionOrder';
  canisterType?: Maybe<WoundSuctionCanisterType>;
  compressionConsistentlyApplied?: Maybe<WoundSuctionCriterionAnswer>;
  dressingsAppliedForMoistEnvironment?: Maybe<WoundSuctionCriterionAnswer>;
  encouragedToAmbulateAndElevate?: Maybe<WoundSuctionCriterionAnswer>;
  exceededMaxCanisterSets?: Maybe<Scalars['Boolean']['output']>;
  exceededMaxDressingKits?: Maybe<Scalars['Boolean']['output']>;
  excessDressingKitsJustification?: Maybe<Scalars['String']['output']>;
  footPressureReduced?: Maybe<WoundSuctionCriterionAnswer>;
  hasCancerInWound?: Maybe<Scalars['Boolean']['output']>;
  hasLargeVolumeDrainageDocumentation?: Maybe<Scalars['Boolean']['output']>;
  hasNecroticTissueWithEschar?: Maybe<Scalars['Boolean']['output']>;
  hasOpenFistula?: Maybe<Scalars['Boolean']['output']>;
  hasSurgicalOrTraumaticWoundComplication?: Maybe<Scalars['Boolean']['output']>;
  hasUntreatedOsteomyelitis?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  includesAdhesiveDrape: Scalars['Boolean']['output'];
  includesFoam: Scalars['Boolean']['output'];
  includesSorbactDressing: Scalars['Boolean']['output'];
  includesSuctionPad: Scalars['Boolean']['output'];
  includesWoundFiller: Scalars['Boolean']['output'];
  isContinuingExistingTherapy?: Maybe<Scalars['Boolean']['output']>;
  isTherapyInitiatedInpatient?: Maybe<Scalars['Boolean']['output']>;
  machineType?: Maybe<WoundSuctionMachineType>;
  moistureAndIncontinenceManaged?: Maybe<WoundSuctionCriterionAnswer>;
  needsAcceleratedGranulation?: Maybe<Scalars['Boolean']['output']>;
  npwtIsBestAvailableOption?: Maybe<Scalars['Boolean']['output']>;
  onDiabeticManagementProgram?: Maybe<WoundSuctionCriterionAnswer>;
  otherCanister?: Maybe<Scalars['String']['output']>;
  patientTurnedAndPositioned?: Maybe<WoundSuctionCriterionAnswer>;
  preferredDmeCompany?: Maybe<Scalars['String']['output']>;
  therapyStartDate?: Maybe<Scalars['Date']['output']>;
  ulcerType?: Maybe<WoundSuctionUlcerType>;
  usedGroup2Or3SupportSurface?: Maybe<WoundSuctionCriterionAnswer>;
  woundSuctionLineItems: Array<WoundSuctionLineItem>;
  woundSuctionTreatments: Array<WoundSuctionTreatment>;
};

export type WoundSuctionOrderInput = {
  canisterType?: InputMaybe<WoundSuctionCanisterType>;
  compressionConsistentlyApplied?: InputMaybe<WoundSuctionCriterionAnswer>;
  dressingsAppliedForMoistEnvironment?: InputMaybe<WoundSuctionCriterionAnswer>;
  encouragedToAmbulateAndElevate?: InputMaybe<WoundSuctionCriterionAnswer>;
  exceededMaxCanisterSets?: InputMaybe<Scalars['Boolean']['input']>;
  exceededMaxDressingKits?: InputMaybe<Scalars['Boolean']['input']>;
  excessDressingKitsJustification?: InputMaybe<Scalars['String']['input']>;
  footPressureReduced?: InputMaybe<WoundSuctionCriterionAnswer>;
  hasCancerInWound?: InputMaybe<Scalars['Boolean']['input']>;
  hasLargeVolumeDrainageDocumentation?: InputMaybe<Scalars['Boolean']['input']>;
  hasNecroticTissueWithEschar?: InputMaybe<Scalars['Boolean']['input']>;
  hasOpenFistula?: InputMaybe<Scalars['Boolean']['input']>;
  hasSurgicalOrTraumaticWoundComplication?: InputMaybe<Scalars['Boolean']['input']>;
  hasUntreatedOsteomyelitis?: InputMaybe<Scalars['Boolean']['input']>;
  includesAdhesiveDrape?: Scalars['Boolean']['input'];
  includesFoam?: Scalars['Boolean']['input'];
  includesSorbactDressing?: Scalars['Boolean']['input'];
  includesSuctionPad?: Scalars['Boolean']['input'];
  includesWoundFiller?: Scalars['Boolean']['input'];
  isContinuingExistingTherapy?: InputMaybe<Scalars['Boolean']['input']>;
  isTherapyInitiatedInpatient?: InputMaybe<Scalars['Boolean']['input']>;
  machineType?: InputMaybe<WoundSuctionMachineType>;
  moistureAndIncontinenceManaged?: InputMaybe<WoundSuctionCriterionAnswer>;
  needsAcceleratedGranulation?: InputMaybe<Scalars['Boolean']['input']>;
  npwtIsBestAvailableOption?: InputMaybe<Scalars['Boolean']['input']>;
  onDiabeticManagementProgram?: InputMaybe<WoundSuctionCriterionAnswer>;
  otherCanister?: InputMaybe<Scalars['String']['input']>;
  patientTurnedAndPositioned?: InputMaybe<WoundSuctionCriterionAnswer>;
  preferredDmeCompany?: InputMaybe<Scalars['String']['input']>;
  therapyStartDate?: InputMaybe<Scalars['Date']['input']>;
  ulcerType?: InputMaybe<WoundSuctionUlcerType>;
  usedGroup2Or3SupportSurface?: InputMaybe<WoundSuctionCriterionAnswer>;
  woundSuctionTreatments?: InputMaybe<Array<WoundSuctionTreatmentInput>>;
};

export type WoundSuctionTreatment = {
  __typename?: 'WoundSuctionTreatment';
  durationOfUse?: Maybe<Scalars['String']['output']>;
  frequencyOfChange?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  selectedWoundIndices: Array<Scalars['Int']['output']>;
};

export type WoundSuctionTreatmentInput = {
  durationOfUse?: InputMaybe<Scalars['String']['input']>;
  frequencyOfChange?: InputMaybe<Scalars['String']['input']>;
  selectedWoundIndices?: Array<Scalars['Int']['input']>;
};

export enum WoundSuctionUlcerType {
  ChronicMixedEtiology = 'CHRONIC_MIXED_ETIOLOGY',
  Neuropathic = 'NEUROPATHIC',
  NoneOfTheAbove = 'NONE_OF_THE_ABOVE',
  PressureStage_3Or_4 = 'PRESSURE_STAGE_3_OR_4',
  VenousOrArterialInsufficiency = 'VENOUS_OR_ARTERIAL_INSUFFICIENCY'
}

export type ZingPrSettings = {
  __typename?: 'ZingPrSettings';
  acknowledgementThreshold: Scalars['Float']['output'];
};

export type ZingPrSettingsInput = {
  acknowledgementThreshold: Scalars['Float']['input'];
};

export type Create_Order_Note_ResponseMutationVariables = Exact<{
  departmentOrderId: Scalars['Int']['input'];
  orderNoteId: Scalars['Int']['input'];
  responseText: Scalars['String']['input'];
  fileAttachments: Array<OrderNoteFileUploads> | OrderNoteFileUploads;
  requireClinicResponse: Scalars['Boolean']['input'];
  llmChosenResponse: Scalars['String']['input'];
  opsUserId?: InputMaybe<Scalars['Int']['input']>;
  lastSeenOrderNoteId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type Create_Order_Note_ResponseMutation = { __typename?: 'Mutation', createOrderNoteResponse: { __typename?: 'OrderNoteResponse', id: number, note: string, createdAt: any, email: string, clinicianName?: string | null, opsUserName?: string | null, departmentOrderRemarks?: Array<DepartmentOrderRemarkType> | null, orderStatus?: ProviderReferralStatus | null, fileAttachments: Array<{ __typename?: 'OrderNoteFileAttachment', fileUrl: string, fileName: string, fileType: string }> } };

export type Issue_ResponseMutationVariables = Exact<{
  orderNumber: Scalars['String']['input'];
  noteId: Scalars['Int']['input'];
  approved: Scalars['Boolean']['input'];
  selections?: InputMaybe<Array<NoteResponseSelectionInput> | NoteResponseSelectionInput>;
}>;


export type Issue_ResponseMutation = { __typename?: 'Mutation', issueResponse: { __typename?: 'IssueNoteResponse', departmentOrderRemarks: Array<DepartmentOrderRemarkType>, orderStatus: ProviderReferralStatus } };

export type CancelAutomaticRemindersMutationVariables = Exact<{
  orderNoteId: Scalars['Int']['input'];
}>;


export type CancelAutomaticRemindersMutation = { __typename?: 'Mutation', cancelAutomaticReminders?: any | null };

export type Draft_Ops_Note_AutocompleteQueryVariables = Exact<{
  orderNoteId: Scalars['Int']['input'];
  orderNumber: Scalars['String']['input'];
  currentDraftMessage: Scalars['String']['input'];
}>;


export type Draft_Ops_Note_AutocompleteQuery = { __typename?: 'Query', draftOpsNoteAutocomplete: string };

export type ResolveOrderNoteMutationVariables = Exact<{
  noteId: Scalars['Int']['input'];
}>;


export type ResolveOrderNoteMutation = { __typename?: 'Mutation', resolveOrderNote: { __typename?: 'ResolveOrderNoteResponse', departmentOrderRemarks: Array<DepartmentOrderRemarkType>, orderStatus?: ProviderReferralStatus | null } };

export type ResolveClinicNoteThreadMutationVariables = Exact<{
  orderNumber: Scalars['String']['input'];
  noteId: Scalars['Int']['input'];
}>;


export type ResolveClinicNoteThreadMutation = { __typename?: 'Mutation', resolveClinicNoteThread: boolean };

export type Get_Row_Validation_Warning_MessagesQueryVariables = Exact<{
  woundProductRow: Array<WoundCareLineItemInput> | WoundCareLineItemInput;
  wounds: Array<WoundInput> | WoundInput;
  isMedicareBlockingEligible: Scalars['Boolean']['input'];
  payor?: InputMaybe<Scalars['String']['input']>;
  insuranceType?: InputMaybe<Scalars['String']['input']>;
  stateName?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type Get_Row_Validation_Warning_MessagesQuery = { __typename?: 'Query', validationWarningMessagesForAllLineItems: Array<{ __typename?: 'WarningMessagesGroup', warnings: Array<{ __typename?: 'WarningMessage', heading: string, message?: string | null, details?: Array<string> | null, key: string, empty: boolean, error: boolean, formItemId?: number | null, woundIndex?: number | null, maxAllowedQuantity?: number | null }> }> };

export type Read_Drainage_Level_WarningsQueryVariables = Exact<{
  woundCareLineItemInput: Array<WoundCareLineItemInput> | WoundCareLineItemInput;
  wounds: Array<WoundInput> | WoundInput;
  isMedicareBlockingEligible: Scalars['Boolean']['input'];
  billerReviewHeading: Scalars['Boolean']['input'];
}>;


export type Read_Drainage_Level_WarningsQuery = { __typename?: 'Query', readDrainageLevelWarnings: { __typename?: 'WarningMessagesGroup', warnings: Array<{ __typename?: 'WarningMessage', heading: string, message?: string | null, details?: Array<string> | null, key: string, empty: boolean, error: boolean, formItemId?: number | null, woundIndex?: number | null }> } };

export type Create_Order_SharedMutationVariables = Exact<{
  providerReferral: ProviderReferralInput;
  s3DocumentReferences: Array<S3DocumentReference> | S3DocumentReference;
  signerInput: SignerInput;
  hospitalName?: InputMaybe<Scalars['String']['input']>;
  isOrderFromDraft: Scalars['Boolean']['input'];
}>;


export type Create_Order_SharedMutation = { __typename?: 'Mutation', createProviderReferral: string };

export type Create_Order_NoteMutationVariables = Exact<{
  orderNoteInput: OrderNoteInput;
}>;


export type Create_Order_NoteMutation = { __typename?: 'Mutation', createOrderNote: number };


export const Create_Order_Note_ResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_ORDER_NOTE_RESPONSE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderNoteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responseText"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileAttachments"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderNoteFileUploads"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requireClinicResponse"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"llmChosenResponse"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opsUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastSeenOrderNoteId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrderNoteResponse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"departmentOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentOrderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderNoteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderNoteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"responseText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responseText"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileAttachments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileAttachments"}}},{"kind":"Argument","name":{"kind":"Name","value":"requireClinicResponse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requireClinicResponse"}}},{"kind":"Argument","name":{"kind":"Name","value":"llmChosenResponse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"llmChosenResponse"}}},{"kind":"Argument","name":{"kind":"Name","value":"opsUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opsUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastSeenOrderNoteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastSeenOrderNoteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"clinicianName"}},{"kind":"Field","name":{"kind":"Name","value":"opsUserName"}},{"kind":"Field","name":{"kind":"Name","value":"fileAttachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departmentOrderRemarks"}},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"}}]}}]}}]} as unknown as DocumentNode<Create_Order_Note_ResponseMutation, Create_Order_Note_ResponseMutationVariables>;
export const Issue_ResponseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ISSUE_RESPONSE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"approved"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selections"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoteResponseSelectionInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueResponse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"noteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"approved"},"value":{"kind":"Variable","name":{"kind":"Name","value":"approved"}}},{"kind":"Argument","name":{"kind":"Name","value":"selections"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selections"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentOrderRemarks"}},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"}}]}}]}}]} as unknown as DocumentNode<Issue_ResponseMutation, Issue_ResponseMutationVariables>;
export const CancelAutomaticRemindersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelAutomaticReminders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderNoteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelAutomaticReminders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderNoteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderNoteId"}}}]}]}}]} as unknown as DocumentNode<CancelAutomaticRemindersMutation, CancelAutomaticRemindersMutationVariables>;
export const Draft_Ops_Note_AutocompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DRAFT_OPS_NOTE_AUTOCOMPLETE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderNoteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentDraftMessage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"draftOpsNoteAutocomplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderNoteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderNoteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"currentDraftMessage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDraftMessage"}}}]}]}}]} as unknown as DocumentNode<Draft_Ops_Note_AutocompleteQuery, Draft_Ops_Note_AutocompleteQueryVariables>;
export const ResolveOrderNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResolveOrderNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolveOrderNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"noteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentOrderRemarks"}},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"}}]}}]}}]} as unknown as DocumentNode<ResolveOrderNoteMutation, ResolveOrderNoteMutationVariables>;
export const ResolveClinicNoteThreadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResolveClinicNoteThread"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolveClinicNoteThread"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"noteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noteId"}}}]}]}}]} as unknown as DocumentNode<ResolveClinicNoteThreadMutation, ResolveClinicNoteThreadMutationVariables>;
export const Get_Row_Validation_Warning_MessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_ROW_VALIDATION_WARNING_MESSAGES"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"woundProductRow"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WoundCareLineItemInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wounds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WoundInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isMedicareBlockingEligible"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"insuranceType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stateName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationWarningMessagesForAllLineItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"woundProductRow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"woundProductRow"}}},{"kind":"Argument","name":{"kind":"Name","value":"wounds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wounds"}}},{"kind":"Argument","name":{"kind":"Name","value":"isMedicareBlockingEligible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isMedicareBlockingEligible"}}},{"kind":"Argument","name":{"kind":"Name","value":"payor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payor"}}},{"kind":"Argument","name":{"kind":"Name","value":"insuranceType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"insuranceType"}}},{"kind":"Argument","name":{"kind":"Name","value":"stateName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateName"}}},{"kind":"Argument","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"empty"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"formItemId"}},{"kind":"Field","name":{"kind":"Name","value":"woundIndex"}},{"kind":"Field","name":{"kind":"Name","value":"maxAllowedQuantity"}}]}}]}}]}}]} as unknown as DocumentNode<Get_Row_Validation_Warning_MessagesQuery, Get_Row_Validation_Warning_MessagesQueryVariables>;
export const Read_Drainage_Level_WarningsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"READ_DRAINAGE_LEVEL_WARNINGS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"woundCareLineItemInput"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WoundCareLineItemInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wounds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WoundInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isMedicareBlockingEligible"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billerReviewHeading"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readDrainageLevelWarnings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"woundCareLineItemInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"woundCareLineItemInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"wounds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wounds"}}},{"kind":"Argument","name":{"kind":"Name","value":"isMedicareBlockingEligible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isMedicareBlockingEligible"}}},{"kind":"Argument","name":{"kind":"Name","value":"billerReviewHeading"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billerReviewHeading"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"empty"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"formItemId"}},{"kind":"Field","name":{"kind":"Name","value":"woundIndex"}}]}}]}}]}}]} as unknown as DocumentNode<Read_Drainage_Level_WarningsQuery, Read_Drainage_Level_WarningsQueryVariables>;
export const Create_Order_SharedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_ORDER_SHARED"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerReferral"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderReferralInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"s3DocumentReferences"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"S3DocumentReference"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signerInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignerInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hospitalName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOrderFromDraft"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProviderReferral"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"providerReferralInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerReferral"}}},{"kind":"Argument","name":{"kind":"Name","value":"s3DocumentReferences"},"value":{"kind":"Variable","name":{"kind":"Name","value":"s3DocumentReferences"}}},{"kind":"Argument","name":{"kind":"Name","value":"signerInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signerInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"hospitalName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hospitalName"}}},{"kind":"Argument","name":{"kind":"Name","value":"isOrderFromDraft"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOrderFromDraft"}}}]}]}}]} as unknown as DocumentNode<Create_Order_SharedMutation, Create_Order_SharedMutationVariables>;
export const Create_Order_NoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CREATE_ORDER_NOTE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderNoteInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderNoteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrderNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderNoteInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderNoteInput"}}}]}]}}]} as unknown as DocumentNode<Create_Order_NoteMutation, Create_Order_NoteMutationVariables>;